var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/common/utils/api-utils.ts
function isRelativePath(url = "") {
  return !["https://", "http://", "data:"].some(
    (prefix) => url.startsWith(prefix) && url.length > prefix.length
  );
}

// src/common/makeHttpClient/makeHttpClient.ts
var makeHttpClient = (baseUrl, additionalHeaders) => (
  // eslint-disable-next-line @typescript-eslint/promise-function-async
  (input, init) => {
    const resource = applyBaseUrl(input, baseUrl || "");
    return fetch(resource, mergeRequestInit(init != null ? init : {}, { headers: additionalHeaders }));
  }
);
var applyBaseUrl = (input, baseUrl) => typeof input === "string" && isRelativePath(input) ? baseUrl + input : input;
var mergeRequestInit = (init, additionalInit) => __spreadProps(__spreadValues(__spreadValues({}, init), additionalInit), {
  headers: mergeHeaders(init == null ? void 0 : init.headers, additionalInit == null ? void 0 : additionalInit.headers)
});
var mergeHeaders = (...headersInits) => headersInits.reduce(
  (acc, headers2) => __spreadValues(__spreadValues({}, acc), Object.fromEntries(new Headers(headers2).entries())),
  {}
);

// src/i18n/de.json
var de_default = {
  "dynamicFlows.ArraySchema.addItem": "Speichern",
  "dynamicFlows.ArraySchema.addItemTitle": "Artikel hinzuf\xFCgen",
  "dynamicFlows.ArraySchema.editItem": "Speichern",
  "dynamicFlows.ArraySchema.maxItemsError": "Bitte f\xFCge {maxItems} oder weniger hinzu.",
  "dynamicFlows.ArraySchema.minItemsError": "Bitte f\xFCge mindestens {minItems} hinzu.",
  "dynamicFlows.ArraySchema.removeItem": "Entfernen",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Erneut versuchen",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Bitte pr\xFCfe, ob deine Kamera verbunden ist, und versuche es dann erneut.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "Wir k\xF6nnen nicht auf deine Kamera zugreifen",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "Der von dir verwendete Browser unterst\xFCtzt keine Kameras. Bitte verwende einen anderen Browser oder ein anderes Ger\xE4t, oder lade unsere App herunter",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Kamera wird nicht unterst\xFCtzt",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Kamerazugriff genehmigen",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Aktiviere den Kamerazugriff in den Einstellungen deines Browsers, um weitermachen zu k\xF6nnen.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "Wir k\xF6nnen nicht auf deine Kamera zugreifen",
  "dynamicFlows.CameraCapture.reviewInstructions": "Ist das aufgenommene Bild deutlich erkennbar und vollst\xE4ndig?",
  "dynamicFlows.CameraCapture.reviewRetry": "Nein, erneut versuchen",
  "dynamicFlows.CameraCapture.reviewSubmit": "Ja, senden",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Drehe dein Ger\xE4t in die Hochformatansicht, um ein Foto aufzunehmen",
  "dynamicFlows.ControlFeedback.maxLength": "Bitte gib nicht mehr als {maxLength} Zeichen ein.",
  "dynamicFlows.ControlFeedback.maximum": "Bitte gib eine Zahl ein, die {maximum} oder weniger betr\xE4gt.",
  "dynamicFlows.ControlFeedback.maximumDate": "Bitte gib ein Datum ein, das am oder vor dem {maximum} liegt.",
  "dynamicFlows.ControlFeedback.minLength": "Bitte gib mindestens {minLength} Zeichen ein.",
  "dynamicFlows.ControlFeedback.minimum": "Bitte gib eine Zahl ein, die {minimum} oder mehr betr\xE4gt.",
  "dynamicFlows.ControlFeedback.minimumDate": "Bitte gib ein Datum ein, das am oder nach dem {minimum} liegt.",
  "dynamicFlows.ControlFeedback.pattern": "Bitte gib die Angabe im richtigen Format ein.",
  "dynamicFlows.ControlFeedback.patternDate": "Bitte gib ein Datum im richtigen Format ein.",
  "dynamicFlows.ControlFeedback.required": "Bitte f\xFClle dieses Feld aus.",
  "dynamicFlows.ControlFeedback.type": "Falscher Typ",
  "dynamicFlows.DefaultErrorMessages.required": "Bitte f\xFClle dieses Feld aus.",
  "dynamicFlows.DynamicExternal.retryTitle": "Fenster erneut \xF6ffnen",
  "dynamicFlows.DynamicParagraph.copied": "In Zwischenablage kopiert",
  "dynamicFlows.DynamicParagraph.copy": "Kopieren",
  "dynamicFlows.ErrorBoundary.errorAlert": "Da ist etwas schiefgegangen.",
  "dynamicFlows.ErrorBoundary.retry": "Erneut versuchen",
  "dynamicFlows.ExternalConfirmation.cancel": "Abbrechen",
  "dynamicFlows.ExternalConfirmation.description": "Bitte best\xE4tige, dass du **{origin}** in einem neuen Browser-Tab \xF6ffnen m\xF6chtest.",
  "dynamicFlows.ExternalConfirmation.open": "In neuem Tab \xF6ffnen",
  "dynamicFlows.ExternalConfirmation.title": "Bitte best\xE4tigen",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Diese Datei ist leider zu gro\xDF. Bitte lade eine kleinere Datei hoch.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Das Dateiformat wird leider nicht unterst\xFCtzt. Bitte lade eine andere Datei hoch.",
  "dynamicFlows.Help.ariaLabel": "Klicke hier f\xFCr mehr Informationen.",
  "dynamicFlows.MultiSelect.summary": "{first} und {count} weitere",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Diese Datei ist leider zu gro\xDF. Bitte lade eine kleinere Datei hoch.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Bitte lade {maxItems} oder weniger Dateien hoch.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Bitte lade mindestens {minItems} Datei(en) hoch.",
  "dynamicFlows.PersistAsyncSchema.genericError": "Da ist etwas schiefgegangen. Versuche es bitte nochmal.",
  "dynamicFlows.ReadOnlySchema.no": "Nein",
  "dynamicFlows.ReadOnlySchema.yes": "Ja",
  "dynamicFlows.SearchLayout.loading": "L\xE4dt..."
};

// src/i18n/en.json
var en_default = {
  "dynamicFlows.ArraySchema.addItem": "Save",
  "dynamicFlows.ArraySchema.addItemTitle": "Add Item",
  "dynamicFlows.ArraySchema.editItem": "Save",
  "dynamicFlows.ArraySchema.maxItemsError": "Please add {maxItems} or fewer.",
  "dynamicFlows.ArraySchema.minItemsError": "Please add at least {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "Remove",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Try again",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Please check if it is connected and try again.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "We can't access your camera",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "The browser you're using doesn't have support for a camera. Try a different browser, device, or download our mobile app.",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Camera not supported",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Enable camera access",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Enable camera access in your browser's settings to get going again.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "We can't access your camera",
  "dynamicFlows.CameraCapture.reviewInstructions": "Is your picture clear, readable and complete?",
  "dynamicFlows.CameraCapture.reviewRetry": "No, try again",
  "dynamicFlows.CameraCapture.reviewSubmit": "Yes, submit",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Rotate your phone to portrait view to take a photo",
  "dynamicFlows.ControlFeedback.maxLength": "Please enter {maxLength} or fewer characters.",
  "dynamicFlows.ControlFeedback.maximum": "Please enter a number that's {maximum} or less.",
  "dynamicFlows.ControlFeedback.maximumDate": "Please enter a date that's on or before {maximum}.",
  "dynamicFlows.ControlFeedback.minLength": "Please enter at least {minLength} characters.",
  "dynamicFlows.ControlFeedback.minimum": "Please enter a number that's {minimum} or more.",
  "dynamicFlows.ControlFeedback.minimumDate": "Please enter a date that's on or after {minimum}.",
  "dynamicFlows.ControlFeedback.pattern": "Please enter this in the correct format.",
  "dynamicFlows.ControlFeedback.patternDate": "Please enter a date in the corrrect format.",
  "dynamicFlows.ControlFeedback.required": "Please fill out this field.",
  "dynamicFlows.ControlFeedback.type": "Incorrect type",
  "dynamicFlows.DefaultErrorMessages.required": "Please fill out this field.",
  "dynamicFlows.DynamicExternal.retryTitle": "Reopen window",
  "dynamicFlows.DynamicParagraph.copied": "Copied to clipboard",
  "dynamicFlows.DynamicParagraph.copy": "Copy",
  "dynamicFlows.ErrorBoundary.errorAlert": "Something went wrong.",
  "dynamicFlows.ErrorBoundary.retry": "Retry",
  "dynamicFlows.ExternalConfirmation.cancel": "Cancel",
  "dynamicFlows.ExternalConfirmation.description": "Please confirm you want to open **{origin}** in a new browser tab.",
  "dynamicFlows.ExternalConfirmation.open": "Open in new tab",
  "dynamicFlows.ExternalConfirmation.title": "Please confirm",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Sorry, that file is too big. Please upload a smaller file.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Sorry, that file format is not supported. Please upload a different file.",
  "dynamicFlows.Help.ariaLabel": "Click here for more info.",
  "dynamicFlows.MultiSelect.summary": "{first} and {count} more",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Sorry, that file is too big. Please upload a smaller file.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Please upload {maxItems} or fewer files.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Please upload at least {minItems} file(s).",
  "dynamicFlows.PersistAsyncSchema.genericError": "Something went wrong, please try again.",
  "dynamicFlows.ReadOnlySchema.no": "No",
  "dynamicFlows.ReadOnlySchema.yes": "Yes",
  "dynamicFlows.SearchLayout.loading": "Loading..."
};

// src/i18n/es.json
var es_default = {
  "dynamicFlows.ArraySchema.addItem": "Guardar",
  "dynamicFlows.ArraySchema.addItemTitle": "A\xF1adir elemento",
  "dynamicFlows.ArraySchema.editItem": "Guardar",
  "dynamicFlows.ArraySchema.maxItemsError": "A\xF1ade {maxItems} o menos.",
  "dynamicFlows.ArraySchema.minItemsError": "A\xF1ade al menos {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "Eliminar",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Intentar de nuevo",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Comprueba si est\xE1 conectado e int\xE9ntalo de nuevo.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "No podemos acceder a tu c\xE1mara",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "El navegador que est\xE1s utilizando no es compatible con una c\xE1mara. Prueba con otro navegador, dispositivo o descarga nuestra app m\xF3vil.",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "C\xE1mara no compatible",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Habilitar acceso a la c\xE1mara",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Habilita el acceso a la c\xE1mara en la configuraci\xF3n de tu navegador para volver a activarla.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "No podemos acceder a tu c\xE1mara",
  "dynamicFlows.CameraCapture.reviewInstructions": "\xBFTu foto es clara, legible y completa?",
  "dynamicFlows.CameraCapture.reviewRetry": "No, intentar de nuevo",
  "dynamicFlows.CameraCapture.reviewSubmit": "S\xED, enviar",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Gira el tel\xE9fono a la vista vertical para hacer una foto",
  "dynamicFlows.ControlFeedback.maxLength": "Introduce {maxLength} caracteres o menos.",
  "dynamicFlows.ControlFeedback.maximum": "Introduce una cifra igual o inferior a {maximum}.",
  "dynamicFlows.ControlFeedback.maximumDate": "Introduce una fecha que sea igual o anterior al {maximum}.",
  "dynamicFlows.ControlFeedback.minLength": "Introduce al menos {minLength} caracteres.",
  "dynamicFlows.ControlFeedback.minimum": "Introduce una cifra igual o inferior a {minimum}.",
  "dynamicFlows.ControlFeedback.minimumDate": "Introduce una fecha que sea igual o posterior al {minimum}.",
  "dynamicFlows.ControlFeedback.pattern": "Utiliza el formato correcto.",
  "dynamicFlows.ControlFeedback.patternDate": "Introduce la fecha en un formato correcto.",
  "dynamicFlows.ControlFeedback.required": "Completa este campo.",
  "dynamicFlows.ControlFeedback.type": "Tipo incorrecto",
  "dynamicFlows.DefaultErrorMessages.required": "Completa este campo.",
  "dynamicFlows.DynamicExternal.retryTitle": "Reabrir ventana",
  "dynamicFlows.DynamicParagraph.copied": "Copiado al portapapeles",
  "dynamicFlows.DynamicParagraph.copy": "Copiar",
  "dynamicFlows.ErrorBoundary.errorAlert": "Ha habido un error.",
  "dynamicFlows.ErrorBoundary.retry": "Reintentar",
  "dynamicFlows.ExternalConfirmation.cancel": "Cancelar",
  "dynamicFlows.ExternalConfirmation.description": "Confirma que quieres abrir **{origin}** en una nueva pesta\xF1a del navegador.",
  "dynamicFlows.ExternalConfirmation.open": "Abrir en nueva pesta\xF1a",
  "dynamicFlows.ExternalConfirmation.title": "Por favor, confirma",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Lo sentimos, el archivo pesa demasiado. Sube uno m\xE1s peque\xF1o.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Lo sentimos, ese formato de archivo no es compatible. Sube otro archivo.",
  "dynamicFlows.Help.ariaLabel": "Haz clic aqu\xED para obtener m\xE1s informaci\xF3n.",
  "dynamicFlows.MultiSelect.summary": "{first} y {count} m\xE1s",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Lo sentimos, el archivo pesa demasiado. Sube uno m\xE1s peque\xF1o.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Sube {maxItems} o menos archivos.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Sube al menos {minItems} archivo(s).",
  "dynamicFlows.PersistAsyncSchema.genericError": "Ha habido un error. Int\xE9ntalo de nuevo.",
  "dynamicFlows.ReadOnlySchema.no": "No",
  "dynamicFlows.ReadOnlySchema.yes": "S\xED",
  "dynamicFlows.SearchLayout.loading": "Cargando..."
};

// src/i18n/fr.json
var fr_default = {
  "dynamicFlows.ArraySchema.addItem": "Enregistrer",
  "dynamicFlows.ArraySchema.addItemTitle": "Ajouter un \xE9l\xE9ment",
  "dynamicFlows.ArraySchema.editItem": "Enregistrer",
  "dynamicFlows.ArraySchema.maxItemsError": "Veuillez ajouter {maxItems} ou moins.",
  "dynamicFlows.ArraySchema.minItemsError": "Veuillez ajouter au moins {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "Supprimer",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "R\xE9essayez",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "V\xE9rifiez s'il est connect\xE9 et r\xE9essayez.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "Nous n'avons pas acc\xE8s \xE0 votre appareil photo",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "Le navigateur que vous utilisez ne prend pas en charge l'appareil photo. Veuillez essayer un autre navigateur, un autre appareil ou t\xE9l\xE9charger notre appli.",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Appareil photo non pris en charge",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Autoriser l'acc\xE8s \xE0 l'appareil photo",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Autorisez l'acc\xE8s \xE0 l'appareil photo depuis les param\xE8tres de votre navigateur.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "Nous n'avons pas acc\xE8s \xE0 votre appareil photo",
  "dynamicFlows.CameraCapture.reviewInstructions": "Votre image est-elle claire, lisible et dans son int\xE9gralit\xE9\xA0?",
  "dynamicFlows.CameraCapture.reviewRetry": "Non, r\xE9essayer",
  "dynamicFlows.CameraCapture.reviewSubmit": "Oui, confirmer",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Faites pivoter votre t\xE9l\xE9phone vers la vue portrait pour prendre une photo",
  "dynamicFlows.ControlFeedback.maxLength": "Veuillez saisir {maxLength} caract\xE8res ou moins.",
  "dynamicFlows.ControlFeedback.maximum": "Veuillez saisir un nombre inf\xE9rieur ou \xE9gal \xE0 {maximum}.",
  "dynamicFlows.ControlFeedback.maximumDate": "Veuillez saisir une date \xE9gale ou ant\xE9rieure au {maximum}.",
  "dynamicFlows.ControlFeedback.minLength": "Veuillez saisir au moins {minLength} caract\xE8res.",
  "dynamicFlows.ControlFeedback.minimum": "Veuillez saisir un nombre sup\xE9rieur ou \xE9gal \xE0 {minimum}.",
  "dynamicFlows.ControlFeedback.minimumDate": "Veuillez saisir une date \xE9gale ou post\xE9rieure au {minimum}.",
  "dynamicFlows.ControlFeedback.pattern": "Veuillez saisir les informations dans le bon format.",
  "dynamicFlows.ControlFeedback.patternDate": "Veuillez saisir une date au format correct.",
  "dynamicFlows.ControlFeedback.required": "Champ obligatoire.",
  "dynamicFlows.ControlFeedback.type": "Type incorrect",
  "dynamicFlows.DefaultErrorMessages.required": "Champ obligatoire.",
  "dynamicFlows.DynamicExternal.retryTitle": "Rouvrir la fen\xEAtre",
  "dynamicFlows.DynamicParagraph.copied": "Copi\xE9 dans le presse-papier",
  "dynamicFlows.DynamicParagraph.copy": "Copier",
  "dynamicFlows.ErrorBoundary.errorAlert": "Une erreur s'est produite.",
  "dynamicFlows.ErrorBoundary.retry": "R\xE9essayer",
  "dynamicFlows.ExternalConfirmation.cancel": "Annuler",
  "dynamicFlows.ExternalConfirmation.description": "Veuillez confirmer que vous souhaitez ouvrir **{origin}** dans un nouvel onglet.",
  "dynamicFlows.ExternalConfirmation.open": "Ouvrir dans un nouvel onglet",
  "dynamicFlows.ExternalConfirmation.title": "Veuillez confirmer",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Nous sommes d\xE9sol\xE9s, ce fichier est trop volumineux. Veuillez t\xE9l\xE9charger un fichier plus petit.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Nous sommes d\xE9sol\xE9s, ce format de fichier n'est pas pris en charge. Veuillez en t\xE9l\xE9charger un autre.",
  "dynamicFlows.Help.ariaLabel": "Cliquez ici pour plus d'informations.",
  "dynamicFlows.MultiSelect.summary": "{first} et {count} de plus",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Nous sommes d\xE9sol\xE9s, ce fichier est trop volumineux. Veuillez t\xE9l\xE9charger un fichier plus petit.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Veuillez t\xE9l\xE9charger {maxItems} fichiers ou moins.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Veuillez t\xE9l\xE9charger au moins {minItems} fichier(s).",
  "dynamicFlows.PersistAsyncSchema.genericError": "Une erreur s'est produite, veuillez r\xE9essayer.",
  "dynamicFlows.ReadOnlySchema.no": "Non",
  "dynamicFlows.ReadOnlySchema.yes": "Oui",
  "dynamicFlows.SearchLayout.loading": "Chargement..."
};

// src/i18n/hu.json
var hu_default = {
  "dynamicFlows.ArraySchema.addItem": "Ment\xE9s",
  "dynamicFlows.ArraySchema.addItemTitle": "Elem hozz\xE1ad\xE1sa",
  "dynamicFlows.ArraySchema.editItem": "Ment\xE9s",
  "dynamicFlows.ArraySchema.maxItemsError": "K\xE9r\xFCnk, {maxItems} vagy ann\xE1l kevesebb t\xE9telt adj meg.",
  "dynamicFlows.ArraySchema.minItemsError": "K\xE9r\xFCnk, legal\xE1bb {minItems} t\xE9telt adj meg.",
  "dynamicFlows.ArraySchema.removeItem": "Elt\xE1vol\xEDt\xE1s",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Pr\xF3b\xE1ld \xFAjra",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Ellen\u0151rizd, hogy csatlakoztatva van-e, \xE9s pr\xF3b\xE1ld \xFAjra.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "Nem tudunk hozz\xE1f\xE9rni a kamer\xE1dhoz",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "Az \xE1ltalad haszn\xE1lt b\xF6ng\xE9sz\u0151 nem t\xE1mogatja a kamera haszn\xE1lat\xE1t. K\xE9r\xFCnk, pr\xF3b\xE1lkozz m\xE1s b\xF6ng\xE9sz\u0151vel, eszk\xF6zzel vagy t\xF6ltsd le az appot",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Kamera nem t\xE1mogatott",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Kamer\xE1hoz val\xF3 hozz\xE1f\xE9r\xE9s enged\xE9lyez\xE9se",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Nem tudunk hozz\xE1f\xE9rni a kamer\xE1dhoz. Ezt a telefonod be\xE1ll\xEDt\xE1saiban enged\xE9lyezheted",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "Nem tudunk hozz\xE1f\xE9rni a kamer\xE1dhoz",
  "dynamicFlows.CameraCapture.reviewInstructions": "Tiszta, olvashat\xF3, teljes k\xE9pet k\xE9sz\xEDtett\xE9l?",
  "dynamicFlows.CameraCapture.reviewRetry": "Nem, pr\xF3b\xE1ljuk \xFAjra",
  "dynamicFlows.CameraCapture.reviewSubmit": "Igen, elk\xFCld\xF6m",
  "dynamicFlows.CameraCapture.rotatePhone.text": "F\xE9nyk\xE9p k\xE9sz\xEDt\xE9s\xE9hez ford\xEDtsd a telefont \xE1ll\xF3 n\xE9zetbe",
  "dynamicFlows.ControlFeedback.maxLength": "K\xE9r\xFCnk, legfeljebb {maxLength} karaktert adj meg.",
  "dynamicFlows.ControlFeedback.maximum": "K\xE9r\xFCnk, add meg ezt vagy egy enn\xE9l kisebb sz\xE1mot: {maximum}.",
  "dynamicFlows.ControlFeedback.maximumDate": "K\xE9r\xFCnk, adj meg egy d\xE1tumot, ami megegyezik {maximum} napj\xE1val, vagy egy enn\xE9l kor\xE1bbit.",
  "dynamicFlows.ControlFeedback.minLength": "K\xE9r\xFCnk, legal\xE1bb {minLength} karaktert adj meg.",
  "dynamicFlows.ControlFeedback.minimum": "K\xE9r\xFCnk add meg ezt vagy egy enn\xE9l nagyobb sz\xE1mot: {minimum}.",
  "dynamicFlows.ControlFeedback.minimumDate": "K\xE9r\xFCnk, adj meg egy d\xE1tumot, ami megegyezik {minimum} napj\xE1val, vagy egy enn\xE9l k\xE9s\u0151bbit.",
  "dynamicFlows.ControlFeedback.pattern": "Helytelen form\xE1tum",
  "dynamicFlows.ControlFeedback.patternDate": "K\xE9r\xFCnk, hogy a d\xE1tumot helyes form\xE1tumban add meg.",
  "dynamicFlows.ControlFeedback.required": "K\xE9r\xFCnk, t\xF6ltsd ki ezt a mez\u0151t.",
  "dynamicFlows.ControlFeedback.type": "Helytelen t\xEDpus",
  "dynamicFlows.DefaultErrorMessages.required": "K\xE9r\xFCnk, t\xF6ltsd ki ezt a mez\u0151t.",
  "dynamicFlows.DynamicExternal.retryTitle": "Ablak \xFAjranyit\xE1sa",
  "dynamicFlows.DynamicParagraph.copied": "V\xE1g\xF3lapra m\xE1solva",
  "dynamicFlows.DynamicParagraph.copy": "M\xE1sol\xE1s",
  "dynamicFlows.ErrorBoundary.errorAlert": "Valami hiba t\xF6rt\xE9nt.",
  "dynamicFlows.ErrorBoundary.retry": "\xDAjra",
  "dynamicFlows.ExternalConfirmation.cancel": "M\xE9gsem",
  "dynamicFlows.ExternalConfirmation.description": "K\xE9r\xFCnk, er\u0151s\xEDtsd meg, hogy a(z) **{origin}** alkalmaz\xE1st egy \xFAj b\xF6ng\xE9sz\u0151lapon szeretn\xE9d megnyitni.",
  "dynamicFlows.ExternalConfirmation.open": "Megnyit\xE1s \xFAj lapon",
  "dynamicFlows.ExternalConfirmation.title": "Meger\u0151s\xEDt\xE9s",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Sajnos ez a f\xE1jl t\xFAl nagy. K\xE9r\xFCnk, t\xF6lts fel egy kisebb f\xE1jlt.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Sajnos ez a f\xE1jlform\xE1tum nem t\xE1mogatott. K\xE9r\xFCnk, t\xF6lts fel egy m\xE1sik f\xE1jlt.",
  "dynamicFlows.Help.ariaLabel": "Kattints ide tov\xE1bbi inform\xE1ci\xF3\xE9rt.",
  "dynamicFlows.MultiSelect.summary": "{first} \xE9s tov\xE1bbi {count}",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Sajnos ez a f\xE1jl t\xFAl nagy. K\xE9r\xFCnk, t\xF6lts fel egy kisebb f\xE1jlt.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "K\xE9r\xFCnk, hogy legfeljebb {maxItems} f\xE1jlt t\xF6lts fel.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "K\xE9r\xFCnk, hogy legal\xE1bb {minItems} f\xE1jlt t\xF6lts fel.",
  "dynamicFlows.PersistAsyncSchema.genericError": "Valami hiba t\xF6rt\xE9nt. K\xE9r\xFCnk, pr\xF3b\xE1ld \xFAjra.",
  "dynamicFlows.ReadOnlySchema.no": "Nem",
  "dynamicFlows.ReadOnlySchema.yes": "Igen",
  "dynamicFlows.SearchLayout.loading": "Bet\xF6lt\xE9s..."
};

// src/i18n/id.json
var id_default = {
  "dynamicFlows.ArraySchema.addItem": "Simpan",
  "dynamicFlows.ArraySchema.addItemTitle": "Tambahkan Item",
  "dynamicFlows.ArraySchema.editItem": "Simpan",
  "dynamicFlows.ArraySchema.maxItemsError": "Harap tambahkan {maxItems} atau kurang.",
  "dynamicFlows.ArraySchema.minItemsError": "Harap tambahkan setidaknya {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "Hapus",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Coba lagi",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Periksa apakah sudah terhubung dan coba lagi.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "Kami tidak dapat mengakses kamera Anda",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "Browser yang Anda gunakan tidak mendukung kamera. Silakan coba browser, perangkat yang lain, atau unduh aplikasi seluler kami.",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Kamera tidak didukung",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Izinkan akses kamera",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Untuk melanjutkan lagi, aktifkan akses kamera di pengaturan browser Anda.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "Kami tidak dapat mengakses kamera Anda",
  "dynamicFlows.CameraCapture.reviewInstructions": "Apakah gambar Anda jelas, dapat dibaca, dan lengkap?",
  "dynamicFlows.CameraCapture.reviewRetry": "Tidak, coba lagi",
  "dynamicFlows.CameraCapture.reviewSubmit": "Ya, kirim",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Putar ponsel Anda ke tampilan potret untuk mengambil foto",
  "dynamicFlows.ControlFeedback.maxLength": "Harap masukkan {maxLength} karakter atau kurang.",
  "dynamicFlows.ControlFeedback.maximum": "Harap masukkan angka paling besar {maximum} atau kurang dari itu.",
  "dynamicFlows.ControlFeedback.maximumDate": "Harap masukkan tanggal pada atau sebelum {maximum}.",
  "dynamicFlows.ControlFeedback.minLength": "Harap masukkan setidaknya {minLength} karakter.",
  "dynamicFlows.ControlFeedback.minimum": "Harap masukkan angka paling kecil {minimum} atau lebih dari itu.",
  "dynamicFlows.ControlFeedback.minimumDate": "Harap masukkan tanggal pada atau setelah {minimum}.",
  "dynamicFlows.ControlFeedback.pattern": "Mohon masukkan ini dalam format yang benar.",
  "dynamicFlows.ControlFeedback.patternDate": "Harap masukkan tanggal dalam format yang benar.",
  "dynamicFlows.ControlFeedback.required": "Harap isi kolom ini.",
  "dynamicFlows.ControlFeedback.type": "Tipe salah",
  "dynamicFlows.DefaultErrorMessages.required": "Harap isi kolom ini.",
  "dynamicFlows.DynamicExternal.retryTitle": "Buka window kembali",
  "dynamicFlows.DynamicParagraph.copied": "Disalin ke clipboard",
  "dynamicFlows.DynamicParagraph.copy": "Salin",
  "dynamicFlows.ErrorBoundary.errorAlert": "Terjadi kesalahan.",
  "dynamicFlows.ErrorBoundary.retry": "Coba lagi",
  "dynamicFlows.ExternalConfirmation.cancel": "Batalkan",
  "dynamicFlows.ExternalConfirmation.description": "Harap konfirmasikan bahwa Anda ingin membuka **{origin}** di tab browser baru.",
  "dynamicFlows.ExternalConfirmation.open": "Buka di tab baru",
  "dynamicFlows.ExternalConfirmation.title": "Harap konfirmasi",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Maaf, file Anda terlalu besar. Silakan unggah file yang lebih kecil.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Maaf, format file itu tidak didukung. Unggah file lain.",
  "dynamicFlows.Help.ariaLabel": "Klik di sini untuk info selengkapnya.",
  "dynamicFlows.MultiSelect.summary": "{first} dan {count} lagi",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Maaf, file Anda terlalu besar. Silakan unggah file yang lebih kecil.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Harap unggah {maxItems} file atau kurang.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Harap unggah sedikitnya {minItems} file.",
  "dynamicFlows.PersistAsyncSchema.genericError": "Terjadi kesalahan, mohon coba lagi.",
  "dynamicFlows.ReadOnlySchema.no": "Tidak",
  "dynamicFlows.ReadOnlySchema.yes": "Ya",
  "dynamicFlows.SearchLayout.loading": "Memuat ..."
};

// src/i18n/it.json
var it_default = {
  "dynamicFlows.ArraySchema.addItem": "Salva",
  "dynamicFlows.ArraySchema.addItemTitle": "Aggiungi elemento",
  "dynamicFlows.ArraySchema.editItem": "Salva",
  "dynamicFlows.ArraySchema.maxItemsError": "Aggiungi al massimo {maxItems}.",
  "dynamicFlows.ArraySchema.minItemsError": "Aggiungi almeno {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "Rimuovi",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Riprova",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Controlla se la fotocamera \xE8 collegata e riprova.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "Accesso alla fotocamera disabilitato",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "Il browser che stai usando non supporta la videocamera. Prova con un altro browser o dispositivo, oppure scarica la nostra app",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Videocamera non supportata",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Consenti l'accesso alla fotocamera",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Non abbiamo accesso alla tua fotocamera. Puoi abilitare l'accesso nelle impostazioni del tuo browser",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "Accesso alla fotocamera disabilitato",
  "dynamicFlows.CameraCapture.reviewInstructions": "La tua foto \xE8 chiara, ben leggibile e completa?",
  "dynamicFlows.CameraCapture.reviewRetry": "No, riprova",
  "dynamicFlows.CameraCapture.reviewSubmit": "S\xEC, invia",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Ruota il telefono in posizione verticale per scattare una foto",
  "dynamicFlows.ControlFeedback.maxLength": "Inserisci un massimo di {maxLength} caratteri.",
  "dynamicFlows.ControlFeedback.maximum": "Inserisci un numero uguale o inferiore a {maximum}.",
  "dynamicFlows.ControlFeedback.maximumDate": "Inserisci una data corrispondente o precedente al {maximum}.",
  "dynamicFlows.ControlFeedback.minLength": "Inserisci almeno {minLength} caratteri.",
  "dynamicFlows.ControlFeedback.minimum": "Inserisci un numero uguale o superiore a {minimum}.",
  "dynamicFlows.ControlFeedback.minimumDate": "Inserisci una data corrispondente o successiva al {minimum}.",
  "dynamicFlows.ControlFeedback.pattern": "Inseriscilo in un formato corretto.",
  "dynamicFlows.ControlFeedback.patternDate": "Inserisci la data in un formato corretto.",
  "dynamicFlows.ControlFeedback.required": "Compila questo campo.",
  "dynamicFlows.ControlFeedback.type": "Tipo errato",
  "dynamicFlows.DefaultErrorMessages.required": "Compila questo campo.",
  "dynamicFlows.DynamicExternal.retryTitle": "Riapri la finestra",
  "dynamicFlows.DynamicParagraph.copied": "Copiato negli appunti",
  "dynamicFlows.DynamicParagraph.copy": "Copia",
  "dynamicFlows.ErrorBoundary.errorAlert": "Qualcosa non ha funzionato.",
  "dynamicFlows.ErrorBoundary.retry": "Riprova",
  "dynamicFlows.ExternalConfirmation.cancel": "Annulla",
  "dynamicFlows.ExternalConfirmation.description": "Conferma di voler aprire **{origin}** in una nuova scheda del browser.",
  "dynamicFlows.ExternalConfirmation.open": "Apri in una nuova scheda",
  "dynamicFlows.ExternalConfirmation.title": "Conferma",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Spiacenti, il file \xE8 troppo grande. Carica un file di dimensioni inferiori.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Siamo spiacenti, questo formato di file non \xE8 supportato. Carica un file diverso.",
  "dynamicFlows.Help.ariaLabel": "Clicca qui per maggiori informazioni.",
  "dynamicFlows.MultiSelect.summary": "{first} e altri {count}",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Spiacenti, il file \xE8 troppo grande. Carica un file di dimensioni inferiori.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Carica al massimo {maxItems} file.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Carica almeno {minItems} file.",
  "dynamicFlows.PersistAsyncSchema.genericError": "Qualcosa \xE8 andato storto. Riprova.",
  "dynamicFlows.ReadOnlySchema.no": "No",
  "dynamicFlows.ReadOnlySchema.yes": "S\xEC",
  "dynamicFlows.SearchLayout.loading": "Caricamento..."
};

// src/i18n/ja.json
var ja_default = {
  "dynamicFlows.ArraySchema.addItem": "\u4FDD\u5B58\u3059\u308B",
  "dynamicFlows.ArraySchema.addItemTitle": "\u30A2\u30A4\u30C6\u30E0\u3092\u8FFD\u52A0\u3059\u308B",
  "dynamicFlows.ArraySchema.editItem": "\u4FDD\u5B58\u3059\u308B",
  "dynamicFlows.ArraySchema.maxItemsError": "{maxItems}\u30A2\u30A4\u30C6\u30E0\u4EE5\u4E0B\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ArraySchema.minItemsError": "{minItems}\u30A2\u30A4\u30C6\u30E0\u4EE5\u4E0A\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ArraySchema.removeItem": "\u524A\u9664\u3059\u308B",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "\u3084\u308A\u76F4\u3059",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u3001\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "\u304A\u5BA2\u69D8\u306E\u30D6\u30E9\u30A6\u30B6\u3067\u306F\u30AB\u30E1\u30E9\u304C\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u5225\u306E\u30D6\u30E9\u30A6\u30B6\u307E\u305F\u306F\u30C7\u30D0\u30A4\u30B9\u3092\u4F7F\u7528\u3059\u308B\u304B\u3001\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "\u30AB\u30E1\u30E9\u304C\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3059\u308B",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "\u30D6\u30E9\u30A6\u30B6\u306E\u8A2D\u5B9A\u3067\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u6709\u52B9\u306B\u3057\u3066\u3001\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
  "dynamicFlows.CameraCapture.reviewInstructions": "\u5199\u771F\u304C\u9BAE\u660E\u3067\u3001\u3059\u3079\u3066\u306E\u60C5\u5831\u304C\u8AAD\u307F\u53D6\u308C\u6B20\u3051\u3066\u3044\u308B\u90E8\u5206\u306A\u3069\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
  "dynamicFlows.CameraCapture.reviewRetry": "\u3044\u3044\u3048\u3001\u64AE\u308A\u76F4\u3059",
  "dynamicFlows.CameraCapture.reviewSubmit": "\u306F\u3044\u3001\u9001\u4FE1\u3059\u308B",
  "dynamicFlows.CameraCapture.rotatePhone.text": "\u7E26\u9577\u306E\u5199\u771F\u3092\u64AE\u5F71\u3059\u308B\u306B\u306F\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u56DE\u8EE2\u3055\u305B\u3066\u304F\u3060\u3055\u3044",
  "dynamicFlows.ControlFeedback.maxLength": "{maxLength}\u6587\u5B57\u4EE5\u4E0B\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ControlFeedback.maximum": "{maximum}\u4EE5\u4E0B\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ControlFeedback.maximumDate": "{maximum}\u307E\u305F\u306F\u305D\u308C\u4EE5\u524D\u306E\u65E5\u4ED8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ControlFeedback.minLength": "{minLength}\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ControlFeedback.minimum": "{minimum}\u4EE5\u4E0A\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ControlFeedback.minimumDate": "{minimum}\u307E\u305F\u306F\u305D\u308C\u4EE5\u964D\u306E\u65E5\u4ED8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ControlFeedback.pattern": "\u6B63\u3057\u3044\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ControlFeedback.patternDate": "\u6B63\u3057\u3044\u5F62\u5F0F\u3067\u65E5\u4ED8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ControlFeedback.required": "\u3053\u306E\u9805\u76EE\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059\u3002",
  "dynamicFlows.ControlFeedback.type": "\u4E0D\u6B63\u306A\u30BF\u30A4\u30D7",
  "dynamicFlows.DefaultErrorMessages.required": "\u3053\u306E\u9805\u76EE\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059\u3002",
  "dynamicFlows.DynamicExternal.retryTitle": "\u30A6\u30A3\u30F3\u30C9\u30A6\u3092\u3082\u3046\u4E00\u5EA6\u958B\u304F",
  "dynamicFlows.DynamicParagraph.copied": "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u3078\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
  "dynamicFlows.DynamicParagraph.copy": "\u30B3\u30D4\u30FC\u3059\u308B",
  "dynamicFlows.ErrorBoundary.errorAlert": "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
  "dynamicFlows.ErrorBoundary.retry": "\u3084\u308A\u76F4\u3059",
  "dynamicFlows.ExternalConfirmation.cancel": "\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B",
  "dynamicFlows.ExternalConfirmation.description": "\u65B0\u3057\u3044\u30D6\u30E9\u30A6\u30B6\u30BF\u30D6\u3067**{origin}**\u3092\u958B\u304F\u3053\u3068\u3092\u627F\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ExternalConfirmation.open": "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
  "dynamicFlows.ExternalConfirmation.title": "\u627F\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "\u5927\u5909\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u304C\u3001\u30D5\u30A1\u30A4\u30EB\u304C\u5927\u304D\u3059\u304E\u307E\u3059\u3002\u3053\u308C\u3088\u308A\u5C0F\u3055\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "\u305D\u306E\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u5225\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.Help.ariaLabel": "\u8A73\u7D30\u306F\u3053\u3061\u3089\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.MultiSelect.summary": "{first}\u3068\u305D\u306E\u4ED6{count}",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "\u5927\u5909\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u304C\u3001\u30D5\u30A1\u30A4\u30EB\u304C\u5927\u304D\u3059\u304E\u307E\u3059\u3002\u3053\u308C\u3088\u308A\u5C0F\u3055\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "{maxItems}\u500B\u4EE5\u4E0B\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "{minItems}\u500B\u4EE5\u4E0A\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.PersistAsyncSchema.genericError": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
  "dynamicFlows.ReadOnlySchema.no": "\u3044\u3044\u3048",
  "dynamicFlows.ReadOnlySchema.yes": "\u306F\u3044",
  "dynamicFlows.SearchLayout.loading": "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026"
};

// src/i18n/pl.json
var pl_default = {
  "dynamicFlows.ArraySchema.addItem": "Zapisz",
  "dynamicFlows.ArraySchema.addItemTitle": "Dodaj pozycj\u0119",
  "dynamicFlows.ArraySchema.editItem": "Zapisz",
  "dynamicFlows.ArraySchema.maxItemsError": "Prosimy doda\u0107 maksymalnie {maxItems}.",
  "dynamicFlows.ArraySchema.minItemsError": "Prosimy doda\u0107 co najmniej {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "Usu\u0144",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Spr\xF3buj ponownie",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Sprawd\u017A po\u0142\u0105czenie i spr\xF3buj ponownie.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "Nie mo\u017Cemy uzyska\u0107 dost\u0119pu do Twojego aparatu",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "Przegl\u0105darka, kt\xF3rej u\u017Cywasz, nie obs\u0142uguje aparatu. Wypr\xF3buj inn\u0105 przegl\u0105dark\u0119 lub urz\u0105dzenie albo pobierz nasz\u0105 aplikacj\u0119 mobiln\u0105.",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Aparat nie jest obs\u0142ugiwany",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "W\u0142\u0105cz dost\u0119p do aparatu",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "W\u0142\u0105cz dost\u0119p do aparatu w ustawieniach przegl\u0105darki, \u017Ceby rozpocz\u0105\u0107 ponownie.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "Nie mo\u017Cemy uzyska\u0107 dost\u0119pu do Twojego aparatu",
  "dynamicFlows.CameraCapture.reviewInstructions": "Czy Twoje zdj\u0119cie jest wyra\u017Ane, czytelne i kompletne?",
  "dynamicFlows.CameraCapture.reviewRetry": "Nie, spr\xF3buj ponownie",
  "dynamicFlows.CameraCapture.reviewSubmit": "Tak, prze\u015Blij",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Obr\xF3\u0107 sw\xF3j telefon do widoku pionowego, \u017Ceby zrobi\u0107 zdj\u0119cie",
  "dynamicFlows.ControlFeedback.maxLength": "Prosimy wprowadzi\u0107 do {maxLength} znak\xF3w.",
  "dynamicFlows.ControlFeedback.maximum": "Wprowad\u017A liczb\u0119 r\xF3wn\u0105 lub mniejsz\u0105 ni\u017C {maximum}.",
  "dynamicFlows.ControlFeedback.maximumDate": "Wprowad\u017A dat\u0119 nie p\xF3\u017Aniejsz\u0105 ni\u017C {maximum}.",
  "dynamicFlows.ControlFeedback.minLength": "Prosz\u0119 wpisa\u0107 co najmniej {minLength} znak\xF3w.",
  "dynamicFlows.ControlFeedback.minimum": "Wprowad\u017A liczb\u0119 r\xF3wn\u0105 lub wi\u0119ksz\u0105 ni\u017C {minimum}.",
  "dynamicFlows.ControlFeedback.minimumDate": "Wprowad\u017A dat\u0119 nie wcze\u015Bniejsz\u0105 ni\u017C {minimum}.",
  "dynamicFlows.ControlFeedback.pattern": "Wprowad\u017A t\u0119 warto\u015B\u0107 w prawid\u0142owym formacie.",
  "dynamicFlows.ControlFeedback.patternDate": "Wprowad\u017A dat\u0119 w prawid\u0142owym formacie.",
  "dynamicFlows.ControlFeedback.required": "Prosz\u0119 wype\u0142ni\u0107 to pole.",
  "dynamicFlows.ControlFeedback.type": "Nieprawid\u0142owy typ",
  "dynamicFlows.DefaultErrorMessages.required": "Prosz\u0119 wype\u0142ni\u0107 to pole.",
  "dynamicFlows.DynamicExternal.retryTitle": "Otw\xF3rz okno ponownie",
  "dynamicFlows.DynamicParagraph.copied": "Skopiowano do schowka",
  "dynamicFlows.DynamicParagraph.copy": "Kopiuj",
  "dynamicFlows.ErrorBoundary.errorAlert": "Co\u015B posz\u0142o nie tak.",
  "dynamicFlows.ErrorBoundary.retry": "Spr\xF3buj ponownie",
  "dynamicFlows.ExternalConfirmation.cancel": "Anuluj",
  "dynamicFlows.ExternalConfirmation.description": "Prosimy potwierdzi\u0107, \u017Ce chcesz otworzy\u0107 **{origin}** w nowej zak\u0142adce przegl\u0105darki.",
  "dynamicFlows.ExternalConfirmation.open": "Otw\xF3rz w nowej zak\u0142adce",
  "dynamicFlows.ExternalConfirmation.title": "Potwierd\u017A",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Przepraszamy, ten plik jest zbyt du\u017Cy. Prze\u015Blij mniejszy plik.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Przepraszamy, ten format pliku nie jest obs\u0142ugiwany. Prosimy przes\u0142a\u0107 inny plik.",
  "dynamicFlows.Help.ariaLabel": "Kliknij tutaj, \u017Ceby uzyska\u0107 wi\u0119cej informacji.",
  "dynamicFlows.MultiSelect.summary": "{first} oraz {count} wi\u0119cej",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Przepraszamy, ten plik jest zbyt du\u017Cy. Prze\u015Blij mniejszy plik.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Prze\u015Blij do {maxItems} plik\xF3w.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Prze\u015Blij co najmniej nast\u0119puj\u0105c\u0105 liczb\u0119 plik\xF3w: {minItems}.",
  "dynamicFlows.PersistAsyncSchema.genericError": "Wyst\u0105pi\u0142 b\u0142\u0105d, prosimy spr\xF3bowa\u0107 ponownie.",
  "dynamicFlows.ReadOnlySchema.no": "Nie",
  "dynamicFlows.ReadOnlySchema.yes": "Tak",
  "dynamicFlows.SearchLayout.loading": "\u0141adowanie..."
};

// src/i18n/pt.json
var pt_default = {
  "dynamicFlows.ArraySchema.addItem": "Salvar",
  "dynamicFlows.ArraySchema.addItemTitle": "Adicionar item",
  "dynamicFlows.ArraySchema.editItem": "Salvar",
  "dynamicFlows.ArraySchema.maxItemsError": "Adicione {maxItems} ou menos.",
  "dynamicFlows.ArraySchema.minItemsError": "Adicione pelo menos {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "Remover",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Tentar novamente",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Verifique se a c\xE2mera est\xE1 conectada e tente novamente.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "N\xE3o temos acesso \xE0 sua c\xE2mera",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "O navegador que voc\xEA est\xE1 usando n\xE3o permite o uso da c\xE2mera. Por favor, tente com outro navegador ou computador, ou baixe o nosso aplicativo",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "C\xE2mera indispon\xEDvel",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Permitir acesso \xE0 c\xE2mera",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Ative o acesso \xE0 c\xE2mera nas configura\xE7\xF5es do navegador para continuar.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "N\xE3o temos acesso \xE0 sua c\xE2mera",
  "dynamicFlows.CameraCapture.reviewInstructions": "A sua foto est\xE1 clara, leg\xEDvel e aparece por inteiro?",
  "dynamicFlows.CameraCapture.reviewRetry": "N\xE3o, tentar novamente",
  "dynamicFlows.CameraCapture.reviewSubmit": "Sim, enviar",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Gire o telefone para o modo retrato para tirar uma foto",
  "dynamicFlows.ControlFeedback.maxLength": "Por favor, insira {maxLength} caracteres ou menos.",
  "dynamicFlows.ControlFeedback.maximum": "Por favor, insira um n\xFAmero que seja {maximum} ou menos.",
  "dynamicFlows.ControlFeedback.maximumDate": "Por favor, insira uma data que seja em ou antes de {maximum}.",
  "dynamicFlows.ControlFeedback.minLength": "Por favor, insira pelo menos {minLength} caracteres.",
  "dynamicFlows.ControlFeedback.minimum": "Por favor, insira um n\xFAmero que seja {minimum} ou mais.",
  "dynamicFlows.ControlFeedback.minimumDate": "Por favor, insira uma data que seja em ou ap\xF3s {minimum}.",
  "dynamicFlows.ControlFeedback.pattern": "Por favor, insira essa informa\xE7\xE3o no formato correto.",
  "dynamicFlows.ControlFeedback.patternDate": "Por favor, insira a data no formato correto.",
  "dynamicFlows.ControlFeedback.required": "Por favor, preencha o campo.",
  "dynamicFlows.ControlFeedback.type": "Tipo incorreto",
  "dynamicFlows.DefaultErrorMessages.required": "Por favor, preencha o campo.",
  "dynamicFlows.DynamicExternal.retryTitle": "Reabrir janela",
  "dynamicFlows.DynamicParagraph.copied": "Copiado",
  "dynamicFlows.DynamicParagraph.copy": "Copiar",
  "dynamicFlows.ErrorBoundary.errorAlert": "Algo deu errado.",
  "dynamicFlows.ErrorBoundary.retry": "Tentar novamente",
  "dynamicFlows.ExternalConfirmation.cancel": "Cancelar",
  "dynamicFlows.ExternalConfirmation.description": "Por favor, confirme que deseja abrir * *{origin}* * em uma nova aba do navegador.",
  "dynamicFlows.ExternalConfirmation.open": "Abrir em uma nova aba",
  "dynamicFlows.ExternalConfirmation.title": "Por favor, confirme",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Este arquivo \xE9 muito grande. Por favor, envie um arquivo menor.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Lamentamos, mas este formato de arquivo n\xE3o \xE9 aceito. Envie um arquivo diferente.",
  "dynamicFlows.Help.ariaLabel": "Clique aqui para mais informa\xE7\xF5es.",
  "dynamicFlows.MultiSelect.summary": "{first} e mais {count} ",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Este arquivo \xE9 muito grande. Por favor, envie um arquivo menor.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Por favor, envie {maxItems} ou menos arquivos.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Por favor, envie pelo menos {minItems} arquivo(s).",
  "dynamicFlows.PersistAsyncSchema.genericError": "Ocorreu um erro. Por favor, tente novamente.",
  "dynamicFlows.ReadOnlySchema.no": "N\xE3o",
  "dynamicFlows.ReadOnlySchema.yes": "Sim",
  "dynamicFlows.SearchLayout.loading": "Carregando..."
};

// src/i18n/ro.json
var ro_default = {
  "dynamicFlows.ArraySchema.addItem": "Salvare",
  "dynamicFlows.ArraySchema.addItemTitle": "Adaug\u0103 produs",
  "dynamicFlows.ArraySchema.editItem": "Salvare",
  "dynamicFlows.ArraySchema.maxItemsError": "Te rug\u0103m s\u0103 adaugi {maxItems} sau mai pu\u021Bine.",
  "dynamicFlows.ArraySchema.minItemsError": "Te rug\u0103m s\u0103 adaugi cel pu\u021Bin {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "Elimin\u0103",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "\xCEncearc\u0103 din nou",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "Te rug\u0103m s\u0103 verifici dac\u0103 este conectat\u0103 \u0219i s\u0103 \xEEncerci din nou.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "Nu \xEE\u021Bi putem accesa camera",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "Browserul pe care \xEEl folose\u0219ti nu poate folosi o camer\u0103 foto. Te rug\u0103m s\u0103 \xEEncerci alt browser, alt dispozitiv sau s\u0103 descarci aplica\u021Bia noastr\u0103.",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Camera nu este acceptat\u0103",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Permite acces la camer\u0103",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Permite accesul la camera foto \xEEn set\u0103rile browserului t\u0103u, pentru a re\xEEncepe.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "Nu \xEE\u021Bi putem accesa camera",
  "dynamicFlows.CameraCapture.reviewInstructions": "Imaginea ta este clar\u0103, lizibil\u0103 \u0219i complet\u0103?",
  "dynamicFlows.CameraCapture.reviewRetry": "Nu, \xEEncearc\u0103 din nou",
  "dynamicFlows.CameraCapture.reviewSubmit": "Da, trimite",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Rote\u0219te-\u021Bi telefonul \xEEn modul portret pentru a face o fotografie",
  "dynamicFlows.ControlFeedback.maxLength": "Te rug\u0103m s\u0103 introduci {maxLength} sau mai pu\u021Bine caractere.",
  "dynamicFlows.ControlFeedback.maximum": "Te rug\u0103m s\u0103 introduci un num\u0103r egal cu {maximum} sau mai mic.",
  "dynamicFlows.ControlFeedback.maximumDate": "Te rug\u0103m s\u0103 introduci o dat\u0103 de \xEEnainte de sau egal\u0103 cu {maximum}.",
  "dynamicFlows.ControlFeedback.minLength": "Te rug\u0103m s\u0103 introduci cel pu\u021Bin {minLength} caractere.",
  "dynamicFlows.ControlFeedback.minimum": "Te rug\u0103m s\u0103 introduci un num\u0103r egal cu {minimum} sau mai mare.",
  "dynamicFlows.ControlFeedback.minimumDate": "Te rug\u0103m s\u0103 introduci o dat\u0103 de dup\u0103 sau egal\u0103 cu {minimum}.",
  "dynamicFlows.ControlFeedback.pattern": "Te rug\u0103m s\u0103 introduci acest lucru \xEEn formatul corect.",
  "dynamicFlows.ControlFeedback.patternDate": "Te rug\u0103m s\u0103 introduci o dat\u0103 \xEEn formatul corect.",
  "dynamicFlows.ControlFeedback.required": "Te rug\u0103m s\u0103 completezi acest spa\u021Biu.",
  "dynamicFlows.ControlFeedback.type": "Tip incorect",
  "dynamicFlows.DefaultErrorMessages.required": "Te rug\u0103m s\u0103 completezi acest spa\u021Biu.",
  "dynamicFlows.DynamicExternal.retryTitle": "Redeschide fereastra",
  "dynamicFlows.DynamicParagraph.copied": "Copiat \xEEn clipboard",
  "dynamicFlows.DynamicParagraph.copy": "Copiaz\u0103",
  "dynamicFlows.ErrorBoundary.errorAlert": "Ceva nu a mers bine.",
  "dynamicFlows.ErrorBoundary.retry": "\xCEncearc\u0103 din nou",
  "dynamicFlows.ExternalConfirmation.cancel": "Anuleaz\u0103",
  "dynamicFlows.ExternalConfirmation.description": "Te rug\u0103m s\u0103 confirmi c\u0103 vrei s\u0103 deschizi **{origin}** \xEEntr-o nou\u0103 fil\u0103 a browserului.",
  "dynamicFlows.ExternalConfirmation.open": "Deschide \xEEntr-o fil\u0103 nou\u0103",
  "dynamicFlows.ExternalConfirmation.title": "Te rug\u0103m s\u0103 confirmi",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "Ne pare r\u0103u, acel fi\u0219ier este prea mare. Te rug\u0103m s\u0103 \xEEncarci un fi\u0219ier mai mic.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "Ne pare r\u0103u, acest format de fi\u0219ier nu este acceptat. Te rug\u0103m s\u0103 \xEEncarci un alt fi\u0219ier.",
  "dynamicFlows.Help.ariaLabel": "D\u0103 click aici pentru mai multe informa\u021Bii.",
  "dynamicFlows.MultiSelect.summary": "{first} \u0219i \xEEnc\u0103 {count}",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "Ne pare r\u0103u, acel fi\u0219ier este prea mare. Te rug\u0103m s\u0103 \xEEncarci un fi\u0219ier mai mic.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "Te rug\u0103m s\u0103 \xEEncarci {maxItems} fi\u0219iere sau mai pu\u021Bine.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "Te rug\u0103m s\u0103 \xEEncarci cel pu\u021Bin {minItems} fi\u0219ier(e).",
  "dynamicFlows.PersistAsyncSchema.genericError": "Ceva nu a mers bine, te rug\u0103m s\u0103 \xEEncerci din nou.",
  "dynamicFlows.ReadOnlySchema.no": "Nu",
  "dynamicFlows.ReadOnlySchema.yes": "Da",
  "dynamicFlows.SearchLayout.loading": "Se \xEEncarc\u0103..."
};

// src/i18n/ru.json
var ru_default = {
  "dynamicFlows.ArraySchema.addItem": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
  "dynamicFlows.ArraySchema.addItemTitle": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u043D\u043A\u0442",
  "dynamicFlows.ArraySchema.editItem": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
  "dynamicFlows.ArraySchema.maxItemsError": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 {maxItems} \u0438\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435.",
  "dynamicFlows.ArraySchema.minItemsError": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 {minItems}.",
  "dynamicFlows.ArraySchema.removeItem": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435, \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0430 \u043B\u0438 \u043A\u0430\u043C\u0435\u0440\u0430, \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "\u041C\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u043C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u0439 \u043A\u0430\u043C\u0435\u0440\u0435",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0439 \u0432\u0430\u043C\u0438 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043A\u0430\u043C\u0435\u0440\u0443. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438\u043B\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E, \u0438\u043B\u0438 \u0441\u043A\u0430\u0447\u0430\u0439\u0442\u0435 \u043D\u0430\u0448\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435.",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "\u041A\u0430\u043C\u0435\u0440\u0430 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043C\u0435\u0440\u0435",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043C\u0435\u0440\u0435 \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "\u041C\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u043C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u0439 \u043A\u0430\u043C\u0435\u0440\u0435",
  "dynamicFlows.CameraCapture.reviewInstructions": "\u0412\u0430\u0448\u0430 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u044F \u0447\u0435\u0442\u043A\u0430\u044F, \u043B\u0435\u0433\u043A\u043E \u0447\u0438\u0442\u0430\u0435\u043C\u0430\u044F \u0438 \u043D\u0435 \u043E\u0431\u0440\u0435\u0437\u0430\u043D\u0430?",
  "dynamicFlows.CameraCapture.reviewRetry": "\u041D\u0435\u0442, \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437",
  "dynamicFlows.CameraCapture.reviewSubmit": "\u0414\u0430, \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
  "dynamicFlows.CameraCapture.rotatePhone.text": "\u041F\u043E\u0432\u0435\u0440\u043D\u0438\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0432 \u043F\u043E\u0440\u0442\u0440\u0435\u0442\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C, \u0447\u0442\u043E\u0431\u044B \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u044E",
  "dynamicFlows.ControlFeedback.maxLength": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 {maxLength} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u0438\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435.",
  "dynamicFlows.ControlFeedback.maximum": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E, \u0440\u0430\u0432\u043D\u043E\u0435 {maximum} \u0438\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435.",
  "dynamicFlows.ControlFeedback.maximumDate": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443, \u0440\u0430\u0432\u043D\u0443\u044E {maximum} \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0440\u0430\u043D\u043D\u044E\u044E.",
  "dynamicFlows.ControlFeedback.minLength": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 {minLength} \u0441\u0438\u043C\u0432\u043E\u043B\u0430(-\u043E\u0432).",
  "dynamicFlows.ControlFeedback.minimum": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E, \u0440\u0430\u0432\u043D\u043E\u0435 {minimum} \u0438\u043B\u0438 \u0431\u043E\u043B\u044C\u0448\u0435.",
  "dynamicFlows.ControlFeedback.minimumDate": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443, \u0440\u0430\u0432\u043D\u0443\u044E {minimum} \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u043F\u043E\u0437\u0434\u043D\u044E\u044E.",
  "dynamicFlows.ControlFeedback.pattern": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u044D\u0442\u043E \u0432 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435.",
  "dynamicFlows.ControlFeedback.patternDate": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u0432 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435.",
  "dynamicFlows.ControlFeedback.required": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u043E\u0435 \u043F\u043E\u043B\u0435.",
  "dynamicFlows.ControlFeedback.type": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0442\u0438\u043F",
  "dynamicFlows.DefaultErrorMessages.required": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u043E\u0435 \u043F\u043E\u043B\u0435.",
  "dynamicFlows.DynamicExternal.retryTitle": "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043E\u043A\u043D\u043E",
  "dynamicFlows.DynamicParagraph.copied": "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
  "dynamicFlows.DynamicParagraph.copy": "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
  "dynamicFlows.ErrorBoundary.errorAlert": "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A.",
  "dynamicFlows.ErrorBoundary.retry": "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
  "dynamicFlows.ExternalConfirmation.cancel": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
  "dynamicFlows.ExternalConfirmation.description": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044C **{origin}** \u0432 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430.",
  "dynamicFlows.ExternalConfirmation.open": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435",
  "dynamicFlows.ExternalConfirmation.title": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u0444\u0430\u0439\u043B \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u043E\u0439. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u043C\u0435\u043D\u044C\u0448\u0435\u0433\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0430.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "\u042D\u0442\u043E\u0442 \u0444\u043E\u0440\u043C\u0430\u0442 \u0444\u0430\u0439\u043B\u0430 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F. \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439 \u0444\u0430\u0439\u043B.",
  "dynamicFlows.Help.ariaLabel": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.",
  "dynamicFlows.MultiSelect.summary": "{first} \u0438 \u0435\u0449\u0435 {count} \u0434\u0440\u0443\u0433\u0438\u0445",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u0444\u0430\u0439\u043B \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u043E\u0439. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u043C\u0435\u043D\u044C\u0448\u0435\u0433\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0430.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 {maxItems} \u0444\u0430\u0439\u043B\u043E\u0432.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 {minItems} \u0444\u0430\u0439\u043B(-\u0430/\u043E\u0432).",
  "dynamicFlows.PersistAsyncSchema.genericError": "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437.",
  "dynamicFlows.ReadOnlySchema.no": "\u041D\u0435\u0442",
  "dynamicFlows.ReadOnlySchema.yes": "\u0414\u0430",
  "dynamicFlows.SearchLayout.loading": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
};

// src/i18n/th.json
var th_default = {
  "dynamicFlows.ArraySchema.addItem": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
  "dynamicFlows.ArraySchema.addItemTitle": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "dynamicFlows.ArraySchema.editItem": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
  "dynamicFlows.ArraySchema.maxItemsError": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21 {maxItems} \u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "dynamicFlows.ArraySchema.minItemsError": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 {minItems}",
  "dynamicFlows.ArraySchema.removeItem": "\u0E25\u0E1A",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E43\u0E2B\u0E21\u0E48\u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E01\u0E25\u0E49\u0E2D\u0E07 \u0E43\u0E2B\u0E49\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E41\u0E2D\u0E1B\u0E21\u0E37\u0E2D\u0E16\u0E37\u0E2D\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E14\u0E39",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E01\u0E25\u0E49\u0E2D\u0E07",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49",
  "dynamicFlows.CameraCapture.reviewInstructions": "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19 \u0E2D\u0E48\u0E32\u0E19\u0E44\u0E14\u0E49 \u0E41\u0E25\u0E30\u0E04\u0E23\u0E1A\u0E16\u0E49\u0E27\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
  "dynamicFlows.CameraCapture.reviewRetry": "\u0E44\u0E21\u0E48 \u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E17\u0E31\u0E49\u0E07",
  "dynamicFlows.CameraCapture.reviewSubmit": "\u0E43\u0E0A\u0E48 \u0E2A\u0E48\u0E07\u0E40\u0E25\u0E22",
  "dynamicFlows.CameraCapture.rotatePhone.text": "\u0E2B\u0E21\u0E38\u0E19\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E21\u0E38\u0E21\u0E41\u0E19\u0E27\u0E15\u0E31\u0E49\u0E07\u0E41\u0E25\u0E49\u0E27\u0E16\u0E48\u0E32\u0E22\u0E23\u0E39\u0E1B",
  "dynamicFlows.ControlFeedback.maxLength": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19 {maxLength} \u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "dynamicFlows.ControlFeedback.maximum": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 {maximum} \u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "dynamicFlows.ControlFeedback.maximumDate": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E15\u0E23\u0E07\u0E1E\u0E2D\u0E14\u0E35\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E48\u0E2D\u0E19 {maximum}",
  "dynamicFlows.ControlFeedback.minLength": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 {minLength} \u0E15\u0E31\u0E27",
  "dynamicFlows.ControlFeedback.minimum": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 {minimum} \u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32",
  "dynamicFlows.ControlFeedback.minimumDate": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E15\u0E23\u0E07\u0E1E\u0E2D\u0E14\u0E35\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E25\u0E31\u0E07 {minimum}",
  "dynamicFlows.ControlFeedback.pattern": "\u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2A\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
  "dynamicFlows.ControlFeedback.patternDate": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
  "dynamicFlows.ControlFeedback.required": "\u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2A\u0E48\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49",
  "dynamicFlows.ControlFeedback.type": "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
  "dynamicFlows.DefaultErrorMessages.required": "\u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2A\u0E48\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49",
  "dynamicFlows.DynamicExternal.retryTitle": "\u0E40\u0E1B\u0E34\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
  "dynamicFlows.DynamicParagraph.copied": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14",
  "dynamicFlows.DynamicParagraph.copy": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
  "dynamicFlows.ErrorBoundary.errorAlert": "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19",
  "dynamicFlows.ErrorBoundary.retry": "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
  "dynamicFlows.ExternalConfirmation.cancel": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
  "dynamicFlows.ExternalConfirmation.description": "\u0E42\u0E1B\u0E23\u0E14\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14 **{origin}** \u0E40\u0E1B\u0E47\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C",
  "dynamicFlows.ExternalConfirmation.open": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E43\u0E2B\u0E21\u0E48",
  "dynamicFlows.ExternalConfirmation.title": "\u0E42\u0E1B\u0E23\u0E14\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E44\u0E1F\u0E25\u0E4C\u0E19\u0E31\u0E49\u0E19\u0E43\u0E2B\u0E0D\u0E48\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E40\u0E25\u0E47\u0E01\u0E25\u0E07",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E1F\u0E25\u0E4C\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E2D\u0E37\u0E48\u0E19",
  "dynamicFlows.Help.ariaLabel": "\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
  "dynamicFlows.MultiSelect.summary": "{first} \u0E41\u0E25\u0E30\u0E2D\u0E35\u0E01 {count}",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E44\u0E1F\u0E25\u0E4C\u0E19\u0E31\u0E49\u0E19\u0E43\u0E2B\u0E0D\u0E48\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E40\u0E25\u0E47\u0E01\u0E25\u0E07",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14 {maxItems} \u0E44\u0E1F\u0E25\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 {minItems} \u0E44\u0E1F\u0E25\u0E4C",
  "dynamicFlows.PersistAsyncSchema.genericError": "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
  "dynamicFlows.ReadOnlySchema.no": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48",
  "dynamicFlows.ReadOnlySchema.yes": "\u0E43\u0E0A\u0E48",
  "dynamicFlows.SearchLayout.loading": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14..."
};

// src/i18n/tr.json
var tr_default = {
  "dynamicFlows.ArraySchema.addItem": "Kaydet",
  "dynamicFlows.ArraySchema.addItemTitle": "\xD6ge ekle",
  "dynamicFlows.ArraySchema.editItem": "Kaydet",
  "dynamicFlows.ArraySchema.maxItemsError": "L\xFCtfen {maxItems} veya daha az ekleme yap\u0131n",
  "dynamicFlows.ArraySchema.minItemsError": "L\xFCtfen en az {minItems} ekleme yap\u0131n.",
  "dynamicFlows.ArraySchema.removeItem": "Kald\u0131r",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "Tekrar deneyin",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "L\xFCtfen ba\u011Fl\u0131 olup olmad\u0131\u011F\u0131n\u0131 kontrol edip tekrar deneyin.",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "Kameran\u0131za eri\u015Femiyoruz",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "Kulland\u0131\u011F\u0131n\u0131z taray\u0131c\u0131da kamera deste\u011Fi yok. Farkl\u0131 bir taray\u0131c\u0131 / cihaz deneyin veya mobil uygulamam\u0131z\u0131 indirin.",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "Kamera desteklenmiyor",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "Kamera eri\u015Fimi verin",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "Tekrar ba\u015Flamak i\xE7in taray\u0131c\u0131n\u0131z\u0131n ayarlar\u0131nda kamera eri\u015Fimini etkinle\u015Ftirin.",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "Kameran\u0131za eri\u015Femiyoruz",
  "dynamicFlows.CameraCapture.reviewInstructions": "Foto\u011Fraf\u0131n\u0131z net, okunakl\u0131 ve eksiksiz mi?",
  "dynamicFlows.CameraCapture.reviewRetry": "Hay\u0131r, tekrar dene",
  "dynamicFlows.CameraCapture.reviewSubmit": "Evet, g\xF6nder",
  "dynamicFlows.CameraCapture.rotatePhone.text": "Foto\u011Fraf \xE7ekmek i\xE7in telefonunuzu dik pozisyonda tutun",
  "dynamicFlows.ControlFeedback.maxLength": "L\xFCtfen {maxLength} veya daha az karakter girin.",
  "dynamicFlows.ControlFeedback.maximum": "L\xFCtfen {maximum} veya daha d\xFC\u015F\xFCk bir say\u0131 girin.",
  "dynamicFlows.ControlFeedback.maximumDate": "L\xFCtfen {maximum} veya daha erken bir tarih girin.",
  "dynamicFlows.ControlFeedback.minLength": "En az {minLength} karakter girebilirsiniz.",
  "dynamicFlows.ControlFeedback.minimum": "L\xFCtfen {minimum} veya daha y\xFCksek bir say\u0131 girin.",
  "dynamicFlows.ControlFeedback.minimumDate": "L\xFCtfen {minimum} veya daha ge\xE7 bir tarih girin.",
  "dynamicFlows.ControlFeedback.pattern": "Yanl\u0131\u015F bi\xE7im",
  "dynamicFlows.ControlFeedback.patternDate": "L\xFCtfen tarihi do\u011Fru bi\xE7imde girin.",
  "dynamicFlows.ControlFeedback.required": "L\xFCtfen bu alan\u0131 doldurun.",
  "dynamicFlows.ControlFeedback.type": "Ge\xE7ersiz se\xE7im",
  "dynamicFlows.DefaultErrorMessages.required": "L\xFCtfen bu alan\u0131 doldurun.",
  "dynamicFlows.DynamicExternal.retryTitle": "Pencereyi yeniden a\xE7",
  "dynamicFlows.DynamicParagraph.copied": "Panoya kopyaland\u0131",
  "dynamicFlows.DynamicParagraph.copy": "Kopyala",
  "dynamicFlows.ErrorBoundary.errorAlert": "Bir sorun olu\u015Ftu.",
  "dynamicFlows.ErrorBoundary.retry": "Tekrar dene",
  "dynamicFlows.ExternalConfirmation.cancel": "\u0130ptal edin",
  "dynamicFlows.ExternalConfirmation.description": "L\xFCtfen yeni bir taray\u0131c\u0131 sekmesinde **{origin}** a\xE7mak istedi\u011Finizi onaylay\u0131n.",
  "dynamicFlows.ExternalConfirmation.open": "Yeni sekmede a\xE7",
  "dynamicFlows.ExternalConfirmation.title": "L\xFCtfen onaylay\u0131n",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "\xDCzg\xFCn\xFCz, bu dosya \xE7ok b\xFCy\xFCk. L\xFCtfen daha k\xFC\xE7\xFCk bir dosya y\xFCkleyin.",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "\xDCzg\xFCn\xFCz, bu dosya bi\xE7imi desteklenmiyor. L\xFCtfen farkl\u0131 bir dosya y\xFCkleyin.",
  "dynamicFlows.Help.ariaLabel": "Ayr\u0131nt\u0131lar i\xE7in t\u0131klay\u0131n.",
  "dynamicFlows.MultiSelect.summary": "{first} ve {count} daha",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "\xDCzg\xFCn\xFCz, bu dosya \xE7ok b\xFCy\xFCk. L\xFCtfen daha k\xFC\xE7\xFCk bir dosya y\xFCkleyin.",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "L\xFCtfen {maxItems} veya daha az dosya y\xFCkleyin.",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "L\xFCtfen en az {minItems} dosya y\xFCkleyin.",
  "dynamicFlows.PersistAsyncSchema.genericError": "Bir \u015Feyler ters gitti, l\xFCtfen tekrar deneyin.",
  "dynamicFlows.ReadOnlySchema.no": "Hay\u0131r",
  "dynamicFlows.ReadOnlySchema.yes": "Evet",
  "dynamicFlows.SearchLayout.loading": "Y\xFCkleniyor..."
};

// src/i18n/zh_CN.json
var zh_CN_default = {
  "dynamicFlows.ArraySchema.addItem": "\u4FDD\u5B58",
  "dynamicFlows.ArraySchema.addItemTitle": "\u6DFB\u52A0\u9879\u76EE",
  "dynamicFlows.ArraySchema.editItem": "\u4FDD\u5B58",
  "dynamicFlows.ArraySchema.maxItemsError": "\u8BF7\u6DFB\u52A0\u4E0D\u8D85\u8FC7 {maxItems} \u9879\u3002",
  "dynamicFlows.ArraySchema.minItemsError": "\u8BF7\u81F3\u5C11\u6DFB\u52A0 {minItems} \u9879\u3002",
  "dynamicFlows.ArraySchema.removeItem": "\u79FB\u9664",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "\u91CD\u8BD5",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "\u8BF7\u68C0\u67E5\u662F\u5426\u8FDE\u63A5\uFF0C\u7136\u540E\u91CD\u8BD5\u3002",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "\u6211\u4EEC\u65E0\u6CD5\u8BBF\u95EE\u60A8\u7684\u6444\u50CF\u5934",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "\u60A8\u76EE\u524D\u4F7F\u7528\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u6444\u50CF\u5934\u3002\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u6D4F\u89C8\u5668\u3001\u8BBE\u5907\u6216\u4E0B\u8F7D\u6211\u4EEC\u7684\u5E94\u7528\u3002",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "\u4E0D\u652F\u6301\u6444\u50CF\u5934",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "\u5141\u8BB8\u8BBF\u95EE\u6444\u50CF\u5934",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "\u5728\u6D4F\u89C8\u5668\u8BBE\u7F6E\u4E2D\u542F\u7528\u76F8\u673A\u8BBF\u95EE\u6743\u9650\uFF0C\u518D\u91CD\u65B0\u5C1D\u8BD5\u3002",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "\u6211\u4EEC\u65E0\u6CD5\u8BBF\u95EE\u60A8\u7684\u6444\u50CF\u5934",
  "dynamicFlows.CameraCapture.reviewInstructions": "\u60A8\u7684\u56FE\u7247\u662F\u5426\u6E05\u6670\u3001\u53EF\u8BFB\u548C\u5B8C\u6574\uFF1F",
  "dynamicFlows.CameraCapture.reviewRetry": "\u5426\uFF0C\u518D\u8BD5\u4E00\u6B21",
  "dynamicFlows.CameraCapture.reviewSubmit": "\u662F\uFF0C\u63D0\u4EA4",
  "dynamicFlows.CameraCapture.rotatePhone.text": "\u5C06\u624B\u673A\u65CB\u8F6C\u5230\u7EB5\u5411\u89C6\u56FE\u4EE5\u62CD\u7167",
  "dynamicFlows.ControlFeedback.maxLength": "\u8BF7\u8F93\u5165\u4E0D\u8D85\u8FC7 {maxLength} \u4E2A\u5B57\u7B26\u3002",
  "dynamicFlows.ControlFeedback.maximum": "\u8BF7\u8F93\u5165\u4E00\u4E2A\u5C0F\u4E8E\u6216\u7B49\u4E8E {maximum} \u7684\u6570\u5B57\u3002",
  "dynamicFlows.ControlFeedback.maximumDate": "\u8BF7\u8F93\u5165 {maximum} \u6216\u4E4B\u524D\u7684\u65E5\u671F",
  "dynamicFlows.ControlFeedback.minLength": "\u8BF7\u81F3\u5C11\u8F93\u5165 {minLength} \u4E2A\u5B57\u7B26",
  "dynamicFlows.ControlFeedback.minimum": "\u8BF7\u8F93\u5165\u4E00\u4E2A\u5927\u4E8E\u6216\u7B49\u4E8E {minimum} \u7684\u6570\u5B57",
  "dynamicFlows.ControlFeedback.minimumDate": "\u8BF7\u8F93\u5165 {minimum} \u6216\u4E4B\u540E\u7684\u65E5\u671F",
  "dynamicFlows.ControlFeedback.pattern": "\u8BF7\u4EE5\u6B63\u786E\u7684\u683C\u5F0F\u8F93\u5165",
  "dynamicFlows.ControlFeedback.patternDate": "\u8BF7\u4EE5\u6B63\u786E\u7684\u683C\u5F0F\u8F93\u5165\u65E5\u671F",
  "dynamicFlows.ControlFeedback.required": "\u8BF7\u586B\u5199\u6B64\u5B57\u6BB5\u3002",
  "dynamicFlows.ControlFeedback.type": "\u7C7B\u578B\u9519\u8BEF",
  "dynamicFlows.DefaultErrorMessages.required": "\u8BF7\u586B\u5199\u6B64\u5B57\u6BB5\u3002",
  "dynamicFlows.DynamicExternal.retryTitle": "\u91CD\u65B0\u6253\u5F00\u7A97\u53E3",
  "dynamicFlows.DynamicParagraph.copied": "\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
  "dynamicFlows.DynamicParagraph.copy": "\u590D\u5236",
  "dynamicFlows.ErrorBoundary.errorAlert": "\u51FA\u9519\u4E86\u3002",
  "dynamicFlows.ErrorBoundary.retry": "\u91CD\u8BD5",
  "dynamicFlows.ExternalConfirmation.cancel": "\u53D6\u6D88",
  "dynamicFlows.ExternalConfirmation.description": "\u8BF7\u786E\u8BA4\u60A8\u662F\u5426\u8981\u5728\u65B0\u6807\u7B7E\u9875\u4E2D\u6253\u5F00**{origin}**\u3002",
  "dynamicFlows.ExternalConfirmation.open": "\u5728\u65B0\u6807\u7B7E\u9875\u4E2D\u6253\u5F00",
  "dynamicFlows.ExternalConfirmation.title": "\u8BF7\u786E\u8BA4",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "\u62B1\u6B49\uFF0C\u8BE5\u6587\u4EF6\u592A\u5927\u3002\u8BF7\u4E0A\u4F20\u4E00\u4E2A\u66F4\u5C0F\u7684\u6587\u4EF6\u3002",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "\u62B1\u6B49\uFF0C\u4E0D\u652F\u6301\u8BE5\u6587\u4EF6\u683C\u5F0F\u3002\u8BF7\u4E0A\u4F20\u5176\u4ED6\u6587\u4EF6\u3002",
  "dynamicFlows.Help.ariaLabel": "\u70B9\u51FB\u6B64\u5904\u83B7\u53D6\u66F4\u591A\u4FE1\u606F\u3002",
  "dynamicFlows.MultiSelect.summary": "{first} \u548C\u5176\u4ED6 {count} \u4E2A",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "\u62B1\u6B49\uFF0C\u8BE5\u6587\u4EF6\u592A\u5927\u3002\u8BF7\u4E0A\u4F20\u4E00\u4E2A\u66F4\u5C0F\u7684\u6587\u4EF6\u3002",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "\u8BF7\u4E0A\u4F20\u4E0D\u8D85\u8FC7 {maxItems} \u4E2A\u6587\u4EF6\u3002",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "\u8BF7\u4E0A\u4F20\u81F3\u5C11 {minItems} \u4E2A\u6587\u4EF6\u3002",
  "dynamicFlows.PersistAsyncSchema.genericError": "\u51FA\u9519\u4E86\uFF0C\u8BF7\u91CD\u8BD5\u3002",
  "dynamicFlows.ReadOnlySchema.no": "\u5426",
  "dynamicFlows.ReadOnlySchema.yes": "\u662F",
  "dynamicFlows.SearchLayout.loading": "\u6B63\u5728\u52A0\u8F7D\u2026"
};

// src/i18n/zh_HK.json
var zh_HK_default = {
  "dynamicFlows.ArraySchema.addItem": "\u5132\u5B58",
  "dynamicFlows.ArraySchema.addItemTitle": "\u6DFB\u52A0\u9805\u76EE",
  "dynamicFlows.ArraySchema.editItem": "\u5132\u5B58",
  "dynamicFlows.ArraySchema.maxItemsError": "\u8ACB\u6DFB\u52A0\u4E0D\u8D85\u904E{maxItems}\u9805\u3002",
  "dynamicFlows.ArraySchema.minItemsError": "\u8ACB\u81F3\u5C11\u6DFB\u52A0{minItems}\u9805\u3002",
  "dynamicFlows.ArraySchema.removeItem": "\u79FB\u9664",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.action": "\u518D\u8A66\u4E00\u6B21",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph": "\u8ACB\u6AA2\u67E5\u9023\u7DDA\u72C0\u614B\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
  "dynamicFlows.CameraCapture.CameraConnectionIssue.title": "\u6211\u5011\u7121\u6CD5\u53D6\u7528\u4F60\u7684\u76F8\u6A5F",
  "dynamicFlows.CameraCapture.CameraNotSupported.paragraph": "\u4F60\u76EE\u524D\u4F7F\u7528\u7684\u700F\u89BD\u5668\u4E0D\u652F\u6301\u76F8\u6A5F\u3002\u8ACB\u5617\u8A66\u4F7F\u7528\u5176\u4ED6\u700F\u89BD\u5668\u6216\u5176\u4ED6\u88DD\u7F6E\uFF0C\u6216\u8005\u4F60\u53EF\u4EE5\u4E0B\u8F09\u6211\u5011\u7684\u61C9\u7528\u7A0B\u5F0F\u3002",
  "dynamicFlows.CameraCapture.CameraNotSupported.title": "\u4E0D\u652F\u6301\u76F8\u6A5F",
  "dynamicFlows.CameraCapture.NoCameraAccess.action": "\u5141\u8A31\u53D6\u7528\u76F8\u6A5F",
  "dynamicFlows.CameraCapture.NoCameraAccess.paragraph": "\u4F60\u53EF\u4EE5\u5728\u700F\u89BD\u5668\u7684\u8A2D\u5B9A\u4E2D\u958B\u555F\u76F8\u6A5F\u5B58\u53D6\u6B0A\u9650\u3002",
  "dynamicFlows.CameraCapture.NoCameraAccess.title": "\u6211\u5011\u7121\u6CD5\u53D6\u7528\u4F60\u7684\u76F8\u6A5F",
  "dynamicFlows.CameraCapture.reviewInstructions": "\u4F60\u7684\u7167\u7247\u662F\u5426\u5B8C\u6574\u3001\u6E05\u6670\u53CA\u53EF\u8B80\uFF1F",
  "dynamicFlows.CameraCapture.reviewRetry": "\u5426\uFF0C\u518D\u8A66\u4E00\u6B21",
  "dynamicFlows.CameraCapture.reviewSubmit": "\u662F\uFF0C\u63D0\u4EA4",
  "dynamicFlows.CameraCapture.rotatePhone.text": "\u5C07\u624B\u6A5F\u65CB\u8F49\u81F3\u5782\u76F4\u756B\u9762\u4EE5\u62CD\u7167",
  "dynamicFlows.ControlFeedback.maxLength": "\u8ACB\u8F38\u5165\u6700\u591A{maxLength}\u500B\u5B57\u5143\u3002",
  "dynamicFlows.ControlFeedback.maximum": "\u8ACB\u8F38\u5165\u4E00\u500B\u5C0F\u65BC\u6216\u7B49\u65BC{maximum}\u7684\u6578\u5B57\u3002",
  "dynamicFlows.ControlFeedback.maximumDate": "\u8ACB\u8F38\u5165{maximum}\u6216\u4E4B\u524D\u7684\u65E5\u671F\u3002",
  "dynamicFlows.ControlFeedback.minLength": "\u8ACB\u8F38\u5165\u81F3\u5C11{minLength}\u500B\u5B57\u5143\u3002",
  "dynamicFlows.ControlFeedback.minimum": "\u8ACB\u8F38\u5165\u4E00\u500B\u5927\u65BC\u6216\u7B49\u65BC{minimum}\u7684\u6578\u5B57\u3002",
  "dynamicFlows.ControlFeedback.minimumDate": "\u8ACB\u8F38\u5165{minimum}\u6216\u4E4B\u5F8C\u7684\u65E5\u671F\u3002",
  "dynamicFlows.ControlFeedback.pattern": "\u8ACB\u4EE5\u6B63\u78BA\u683C\u5F0F\u8F38\u5165\u5185\u5BB9\u3002",
  "dynamicFlows.ControlFeedback.patternDate": "\u8ACB\u4EE5\u6B63\u78BA\u683C\u5F0F\u8F38\u5165\u65E5\u671F\u3002",
  "dynamicFlows.ControlFeedback.required": "\u8ACB\u586B\u5BEB\u6B64\u6B04\u4F4D\u3002",
  "dynamicFlows.ControlFeedback.type": "\u932F\u8AA4\u7684\u985E\u578B",
  "dynamicFlows.DefaultErrorMessages.required": "\u8ACB\u586B\u5BEB\u6B64\u6B04\u4F4D\u3002",
  "dynamicFlows.DynamicExternal.retryTitle": "\u91CD\u65B0\u6253\u958B\u8996\u7A97",
  "dynamicFlows.DynamicParagraph.copied": "\u8907\u88FD\u5230\u526A\u8CBC\u677F",
  "dynamicFlows.DynamicParagraph.copy": "\u8907\u88FD",
  "dynamicFlows.ErrorBoundary.errorAlert": "\u51FA\u4E86\u4E9B\u554F\u984C\u3002",
  "dynamicFlows.ErrorBoundary.retry": "\u91CD\u8A66",
  "dynamicFlows.ExternalConfirmation.cancel": "\u53D6\u6D88",
  "dynamicFlows.ExternalConfirmation.description": "\u8ACB\u78BA\u8A8D\u4F60\u662F\u5426\u8981\u5728\u700F\u89BD\u5668\u7684\u65B0\u5206\u9801\u6253\u958B**{origin}**\u3002",
  "dynamicFlows.ExternalConfirmation.open": "\u5728\u65B0\u5206\u9801\u4E2D\u958B\u555F",
  "dynamicFlows.ExternalConfirmation.title": "\u8ACB\u78BA\u8A8D",
  "dynamicFlows.FileUploadSchema.maxFileSizeError": "\u62B1\u6B49\uFF0C\u8A72\u6A94\u6848\u592A\u5927\u3002\u8ACB\u4E0A\u8F09\u4E00\u500B\u8F03\u5C0F\u7684\u6A94\u6848\u3002",
  "dynamicFlows.FileUploadSchema.wrongFileTypeError": "\u62B1\u6B49\uFF0C\u7CFB\u7D71\u4E0D\u652F\u63F4\u8A72\u6A94\u6848\u3002\u8ACB\u4E0A\u8F09\u5176\u4ED6\u6A94\u6848\u3002",
  "dynamicFlows.Help.ariaLabel": "\u6309\u6B64\u67E5\u770B\u8A73\u60C5\u3002",
  "dynamicFlows.MultiSelect.summary": "{first}\u548C\u5176\u4ED6{count}\u9805",
  "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError": "\u62B1\u6B49\uFF0C\u8A72\u6A94\u6848\u592A\u5927\u3002\u8ACB\u4E0A\u8F09\u4E00\u500B\u8F03\u5C0F\u7684\u6A94\u6848\u3002",
  "dynamicFlows.MultipleFileUploadSchema.maxItemsError": "\u8ACB\u4E0D\u8981\u4E0A\u8F09\u8D85\u904E{maxItems}\u500B\u6A94\u6848\u3002",
  "dynamicFlows.MultipleFileUploadSchema.minItemsError": "\u8ACB\u4E0A\u8F09\u81F3\u5C11{minItems}\u500B\u6A94\u6848\u3002",
  "dynamicFlows.PersistAsyncSchema.genericError": "\u51FA\u73FE\u4E86\u554F\u984C\uFF0C\u8ACB\u518D\u8A66\u4E00\u6B21\u3002",
  "dynamicFlows.ReadOnlySchema.no": "\u5426",
  "dynamicFlows.ReadOnlySchema.yes": "\u662F",
  "dynamicFlows.SearchLayout.loading": "\u8F09\u5165\u4E2D\u2026"
};

// src/i18n/index.ts
var translations = {
  en: en_default,
  de: de_default,
  es: es_default,
  fr: fr_default,
  hu: hu_default,
  id: id_default,
  it: it_default,
  ja: ja_default,
  pl: pl_default,
  pt: pt_default,
  ro: ro_default,
  ru: ru_default,
  th: th_default,
  tr: tr_default,
  zh: zh_CN_default,
  "zh-CN": zh_CN_default,
  "zh-HK": zh_HK_default
};
var i18n_default = translations;

// src/revamp/DynamicFlowCore.tsx
import { useMemo as useMemo2 } from "react";

// src/common/errorBoundary/ErrorBoundary.tsx
import { Component } from "react";

// src/common/errorBoundary/ErrorBoundaryAlert.tsx
import { Alert, Sentiment } from "@transferwise/components";
import { useIntl } from "react-intl";

// src/common/messages/generic-error.messages.ts
import { defineMessages } from "react-intl";
var generic_error_messages_default = defineMessages({
  genericErrorRetryHint: {
    id: "dynamicFlows.PersistAsyncSchema.genericError",
    defaultMessage: "Something went wrong, please try again.",
    description: "Generic error message for persist async schema"
  },
  genericError: {
    id: "dynamicFlows.ErrorBoundary.errorAlert",
    defaultMessage: "Something went wrong.",
    description: "Generic error message for when something has gone wrong."
  },
  retry: {
    id: "dynamicFlows.ErrorBoundary.retry",
    defaultMessage: "Retry",
    description: "Usually this follows the generic error and contains a link."
  }
});

// src/common/errorBoundary/ErrorBoundaryAlert.tsx
import { jsx } from "react/jsx-runtime";
function ErrorBoundaryAlert({ onDismiss }) {
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ jsx(
    Alert,
    {
      action: {
        text: formatMessage(generic_error_messages_default.retry),
        href: window.location.href
      },
      message: formatMessage(generic_error_messages_default.genericError),
      type: Sentiment.NEGATIVE,
      className: "m-b-3",
      onDismiss
    }
  );
}

// src/common/errorBoundary/ErrorBoundary.tsx
import { Fragment, jsx as jsx2, jsxs } from "react/jsx-runtime";
var noop = () => {
};
var ErrorBoundary = class extends Component {
  constructor(props) {
    super(props);
    this.handleErrorReset = () => {
      this.setState({ hasError: false, isFatalError: false });
    };
    this.state = { hasError: false, isFatalError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true, isFatalError: true };
  }
  componentDidCatch(error) {
    const { onError = noop } = this.props;
    onError(error);
  }
  render() {
    const { children } = this.props;
    const { hasError, isFatalError } = this.state;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      hasError && /* @__PURE__ */ jsx2(ErrorBoundaryAlert, { onDismiss: this.handleErrorReset }),
      !isFatalError && children
    ] });
  }
};
var ErrorBoundary_default = ErrorBoundary;

// src/revamp/renderers/CoreContainerRenderer.tsx
import { Fragment as Fragment2, jsx as jsx3 } from "react/jsx-runtime";
var CoreContainerRenderer = {
  canRenderType: "container",
  render: ({ children }) => /* @__PURE__ */ jsx3(Fragment2, { children })
};

// src/revamp/utils/type-validators.ts
var isString = (value) => typeof value === "string";
var isNumber = (value) => typeof value === "number" && !Number.isNaN(value);
var isInteger = (value) => isNumber(value) && Math.floor(value) === value;
var isBoolean = (value) => typeof value === "boolean";
var isObject = (value) => !isNullish(value) && (value == null ? void 0 : value.constructor) === Object;
var isArray = (value) => Array.isArray(value);
var isNull = (value) => value === null;
var isUndefined = (value) => typeof value === "undefined";
var isNullish = (v) => isNull(v) || isUndefined(v);
var isFile = (value) => value instanceof File;

// src/revamp/renderers/utils.ts
function findRendererPropsByType(root, type, predicate = () => true) {
  if (isArray(root)) {
    return root.flatMap((child) => findRendererPropsByType(child, type, predicate));
  }
  return [
    ...isType(root, type) && predicate(root) ? [root] : [],
    ...getChildren(root).flatMap((child) => findRendererPropsByType(child, type, predicate))
  ];
}
var isType = (node, type) => node.type === type;
function getChildren(node) {
  switch (node.type) {
    case "root":
    case "box":
    case "container":
    case "form":
    case "section":
    case "step":
      return node.childrenProps;
    case "columns":
      return [...node.startChildrenProps, ...node.endChildrenProps];
    case "modal":
      return node.content.childrenProps;
    case "repeatable":
      return node.editableItemProps ? [node.editableItemProps] : [];
    case "input-select":
      return node.childrenProps ? [node.childrenProps] : [];
    case "alert":
    case "button":
    case "input-checkbox":
    case "input-date":
    case "decision":
    case "divider":
    case "heading":
    case "hidden":
    case "image":
    case "instructions":
    case "input-integer":
    case "list":
    case "loading-indicator":
    case "markdown":
    case "input-multi-select":
    case "input-upload-multi":
    case "input-number":
    case "paragraph":
    case "review":
    case "search":
    case "status-list":
    case "input-text":
    case "input-upload":
      return [];
  }
}

// src/revamp/renderers/CoreRootRenderer.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var CoreRootRenderer = {
  canRenderType: "root",
  render: ({ children, childrenProps }) => {
    const [stepProps] = findRendererPropsByType(childrenProps, "step");
    return /* @__PURE__ */ jsx4("div", { id: stepProps == null ? void 0 : stepProps.id, className: "dynamic-flow", children });
  }
};

// src/revamp/renderers/getRenderFunction.tsx
import { Fragment as Fragment3, jsx as jsx5 } from "react/jsx-runtime";
var getRenderFunction = (renderers) => {
  function ComponentRenderer(props) {
    const { type } = props;
    if (type === "hidden") {
      return null;
    }
    const renderer = renderers.find(
      ({ canRenderType, canRender = () => true }) => (
        // once the type is matched, we know the props are of the correct type
        canRenderType === type && canRender(props)
      )
    );
    if (!renderer) {
      throw new Error(`Could not find a renderer for ${type}`);
    }
    return renderer.render(props);
  }
  const render = (props) => {
    if (!props) {
      return /* @__PURE__ */ jsx5(Fragment3, {});
    }
    return /* @__PURE__ */ jsx5(ComponentRenderer, __spreadValues({}, props), props.uid);
  };
  return render;
};

// src/revamp/utils/type-utils.ts
var hasChildren = (component) => "getChildren" in component && typeof component.getChildren === "function";
var isHiddenComponent = (component) => "hidden" in component && component.hidden;
var isObjectLocalValue = (value) => value != null && typeof value === "object" && !Array.isArray(value) && !(value instanceof File);
var isArrayLocalValue = (value) => Array.isArray(value);
var isObjectModel = (model) => model != null && typeof model === "object" && !Array.isArray(model);
var isArrayModel = (model) => Array.isArray(model);
var isAllOfSchema = (schema) => "allOf" in schema && !isNullish(schema.allOf);
var isBooleanSchema = (schema) => "type" in schema && schema.type === "boolean";
var isBlobSchema = (schema) => "type" in schema && schema.type === "blob";
var isConstSchema = (schema) => "const" in schema && schema.const !== void 0;
var isIntegerSchema = (schema) => "type" in schema && schema.type === "integer";
var isNumberSchema = (schema) => "type" in schema && schema.type === "number";
var isObjectSchema = (schema) => "type" in schema && schema.type === "object";
var isOneOfSchema = (schema) => "oneOf" in schema && !isNullish(schema.oneOf);
var isArraySchema = (schema) => "items" in schema && !isNullish(schema.items);
var isArrayListSchema = (schema) => "items" in schema && isObject(schema.items) && !isArray(schema.items);
var isArrayTupleSchema = (schema) => "items" in schema && !isObject(schema.items) && isArray(schema.items);
var isStringSchema = (schema) => "type" in schema && schema.type === "string";
var isStringSchemaWithUpload = (schema) => isStringSchema(schema) && schema.format === "base64url";
var isSchemaWithPersistAsync = (schema) => "persistAsync" in schema && !isNullish(schema.persistAsync);

// src/revamp/renderers/mappers/utils/pick.ts
function pick(obj, ...keys) {
  const result = {};
  keys.forEach((key) => {
    result[key] = obj[key];
  });
  return result;
}

// src/revamp/renderers/mappers/alertComponentToProps.ts
var alertComponentToProps = (component, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(component, "uid", "type", "callToAction", "context", "control", "margin", "markdown")), rendererMapperProps);

// src/revamp/renderers/mappers/allOfComponentToProps.ts
var allOfComponentToProps = (component, rendererMapperProps) => {
  const childrenProps = component.components.map(
    (c) => componentToRendererProps(c, rendererMapperProps)
  );
  return __spreadProps(__spreadValues(__spreadValues({
    type: "section"
  }, pick(component, "uid", "control", "description", "help", "icon", "image", "title")), rendererMapperProps), {
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps
  });
};

// src/revamp/renderers/mappers/utils/mapErrorsToValidationState.ts
var mapErrorsToValidationState = (errors) => {
  if (errors) {
    if (errors.length > 0) {
      return { status: "invalid", message: errors[0] };
    }
    return { status: "valid" };
  }
  return void 0;
};

// src/revamp/renderers/mappers/utils/inputComponentToProps.ts
var inputComponentToProps = (component, type) => {
  var _a;
  const {
    uid,
    control,
    description,
    disabled,
    errors,
    help,
    icon,
    id,
    image,
    placeholder,
    required,
    title,
    validationAsyncState,
    onBlur,
    onFocus
  } = component;
  const { messages } = validationAsyncState != null ? validationAsyncState : {};
  return {
    uid,
    type,
    control,
    description,
    disabled,
    error: (_a = messages == null ? void 0 : messages.error) != null ? _a : errors == null ? void 0 : errors[0],
    help,
    icon,
    id,
    image,
    placeholder,
    required,
    title,
    validationState: getValidationState(errors, validationAsyncState),
    value: component.getLocalValue(),
    onBlur: onBlur.bind(component),
    onFocus: onFocus.bind(component)
  };
};
var getValidationState = (errors, validationAsyncState) => {
  if (validationAsyncState) {
    if (validationAsyncState == null ? void 0 : validationAsyncState.messages.error) {
      return { status: "invalid", message: validationAsyncState == null ? void 0 : validationAsyncState.messages.error };
    }
    if (validationAsyncState == null ? void 0 : validationAsyncState.messages.success) {
      return { status: "valid", message: validationAsyncState == null ? void 0 : validationAsyncState.messages.success };
    }
  }
  return mapErrorsToValidationState(errors);
};

// src/revamp/renderers/mappers/booleanInputComponentToProps.ts
var booleanInputComponentToProps = (component, rendererMapperProps) => {
  var _a;
  return __spreadProps(__spreadValues(__spreadValues({}, inputComponentToProps(component, "input-checkbox")), rendererMapperProps), {
    value: (_a = component.value) != null ? _a : false,
    onChange: component.onChange.bind(component)
  });
};

// src/revamp/renderers/mappers/boxComponentToProps.ts
var boxComponentToProps = (component, rendererMapperProps) => {
  const childrenProps = component.components.map(
    (c) => componentToRendererProps(c, rendererMapperProps)
  );
  const { border, control } = component;
  return __spreadProps(__spreadValues(__spreadValues({}, pick(component, "uid", "type", "control", "width", "margin")), rendererMapperProps), {
    control: mapBoxControl({ border, control }),
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps
  });
};
var mapBoxControl = ({
  border,
  control
}) => {
  if (border && control == null) {
    return "bordered";
  }
  return control;
};

// src/revamp/renderers/mappers/buttonComponentToProps.ts
var buttonComponentToProps = (component, rendererMapperProps) => {
  return __spreadValues(__spreadProps(__spreadValues({
    type: "button"
  }, pick(
    component,
    "uid",
    "title",
    "control",
    "context",
    "margin",
    "pinOrder",
    "size",
    "onClick"
  )), {
    disabled: component.disabled || rendererMapperProps.stepLoadingState !== "idle"
  }), rendererMapperProps);
};

// src/revamp/renderers/mappers/columnsComponentToProps.ts
var columnsComponentToProps = ({ uid, bias, control, margin, startComponents, endComponents }, rendererMapperProps) => {
  const startChildrenProps = startComponents.map(
    (c) => componentToRendererProps(c, rendererMapperProps)
  );
  const endChildrenProps = endComponents.map(
    (c) => componentToRendererProps(c, rendererMapperProps)
  );
  return __spreadValues({
    uid,
    type: "columns",
    bias,
    control,
    margin,
    startChildren: startChildrenProps.map(rendererMapperProps.render),
    endChildren: endChildrenProps.map(rendererMapperProps.render),
    startChildrenProps,
    endChildrenProps
  }, rendererMapperProps);
};

// src/revamp/renderers/mappers/containerComponentToProps.ts
var containerComponentToProps = (component, rendererMapperProps) => {
  const childrenProps = component.getChildren().map((c) => componentToRendererProps(c, rendererMapperProps));
  return __spreadValues({
    type: "container",
    uid: component.uid,
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps
  }, rendererMapperProps);
};

// src/revamp/renderers/mappers/dateInputComponentToProps.ts
var dateInputComponentToProps = (component, rendererMapperProps) => __spreadProps(__spreadValues(__spreadValues({}, inputComponentToProps(component, "input-date")), rendererMapperProps), {
  autoComplete: component.autoComplete,
  minimumDate: component.minimumDate,
  maximumDate: component.maximumDate,
  suggestions: component.suggestions,
  onChange: component.onChange.bind(component)
});

// src/revamp/renderers/mappers/decisionComponentToProps.ts
var decisionComponentToProps = (component, rendererMapperProps) => __spreadProps(__spreadValues(__spreadValues({}, pick(component, "uid", "type", "control", "margin", "title")), rendererMapperProps), {
  options: component.options.map((_a) => {
    var _b = _a, { disabled } = _b, rest = __objRest(_b, ["disabled"]);
    return __spreadProps(__spreadValues({}, rest), {
      disabled: disabled || rendererMapperProps.stepLoadingState !== "idle"
    });
  })
});

// src/revamp/renderers/mappers/dividerComponentToProps.ts
var dividerComponentToProps = (component, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(component, "uid", "type", "control", "margin")), rendererMapperProps);

// src/revamp/renderers/mappers/formComponentToProps.ts
var formComponentToProps = (component, rendererMapperProps) => {
  const childrenProps = component.getChildren().map((c) => componentToRendererProps(c, rendererMapperProps));
  const { uid, control, margin } = component;
  return __spreadValues({
    uid,
    type: "form",
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps,
    control,
    margin
  }, rendererMapperProps);
};

// src/revamp/renderers/mappers/headingComponentToProps.ts
var headingComponentToProps = (component, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(component, "uid", "type", "align", "control", "margin", "size", "text")), rendererMapperProps);

// src/revamp/renderers/mappers/hiddenComponentToProps.ts
var hiddenComponentToProps = ({ uid }) => ({
  uid,
  type: "hidden"
});

// src/revamp/renderers/mappers/imageComponentToProps.ts
var imageComponentToProps = (component, rendererMapperProps) => __spreadProps(__spreadValues(__spreadValues({}, pick(component, "uid", "type", "align", "control", "margin", "size")), rendererMapperProps), {
  uri: component.content.uri,
  accessibilityDescription: component.content.accessibilityDescription
});

// src/revamp/renderers/mappers/instructionsComponentToProps.ts
var instructionsComponentToProps = (component, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(component, "uid", "type", "control", "items", "margin", "title")), rendererMapperProps);

// src/revamp/renderers/mappers/integerInputComponentToProps.ts
var integerInputComponentToProps = (component, rendererMapperProps) => __spreadProps(__spreadValues(__spreadValues({}, inputComponentToProps(component, "input-integer")), rendererMapperProps), {
  autoComplete: component.autoComplete,
  maximum: component.maximum,
  minimum: component.minimum,
  onChange: component.onChange.bind(component)
});

// src/revamp/renderers/mappers/loadingIndicatorComponentToProps.ts
var loadingIndicatorComponentToProps = (component, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(component, "uid", "type", "control", "margin", "size")), rendererMapperProps);

// src/revamp/renderers/mappers/markdownComponentToProps.ts
var markdownComponentToProps = (control, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(control, "uid", "type", "align", "margin", "content", "control")), rendererMapperProps);

// src/revamp/renderers/mappers/modalComponentToProps.ts
var modalComponentToProps = (component, rendererMapperProps) => {
  const { uid, content, control, margin, trigger } = component;
  const childrenProps = component.getChildren().map((c) => componentToRendererProps(c, rendererMapperProps));
  return __spreadValues({
    uid,
    type: "modal",
    content: {
      children: childrenProps.map(rendererMapperProps.render),
      childrenProps,
      title: content.title
    },
    control,
    margin,
    trigger
  }, rendererMapperProps);
};

// src/revamp/renderers/mappers/multiUploadInputComponentToProps.ts
var multiUploadInputComponentToProps = (component, rendererMapperProps) => {
  const { accepts, cameraConfig, files, maxSize, minItems, maxItems, source, uploadLabel } = component;
  return __spreadProps(__spreadValues(__spreadValues({}, inputComponentToProps(component, "input-upload-multi")), rendererMapperProps), {
    accepts,
    cameraConfig,
    maxSize,
    minItems,
    maxItems,
    source,
    uploadLabel,
    value: files.map((file) => __spreadProps(__spreadValues({}, file), {
      validationState: mapErrorsToValidationState(file.errors)
    })),
    onInsertFile: component.onInsertFile.bind(component),
    onRemoveFile: component.onRemoveFile.bind(component)
  });
};

// src/revamp/renderers/mappers/numberInputComponentToProps.ts
var numberInputComponentToProps = (component, rendererMapperProps) => __spreadProps(__spreadValues(__spreadValues({}, inputComponentToProps(component, "input-number")), rendererMapperProps), {
  maximum: component.maximum,
  minimum: component.minimum,
  onChange: component.onChange.bind(component)
});

// src/revamp/renderers/mappers/objectComponentToProps.ts
var objectComponentToProps = (component, rendererMapperProps) => {
  const childrenProps = component.getChildren().map((c) => componentToRendererProps(c, rendererMapperProps));
  return __spreadProps(__spreadValues(__spreadValues({
    type: "section"
  }, pick(component, "uid", "control", "description", "help", "icon", "image", "title")), rendererMapperProps), {
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps
  });
};

// src/revamp/renderers/mappers/paragraphComponentToProps.ts
var paragraphComponentToProps = (component, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(component, "uid", "type", "align", "control", "margin", "text")), rendererMapperProps);

// src/revamp/renderers/mappers/repeatableComponentToProps.ts
var repeatableComponentToProps = (component, rendererMapperProps) => {
  const {
    uid,
    addItemTitle,
    control,
    components,
    description,
    editableComponent,
    editItemTitle,
    errors,
    icon,
    image,
    maxItems,
    minItems,
    summaryDefaults,
    title = "",
    onEdit,
    onAdd,
    onSave,
    onRemove
  } = component;
  const childrenProps = component.getChildren().map((c) => componentToRendererProps(c, rendererMapperProps));
  const editableItemProps = editableComponent ? componentToRendererProps(editableComponent, rendererMapperProps) : null;
  const getSummary = (componentSummary) => {
    var _a, _b, _c, _d;
    return {
      title: (_a = componentSummary.title) != null ? _a : summaryDefaults.title,
      description: (_b = componentSummary.description) != null ? _b : summaryDefaults.description,
      icon: (_c = componentSummary.icon) != null ? _c : summaryDefaults.icon,
      image: (_d = componentSummary.image) != null ? _d : summaryDefaults.image
    };
  };
  const itemProps = components.map((childComponent) => __spreadProps(__spreadValues({}, getSummary(childComponent.getSummary())), {
    id: `${childComponent.uid}-summary`
  }));
  return __spreadValues({
    uid,
    type: "repeatable",
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps,
    addItemTitle,
    control,
    description,
    editableItem: rendererMapperProps.render(editableItemProps),
    editableItemProps,
    editItemTitle,
    icon,
    image,
    items: itemProps,
    maxItems,
    minItems,
    title,
    validationState: mapErrorsToValidationState(errors),
    onAdd: onAdd.bind(component),
    onEdit: onEdit.bind(component),
    onSave: onSave.bind(component),
    onRemove: onRemove.bind(component)
  }, rendererMapperProps);
};

// src/revamp/renderers/mappers/reviewComponentToProps.ts
var reviewComponentToProps = (component, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(component, "uid", "type", "callToAction", "control", "fields", "margin", "title")), rendererMapperProps);

// src/revamp/domain/mappers/utils/image.ts
var mapSpecImage = (image) => {
  var _a, _b, _c;
  return image ? {
    uri: (_b = (_a = image.uri) != null ? _a : image.url) != null ? _b : "",
    accessibilityDescription: (_c = image.accessibilityDescription) != null ? _c : image.text
  } : void 0;
};

// src/revamp/renderers/mappers/searchComponentToProps.ts
var searchComponentToProps = (component, rendererMapperProps) => {
  const { uid, control, emptyMessage, error, isLoading, margin, query, results, title } = component;
  const onChange = component.onChange.bind(component);
  const onSelect = component.onSelect.bind(component);
  const state = getSearchState({
    emptyMessage,
    error,
    isLoading,
    query,
    results,
    onChange,
    onSelect
  });
  return __spreadValues({
    uid,
    type: "search",
    id: uid,
    control,
    isLoading,
    margin,
    query,
    state,
    title,
    onChange
  }, rendererMapperProps);
};
var getSearchState = ({
  emptyMessage,
  error,
  isLoading,
  query,
  results,
  onChange,
  onSelect
}) => {
  if (!query || isLoading) {
    return { type: "pending" };
  }
  if (error) {
    return { type: "error", onRetry: () => onChange(query) };
  }
  if (results.length === 0) {
    return { type: "noResults", message: emptyMessage };
  }
  const rendererResults = results.map((result) => {
    var _a;
    return __spreadProps(__spreadValues({}, result), {
      id: result.type === "action" ? (_a = result.value.id) != null ? _a : result.value.$id : void 0,
      image: mapSpecImage(result.image),
      onClick: () => onSelect(result)
    });
  });
  return { type: "results", results: rendererResults };
};

// src/revamp/renderers/mappers/selectInputComponentToProps.ts
var selectInputComponentToProps = (component, rendererMapperProps) => {
  const { autoComplete, options, selectedIndex, onSelect } = component;
  const selectedChild = component.getSelectedChild();
  const childrenProps = selectedChild ? componentToRendererProps(selectedChild, rendererMapperProps) : null;
  const _a = inputComponentToProps(component, "input-select"), { value } = _a, props = __objRest(_a, ["value"]);
  return __spreadProps(__spreadValues(__spreadValues({}, props), rendererMapperProps), {
    autoComplete,
    options,
    selectedIndex,
    onSelect: onSelect.bind(component),
    children: rendererMapperProps.render(childrenProps),
    childrenProps
  });
};

// src/revamp/renderers/mappers/statusListComponentToProps.ts
var statusListComponentToProps = (component, rendererMapperProps) => __spreadValues(__spreadValues({}, pick(component, "uid", "type", "control", "items", "margin", "title")), rendererMapperProps);

// src/revamp/renderers/mappers/textInputComponentToProps.ts
var textInputComponentToProps = (component, rendererMapperProps) => __spreadProps(__spreadValues(__spreadValues({}, inputComponentToProps(component, "input-text")), rendererMapperProps), {
  autoComplete: component.autoComplete,
  autoCapitalize: component == null ? void 0 : component.autocapitalization,
  displayFormat: component.displayFormat,
  maxLength: component.maxLength,
  minLength: component.minLength,
  suggestions: component.suggestions,
  onChange: component.onChange.bind(component)
});

// src/revamp/renderers/mappers/multiSelectComponentToProps.ts
var multiSelectInputComponentToProps = (component, rendererMapperProps) => {
  const { autoComplete, maxItems, minItems, options, selectedIndices, onSelect } = component;
  const _a = inputComponentToProps(component, "input-multi-select"), { required, value } = _a, props = __objRest(_a, ["required", "value"]);
  return __spreadProps(__spreadValues(__spreadValues({}, props), rendererMapperProps), {
    autoComplete,
    maxItems,
    minItems,
    options,
    selectedIndices,
    onSelect: onSelect.bind(component)
  });
};

// src/revamp/renderers/mappers/uploadInputComponentToProps.ts
var uploadInputComponentToProps = (component, rendererMapperProps) => {
  const { accepts, cameraConfig, maxSize, source } = component;
  return __spreadProps(__spreadValues(__spreadValues({}, inputComponentToProps(component, "input-upload")), rendererMapperProps), {
    cameraConfig,
    source,
    accepts,
    maxSize,
    onUpload: component.onUpload.bind(component)
  });
};

// src/revamp/renderers/mappers/tupleComponentToProps.ts
var tupleComponentToProps = (component, rendererMapperProps) => {
  const childrenProps = component.getChildren().map((c) => componentToRendererProps(c, rendererMapperProps));
  return __spreadProps(__spreadValues(__spreadValues({
    type: "section"
  }, pick(component, "uid", "control", "description", "help", "icon", "image", "title")), rendererMapperProps), {
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps
  });
};

// src/revamp/renderers/mappers/listComponentToProps.ts
var listComponentToProps = (component, rendererMapperProps) => __spreadProps(__spreadValues(__spreadValues({}, pick(component, "uid", "type", "callToAction", "control", "margin", "title")), rendererMapperProps), {
  items: component.items.map((_a) => {
    var item = __objRest(_a, []);
    return __spreadValues({}, item);
  })
});

// src/revamp/renderers/stepComponentToProps.ts
var stepComponentToProps = ({
  uid,
  back,
  control,
  description,
  error,
  external,
  loadingState,
  step,
  title,
  components,
  onBehavior
}, rendererMapperProps) => {
  const childrenProps = components.map((c) => componentToRendererProps(c, rendererMapperProps));
  return __spreadValues({
    type: "step",
    id: step.id,
    uid,
    back,
    control,
    description,
    error,
    external,
    loadingState,
    step,
    title,
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps,
    onAction: (action) => {
      void onBehavior({ type: "action", action });
    }
  }, rendererMapperProps);
};

// src/revamp/renderers/mappers/rootComponentToProps.ts
var rootComponentToProps = (rootComponent, rendererMapperProps) => {
  const childrenProps = rootComponent.getChildren().map((child) => componentToRendererProps(child, rendererMapperProps));
  return {
    type: "root",
    uid: rootComponent.uid,
    children: childrenProps.map(rendererMapperProps.render),
    childrenProps
  };
};

// src/revamp/renderers/mappers/componentToRendererProps.ts
var componentToRendererProps = (component, rendererMapperProps) => {
  if (isHiddenComponent(component)) {
    return hiddenComponentToProps(component);
  }
  switch (component.type) {
    case "root":
      return rootComponentToProps(component, rendererMapperProps);
    case "step":
      return stepComponentToProps(component, rendererMapperProps);
    case "alert":
      return alertComponentToProps(component, rendererMapperProps);
    case "all-of":
      return allOfComponentToProps(component, rendererMapperProps);
    case "boolean":
      return booleanInputComponentToProps(component, rendererMapperProps);
    case "box":
      return boxComponentToProps(component, rendererMapperProps);
    case "button":
      return buttonComponentToProps(component, rendererMapperProps);
    case "columns":
      return columnsComponentToProps(component, rendererMapperProps);
    case "container":
      return containerComponentToProps(component, rendererMapperProps);
    case "date":
      return dateInputComponentToProps(component, rendererMapperProps);
    case "decision":
      return decisionComponentToProps(component, rendererMapperProps);
    case "divider":
      return dividerComponentToProps(component, rendererMapperProps);
    case "form":
      return formComponentToProps(component, rendererMapperProps);
    case "heading":
      return headingComponentToProps(component, rendererMapperProps);
    case "const":
      return hiddenComponentToProps(component);
    case "image":
      return imageComponentToProps(component, rendererMapperProps);
    case "instructions":
      return instructionsComponentToProps(component, rendererMapperProps);
    case "integer":
      return integerInputComponentToProps(component, rendererMapperProps);
    case "list":
      return listComponentToProps(component, rendererMapperProps);
    case "loading-indicator":
      return loadingIndicatorComponentToProps(component, rendererMapperProps);
    case "markdown":
      return markdownComponentToProps(component, rendererMapperProps);
    case "modal":
      return modalComponentToProps(component, rendererMapperProps);
    case "multi-select":
      return multiSelectInputComponentToProps(component, rendererMapperProps);
    case "multi-upload":
      return multiUploadInputComponentToProps(component, rendererMapperProps);
    case "number":
      return numberInputComponentToProps(component, rendererMapperProps);
    case "object":
      return objectComponentToProps(component, rendererMapperProps);
    case "paragraph":
      return paragraphComponentToProps(component, rendererMapperProps);
    case "repeatable":
      return repeatableComponentToProps(component, rendererMapperProps);
    case "review":
      return reviewComponentToProps(component, rendererMapperProps);
    case "search":
      return searchComponentToProps(component, rendererMapperProps);
    case "select":
      return selectInputComponentToProps(component, rendererMapperProps);
    case "status-list":
      return statusListComponentToProps(component, rendererMapperProps);
    case "text":
      return textInputComponentToProps(component, rendererMapperProps);
    case "tuple":
      return tupleComponentToProps(component, rendererMapperProps);
    case "upload":
      return uploadInputComponentToProps(component, rendererMapperProps);
    default:
      throw new Error("Unknown component type");
  }
};

// src/revamp/useDynamicFlowCore.tsx
import { validateStep } from "@wise/dynamic-flow-types";
import { useCallback as useCallback2, useEffect, useMemo, useRef as useRef2, useState } from "react";
import { useIntl as useIntl2 } from "react-intl";

// src/revamp/domain/components/RootDomainComponent.ts
var createRootDomainComponent = () => ({
  type: "root",
  uid: "root",
  stepComponent: null,
  getChildren() {
    return this.stepComponent ? [this.stepComponent] : [];
  },
  getLocalValue() {
    return this.stepComponent ? this.stepComponent.getLocalValue() : null;
  },
  async getSubmittableValue() {
    return this.stepComponent ? this.stepComponent.getSubmittableValue() : null;
  },
  getSubmittableValueSync() {
    return this.stepComponent ? this.stepComponent.getSubmittableValueSync() : null;
  },
  getSummary() {
    return this.stepComponent ? this.stepComponent.getSummary() : {};
  },
  validate() {
    return this.stepComponent ? this.stepComponent.validate() : false;
  },
  setLoadingState(loadingState) {
    var _a;
    (_a = this.stepComponent) == null ? void 0 : _a.setLoadingState(loadingState);
  },
  getLoadingState() {
    return this.stepComponent ? this.stepComponent.loadingState : "initial";
  },
  getTrackEvent() {
    return this.stepComponent ? this.stepComponent.trackEvent : null;
  },
  hasStep() {
    return Boolean(this.stepComponent);
  },
  stop() {
    var _a;
    (_a = this.stepComponent) == null ? void 0 : _a.stop();
  }
});

// src/revamp/utils/component-utils.ts
var getSubmittableData = async (components) => Promise.all(components.map(async (component) => component.getSubmittableValue())).then(
  (values) => values.reduce((acc, value) => mergeModels(acc, value), null)
);
var getSubmittableDataSync = (components) => components.map((component) => component.getSubmittableValueSync()).reduce((acc, value) => mergeModels(acc, value), null);
var getLocalValues = (components) => components.map((component) => component.getLocalValue()).reduce((acc, value) => mergeLocalValues(acc, value), null);
var mergeLocalValues = (valueA, valueB) => {
  if (valueA === null) {
    return valueB;
  }
  if (valueB === null) {
    return valueA;
  }
  if (isObjectLocalValue(valueA) && isObjectLocalValue(valueB)) {
    return __spreadValues(__spreadValues({}, valueA), valueB);
  }
  return valueB;
};
var mergeModels = (valueA, valueB) => {
  if (valueA === null) {
    return valueB;
  }
  if (valueB === null) {
    return valueA;
  }
  if (isObjectModel(valueA) && isObjectModel(valueB)) {
    return __spreadValues(__spreadValues({}, valueA), valueB);
  }
  return valueB;
};

// src/revamp/domain/features/summary/summary-utils.ts
var getSummariser = (schema) => (value) => {
  const { summary, icon, image } = schema;
  const stringValueOrNull = isString(value) ? value : null;
  return summaryIfProvides(summary, { value: stringValueOrNull, icon, image });
};
var getConstSummary = (schema, model) => {
  const { summary, icon, image } = schema;
  const value = isString(model) ? model : null;
  return summaryIfProvides(summary, { value, icon, image });
};
var summariseFromChildren = (components) => components.reduce(
  (acc, component) => mergeSummaries(acc, component.getSummary()),
  {}
);
var mergeSummaries = (summaryA, summaryB) => {
  var _a, _b, _c, _d;
  return {
    title: (_a = summaryA.title) != null ? _a : summaryB.title,
    description: (_b = summaryA.description) != null ? _b : summaryB.description,
    icon: (_c = summaryA.icon) != null ? _c : summaryB.icon,
    image: (_d = summaryA.image) != null ? _d : summaryB.image
  };
};
var summaryIfProvides = (summary, { value, icon, image }) => {
  if (!summary) {
    return {};
  }
  return {
    title: summary.providesTitle && value || void 0,
    description: summary.providesDescription && value || void 0,
    icon: summary.providesIcon && icon || void 0,
    image: summary.providesImage && mapSpecImage(image != null ? image : void 0) || void 0
  };
};

// src/revamp/domain/features/validation/validation-functions.ts
var validateComponents = (components) => components.reduce((acc, component) => component.validate() && acc, true);
var getLocalValueValidator = (checks) => (currentValue) => checks.map((check) => check(currentValue)).filter(isString);

// src/revamp/domain/components/utils/component-utils.ts
var getInputUpdateFunction = (uid, updateComponent) => (updateFn) => {
  updateComponent(uid, (draft) => {
    const draftState = draft;
    updateFn(draftState);
  });
};

// src/revamp/domain/components/StepDomainComponent.ts
var createStepComponent = (stepProps) => {
  const _a = stepProps, { uid, stepPolling, stepRefreshAfter, updateComponent } = _a, rest = __objRest(_a, ["uid", "stepPolling", "stepRefreshAfter", "updateComponent"]);
  const update = getInputUpdateFunction(uid, updateComponent);
  return __spreadProps(__spreadValues({
    uid
  }, rest), {
    type: "step",
    getChildren() {
      return this.components;
    },
    async getSubmittableValue() {
      return getSubmittableData(this.components);
    },
    getSubmittableValueSync() {
      return getSubmittableDataSync(this.components);
    },
    getSummary() {
      return summariseFromChildren(this.getChildren());
    },
    getLocalValue() {
      return getLocalValues(this.components);
    },
    validate() {
      return validateComponents(this.getChildren());
    },
    setLoadingState(loadingState) {
      update((draft) => {
        draft.loadingState = loadingState;
      });
    },
    stop() {
      stepPolling == null ? void 0 : stepPolling.stop();
      stepRefreshAfter == null ? void 0 : stepRefreshAfter.stop();
    }
  });
};

// src/revamp/domain/mappers/utils/behavior-utils.ts
var getDomainLayerBehavior = ({
  action,
  behavior
}, stepActions) => {
  if (behavior) {
    return normaliseBehavior(behavior, stepActions);
  }
  if (action) {
    return actionToBehavior(action, stepActions);
  }
  return { type: "none" };
};
var skipValidation = (behavior) => behavior.type === "action" ? __spreadProps(__spreadValues({}, behavior), { action: __spreadProps(__spreadValues({}, behavior.action), { skipValidation: true }) }) : behavior;
var normaliseBehavior = (behavior, stepActions) => {
  if ("type" in behavior) {
    return behavior;
  }
  if ("action" in behavior && behavior.action) {
    return actionToBehavior(behavior.action, stepActions);
  }
  if ("link" in behavior && behavior.link) {
    return { type: "link", url: behavior.link.url };
  }
  return { type: "none" };
};
var actionToBehavior = (action, stepActions) => ({
  type: "action",
  action: inlineAction(action, stepActions)
});
var inlineAction = (action, stepActions = []) => action.$ref ? __spreadValues(__spreadValues({}, getActionByReference(action.$ref, stepActions)), action) : action;
var getActionByReference = ($ref, actions = []) => {
  const action = actions.find((a) => a.$id === $ref);
  if (!action) {
    throw new Error("Action reference not found in actions array.");
  }
  return action;
};

// src/revamp/domain/features/polling/getStepPolling.ts
var getStepPolling = ({
  pollingConfig,
  onBehavior,
  onPoll
}) => {
  const { interval, delay = interval, maxAttempts, url, onError } = pollingConfig;
  let abortController = new AbortController();
  if (delay == null) {
    throw new Error("Polling configuration must include delay or interval");
  }
  const onErrorBehavior = skipValidation(getDomainLayerBehavior(onError, []));
  let attempts = 0;
  const poll = () => {
    attempts += 1;
    abortController.abort();
    abortController = new AbortController();
    const { signal } = abortController;
    onPoll(url, onErrorBehavior, signal).then((result) => {
      if (result) {
        stop();
        return;
      }
      if (attempts >= maxAttempts && !signal.aborted) {
        void onBehavior(onErrorBehavior);
        stop();
      }
    }).catch(() => {
    });
  };
  const intervalRef = setInterval(poll, delay * 1e3);
  const stop = () => {
    clearTimeout(intervalRef);
    abortController.abort();
  };
  poll();
  return { stop };
};

// src/revamp/domain/features/refreshAfter/getStepRefreshAfter.ts
var ONE_SECOND = 1e3;
var getStepRefreshAfter = ({ refreshAfter, onRefresh }) => {
  const targetTime = new Date(refreshAfter).getTime();
  if (typeof refreshAfter !== "string" || Number.isNaN(targetTime)) {
    throw new Error(`Invalid refreshAfter value: ${String(refreshAfter)}`);
  }
  const timeLeft = Math.max(targetTime - Date.now(), ONE_SECOND);
  const timeout = setTimeout(() => {
    void onRefresh("refreshAfter");
  }, timeLeft);
  return {
    stop: () => clearTimeout(timeout)
  };
};

// src/revamp/domain/components/AlertComponent.ts
var createAlertComponent = (alertProps) => __spreadProps(__spreadValues({
  type: "alert"
}, alertProps), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getLocalValue: () => null,
  getSummary: () => ({}),
  // Noop
  validate: () => true
});

// src/revamp/domain/mappers/utils/call-to-action-utils.ts
var getDomainLayerCallToAction = (callToAction, onBehavior, stepActions) => {
  if (!callToAction) {
    return void 0;
  }
  const { title = "", accessibilityDescription, action, behavior } = callToAction;
  return getCallToAction(
    { title, accessibilityDescription },
    getDomainLayerBehavior({ action, behavior }, stepActions),
    onBehavior
  );
};
var getCallToAction = ({ title, accessibilityDescription }, behavior, onBehavior) => {
  const onClick = () => {
    void onBehavior(behavior);
  };
  switch (behavior.type) {
    case "action": {
      return {
        type: "action",
        title: title != null ? title : "",
        accessibilityDescription,
        onClick
      };
    }
    case "link": {
      return {
        type: "link",
        title: title != null ? title : "",
        href: behavior.url,
        accessibilityDescription,
        onClick
      };
    }
    default:
      return void 0;
  }
};

// src/revamp/domain/mappers/utils/legacy-utils.ts
var mapLegacyContext = (context) => {
  switch (context) {
    case "success":
      return "positive";
    case "failure":
      return "negative";
    case "info":
    case "primary":
      return "neutral";
    default:
      return context;
  }
};
var mapLegacyBias = (bias) => {
  switch (bias) {
    case "left":
      return "start";
    case "right":
      return "end";
    default:
      return bias;
  }
};
var mapLegacyAlign = (align) => {
  switch (align) {
    case "left":
      return "start";
    case "right":
      return "end";
    default:
      return align;
  }
};
var legacyActionTypeToContext = {
  positive: "positive",
  negative: "negative",
  primary: "neutral",
  secondary: "neutral",
  link: "neutral"
};
var mapLegacyActionTypeToContext = (type) => type && type in legacyActionTypeToContext ? legacyActionTypeToContext[type] : "neutral";
var legacyActionTypeToControl = {
  primary: "primary",
  secondary: "secondary",
  link: "tertiary",
  positive: "primary",
  negative: "primary"
};
var mapLegacyActionTypeToControl = (type) => type && type in legacyActionTypeToControl ? legacyActionTypeToControl[type] : "secondary";

// src/revamp/domain/mappers/layout/alertLayoutToComponent.ts
var alertLayoutToComponent = (uid, { control, markdown, margin = "md", context = "neutral", callToAction }, { onBehavior, step }) => {
  var _a;
  const cta = callToAction ? getDomainLayerCallToAction(callToAction, onBehavior, (_a = step.actions) != null ? _a : []) : void 0;
  return createAlertComponent({
    uid,
    control,
    markdown,
    margin,
    callToAction: cta,
    context: mapLegacyContext(context)
  });
};

// src/revamp/domain/components/BoxComponent.ts
var createBoxComponent = (boxProps) => __spreadProps(__spreadValues({}, boxProps), {
  type: "box",
  getChildren() {
    return this.components;
  },
  async getSubmittableValue() {
    return getSubmittableData(this.components);
  },
  getSubmittableValueSync() {
    return getSubmittableDataSync(this.components);
  },
  getSummary() {
    return summariseFromChildren(this.getChildren());
  },
  getLocalValue() {
    return getLocalValues(this.components);
  },
  validate() {
    return validateComponents(this.getChildren());
  }
});

// src/revamp/domain/mappers/layout/boxLayoutToComponents.ts
var boxLayoutToComponent = (uid, { border = false, components, control, margin = "md", width = "xl" }, mapperProps) => createBoxComponent({
  uid,
  border,
  control,
  margin,
  width,
  components: components.map(
    (component, index) => mapLayoutToComponent(`${uid}.box-${index}`, component, mapperProps)
  )
});

// src/revamp/domain/components/ButtonComponent.ts
var createButtonComponent = (buttonProps) => __spreadProps(__spreadValues({
  type: "button"
}, buttonProps), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getLocalValue: () => null,
  getSummary: () => ({}),
  // Noop
  validate: () => true
});

// src/revamp/domain/mappers/layout/buttonLayoutToComponent.ts
var buttonLayoutToComponent = (uid, button, mapperProps) => {
  if (!button.behavior && button.action) {
    return buttonLayoutToComponentWithAction(
      uid,
      __spreadProps(__spreadValues({}, button), { action: button.action }),
      mapperProps
    );
  }
  return buttonLayoutToComponentWithBehavior(uid, button, mapperProps);
};
var buttonLayoutToComponentWithBehavior = (uid, button, mapperProps) => {
  var _a;
  const { onBehavior } = mapperProps;
  const { context, control, disabled, margin = "md", pinOrder, size, title } = button;
  const behavior = getDomainLayerBehavior(button, (_a = mapperProps.step.actions) != null ? _a : []);
  const onClick = () => {
    void onBehavior(behavior);
  };
  return createButtonComponent({
    uid,
    context: mapLegacyContext(context != null ? context : "neutral"),
    control,
    disabled: disabled != null ? disabled : false,
    margin,
    pinOrder,
    size,
    title: title != null ? title : "",
    onClick
  });
};
var buttonLayoutToComponentWithAction = (uid, button, mapperProps) => {
  const { onBehavior, step } = mapperProps;
  const { context, control, disabled, margin = "md", pinOrder, size, title } = button;
  const { action } = button;
  const inlinedAction = action ? inlineAction(action, step == null ? void 0 : step.actions) : {};
  const onClick = () => {
    void onBehavior({ type: "action", action: inlinedAction });
  };
  return createButtonComponent({
    uid,
    context: getButtonContext({ context, action: inlinedAction }),
    control: getButtonControl({ control, action: inlinedAction }),
    disabled: getButtonDisabled({ disabled, action: inlinedAction }),
    margin,
    pinOrder,
    size,
    title: getButtonTitle({ title, action: inlinedAction }),
    onClick
  });
};
var getButtonTitle = ({ title, action }) => {
  var _a;
  return (_a = title != null ? title : action == null ? void 0 : action.title) != null ? _a : "";
};
var getButtonDisabled = ({
  disabled,
  action
}) => {
  var _a;
  return (_a = disabled != null ? disabled : action == null ? void 0 : action.disabled) != null ? _a : false;
};
var getButtonControl = ({ control, action }) => {
  if (control) {
    return control;
  }
  return (action == null ? void 0 : action.type) ? mapLegacyActionTypeToControl(action.type) : void 0;
};
var getButtonContext = ({ context, action }) => {
  if (context) {
    return mapLegacyContext(context);
  }
  return (action == null ? void 0 : action.type) ? mapLegacyActionTypeToContext(action.type) : "neutral";
};

// src/revamp/domain/components/ColumnsComponent.ts
var createColumnsComponent = (columnsProps) => __spreadProps(__spreadValues({}, columnsProps), {
  type: "columns",
  getChildren() {
    return [...this.startComponents, ...this.endComponents];
  },
  async getSubmittableValue() {
    return getSubmittableData(this.getChildren());
  },
  getSubmittableValueSync() {
    return getSubmittableDataSync(this.getChildren());
  },
  getSummary() {
    return summariseFromChildren(this.getChildren());
  },
  getLocalValue() {
    return getLocalValues(this.getChildren());
  },
  validate() {
    return validateComponents(this.getChildren());
  }
});

// src/revamp/domain/mappers/layout/columnsLayoutToComponent.ts
var columnsLayoutToComponent = (uid, { control, left, right, bias = "none", margin = "md" }, mapperProps) => createColumnsComponent({
  uid,
  control,
  margin,
  bias: mapLegacyBias(bias),
  startComponents: left.map(
    (component, index) => mapLayoutToComponent(`${uid}.columns-start-${index}`, component, mapperProps)
  ),
  endComponents: right.map(
    (component, index) => mapLayoutToComponent(`${uid}.columns-end-${index}`, component, mapperProps)
  )
});

// src/revamp/domain/components/DecisionComponent.ts
var createDecisionComponent = (decisionProps) => __spreadProps(__spreadValues({
  type: "decision"
}, decisionProps), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getLocalValue: () => null,
  getSummary: () => ({}),
  // Noop
  validate: () => true
});

// src/revamp/domain/mappers/layout/decisionLayoutToComponent.ts
var decisionLayoutToComponent = (uid, {
  control,
  margin = "md",
  options,
  title
}, { onBehavior, step }) => createDecisionComponent({
  uid,
  control,
  margin,
  options: options.map((option) => {
    var _a, _b;
    const behavior = getDomainLayerBehavior(option, (_a = step.actions) != null ? _a : []);
    return __spreadProps(__spreadValues({}, option), {
      disabled: (_b = option.disabled) != null ? _b : false,
      href: behavior.type === "link" ? behavior.url : void 0,
      image: mapSpecImage(option.image),
      onClick: () => {
        void onBehavior(behavior);
      }
    });
  }),
  title
});

// src/revamp/domain/components/DividerComponent.ts
var createDividerComponent = (props) => __spreadProps(__spreadValues({
  type: "divider"
}, props), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getLocalValue: () => null,
  getSummary: () => ({}),
  // Noop
  validate: () => true
});

// src/revamp/domain/mappers/layout/dividerLayoutToComponent.ts
var dividerLayoutToComponent = (uid, { control, margin = "md" }) => createDividerComponent({ uid, control, margin });

// src/revamp/domain/features/utils/http-utils.ts
function constructPayload({
  value,
  signal,
  requestConfig
}) {
  const isFile2 = value instanceof File;
  const { method, param } = requestConfig;
  const body = isFile2 ? wrapInFormData(param, value) : JSON.stringify({ [param]: value });
  const headers2 = __spreadValues({}, !isFile2 && { "Content-Type": "application/json" });
  return {
    method,
    headers: headers2,
    body,
    signal
  };
}
var wrapInFormData = (key, file) => {
  const formData = new FormData();
  formData.append(key, file);
  return formData;
};
var abortAndResetController = (abortController) => {
  abortController.abort();
  return new AbortController();
};

// src/revamp/domain/components/utils/isExactLocalValueMatch.ts
var isExactLocalValueMatch = (valueA, valueB) => {
  if (isArrayLocalValue(valueA) && isArrayLocalValue(valueB)) {
    return valueA.length === valueB.length && valueA.every((value, index) => isExactLocalValueMatch(value, valueB[index]));
  }
  if (isObjectLocalValue(valueA) && isObjectLocalValue(valueB)) {
    const keysA = Object.keys(valueA);
    const keysB = Object.keys(valueB);
    return keysA.length === keysB.length && keysA.every((key) => isExactLocalValueMatch(valueA[key], valueB[key]));
  }
  return valueA === valueB;
};

// src/revamp/domain/components/utils/getRandomId.ts
var getRandomId = () => Math.random().toString(36).substring(2);

// src/revamp/domain/features/persistAsync/getComponentPersistAsync.ts
var getComponentPersistAsync = (update, performPersistAsync) => (
  /**
   * Will update the persistedState when a new request is made, and will update
   * the value or set errors when the request completes.
   */
  async (persistedState, currentValue) => {
    const { abortController, lastSubmitted, submission } = persistedState;
    if (isExactLocalValueMatch(lastSubmitted, currentValue)) {
      return submission;
    }
    const newAbortController = abortAndResetController(abortController);
    if (isNullish(currentValue) || currentValue === "") {
      const resolvedNull = Promise.resolve(null);
      update((draft) => {
        draft.persistedState.abortController = newAbortController;
        draft.persistedState.lastResponse = null;
        draft.persistedState.lastSubmitted = currentValue;
        draft.persistedState.submission = resolvedNull;
      });
      return resolvedNull;
    }
    const { signal } = newAbortController;
    const newSubmission = performPersistAsync({ value: currentValue, signal }).then((newValue) => {
      update((draft) => {
        draft.persistedState.lastResponse = newValue;
      });
      return newValue;
    }).catch((error) => {
      if (error instanceof DOMException && error.name === "AbortError") {
        return null;
      }
      update((draft) => {
        draft.errors = [error.message];
        draft.persistedState.lastResponse = null;
        draft.persistedState.lastSubmitted = null;
      });
      throw error;
    });
    update((draft) => {
      draft.persistedState = {
        abortController: newAbortController,
        lastResponse: null,
        lastSubmitted: currentValue,
        submission: newSubmission
      };
    });
    return newSubmission;
  }
);
var getComponentMultiPersistAsync = (update, performPersistAsync) => (
  /**
   * Will update the persistedState when a new request is made, and will update
   * the value or set errors when the request completes.
   */
  async (index, value) => {
    if (isNullish(value)) {
      throw new Error("Value must be a file or base64 string.");
    }
    const newAbortController = new AbortController();
    const { signal } = newAbortController;
    const newSubmission = performPersistAsync({ value, signal }).then((newValue) => {
      update((draft) => {
        draft.persistedState[index].lastResponse = newValue;
      });
      return newValue;
    }).catch((error) => {
      update((draft) => {
        draft.persistedState = [
          ...draft.persistedState.slice(0, index),
          ...draft.persistedState.slice(index + 1)
        ];
        draft.value.splice(index, 1);
        draft.files.splice(index, 1);
      });
      throw error;
    });
    update((draft) => {
      draft.persistedState = [
        ...draft.persistedState.slice(0, index),
        {
          id: getRandomId(),
          abortController: newAbortController,
          lastResponse: null,
          lastSubmitted: null,
          submission: newSubmission
        },
        ...draft.persistedState.slice(index)
      ];
    });
    return newSubmission;
  }
);

// src/revamp/domain/components/utils/debounce.ts
var debounce = (callback, waitMs) => {
  let timeoutId = null;
  let lastArgs = null;
  const clearTimer = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    lastArgs = null;
  };
  const debouncedFn = (...args) => {
    lastArgs = args;
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      callback(...lastArgs);
      timeoutId = null;
      lastArgs = null;
    }, waitMs);
  };
  debouncedFn.cancel = () => {
    if (timeoutId !== null) {
      clearTimer();
    }
  };
  debouncedFn.flush = () => {
    if (timeoutId !== null) {
      callback(...lastArgs);
      clearTimer();
    }
  };
  debouncedFn.isPending = () => timeoutId !== null;
  return debouncedFn;
};

// src/revamp/domain/components/utils/isOrWasValid.ts
var isOrWasValid = (getErrors, previous, current) => {
  const wasValid = getErrors(previous).length === 0 && previous !== null;
  const isValid = getErrors(current).length === 0;
  return wasValid || isValid;
};

// src/revamp/domain/features/refresh/getPerformRefresh.ts
var getPerformRefresh = (schema, onRefresh) => {
  var _a, _b;
  if ("refreshStepOnChange" in schema && ((_a = schema.refreshStepOnChange) != null ? _a : false) || "refreshFormOnChange" in schema && ((_b = schema.refreshFormOnChange) != null ? _b : false)) {
    const { $id, analyticsId, refreshUrl, refreshFormUrl } = schema;
    const schemaId = analyticsId != null ? analyticsId : $id;
    return () => {
      void onRefresh(schemaId, refreshUrl != null ? refreshUrl : refreshFormUrl);
    };
  }
  return void 0;
};
var getDebouncedPerformRefresh = (performRefresh, getValidationErrors) => {
  if (!performRefresh) {
    return void 0;
  }
  const performDebouncedRefresh = debounce(performRefresh, 1e3);
  const debouncedFn = (prevValue, updatedValue) => {
    if (isOrWasValid(getValidationErrors, prevValue, updatedValue) || (performDebouncedRefresh == null ? void 0 : performDebouncedRefresh.isPending())) {
      performDebouncedRefresh == null ? void 0 : performDebouncedRefresh();
    }
  };
  debouncedFn.flush = () => performDebouncedRefresh.flush();
  debouncedFn.cancel = () => performDebouncedRefresh.cancel();
  debouncedFn.isPending = () => performDebouncedRefresh.isPending();
  return debouncedFn;
};

// src/revamp/domain/features/validationAsync/getComponentValidationAsync.ts
var getComponentValidationAsync = (update, performValidationAsync) => (
  /**
   * Will update the validationAsyncState when a new request is made, and will update
   * the description or set errors when the request completes.
   */
  async (validationAsyncState, currentValue) => {
    const { abortController } = validationAsyncState;
    const newAbortController = abortAndResetController(abortController);
    if (isNullish(currentValue)) {
      update((draft) => {
        draft.validationAsyncState = {
          abortController: newAbortController,
          lastSubmitted: currentValue,
          messages: {}
        };
      });
      return;
    }
    const { signal } = newAbortController;
    const newSubmission = performValidationAsync({ value: currentValue, signal }).then((message) => {
      update((draft) => {
        if (message) {
          draft.validationAsyncState.messages.success = message;
        }
      });
      return message;
    }).catch((error) => {
      if (error instanceof DOMException && error.name === "AbortError") {
        return null;
      }
      update((draft) => {
        draft.validationAsyncState.messages.error = error.message;
      });
    });
    update((draft) => {
      draft.validationAsyncState = {
        abortController: newAbortController,
        lastSubmitted: currentValue,
        messages: {}
      };
    });
    return newSubmission;
  }
);
var getDebouncedComponentValidationAsync = (update, performValidationAsync) => debounce(getComponentValidationAsync(update, performValidationAsync), 1e3);

// src/revamp/domain/components/NumberInputComponent.ts
var createNumberInputComponent = (numberInputProps, updateComponent) => {
  const _a = numberInputProps, {
    uid,
    id,
    checks,
    performPersistAsync,
    performRefresh,
    performValidationAsync,
    onValueChange,
    summariser
  } = _a, rest = __objRest(_a, [
    "uid",
    "id",
    "checks",
    "performPersistAsync",
    "performRefresh",
    "performValidationAsync",
    "onValueChange",
    "summariser"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const getValidationErrors = getLocalValueValidator(checks);
  const performDebouncedRefresh = getDebouncedPerformRefresh(performRefresh, getValidationErrors);
  const getAndSetValidationErrors = (currentValue) => {
    const messages = getValidationErrors(currentValue);
    update((draft) => {
      draft.errors = messages;
    });
    return messages;
  };
  const numberComponent = __spreadValues({
    type: "number",
    uid,
    id,
    onBlur() {
      getAndSetValidationErrors(this.getLocalValue());
      performDebouncedRefresh == null ? void 0 : performDebouncedRefresh.flush();
    },
    onFocus() {
    },
    // Noop
    onChange(updatedValue) {
      const prevValue = this.value;
      update((draft) => {
        draft.errors = [];
        draft.validationAsyncState.messages = {};
        draft.value = updatedValue;
      });
      performDebouncedRefresh == null ? void 0 : performDebouncedRefresh(prevValue, updatedValue);
      onValueChange();
    },
    async getSubmittableValue() {
      return this.getSubmittableValueSync();
    },
    getSubmittableValueSync() {
      var _a2;
      return (_a2 = this.getLocalValue()) != null ? _a2 : null;
    },
    getSummary() {
      return summariser(this.getLocalValue());
    },
    getLocalValue() {
      return this.value;
    },
    validate() {
      const messages = getAndSetValidationErrors(this.getLocalValue());
      return messages.length === 0;
    }
  }, rest);
  if (performRefresh) {
    return numberComponent;
  }
  if (performPersistAsync) {
    const persist = getComponentPersistAsync(update, performPersistAsync);
    return __spreadProps(__spreadValues({}, numberComponent), {
      onBlur() {
        if (this.validate()) {
          persist(this.persistedState, this.getLocalValue()).catch(() => {
          });
        }
      },
      async getSubmittableValue() {
        return persist(this.persistedState, this.getLocalValue());
      },
      getSubmittableValueSync() {
        return this.persistedState.lastResponse;
      }
    });
  }
  if (performValidationAsync) {
    const validateAsync = getDebouncedComponentValidationAsync(update, performValidationAsync);
    return __spreadProps(__spreadValues({}, numberComponent), {
      onBlur() {
        if (this.validate()) {
          validateAsync.flush();
        }
      },
      onChange(updatedValue) {
        numberComponent.onChange.call(this, updatedValue);
        if (getValidationErrors(updatedValue).length === 0) {
          validateAsync(this.validationAsyncState, updatedValue);
        }
      }
    });
  }
  return numberComponent;
};

// src/revamp/domain/features/validation/validateStringPattern.ts
var validateStringPattern = (pattern, logEvent) => {
  if (!pattern) {
    return;
  }
  try {
    new RegExp(pattern, "u");
  } catch (error) {
    const message = `Invalid schema pattern. Failed to instantiate RegExp with Unicode support.`;
    if (logEvent) {
      logEvent("warning", message, {
        pattern,
        error: error == null ? void 0 : error.toString()
      });
    } else {
      console.warn(`DynamicFlow - warning - ${message}`, {
        pattern,
        error: error == null ? void 0 : error.toString()
      });
    }
  }
};

// src/revamp/domain/features/validation/value-checks.ts
var getAboveMaxItemsCheck = ({ maxItems }, messageFunctions) => (value) => {
  if (isNumber(maxItems) && isArray(value) && value.length > maxItems) {
    return messageFunctions.maxItems(maxItems);
  }
  return null;
};
var getBelowMinFilesCheck = ({ minItems }, messageFunctions) => (value) => {
  if (isNumber(minItems) && isArray(value) && value.length > 0 && value.length < minItems) {
    return messageFunctions.minFiles(minItems);
  }
  return null;
};
var getAboveMaxFilesCheck = ({ maxItems }, messageFunctions) => (value) => {
  if (isNumber(maxItems) && isArray(value) && value.length > maxItems) {
    return messageFunctions.maxFiles(maxItems);
  }
  return null;
};
var getFileSizeCheck = (schema, messageFunctions) => (value) => {
  const maxSize = "persistAsync" in schema ? schema.persistAsync.schema.maxSize : schema.maxSize;
  if (maxSize && value && value.size > maxSize) {
    return messageFunctions.maxSize();
  }
  return null;
};
var getFileTypeCheck = (schema, messageFunctions) => (value) => {
  const accepts = "persistAsync" in schema ? schema.persistAsync.schema.accepts : schema.accepts;
  if (accepts && value && !accepts.includes(value.type)) {
    return messageFunctions.accepts();
  }
  return null;
};
var getBelowMinItemsCheck = ({ minItems }, messageFunctions) => (value) => {
  if (isNumber(minItems) && isArray(value) && value.length > 0 && value.length < minItems) {
    return messageFunctions.minItems(minItems);
  }
  return null;
};
var getAboveMaxLengthCheck = ({ maxLength }, messageFunctions) => (value) => {
  if (isNumber(maxLength) && isString(value) && value.length > maxLength) {
    return messageFunctions.maxLength(maxLength);
  }
  return null;
};
var getBelowMinLengthCheck = ({ minLength }, messageFunctions) => (value) => {
  if (isNumber(minLength) && isString(value) && value && value.length < minLength) {
    return messageFunctions.minLength(minLength);
  }
  return null;
};
var getAboveMaximumCheck = ({ maximum }, messageFunctions) => (value) => {
  if (isNumber(maximum) && isNumber(value) && value > maximum) {
    return messageFunctions.maximum(maximum);
  }
  return null;
};
var getBelowMinimumCheck = ({ minimum }, messageFunctions) => (value) => {
  if (isNumber(minimum) && isNumber(value) && value < minimum) {
    return messageFunctions.minimum(minimum);
  }
  return null;
};
var getAboveMaximumDateCheck = ({ maximum }, messageFunctions) => (value) => {
  if (isString(maximum) && isString(value) && value > maximum) {
    return messageFunctions.maximumDate(maximum);
  }
  return null;
};
var getBelowMinimumDateCheck = ({ minimum }, messageFunctions) => (value) => {
  if (isString(minimum) && isString(value) && value && value < minimum) {
    return messageFunctions.minimumDate(minimum);
  }
  return null;
};
var getNotAdheringToPatternCheck = ({ pattern }, messageFunctions, options) => {
  validateStringPattern(pattern, options == null ? void 0 : options.logEvent);
  return (value) => {
    if (isString(pattern) && isString(value) && value) {
      return new RegExp(pattern).test(value) ? null : messageFunctions.pattern();
    }
    return null;
  };
};
var getRequiredCheck = (required, messageFunctions) => (value) => {
  if (!required) {
    return null;
  }
  if (isArray(value) && value.length === 0) {
    return messageFunctions.required();
  }
  return isNullish(value) ? messageFunctions.required() : null;
};

// src/revamp/domain/mappers/utils/getAutocompleteString.ts
var getAutocompleteString = (hints) => {
  if (!hints || hints.length === 0) {
    return "off";
  }
  const validHints = hints.filter((hint) => autocompleteTokenMap[hint]);
  if (validHints.length === 0) {
    return "off";
  }
  return validHints.map((hint) => autocompleteTokenMap[hint]).join(" ");
};
var autocompleteTokenMap = {
  on: "on",
  name: "name",
  "name-prefix": "honorific-prefix",
  "given-name": "given-name",
  "additional-name": "additional-name",
  "family-name": "family-name",
  "name-suffix": "honorific-suffix",
  nickname: "nickname",
  email: "email",
  // Web doesn't have a specific mapping for new username, but this is semantically close enough
  "new-username": "username",
  username: "username",
  "new-password": "new-password",
  password: "current-password",
  "one-time-code": "one-time-code",
  "job-title": "organization-title",
  "organization-name": "organization",
  "full-street-address": "street-address",
  "street-address-line-1": "address-line1",
  "street-address-line-2": "address-line2",
  "street-address-line-3": "address-line3",
  "address-level-1": "address-level1",
  "address-level-2": "address-level2",
  "address-level-3": "address-level3",
  "address-level-4": "address-level4",
  "country-code": "country",
  "country-name": "country-name",
  "postal-code": "postal-code",
  "credit-card-name": "cc-name",
  "credit-card-given-name": "cc-given-name",
  "credit-card-middle-name": "cc-additional-name",
  "credit-card-family-name": "cc-family-name",
  "credit-card-number": "cc-number",
  "credit-card-expiration": "cc-exp",
  "credit-card-expiration-month": "cc-exp-month",
  "credit-card-expiration-year": "cc-exp-year",
  "credit-card-security-code": "cc-csc",
  "credit-card-type": "cc-type",
  "transaction-currency": "transaction-currency",
  "transaction-amount": "transaction-amount",
  language: "language",
  birthdate: "bday",
  "birthdate-day": "bday-day",
  "birthdate-month": "bday-month",
  "birthdate-year": "bday-year",
  gender: "sex",
  "phone-number": "tel",
  "phone-country-code": "tel-country-code",
  "phone-national": "tel-national",
  "phone-area-code": "tel-area-code",
  "phone-local": "tel-local",
  "phone-local-prefix": "tel-local-prefix",
  "phone-local-suffix": "tel-local-suffix",
  "phone-extension": "tel-extension",
  url: "url",
  photo: "photo",
  impp: "impp",
  shipping: "shipping",
  billing: "billing",
  home: "home",
  work: "work",
  mobile: "mobile",
  fax: "fax",
  pager: "pager"
};

// src/revamp/flow/response-utils.ts
import { validateActionResponse } from "@wise/dynamic-flow-types";
var assertResponseIsValid = (response) => {
  if (!isResponse(response)) {
    throw new Error("Incorrect type of response from fetch. Expected object of type Response.");
  }
  if (response.bodyUsed) {
    throw new Error(
      "The body of the provided Response object has already been used. Every request must respond with a new Response object."
    );
  }
};
var isResponse = (response) => typeof response === "object" && response !== null && "clone" in response && "bodyUsed" in response;
var parseResponseBodyAsJsonElement = async (response) => {
  try {
    return await response.json();
  } catch (e) {
    return null;
  }
};
function isActionResponseBody(body) {
  return validateActionResponse(body).valid;
}
function assertActionResponseBody(body) {
  if (!isObject(body) || !isObject(body.action)) {
    throw new Error(
      "Incorrect response body in action response. Expected an object satisfying the type { action: Action }."
    );
  }
}
function isErrorResponseBody(body) {
  return Boolean(
    isObject(body) && (body.refreshFormUrl || body.refreshUrl || body.validation || body.error || body.analytics)
  );
}
function assertStepResponseBody(body) {
  if (!isObject(body)) {
    throw new Error("Incorrect response body in step response. Expected an object.");
  }
}

// src/revamp/domain/features/utils/response-utils.ts
var getAnalyticsFromErrorResponse = (json) => {
  if (!isErrorResponseBody(json)) {
    return void 0;
  }
  const { analytics } = json;
  return isObject(analytics) ? analytics : void 0;
};

// src/revamp/domain/features/persistAsync/getPerformPersistAsync.ts
var getPerformPersistAsync = ({
  genericErrorMessage,
  httpClient,
  persistAsyncConfig,
  schemaId,
  logEvent,
  trackEvent
}) => {
  const { idProperty, param, method, url } = persistAsyncConfig;
  const trackFailure = (json) => {
    const analytics = getAnalyticsFromErrorResponse(json);
    trackEvent("PersistAsync Failed", __spreadValues({ schema: schemaId }, analytics));
  };
  return async function performPersistAsync({ value, signal }) {
    let response;
    let json;
    try {
      trackEvent("PersistAsync Triggered", { schema: schemaId });
      response = await httpClient(
        url,
        constructPayload({ value, signal, requestConfig: { method, param } })
      );
      json = await response.json();
      if (response.ok && isObject(json)) {
        trackEvent("PersistAsync Succeeded", { schema: schemaId });
        if (json[idProperty] === void 0) {
          logEvent(
            "error",
            `Response from persist async did not contain expected property ${idProperty}.`
          );
          throw new Error(genericErrorMessage);
        }
        return json[idProperty];
      }
    } catch (error) {
      trackFailure();
      throw new Error(genericErrorMessage);
    }
    const validationError = !response.ok && isObject(json) ? getValidationError(param, json) : null;
    trackFailure(json);
    throw new Error(validationError != null ? validationError : genericErrorMessage);
  };
};
var getValidationError = (param, response) => {
  var _a;
  const message = (_a = response.validation) == null ? void 0 : _a[param];
  return isString(message) ? message : null;
};

// src/revamp/domain/features/persistAsync/getInitialPersistedState.ts
var getInitialPersistedState = (lastSubmitted, model) => ({
  abortController: new AbortController(),
  lastSubmitted: !isNullish(model) ? lastSubmitted != null ? lastSubmitted : null : null,
  lastResponse: model != null ? model : null,
  submission: Promise.resolve(model != null ? model : null)
});

// src/revamp/domain/mappers/schema/utils/getPersistAsyncInitialState.ts
var getPersistAsyncInitialState = (schemaMapperProps, mapperProps) => {
  const { localValue, model } = schemaMapperProps;
  const performPersistAsync = getPerformPersisAsyncFn(schemaMapperProps, mapperProps);
  const persistedState = performPersistAsync ? getInitialPersistedState(localValue, model) : getInitialPersistedState();
  return { performPersistAsync, persistedState };
};
var getPerformPersisAsyncFn = (schemaMapperProps, mapperProps) => {
  const { schema, persistAsyncConfig } = schemaMapperProps;
  const { trackEvent, logEvent } = mapperProps;
  if (!persistAsyncConfig) {
    return void 0;
  }
  const { $id, analyticsId } = schema;
  const { getErrorMessageFunctions, httpClient } = mapperProps;
  const validationMessages = schemaHasValidationMessages(schema) ? schema.validationMessages : void 0;
  const errorMessageFunctions = getErrorMessageFunctions(validationMessages);
  const persistAsyncError = errorMessageFunctions.genericError();
  return getPerformPersistAsync({
    genericErrorMessage: persistAsyncError,
    httpClient,
    logEvent,
    persistAsyncConfig,
    schemaId: analyticsId != null ? analyticsId : $id,
    trackEvent
  });
};
var schemaHasValidationMessages = (schema) => Boolean("validationMessages" in schema && schema.validationMessages);

// src/revamp/domain/mappers/schema/utils/mapCommonSchemaProps.ts
var mapCommonSchemaProps = (schemaMapperProps) => {
  var _a;
  const { uid, schema, required, validationErrors } = schemaMapperProps;
  const { $id, analyticsId, control, description, icon, image, keywords, title, hidden } = schema;
  return __spreadValues(__spreadValues({
    uid,
    id: $id != null ? $id : uid,
    analyticsId: (_a = analyticsId != null ? analyticsId : $id) != null ? _a : "",
    control,
    description,
    disabled: schemaHasDisabled(schema) ? schema.disabled : false,
    errors: isString(validationErrors) ? [validationErrors] : void 0,
    hidden: Boolean(hidden),
    icon,
    image: mapSpecImage(image),
    keywords,
    required: Boolean(required),
    title,
    summariser: getSummariser(schema)
  }, schemaHasHelp(schema) ? { help: schema.help.markdown } : {}), schemaHasPlaceholder(schema) ? { placeholder: schema.placeholder } : {});
};
var schemaHasDisabled = (schema) => Boolean("disabled" in schema && schema.disabled !== void 0);
var schemaHasHelp = (schema) => Boolean("help" in schema && schema.help);
var schemaHasPlaceholder = (schema) => Boolean("placeholder" in schema && schema.placeholder);

// src/revamp/domain/features/validationAsync/getPerformValidationAsync.ts
var getPerformValidationAsync = ({
  httpClient,
  validationAsyncConfig,
  schemaId,
  trackEvent
}) => {
  const { method, param, url } = validationAsyncConfig;
  const trackFailureAndReturn = (json) => {
    const analytics = getAnalyticsFromErrorResponse(json);
    trackEvent("ValidationAsync Failed", __spreadValues({ schema: schemaId }, analytics));
    return null;
  };
  return async function performValidationAsync({ value, signal }) {
    let response;
    trackEvent("ValidationAsync Triggered", { schema: schemaId });
    try {
      response = await httpClient(
        url,
        constructPayload({ value, signal, requestConfig: { method, param } })
      );
    } catch (e) {
      return trackFailureAndReturn();
    }
    const json = await response.json().catch(() => null);
    const message = getValidationMessage(json);
    if (response.ok) {
      trackEvent("ValidationAsync Succeeded", { schema: schemaId });
      return message;
    }
    if (response.status === 422) {
      if (message) {
        trackEvent("ValidationAsync Succeeded", { schema: schemaId });
        throw new Error(message);
      }
    }
    return trackFailureAndReturn(json);
  };
};
var getValidationMessage = (json) => {
  if (!isObject(json)) {
    return null;
  }
  const { message } = json;
  return isString(message) ? message : null;
};

// src/revamp/domain/features/validationAsync/getInitialValidationAsyncState.ts
var getInitialValidationAsyncState = () => ({
  abortController: new AbortController(),
  lastSubmitted: null,
  messages: {}
});

// src/revamp/domain/mappers/schema/utils/getValidationAsyncInitialState.ts
var getValidationAsyncInitialState = (schemaMapperProps, mapperProps) => {
  const performValidationAsync = getValidationAsyncFn(schemaMapperProps, mapperProps);
  const validationAsyncState = getInitialValidationAsyncState();
  return { performValidationAsync, validationAsyncState };
};
var getValidationAsyncFn = (schemaMapperProps, mapperProps) => {
  const { schema } = schemaMapperProps;
  const { trackEvent } = mapperProps;
  if (!schemaHasValidationAsync(schema)) {
    return void 0;
  }
  const { $id, analyticsId, validationAsync } = schema;
  const { httpClient } = mapperProps;
  return getPerformValidationAsync({
    httpClient,
    validationAsyncConfig: validationAsync,
    schemaId: analyticsId != null ? analyticsId : $id,
    trackEvent
  });
};
var schemaHasValidationAsync = (schema) => Boolean("validationAsync" in schema && schema.validationAsync);

// src/revamp/domain/mappers/schema/numberSchemaToComponent.ts
var numberSchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { schema, model, localValue, required = false } = schemaMapperProps;
  const { autocompleteHint, validationMessages, default: defaultValue, maximum, minimum } = schema;
  const { getErrorMessageFunctions, updateComponent, onRefresh, onValueChange } = mapperProps;
  const errorMessageFunctions = getErrorMessageFunctions(validationMessages);
  const { performPersistAsync, persistedState } = getPersistAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const { performValidationAsync, validationAsyncState } = getValidationAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const validLocalValue = isNumber(localValue) ? localValue : null;
  const validModel = isNumber(model) ? model : defaultValue != null ? defaultValue : null;
  const value = performPersistAsync ? validLocalValue : validModel;
  return createNumberInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      autoComplete: getAutocompleteString(autocompleteHint),
      checks: [
        getRequiredCheck(required, errorMessageFunctions),
        getBelowMinimumCheck(schema, errorMessageFunctions),
        getAboveMaximumCheck(schema, errorMessageFunctions)
      ],
      value,
      maximum,
      minimum,
      persistedState,
      validationAsyncState,
      performPersistAsync,
      performRefresh: getPerformRefresh(schema, onRefresh),
      performValidationAsync,
      onValueChange
    }),
    updateComponent
  );
};

// src/revamp/domain/components/ObjectComponent.ts
var createObjectComponent = (objectProps) => {
  const {
    uid,
    analyticsId,
    componentMap,
    control,
    description,
    displayOrder,
    help,
    hidden,
    icon,
    image,
    summariser,
    title
  } = objectProps;
  return {
    type: "object",
    uid,
    analyticsId,
    componentMap,
    control,
    description,
    help,
    hidden,
    icon,
    image,
    title,
    getChildren() {
      return displayOrder.map((propName) => this.componentMap[propName]);
    },
    async getSubmittableValue() {
      return Promise.all(
        displayOrder.map(
          async (propName) => this.componentMap[propName].getSubmittableValue().then((value) => ({ value, propName }))
        )
      ).then(
        (values) => values.reduce(
          (acc, { value, propName }) => __spreadValues(__spreadValues({}, acc), value === null ? {} : { [propName]: value }),
          {}
        )
      );
    },
    getSubmittableValueSync() {
      return mergeChildrenValues(
        displayOrder,
        (propName) => this.componentMap[propName].getSubmittableValueSync()
      );
    },
    getSummary() {
      const summary = summariser(this.getLocalValue());
      const childSummary = summariseFromChildren(this.getChildren());
      return mergeSummaries(summary, childSummary);
    },
    getLocalValue() {
      return mergeChildrenValues(
        displayOrder,
        (propName) => this.componentMap[propName].getLocalValue()
      );
    },
    validate() {
      return hidden ? true : validateComponents(this.getChildren());
    }
  };
};
var mergeChildrenValues = (displayOrder, getComponentValue) => displayOrder.reduce((acc, propName) => {
  const componentValue = getComponentValue(propName);
  return __spreadValues(__spreadValues({}, acc), componentValue === null ? {} : { [propName]: componentValue });
}, {});

// src/revamp/domain/mappers/schema/objectSchemaToComponent/objectSchemaToComponent.ts
var objectSchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { uid, localValue, schema, model, validationErrors } = schemaMapperProps;
  const { $id, displayOrder, properties, required } = schema;
  validateDisplayOrder($id, displayOrder, properties, mapperProps.logEvent);
  const componentMap = displayOrder.reduce((acc, propName) => {
    var _a;
    const propSchema = properties[propName];
    if (propSchema === void 0) {
      throw new Error(`Object schema ${$id} has no property named ${propName}`);
    }
    return __spreadProps(__spreadValues({}, acc), {
      [propName]: mapSchemaToComponent(
        {
          uid: `${uid}.obj-${propName}`,
          schema: propSchema,
          model: isObjectModel(model) ? model[propName] : null,
          localValue: isObjectLocalValue(localValue) ? localValue[propName] : null,
          required: (_a = required == null ? void 0 : required.includes(propName)) != null ? _a : false,
          validationErrors: isObject(validationErrors) ? validationErrors[propName] : void 0
        },
        mapperProps
      )
    });
  }, {});
  return createObjectComponent(__spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
    componentMap,
    displayOrder
  }));
};
var validateDisplayOrder = ($id, displayOrder, properties, logEvent) => {
  if (!displayOrder) {
    const message = `Object schema ${$id} has no displayOrder property.`;
    logEvent("error", message);
    throw new Error(message);
  }
  const propertyNames = Object.keys(properties);
  displayOrder.forEach((propName) => {
    if (!properties[propName]) {
      const message = `Object schema ${$id} has no property named "${propName}", but it is listed in the displayOrder array.`;
      logEvent("error", message);
      throw new Error(message);
    }
  });
  propertyNames.forEach((propName) => {
    if (!displayOrder.includes(propName)) {
      const message = `Object schema ${$id} has a "${propName}" property which is missing in the displayOrder array.`;
      logEvent("error", message);
      throw new Error(message);
    }
  });
};

// src/revamp/domain/components/AllOfComponent.ts
var createAllOfComponent = (allOfProps) => {
  const { uid, analyticsId, components, control, description, help, hidden, icon, image, title } = allOfProps;
  return {
    type: "all-of",
    uid,
    analyticsId,
    components,
    control,
    description,
    help,
    hidden,
    icon,
    image,
    title,
    getChildren() {
      return this.components;
    },
    getSummary() {
      return summariseFromChildren(this.getChildren());
    },
    async getSubmittableValue() {
      return getSubmittableData(this.components);
    },
    getSubmittableValueSync() {
      return getSubmittableDataSync(this.components);
    },
    getLocalValue() {
      return getLocalValues(this.components);
    },
    validate() {
      return hidden ? true : validateComponents(this.getChildren());
    }
  };
};

// src/revamp/domain/mappers/schema/allOfSchemaToComponent.ts
var allOfSchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { uid, schema, localValue, model, required, validationErrors } = schemaMapperProps;
  const { allOf } = schema;
  const components = allOf.map(
    (childSchema, index) => mapSchemaToComponent(
      {
        uid: `${uid}.allOf-${index}`,
        schema: childSchema,
        model,
        localValue,
        required,
        validationErrors
      },
      mapperProps
    )
  );
  return createAllOfComponent(__spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
    components
  }));
};

// src/revamp/domain/components/ConstComponent.ts
var createConstComponent = (hiddenProps) => {
  const { uid, analyticsId, value, summary } = hiddenProps;
  return {
    type: "const",
    uid,
    analyticsId,
    getLocalValue: () => value,
    getSubmittableValue: async () => value,
    getSubmittableValueSync: () => value,
    getSummary: () => summary,
    validate: () => true
  };
};

// src/revamp/domain/mappers/schema/constSchemaToComponent.ts
var constSchemaToComponent = (uid, schemaMapperProps) => {
  var _a;
  const { schema } = schemaMapperProps;
  const { title, const: constValue, analyticsId, $id } = schema;
  const titleOrValue = (_a = title != null ? title : constValue) != null ? _a : null;
  return createConstComponent({
    uid,
    analyticsId: analyticsId != null ? analyticsId : $id,
    summary: getConstSummary(schema, titleOrValue),
    value: schema.const
  });
};

// src/revamp/domain/components/IntegerInputComponent.ts
var createIntegerInputComponent = (integerInputProps, updateComponent) => {
  const _a = integerInputProps, {
    uid,
    id,
    checks,
    value,
    performPersistAsync,
    performRefresh,
    performValidationAsync,
    onValueChange,
    summariser
  } = _a, rest = __objRest(_a, [
    "uid",
    "id",
    "checks",
    "value",
    "performPersistAsync",
    "performRefresh",
    "performValidationAsync",
    "onValueChange",
    "summariser"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const getValidationErrors = getLocalValueValidator(checks);
  const performDebouncedRefresh = getDebouncedPerformRefresh(performRefresh, getValidationErrors);
  const getAndSetValidationErrors = (currentValue) => {
    const messages = getValidationErrors(currentValue);
    update((draft) => {
      draft.errors = messages;
    });
    return messages;
  };
  const integerComponent = __spreadValues({
    type: "integer",
    uid,
    id,
    value,
    onBlur() {
      getAndSetValidationErrors(this.getLocalValue());
      performDebouncedRefresh == null ? void 0 : performDebouncedRefresh.flush();
    },
    onFocus() {
    },
    // Noop
    onChange(updatedValue) {
      const prevValue = this.value;
      update((draft) => {
        draft.errors = [];
        draft.validationAsyncState.messages = {};
        draft.value = updatedValue;
      });
      performDebouncedRefresh == null ? void 0 : performDebouncedRefresh(prevValue, updatedValue);
      onValueChange();
    },
    async getSubmittableValue() {
      return this.getSubmittableValueSync();
    },
    getSubmittableValueSync() {
      var _a2;
      return (_a2 = this.getLocalValue()) != null ? _a2 : null;
    },
    getSummary() {
      return summariser(this.getLocalValue());
    },
    getLocalValue() {
      return this.value;
    },
    validate() {
      const messages = getAndSetValidationErrors(this.getLocalValue());
      return messages.length === 0;
    }
  }, rest);
  if (performRefresh) {
    return integerComponent;
  }
  if (performPersistAsync) {
    const persist = getComponentPersistAsync(update, performPersistAsync);
    return __spreadProps(__spreadValues({}, integerComponent), {
      onBlur() {
        if (this.validate()) {
          persist(this.persistedState, this.getLocalValue()).catch(() => {
          });
        }
      },
      async getSubmittableValue() {
        return persist(this.persistedState, this.getLocalValue());
      },
      getSubmittableValueSync() {
        return this.persistedState.lastResponse;
      }
    });
  }
  if (performValidationAsync) {
    const validateAsync = getDebouncedComponentValidationAsync(update, performValidationAsync);
    return __spreadProps(__spreadValues({}, integerComponent), {
      onBlur() {
        if (this.validate()) {
          validateAsync.flush();
        }
      },
      onChange(updatedValue) {
        integerComponent.onChange.call(this, updatedValue);
        if (getValidationErrors(updatedValue).length === 0) {
          validateAsync(this.validationAsyncState, updatedValue);
        }
      }
    });
  }
  return integerComponent;
};

// src/revamp/domain/mappers/schema/integerSchemaToComponent.ts
var integerSchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { schema, localValue, model, required = false } = schemaMapperProps;
  const { autocompleteHint, validationMessages, default: defaultValue, maximum, minimum } = schema;
  const { getErrorMessageFunctions, updateComponent, onRefresh, onValueChange } = mapperProps;
  const errorMessageFunctions = getErrorMessageFunctions(validationMessages);
  const { performPersistAsync, persistedState } = getPersistAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const { performValidationAsync, validationAsyncState } = getValidationAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const validLocalValue = isInteger(localValue) ? localValue : null;
  const validModel = isInteger(model) ? model : defaultValue != null ? defaultValue : null;
  const value = performPersistAsync ? validLocalValue : validModel;
  const checks = [
    getRequiredCheck(required, errorMessageFunctions),
    getBelowMinimumCheck(schema, errorMessageFunctions),
    getAboveMaximumCheck(schema, errorMessageFunctions)
  ];
  return createIntegerInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      autoComplete: getAutocompleteString(autocompleteHint),
      checks,
      maximum,
      minimum,
      persistedState,
      value,
      validationAsyncState,
      performPersistAsync,
      performRefresh: getPerformRefresh(schema, onRefresh),
      performValidationAsync,
      onValueChange
    }),
    updateComponent
  );
};

// src/revamp/domain/components/utils/isPartialModelMatch.ts
var isPartialModelMatch = (localModel, incomingModel) => {
  if (isArrayModel(localModel) && isArrayModel(incomingModel)) {
    return localModel.length === incomingModel.length && localModel.every((value, index) => isPartialModelMatch(value, incomingModel[index]));
  }
  if (isObjectModel(localModel) && isObjectModel(incomingModel)) {
    if (Object.keys(localModel).length === 0 && Object.keys(incomingModel).length === 0) {
      return true;
    }
    const nonNullishKeysInBoth = nonNullishKeys(localModel).filter(
      (key) => nonNullishKeys(incomingModel).includes(key)
    );
    return nonNullishKeysInBoth.length > 0 && nonNullishKeysInBoth.every((key) => isPartialModelMatch(localModel[key], incomingModel[key]));
  }
  return localModel === incomingModel;
};
var nonNullishKeys = (model) => Object.keys(model).filter((key) => !isNullish(model[key]));

// src/revamp/domain/components/SelectInputComponent.ts
var createSelectInputComponent = (selectProps, updateComponent) => {
  const _a = selectProps, { uid, checks, initialModel, options, performRefresh, onValueChange, summariser } = _a, rest = __objRest(_a, ["uid", "checks", "initialModel", "options", "performRefresh", "onValueChange", "summariser"]);
  const children = options.map((option) => option.component);
  const matchingOptions = options.map(
    (option) => isPartialModelMatch(option.component.getSubmittableValueSync(), initialModel)
  );
  const selectedIndex = matchingOptions.filter((match) => match).length === 1 ? matchingOptions.indexOf(true) : null;
  const update = getInputUpdateFunction(uid, updateComponent);
  const getValidationErrors = getLocalValueValidator(checks);
  const getAndSetValidationErrors = (currentValue) => {
    const messages = getValidationErrors(currentValue);
    update((draft) => {
      draft.errors = messages;
    });
    return messages;
  };
  return __spreadProps(__spreadValues({
    uid,
    type: "select",
    children,
    options,
    selectedIndex,
    value: null
  }, rest), {
    getChildren() {
      return this.children;
    },
    getSelectedChild() {
      return this.selectedIndex !== null ? this.children[this.selectedIndex] : null;
    },
    async getSubmittableValue() {
      var _a2, _b;
      return (_b = await ((_a2 = this.getSelectedChild()) == null ? void 0 : _a2.getSubmittableValue())) != null ? _b : null;
    },
    getSubmittableValueSync() {
      var _a2, _b;
      return (_b = (_a2 = this.getSelectedChild()) == null ? void 0 : _a2.getSubmittableValueSync()) != null ? _b : null;
    },
    getSummary() {
      var _a2, _b;
      return (_b = (_a2 = this.getSelectedChild()) == null ? void 0 : _a2.getSummary()) != null ? _b : {};
    },
    getLocalValue() {
      var _a2, _b;
      return (_b = (_a2 = this.getSelectedChild()) == null ? void 0 : _a2.getLocalValue()) != null ? _b : null;
    },
    onBlur() {
      getAndSetValidationErrors(this.getLocalValue());
    },
    onFocus() {
    },
    // noop
    onSelect(updatedIndex) {
      if (updatedIndex !== null && this.analyticsId) {
        selectProps.trackEvent("OneOf Selected", {
          oneOfId: this.analyticsId,
          schemaId: this.children[updatedIndex].analyticsId
        });
      }
      update((draft) => {
        draft.errors = [];
        draft.selectedIndex = updatedIndex;
      });
      performRefresh == null ? void 0 : performRefresh();
      onValueChange();
    },
    validate() {
      var _a2, _b;
      const validChild = (_b = (_a2 = this.getSelectedChild()) == null ? void 0 : _a2.validate()) != null ? _b : true;
      const messages = getAndSetValidationErrors(this.getLocalValue());
      return messages.length === 0 && validChild;
    }
  });
};

// src/revamp/domain/mappers/schema/oneOfSchemaToComponent/oneOfSchemaToComponent.ts
var oneOfSchemaToComponent = (schemaMapperProps, mapperProps) => {
  var _a;
  const {
    uid,
    localValue,
    schema,
    model,
    validationErrors: initialError,
    required = false
  } = schemaMapperProps;
  const initialModel = (_a = model != null ? model : schema.default) != null ? _a : null;
  if (schema.oneOf.length === 1 && isFormSectionSchema(schema.oneOf[0])) {
    return mapSchemaToComponent(
      {
        uid,
        schema: supressSchemaTitleAndDescription(schema.oneOf[0]),
        model: initialModel,
        localValue,
        validationErrors: initialError,
        required
      },
      mapperProps
    );
  }
  const options = schema.oneOf.map((childSchema, index) => {
    const { title = "", description, image, icon, keywords = [] } = childSchema;
    return {
      title,
      description,
      image: mapSpecImage(image),
      icon,
      keywords,
      disabled: "disabled" in childSchema ? Boolean(childSchema.disabled) : false,
      component: mapSchemaToComponent(
        {
          uid: `${uid}.oneOf-${index}`,
          schema: isFormSectionSchema(childSchema) ? supressSchemaTitleAndDescription(childSchema) : childSchema,
          model: initialModel,
          localValue,
          validationErrors: initialError,
          required
        },
        mapperProps
      )
    };
  });
  const { getErrorMessageFunctions, updateComponent, trackEvent, onRefresh, onValueChange } = mapperProps;
  const { validationMessages } = schema;
  const errorMessageFunctions = getErrorMessageFunctions(validationMessages);
  return createSelectInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      autoComplete: getAutocompleteString(schema.autocompleteHint),
      checks: schema.hidden ? [] : [getRequiredCheck(required, errorMessageFunctions)],
      options,
      initialModel,
      performRefresh: getPerformRefresh(schema, onRefresh),
      onValueChange,
      trackEvent
    }),
    updateComponent
  );
};
var isFormSectionSchema = (schema) => isObjectSchema(schema) || isArrayTupleSchema(schema) || isAllOfSchema(schema);
var supressSchemaTitleAndDescription = (schema) => {
  const _a = schema, { title, description } = _a, headlessSchema = __objRest(_a, ["title", "description"]);
  return headlessSchema;
};

// src/revamp/domain/components/DateInputComponent.ts
var createDateInputComponent = (textInputProps, updateComponent) => {
  const _a = textInputProps, {
    uid,
    id,
    checks,
    performPersistAsync,
    performRefresh,
    performValidationAsync,
    onValueChange,
    summariser,
    value
  } = _a, rest = __objRest(_a, [
    "uid",
    "id",
    "checks",
    "performPersistAsync",
    "performRefresh",
    "performValidationAsync",
    "onValueChange",
    "summariser",
    "value"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const getValidationErrors = getLocalValueValidator(checks);
  const getAndSetValidationErrors = (currentValue) => {
    const messages = getValidationErrors(currentValue);
    update((draft) => {
      draft.errors = messages;
    });
    return messages;
  };
  const dateInputComponent = __spreadValues({
    type: "date",
    uid,
    id,
    value,
    onBlur() {
      getAndSetValidationErrors(this.getLocalValue());
    },
    onFocus() {
    },
    // Noop
    onChange(updatedValue) {
      const prevValue = this.value;
      update((draft) => {
        draft.errors = [];
        draft.validationAsyncState.messages = {};
        draft.value = updatedValue;
      });
      if (isOrWasValid(getValidationErrors, prevValue, updatedValue)) {
        performRefresh == null ? void 0 : performRefresh();
      }
      onValueChange();
    },
    async getSubmittableValue() {
      return this.getSubmittableValueSync();
    },
    getSubmittableValueSync() {
      var _a2;
      return (_a2 = this.getLocalValue()) != null ? _a2 : null;
    },
    getSummary() {
      return summariser(this.getLocalValue());
    },
    getLocalValue() {
      return this.value;
    },
    validate() {
      const messages = getAndSetValidationErrors(this.getLocalValue());
      return messages.length === 0;
    }
  }, rest);
  if (performRefresh) {
    return dateInputComponent;
  }
  if (performPersistAsync) {
    const persist = getComponentPersistAsync(update, performPersistAsync);
    return __spreadProps(__spreadValues({}, dateInputComponent), {
      onChange(updatedValue) {
        dateInputComponent.onChange.call(this, updatedValue);
        const isValid = getValidationErrors(updatedValue).length === 0;
        if (isValid) {
          persist(this.persistedState, this.getLocalValue()).catch(() => {
          });
        }
      },
      async getSubmittableValue() {
        return persist(this.persistedState, this.getLocalValue());
      },
      getSubmittableValueSync() {
        return this.persistedState.lastResponse;
      }
    });
  }
  if (performValidationAsync) {
    const validateAsync = getComponentValidationAsync(update, performValidationAsync);
    return __spreadProps(__spreadValues({}, dateInputComponent), {
      onBlur() {
        if (this.validate()) {
          validateAsync(this.validationAsyncState, this.getLocalValue()).catch(() => {
          });
        }
      }
    });
  }
  return dateInputComponent;
};

// src/revamp/domain/mappers/schema/stringSchemaToComponent/stringSchemaToDateInputComponent.ts
var stringSchemaToDateInputComponent = (schemaMapperProps, mapperProps) => {
  const { schema, localValue, model, required = false } = schemaMapperProps;
  const {
    autocompleteHint,
    default: defaultValue,
    minimum: minimumDate,
    maximum: maximumDate,
    suggestions
  } = schema;
  const { getErrorMessageFunctions, updateComponent, onRefresh, onValueChange } = mapperProps;
  const errorMessageFunctions = getErrorMessageFunctions(schema.validationMessages);
  const { performPersistAsync, persistedState } = getPersistAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const { performValidationAsync, validationAsyncState } = getValidationAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const validLocalValue = isString(localValue) ? localValue : null;
  const validModel = isString(model) ? model : defaultValue != null ? defaultValue : null;
  const value = performPersistAsync ? validLocalValue : validModel;
  return createDateInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      autoComplete: getAutocompleteString(autocompleteHint),
      checks: schema.hidden ? [] : [
        getRequiredCheck(required, errorMessageFunctions),
        getAboveMaximumDateCheck(schema, errorMessageFunctions),
        getBelowMinimumDateCheck(schema, errorMessageFunctions)
      ],
      minimumDate,
      maximumDate,
      suggestions: suggestions ? {
        values: suggestions.values.map((suggestion) => __spreadProps(__spreadValues({}, suggestion), {
          image: mapSpecImage(suggestion.image)
        }))
      } : void 0,
      value,
      persistedState,
      validationAsyncState,
      performPersistAsync,
      performRefresh: getPerformRefresh(schema, onRefresh),
      performValidationAsync,
      onValueChange
    }),
    updateComponent
  );
};

// src/revamp/domain/components/utils/file-utils.ts
var toBase64 = async (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => resolve(reader.result));
  reader.addEventListener("error", reject);
  reader.readAsDataURL(file);
});
var base64dataUrltoFile = (dataurl, filename) => {
  if (!isBase64DataUrl(dataurl)) {
    return null;
  }
  const [, base64data] = dataurl.split(",");
  return new File([base64ToBytes(base64data)], filename, { type: getMimeType(dataurl) });
};
var isBase64DataUrl = (dataurl) => dataurl.startsWith("data:") && dataurl.includes("base64") && dataurl.includes(",");
var getMimeType = (base64dataUrl) => base64dataUrl.substring("data:".length).split(";")[0];
var base64ToBytes = (base64) => {
  const charCodes = atob(base64).split("").map((m) => m.charCodeAt(0));
  return Uint8Array.from(charCodes);
};

// src/revamp/domain/components/UploadInputComponent.ts
var createUploadInputComponent = (uploadInputProps, updateComponent) => {
  const _a = uploadInputProps, {
    uid,
    id,
    checks,
    format,
    value,
    performPersistAsync,
    performRefresh,
    onValueChange,
    summariser
  } = _a, rest = __objRest(_a, [
    "uid",
    "id",
    "checks",
    "format",
    "value",
    "performPersistAsync",
    "performRefresh",
    "onValueChange",
    "summariser"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const getValidationErrors = getLocalValueValidator(checks);
  const getAndSetValidationErrors = (currentValue) => {
    const messages = getValidationErrors(currentValue);
    update((draft) => {
      draft.errors = messages;
    });
    return messages;
  };
  const uploadComponent = __spreadValues({
    type: "upload",
    uid,
    id,
    format: "base64",
    value,
    onBlur() {
      getAndSetValidationErrors(this.getLocalValue());
    },
    onFocus() {
    },
    // Noop
    async onUpload(updatedValue) {
      update((draft) => {
        draft.errors = [];
        draft.value = updatedValue;
      });
      performRefresh == null ? void 0 : performRefresh();
      onValueChange();
    },
    async getSubmittableValue() {
      const file = this.getLocalValue();
      return file ? toBase64(file) : null;
    },
    getSubmittableValueSync() {
      return null;
    },
    getSummary() {
      var _a2, _b;
      return summariser((_b = (_a2 = this.getLocalValue()) == null ? void 0 : _a2.name) != null ? _b : null);
    },
    getLocalValue() {
      return this.value;
    },
    validate() {
      const messages = getAndSetValidationErrors(this.getLocalValue());
      return messages.length === 0;
    }
  }, rest);
  if (!performPersistAsync) {
    return uploadComponent;
  }
  const persist = getComponentPersistAsync(update, performPersistAsync);
  return __spreadProps(__spreadValues({}, uploadComponent), {
    format,
    async onUpload(file) {
      update((draft) => {
        draft.errors = [];
        draft.value = file;
      });
      onValueChange();
      const submission = format === "base64" && file ? await toBase64(file) : file;
      await persist(this.persistedState, submission).catch((error) => {
        update((draft) => {
          draft.persistedState.lastResponse = null;
          draft.persistedState.lastSubmitted = null;
          draft.persistedState.submission = Promise.resolve(null);
          draft.errors = [];
          draft.value = null;
        });
        throw error;
      });
      onValueChange();
    },
    async getSubmittableValue() {
      return this.persistedState.submission;
    },
    getSubmittableValueSync() {
      return this.persistedState.lastResponse;
    }
  });
};

// src/revamp/domain/mappers/schema/stringSchemaToComponent/stringSchemaToUploadInputComponent.ts
var stringSchemaToUploadInputComponent = (schemaMapperProps, mapperProps) => {
  var _a;
  const { schema, localValue, model, required = false } = schemaMapperProps;
  const { accepts, autocompleteHint, cameraConfig, hidden, maxSize, source, validationMessages } = schema;
  const { getErrorMessageFunctions, updateComponent, onRefresh, onValueChange } = mapperProps;
  const errorMessageFunctions = getErrorMessageFunctions(validationMessages);
  const { performPersistAsync } = getPersistAsyncInitialState(schemaMapperProps, mapperProps);
  const persistedState = performPersistAsync ? getInitialPersistedState(null, model) : getInitialPersistedState();
  const validLocalValue = isFile(localValue) ? localValue : null;
  const value = (_a = getFileFromModel(model)) != null ? _a : validLocalValue;
  const checks = hidden ? [] : [
    getRequiredCheck(required, errorMessageFunctions),
    getFileSizeCheck(schema, errorMessageFunctions),
    getFileTypeCheck(schema, errorMessageFunctions)
  ];
  return createUploadInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      accepts,
      autoComplete: getAutocompleteString(autocompleteHint),
      cameraConfig,
      checks,
      format: "base64",
      maxSize,
      source,
      value,
      persistedState,
      performPersistAsync,
      performRefresh: getPerformRefresh(schema, onRefresh),
      onValueChange
    }),
    updateComponent
  );
};
var getFileFromModel = (model) => isString(model) ? base64dataUrltoFile(model, "") : null;

// src/revamp/domain/components/TextInputComponent.ts
var createTextInputComponent = (textInputProps, updateComponent) => {
  const _a = textInputProps, {
    uid,
    id,
    checks,
    performPersistAsync,
    performRefresh,
    performValidationAsync,
    onValueChange,
    summariser,
    value
  } = _a, rest = __objRest(_a, [
    "uid",
    "id",
    "checks",
    "performPersistAsync",
    "performRefresh",
    "performValidationAsync",
    "onValueChange",
    "summariser",
    "value"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const getValidationErrors = getLocalValueValidator(checks);
  const performDebouncedRefresh = getDebouncedPerformRefresh(performRefresh, getValidationErrors);
  const getAndSetValidationErrors = (currentValue) => {
    const messages = getValidationErrors(currentValue);
    update((draft) => {
      draft.errors = messages;
    });
    return messages;
  };
  const inputComponent = __spreadValues({
    type: "text",
    uid,
    id,
    value,
    onBlur() {
      getAndSetValidationErrors(this.getLocalValue());
      performDebouncedRefresh == null ? void 0 : performDebouncedRefresh.flush();
    },
    onFocus() {
    },
    // Noop
    onChange(updatedValue) {
      const prevValue = this.value;
      update((draft) => {
        draft.errors = [];
        draft.validationAsyncState.messages = {};
        draft.value = updatedValue;
      });
      performDebouncedRefresh == null ? void 0 : performDebouncedRefresh(prevValue, updatedValue);
      onValueChange();
    },
    async getSubmittableValue() {
      return this.getSubmittableValueSync();
    },
    getSubmittableValueSync() {
      var _a2;
      return (_a2 = this.getLocalValue()) != null ? _a2 : null;
    },
    getSummary() {
      return summariser(this.getLocalValue());
    },
    getLocalValue() {
      return this.value;
    },
    validate() {
      const messages = getAndSetValidationErrors(this.getLocalValue());
      return messages.length === 0;
    }
  }, rest);
  if (performRefresh) {
    return inputComponent;
  }
  if (performPersistAsync) {
    const persist = getComponentPersistAsync(update, performPersistAsync);
    return __spreadProps(__spreadValues({}, inputComponent), {
      onBlur() {
        if (this.validate()) {
          persist(this.persistedState, this.getLocalValue()).catch(() => {
          });
        }
      },
      async getSubmittableValue() {
        return persist(this.persistedState, this.getLocalValue());
      },
      getSubmittableValueSync() {
        return this.persistedState.lastResponse;
      }
    });
  }
  if (performValidationAsync) {
    const validateAsync = getDebouncedComponentValidationAsync(update, performValidationAsync);
    return __spreadProps(__spreadValues({}, inputComponent), {
      onBlur() {
        if (this.validate()) {
          validateAsync.flush();
        }
      },
      onChange(updatedValue) {
        inputComponent.onChange.call(this, updatedValue);
        if (getValidationErrors(updatedValue).length === 0) {
          validateAsync(this.validationAsyncState, updatedValue);
        }
      }
    });
  }
  return inputComponent;
};

// src/revamp/domain/mappers/schema/stringSchemaToComponent/stringSchemaToTextInputComponent.ts
var stringSchemaToTextInputComponent = (schemaMapperProps, mapperProps) => {
  const { schema, localValue, model, required = false } = schemaMapperProps;
  const {
    autocapitalization,
    autocompleteHint,
    control,
    default: defaultValue,
    displayFormat,
    format,
    maxLength,
    minLength,
    suggestions,
    validationMessages
  } = schema;
  const { getErrorMessageFunctions, updateComponent, onRefresh, onValueChange, logEvent } = mapperProps;
  const controlForLegacyFormat = getControlForLegacyFormat(format);
  const errorMessageFunctions = getErrorMessageFunctions(validationMessages);
  const { performPersistAsync, persistedState } = getPersistAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const { performValidationAsync, validationAsyncState } = getValidationAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const validLocalValue = isString(localValue) ? localValue : null;
  const validModel = isString(model) ? model : defaultValue != null ? defaultValue : null;
  const value = performPersistAsync ? validLocalValue : validModel;
  return createTextInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      autocapitalization,
      autoComplete: getAutocompleteString(autocompleteHint),
      checks: schema.hidden ? [] : [
        getRequiredCheck(required, errorMessageFunctions),
        getAboveMaxLengthCheck(schema, errorMessageFunctions),
        getBelowMinLengthCheck(schema, errorMessageFunctions),
        getNotAdheringToPatternCheck(schema, errorMessageFunctions, { logEvent })
      ],
      control: control != null ? control : controlForLegacyFormat,
      displayFormat,
      maxLength,
      minLength,
      suggestions: suggestions ? {
        values: suggestions.values.map((suggestion) => __spreadProps(__spreadValues({}, suggestion), {
          image: mapSpecImage(suggestion.image)
        }))
      } : void 0,
      value,
      persistedState,
      validationAsyncState,
      performPersistAsync,
      performRefresh: getPerformRefresh(schema, onRefresh),
      performValidationAsync,
      onValueChange
    }),
    updateComponent
  );
};
var getControlForLegacyFormat = (format) => {
  if (format && ["numeric", "phone-number", "email", "password"].includes(format)) {
    return format;
  }
  return void 0;
};

// src/revamp/domain/mappers/schema/stringSchemaToComponent/stringSchemaToComponent.ts
var stringSchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { schema } = schemaMapperProps;
  if (isStringSchemaWithBase64(schema)) {
    return stringSchemaToUploadInputComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  switch (schema.format) {
    case "date":
      return stringSchemaToDateInputComponent(schemaMapperProps, mapperProps);
    default:
      return stringSchemaToTextInputComponent(schemaMapperProps, mapperProps);
  }
};
var isStringSchemaWithBase64 = (schema) => {
  return schema.format === "base64url" && !("persistAsync" in schema);
};

// src/revamp/domain/components/ContainerComponent.ts
var createContainerComponent = (containerProps) => __spreadProps(__spreadValues({}, containerProps), {
  type: "container",
  getChildren() {
    return this.components;
  },
  async getSubmittableValue() {
    return getSubmittableData(this.components);
  },
  getSubmittableValueSync() {
    return getSubmittableDataSync(this.components);
  },
  getSummary() {
    return summariseFromChildren(this.getChildren());
  },
  getLocalValue() {
    return getLocalValues(this.components);
  },
  validate() {
    return validateComponents(this.getChildren());
  }
});

// src/revamp/domain/components/RepeatableComponent.ts
var createRepeatableComponent = (repeatableProps, updateComponent) => {
  const _a = repeatableProps, {
    uid,
    id,
    checks,
    components,
    summary,
    onValueChange,
    createEditableComponent,
    summariser
  } = _a, componentProps = __objRest(_a, [
    "uid",
    "id",
    "checks",
    "components",
    "summary",
    "onValueChange",
    "createEditableComponent",
    "summariser"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const getValidationErrors = getLocalValueValidator(checks);
  return __spreadProps(__spreadValues({
    uid,
    id,
    type: "repeatable",
    components,
    editableComponent: null,
    editableIndex: null,
    summaryDefaults: {
      title: summary == null ? void 0 : summary.defaultTitle,
      description: summary == null ? void 0 : summary.defaultDescription,
      icon: summary == null ? void 0 : summary.defaultIcon,
      image: summary == null ? void 0 : summary.defaultImage
    }
  }, componentProps), {
    onEdit(itemIndex) {
      update((draft) => {
        draft.editableComponent = createEditableComponent(
          draft.components[itemIndex].getLocalValue()
        );
        draft.editableIndex = itemIndex;
      });
    },
    onAdd() {
      update((draft) => {
        draft.editableComponent = createEditableComponent(null);
        draft.editableIndex = null;
        draft.errors = [];
      });
    },
    onSave() {
      var _a2;
      const isValid = (_a2 = this.editableComponent) == null ? void 0 : _a2.validate();
      if (!isValid) {
        return false;
      }
      update((draft) => {
        if (draft.editableComponent === null) {
          return;
        }
        if (draft.editableIndex === null) {
          const newComponent = __spreadValues({}, draft.editableComponent);
          draft.components = [...this.components, newComponent];
        } else {
          draft.components[draft.editableIndex] = __spreadProps(__spreadValues({}, draft.editableComponent), {
            uid: draft.components[draft.editableIndex].uid
          });
        }
        draft.editableComponent = null;
        draft.editableIndex = null;
      });
      onValueChange();
      return true;
    },
    onRemove() {
      update((draft) => {
        if (draft.editableIndex === null) {
          return;
        }
        draft.components.splice(draft.editableIndex, 1);
        draft.editableComponent = null;
        draft.editableIndex = null;
      });
      onValueChange();
    },
    getChildren() {
      return this.editableComponent !== null ? [...this.components, this.editableComponent] : this.components;
    },
    async getSubmittableValue() {
      return Promise.all(this.components.map(async (component) => component.getSubmittableValue()));
    },
    getSubmittableValueSync() {
      return this.components.map((component) => component.getSubmittableValueSync());
    },
    getSummary() {
      return summariser(null);
    },
    getLocalValue() {
      return this.components.map((component) => component.getLocalValue());
    },
    validate() {
      const messages = getValidationErrors(this.getLocalValue());
      const childComponentsValid = validateComponents(this.getChildren());
      update((draft) => {
        draft.errors = messages;
      });
      return messages.length === 0 && childComponentsValid;
    }
  });
};

// src/revamp/domain/mappers/schema/arraySchemaToComponent/arraySchemaToRepeatableComponent.ts
var arraySchemaToRepeatableComponent = (schemaMapperProps, mapperProps) => {
  const { getErrorMessageFunctions } = mapperProps;
  const {
    uid,
    localValue,
    schema,
    model: initialModel,
    required = false,
    validationErrors
  } = schemaMapperProps;
  const { items, addItemTitle, editItemTitle, maxItems, minItems, summary } = schema;
  const value = isArray(localValue) ? localValue : [];
  const components = initialModel == null ? void 0 : initialModel.map(
    (item, index) => mapSchemaToComponent(
      {
        uid: `${uid}.arr-${index}`,
        schema: items,
        model: item,
        localValue: value == null ? void 0 : value[index],
        // TODO tests for this
        validationErrors
      },
      mapperProps
    )
  );
  const createEditableComponent = (editableValue) => mapSchemaToComponent(
    {
      uid: `${uid}.arr-rnd-${getRandomInt()}`,
      schema: items,
      localValue: editableValue,
      model: localValueToJsonElement(editableValue),
      validationErrors: void 0,
      required: true
    },
    mapperProps
  );
  const { onValueChange } = mapperProps;
  const errorMessageFunctions = getErrorMessageFunctions(schema.validationMessages);
  return createRepeatableComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      addItemTitle,
      checks: schema.hidden ? [] : [
        getRequiredCheck(required, errorMessageFunctions),
        getAboveMaxItemsCheck(schema, errorMessageFunctions),
        getBelowMinItemsCheck(schema, errorMessageFunctions)
      ],
      components: components != null ? components : [],
      editItemTitle,
      maxItems,
      minItems,
      summary: __spreadProps(__spreadValues({}, summary), {
        defaultImage: mapSpecImage(summary == null ? void 0 : summary.defaultImage)
      }),
      createEditableComponent,
      onValueChange
    }),
    mapperProps.updateComponent
  );
};
var localValueToJsonElement = (localValue) => {
  if (localValue instanceof Array) {
    return localValue.map(localValueToJsonElement);
  }
  if (isObject(localValue)) {
    return Object.fromEntries(
      Object.entries(localValue).map(([key, value]) => [key, localValueToJsonElement(value)])
    );
  }
  if (localValue instanceof File) {
    return localValue.name;
  }
  return localValue;
};
var getRandomInt = () => Math.floor(Math.random() * 1e8);

// src/revamp/domain/components/MultiUploadInputComponent.ts
var createMultiUploadInputComponent = (uploadInputProps, updateComponent) => {
  const _a = uploadInputProps, {
    uid,
    id,
    checks,
    fileChecks,
    format,
    performPersistAsync,
    onValueChange,
    summariser
  } = _a, rest = __objRest(_a, [
    "uid",
    "id",
    "checks",
    "fileChecks",
    "format",
    "performPersistAsync",
    "onValueChange",
    "summariser"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const getValidationErrors = getLocalValueValidator(checks);
  const getFileValidationErrors = getLocalValueValidator(fileChecks);
  const getAndSetValidationErrors = (currentValue) => {
    const messages = getValidationErrors(currentValue);
    update((draft) => {
      draft.errors = messages;
    });
    return messages;
  };
  const uploadComponent = __spreadValues({
    type: "multi-upload",
    uid,
    id,
    format: "base64",
    files: [],
    onBlur() {
      getAndSetValidationErrors(this.getLocalValue());
    },
    onFocus() {
    },
    // Noop
    async onRemoveFile(index) {
      update((draft) => {
        draft.value.splice(index, 1);
        draft.files.splice(index, 1);
      });
    },
    async onInsertFile(index, file) {
      const fileErrors = getFileValidationErrors(file);
      const fileId = getRandomId();
      update((draft) => {
        draft.value.splice(index, 0, file);
        draft.files.splice(index, 0, { file, id: fileId, errors: fileErrors });
        draft.errors = [];
      });
      onValueChange();
      return fileId;
    },
    async getSubmittableValue() {
      const files = this.getLocalValue();
      return files ? Promise.all(files.map(toBase64)) : null;
    },
    getSubmittableValueSync() {
      return null;
    },
    getSummary() {
      return summariser(this.getLocalValue().map(({ name }) => name));
    },
    getLocalValue() {
      return this.value;
    },
    validate() {
      const messages = getAndSetValidationErrors(this.getLocalValue());
      return messages.length === 0 && this.files.every(({ errors }) => errors.length === 0);
    }
  }, rest);
  if (!performPersistAsync) {
    return uploadComponent;
  }
  const persist = getComponentMultiPersistAsync(update, performPersistAsync);
  return __spreadProps(__spreadValues({}, uploadComponent), {
    format,
    async onInsertFile(index, file) {
      const fileId = await uploadComponent.onInsertFile.call(this, index, file);
      const submission = format === "blob" ? file : await toBase64(file);
      await persist(index, submission);
      onValueChange();
      return fileId;
    },
    async onRemoveFile(index) {
      var _a2;
      await uploadComponent.onRemoveFile.call(this, index);
      (_a2 = this.persistedState[index]) == null ? void 0 : _a2.abortController.abort();
      update((draft) => {
        draft.persistedState = draft.persistedState.splice(index, 1);
      });
    },
    async getSubmittableValue() {
      return Promise.all(this.persistedState.map(async ({ submission }) => submission));
    },
    getSubmittableValueSync() {
      return this.persistedState.map(({ lastResponse }) => lastResponse);
    }
  });
};

// src/revamp/domain/mappers/schema/arraySchemaToComponent/arraySchemaToMultiUploadComponent.ts
var arraySchemaToMultiUploadComponent = (schemaMapperProps, mapperProps) => {
  var _a;
  const { getErrorMessageFunctions } = mapperProps;
  const { localValue, model, schema, required = false } = schemaMapperProps;
  const uploadSchema = getUploadSchema(schema.items);
  const { accepts, cameraConfig, maxSize } = uploadSchema;
  const { minItems, maxItems, title, validationMessages } = schema;
  const arrayErrorMessageFunctions = getErrorMessageFunctions(validationMessages);
  const fileErrorMessageFunctions = getErrorMessageFunctions(uploadSchema.validationMessages);
  const checks = [
    getRequiredCheck(required, arrayErrorMessageFunctions),
    getAboveMaxFilesCheck(schema, arrayErrorMessageFunctions),
    getBelowMinFilesCheck(schema, arrayErrorMessageFunctions)
  ];
  const fileChecks = [
    getFileSizeCheck(schema.items, fileErrorMessageFunctions),
    getFileTypeCheck(schema.items, fileErrorMessageFunctions)
  ];
  const persistAsyncConfig = getPersistAsyncConfig(schema.items);
  const format = getFormat(schema.items);
  const combinedSchemaProps = __spreadProps(__spreadValues({}, schemaMapperProps), {
    persistAsyncConfig,
    schema: __spreadProps(__spreadValues({}, uploadSchema), { hidden: (_a = schema.hidden) != null ? _a : uploadSchema.hidden })
  });
  const { onValueChange } = mapperProps;
  const { performPersistAsync } = getPersistAsyncInitialState(combinedSchemaProps, mapperProps);
  const value = performPersistAsync ? getValueForPersistAsync(localValue) : [];
  const persistedState = performPersistAsync && isArray(model) ? model.map((itemModel) => getInitialPersistedState(null, itemModel)) : [];
  return createMultiUploadInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(combinedSchemaProps)), {
      title,
      cameraConfig,
      uploadLabel: uploadSchema.title,
      accepts,
      autoComplete: "off",
      checks: schema.hidden ? [] : checks,
      fileChecks: schema.hidden ? [] : fileChecks,
      format,
      maxSize,
      minItems,
      maxItems,
      required,
      source: uploadSchema.source,
      value,
      persistedState,
      performPersistAsync,
      onValueChange
    }),
    mapperProps.updateComponent
  );
};
var getFormat = (schema) => {
  if (isStringSchemaWithUpload(schema)) {
    return "base64";
  }
  return isBlobSchema(schema.persistAsync.schema) ? "blob" : "base64";
};
var getUploadSchema = (schema) => {
  if (isStringSchemaWithUpload(schema)) {
    return schema;
  }
  return schema.persistAsync.schema;
};
var getPersistAsyncConfig = (schema) => {
  if (!isSchemaWithPersistAsync(schema)) {
    return void 0;
  }
  const { persistAsync } = schema;
  const { idProperty, method, param, url } = persistAsync;
  return { idProperty, method, param, url };
};
var getValueForPersistAsync = (localValue) => isArray(localValue) && localValue.every(isFile) ? localValue : [];

// src/revamp/domain/components/MultiSelectInputComponent.ts
var createMultiSelectComponent = (multiSelectProps, updateComponent) => {
  const _a = multiSelectProps, {
    uid,
    checks,
    options,
    initialValue,
    performValidationAsync,
    performRefresh,
    onValueChange
  } = _a, rest = __objRest(_a, [
    "uid",
    "checks",
    "options",
    "initialValue",
    "performValidationAsync",
    "performRefresh",
    "onValueChange"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const children = options.map((option) => option.component);
  const selectedIndices = getInitialModelIndices(initialValue, children);
  const getValidationErrors = getLocalValueValidator(checks);
  const getAndSetValidationErrors = (currentValue) => {
    const messages = getValidationErrors(currentValue);
    update((draft) => {
      draft.errors = messages;
    });
    return messages;
  };
  const inputComponent = __spreadProps(__spreadValues({
    uid,
    type: "multi-select",
    children,
    options,
    selectedIndices,
    value: null
  }, rest), {
    onSelect(indices) {
      update((draft) => {
        draft.selectedIndices = indices;
        draft.errors = [];
      });
      performRefresh == null ? void 0 : performRefresh();
      onValueChange();
      getAndSetValidationErrors(this.getLocalValue());
    },
    onBlur() {
    },
    // Noop
    onFocus() {
    },
    // Noop
    getLocalValue() {
      var _a2, _b;
      return (_b = (_a2 = this.getSelectedChildren()) == null ? void 0 : _a2.map((child) => child.getLocalValue())) != null ? _b : null;
    },
    validate() {
      const messages = getAndSetValidationErrors(this.getLocalValue());
      return messages.length === 0;
    },
    async getSubmittableValue() {
      const selected = this.getSelectedChildren();
      if (selected) {
        return Promise.all(selected.map(async (child) => child.getSubmittableValue()));
      }
      return null;
    },
    getSubmittableValueSync() {
      var _a2, _b;
      return (_b = (_a2 = this.getSelectedChildren()) == null ? void 0 : _a2.map((child) => child.getSubmittableValueSync())) != null ? _b : null;
    },
    getSummary: () => ({}),
    getChildren() {
      return this.children;
    },
    getSelectedChildren() {
      return this.selectedIndices.map((i) => this.children[i]);
    }
  });
  if (performRefresh) {
    return inputComponent;
  }
  if (performValidationAsync) {
    const validateAsync = getComponentValidationAsync(update, performValidationAsync);
    return __spreadProps(__spreadValues({}, inputComponent), {
      onSelect(indices) {
        inputComponent.onSelect.call(this, indices);
        if (this.validate()) {
          validateAsync(this.validationAsyncState, this.getLocalValue()).catch(() => {
          });
        }
      }
    });
  }
  return inputComponent;
};
var getInitialModelIndices = (model, options) => {
  if (!isArray(model)) {
    return [];
  }
  return model.map((m) => options.findIndex((o) => o.getLocalValue() === m)).filter((n) => n >= 0);
};

// src/revamp/domain/mappers/schema/arraySchemaToComponent/arraySchemaToMultiSelectComponent.ts
var arraySchemaToMultiSelectComponent = (schemaMapperProps, mapperProps) => {
  const {
    uid,
    localValue,
    schema,
    model,
    required = false,
    validationErrors: initialError
  } = schemaMapperProps;
  const initialModel = model != null ? model : null;
  const options = schema.items.oneOf.map((childSchema, index) => {
    const { title: title2 = "", description, image, icon, keywords = [] } = childSchema;
    return {
      title: title2,
      description,
      image: mapSpecImage(image),
      icon,
      keywords,
      disabled: "disabled" in childSchema ? Boolean(childSchema.disabled) : false,
      component: mapSchemaToComponent(
        {
          uid: `${uid}.oneOf-${index}`,
          schema: childSchema,
          model: initialModel,
          localValue,
          validationErrors: initialError,
          required
        },
        mapperProps
      )
    };
  });
  const { maxItems, minItems, title, validationMessages } = schema;
  const { getErrorMessageFunctions, onRefresh, onValueChange, updateComponent } = mapperProps;
  const errorMessageFunctions = getErrorMessageFunctions(validationMessages);
  const { performValidationAsync, validationAsyncState } = getValidationAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const initialValue = model != null ? model : null;
  return createMultiSelectComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      autoComplete: "off",
      checks: schema.hidden ? [] : [
        getRequiredCheck(required, errorMessageFunctions),
        getAboveMaxItemsCheck(schema, errorMessageFunctions),
        getBelowMinItemsCheck(schema, errorMessageFunctions)
      ],
      initialValue,
      maxItems,
      minItems,
      options,
      required,
      title,
      validationAsyncState,
      performValidationAsync,
      performRefresh: getPerformRefresh(schema, onRefresh),
      onValueChange
    }),
    updateComponent
  );
};

// src/revamp/domain/components/TupleComponent.ts
var createTupleComponent = (tupleProps) => {
  const {
    uid,
    analyticsId,
    components,
    control,
    description,
    help,
    hidden,
    icon,
    image,
    summariser,
    title
  } = tupleProps;
  return {
    type: "tuple",
    uid,
    analyticsId,
    components,
    control,
    description,
    help,
    hidden,
    icon,
    image,
    title,
    getChildren() {
      return this.components;
    },
    async getSubmittableValue() {
      return Promise.all(this.components.map(async (child) => child.getSubmittableValue()));
    },
    getSubmittableValueSync() {
      return this.components.map((child) => child.getSubmittableValueSync());
    },
    getSummary() {
      const summary = summariser(this.getLocalValue());
      const childSummary = summariseFromChildren(this.getChildren());
      return mergeSummaries(summary, childSummary);
    },
    getLocalValue() {
      return this.components.map((child) => child.getLocalValue());
    },
    validate() {
      return hidden ? true : validateComponents(this.getChildren());
    }
  };
};

// src/revamp/domain/mappers/schema/arraySchemaToComponent/arraySchemaToTupleComponent.ts
var arraySchemaToTupleComponent = (schemaMapperProps, mapperProps) => {
  const {
    uid,
    localValue,
    schema,
    model: initialModel,
    required = false,
    validationErrors
  } = schemaMapperProps;
  const { items } = schema;
  const components = items.map(
    (childSchema, index) => {
      var _a, _b;
      return mapSchemaToComponent(
        {
          uid: `${uid}-arr.${index}`,
          schema: childSchema,
          model: isArray(initialModel) ? (_a = initialModel[index]) != null ? _a : null : null,
          localValue: isArray(localValue) ? (_b = localValue[index]) != null ? _b : null : null,
          validationErrors: isArray(validationErrors) ? validationErrors[index] : void 0,
          required
        },
        mapperProps
      );
    }
  );
  return createTupleComponent(__spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
    components
  }));
};

// src/revamp/domain/mappers/schema/arraySchemaToComponent/arraySchemaToComponent.ts
var arraySchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { schema, model: originalModel } = schemaMapperProps;
  const model = isNullish(originalModel) || isArrayModel(originalModel) ? originalModel : null;
  if (isArraySchemaListWithMultiFileUpload(schema)) {
    return arraySchemaToMultiUploadComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema, model }), mapperProps);
  }
  if (isArraySchemaListWithMultiSelect(schema)) {
    return arraySchemaToMultiSelectComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema, model }), mapperProps);
  }
  if (isArrayTupleSchema(schema)) {
    return arraySchemaToTupleComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema, model }), mapperProps);
  }
  return arraySchemaToRepeatableComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema, model }), mapperProps);
};
var isArraySchemaListWithMultiFileUpload = (schema) => isArrayListSchema(schema) && (isPersistAsyncWithUploadSchema(schema.items) || isStringSchemaWithUpload(schema.items));
var isPersistAsyncWithUploadSchema = (schema) => isSchemaWithPersistAsync(schema) && (isBlobSchema(schema.persistAsync.schema) || isStringSchemaWithUpload(schema.persistAsync.schema));
var isArraySchemaListWithMultiSelect = (schema) => isArrayListSchema(schema) && "oneOf" in schema.items && schema.items.oneOf.every(isConstSchema);

// src/revamp/domain/components/BooleanInputComponent.ts
var createBooleanInputComponent = (booleanInputProps, updateComponent) => {
  const _a = booleanInputProps, {
    uid,
    id,
    value,
    performPersistAsync,
    performRefresh,
    performValidationAsync,
    onValueChange,
    summariser
  } = _a, rest = __objRest(_a, [
    "uid",
    "id",
    "value",
    "performPersistAsync",
    "performRefresh",
    "performValidationAsync",
    "onValueChange",
    "summariser"
  ]);
  const update = getInputUpdateFunction(uid, updateComponent);
  const booleanComponent = __spreadValues({
    type: "boolean",
    uid,
    id,
    autoComplete: "",
    value,
    onBlur() {
    },
    // Noop
    onFocus() {
    },
    // Noop
    onChange(updatedValue) {
      update((draft) => {
        draft.errors = [];
        draft.value = updatedValue;
      });
      performRefresh == null ? void 0 : performRefresh();
      onValueChange();
    },
    async getSubmittableValue() {
      return this.getSubmittableValueSync();
    },
    getSubmittableValueSync() {
      return this.getLocalValue();
    },
    getSummary() {
      return summariser(this.getLocalValue());
    },
    getLocalValue() {
      return this.value;
    },
    validate: () => true
  }, rest);
  if (performRefresh) {
    return booleanComponent;
  }
  if (performPersistAsync) {
    const persist = getComponentPersistAsync(update, performPersistAsync);
    return __spreadProps(__spreadValues({}, booleanComponent), {
      onChange(updatedValue) {
        booleanComponent.onChange.call(this, updatedValue);
        persist(this.persistedState, this.getLocalValue()).catch(() => {
        });
      },
      async getSubmittableValue() {
        return persist(this.persistedState, this.getLocalValue());
      },
      getSubmittableValueSync() {
        return this.persistedState.lastResponse;
      }
    });
  }
  if (performValidationAsync) {
    const validateAsync = getComponentValidationAsync(update, performValidationAsync);
    return __spreadProps(__spreadValues({}, booleanComponent), {
      onChange(updatedValue) {
        booleanComponent.onChange.call(this, updatedValue);
        validateAsync(this.validationAsyncState, this.getLocalValue()).catch(() => {
        });
      }
    });
  }
  return booleanComponent;
};

// src/revamp/domain/mappers/schema/booleanSchemaToComponent.ts
var booleanSchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { schema, localValue, model } = schemaMapperProps;
  const { default: defaultValue } = schema;
  const { updateComponent, onRefresh, onValueChange } = mapperProps;
  const performRefresh = getPerformRefresh(schema, onRefresh);
  const { performPersistAsync, persistedState } = getPersistAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const { performValidationAsync, validationAsyncState } = getValidationAsyncInitialState(
    schemaMapperProps,
    mapperProps
  );
  const validLocalValue = isBoolean(localValue) ? localValue : false;
  const validModel = getValidModel(model, defaultValue);
  const value = performPersistAsync ? validLocalValue : validModel;
  return createBooleanInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      value: value != null ? value : false,
      persistedState,
      validationAsyncState,
      performPersistAsync,
      performRefresh,
      performValidationAsync,
      onValueChange
    }),
    updateComponent
  );
};
var getValidModel = (model, defaultValue) => {
  if (isBoolean(model)) {
    return model;
  }
  if (isBoolean(defaultValue)) {
    return defaultValue;
  }
  return false;
};

// src/revamp/domain/mappers/schema/blobSchemaToComponent.ts
var blobSchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { schema, localValue, model, required = false } = schemaMapperProps;
  const { accepts, cameraConfig, maxSize, source, validationMessages } = schema;
  const { getErrorMessageFunctions, updateComponent, onValueChange } = mapperProps;
  const errorMessageFunctions = getErrorMessageFunctions(validationMessages);
  const { performPersistAsync } = getPersistAsyncInitialState(schemaMapperProps, mapperProps);
  const persistedState = performPersistAsync ? getInitialPersistedState(null, model) : getInitialPersistedState();
  const validLocalValue = isFile(localValue) ? localValue : null;
  const value = performPersistAsync ? validLocalValue : null;
  return createUploadInputComponent(
    __spreadProps(__spreadValues({}, mapCommonSchemaProps(schemaMapperProps)), {
      accepts,
      autoComplete: "off",
      cameraConfig,
      format: "blob",
      maxSize,
      source,
      value,
      persistedState,
      performPersistAsync,
      checks: schema.hidden ? [] : [getRequiredCheck(required, errorMessageFunctions)],
      onValueChange
    }),
    updateComponent
  );
};

// src/revamp/domain/mappers/mapSchemaToComponent.ts
var mapSchemaToComponent = (schemaMapperProps, mapperProps) => {
  const { uid, schema } = schemaMapperProps;
  const { alert } = schema;
  if (alert) {
    return createContainerComponent({
      uid,
      components: [
        alertLayoutToComponent(`${uid}.container.alert`, alert, mapperProps),
        getSchemaComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { uid: `${uid}.container` }), mapperProps)
      ]
    });
  }
  return getSchemaComponent(schemaMapperProps, mapperProps);
};
var getSchemaComponent = (schemaMapperProps, mapperProps) => {
  const { uid, schema } = schemaMapperProps;
  if (isConstSchema(schema)) {
    return constSchemaToComponent(uid, __spreadProps(__spreadValues({}, schemaMapperProps), { schema }));
  }
  if (isSchemaWithPersistAsync(schema)) {
    const { persistAsync } = schema;
    const { idProperty, method, param, url } = persistAsync;
    const persistAsyncConfig = { idProperty, method, param, url };
    return mapSchemaToComponent(
      __spreadProps(__spreadValues({}, schemaMapperProps), { persistAsyncConfig, schema: persistAsync.schema }),
      mapperProps
    );
  }
  if (isAllOfSchema(schema)) {
    return allOfSchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  if (isOneOfSchema(schema)) {
    return oneOfSchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  if (isBooleanSchema(schema)) {
    return booleanSchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  if (isObjectSchema(schema)) {
    return objectSchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  if (isIntegerSchema(schema)) {
    return integerSchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  if (isNumberSchema(schema)) {
    return numberSchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  if (isStringSchema(schema)) {
    return stringSchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  if (isArraySchema(schema)) {
    return arraySchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  if (isBlobSchema(schema)) {
    if (!schemaMapperProps.persistAsyncConfig) {
      throw new Error(
        "Blob schemas can only be used as the schema of a persist async configuration."
      );
    }
    return blobSchemaToComponent(__spreadProps(__spreadValues({}, schemaMapperProps), { schema }), mapperProps);
  }
  throw new Error("Not yet supported");
};

// src/revamp/domain/components/FormComponent.ts
var createFormComponent = (formProps) => __spreadProps(__spreadValues({}, formProps), {
  type: "form",
  getChildren() {
    return this.components;
  },
  async getSubmittableValue() {
    return getSubmittableData(this.getChildren());
  },
  getSubmittableValueSync() {
    return getSubmittableDataSync(this.getChildren());
  },
  getSummary() {
    return summariseFromChildren(this.getChildren());
  },
  getLocalValue() {
    return getLocalValues(this.getChildren());
  },
  validate() {
    return validateComponents(this.getChildren());
  }
});

// src/revamp/domain/mappers/layout/formLayoutToComponent.ts
var formLayoutToComponent = (uid, { schemaId, schema: schemaRef, control, margin = "md" }, mapperProps) => {
  const { step, stepLocalValue } = mapperProps;
  const { schemas, model, errors } = step;
  const id = schemaId != null ? schemaId : schemaRef == null ? void 0 : schemaRef.$ref;
  if (id == null) {
    throw new Error(
      "FormLayouts must refer to a schema. Set the `schemaId` property to the intended schema."
    );
  }
  const schema = schemas.find((s) => s.$id === id);
  if (!schema) {
    throw new Error("Schema not found in schemas array.");
  }
  return createFormComponent({
    uid,
    components: [
      mapSchemaToComponent(
        {
          uid: `${uid}.form`,
          schema,
          model: model != null ? model : null,
          localValue: stepLocalValue,
          validationErrors: errors == null ? void 0 : errors.validation,
          required: true
        },
        mapperProps
      )
    ],
    control,
    margin
  });
};

// src/revamp/domain/components/HeadingComponent.ts
var createHeadingComponent = (headingProps) => __spreadProps(__spreadValues({
  type: "heading"
}, headingProps), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getSummary: () => ({}),
  // Noop
  getLocalValue: () => null,
  validate: () => true
});

// src/revamp/domain/mappers/layout/headingLayoutToComponent.ts
var headingLayoutToComponent = (uid, { align = "left", margin = "md", size = "md", control, text }) => createHeadingComponent({
  uid,
  align: mapLegacyAlign(align),
  control,
  margin,
  size,
  text
});

// src/revamp/domain/components/ImageComponent.ts
var createImageComponent = (imageProps) => __spreadProps(__spreadValues({
  type: "image"
}, imageProps), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getLocalValue: () => null,
  getSummary: () => ({}),
  // Noop
  validate: () => true
});

// src/revamp/domain/mappers/layout/imageLayoutToComponent.ts
var imageLayoutToComponent = (uid, {
  accessibilityDescription,
  align = "center",
  content,
  control,
  margin = "md",
  size = "md",
  text,
  url
}) => {
  var _a, _b, _c;
  return createImageComponent({
    uid,
    align: mapLegacyAlign(align),
    content: content ? {
      uri: (_b = (_a = content.uri) != null ? _a : content.url) != null ? _b : "",
      accessibilityDescription: (_c = content.accessibilityDescription) != null ? _c : content.text
    } : { accessibilityDescription: accessibilityDescription != null ? accessibilityDescription : text, uri: url != null ? url : "" },
    control,
    margin,
    size
  });
};

// src/revamp/domain/components/MarkdownComponent.ts
var createMarkdownComponent = (markdownProps) => __spreadProps(__spreadValues({
  type: "markdown"
}, markdownProps), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getLocalValue: () => null,
  getSummary: () => ({}),
  validate: () => true
});

// src/revamp/domain/mappers/layout/infoLayoutToComponent.ts
var infoLayoutToComponent = (uid, { align = "left", control, margin = "md", markdown: content }) => createMarkdownComponent({
  uid,
  align: mapLegacyAlign(align),
  content,
  control,
  margin
});

// src/revamp/domain/components/InstructionsComponent.ts
var createInstructionsComponent = (instructionsProps) => __spreadProps(__spreadValues({
  type: "instructions"
}, instructionsProps), {
  getLocalValue: () => null,
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getSummary: () => ({}),
  // Noop
  validate: () => true
});

// src/revamp/domain/mappers/layout/instructionsLayoutToComponent.ts
var instructionsLayoutToComponent = (uid, { control, items, margin = "md", title }) => createInstructionsComponent({
  uid,
  control,
  items: items.map((item) => __spreadProps(__spreadValues({}, item), {
    context: mapLegacyContext(item.context)
  })),
  margin,
  title
});

// src/revamp/domain/components/LoadingIndicatorComponent.ts
var createLoadingIndicatorComponent = (loadingIndicatorProps) => __spreadProps(__spreadValues({
  type: "loading-indicator"
}, loadingIndicatorProps), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getLocalValue: () => null,
  getSummary: () => ({}),
  // Noop
  validate: () => true
});

// src/revamp/domain/mappers/layout/loadingIndicatorLayoutToComponent.ts
var loadingIndicatorLayoutToComponent = (uid, { size = "md", margin = "md", control }) => createLoadingIndicatorComponent({ uid, size, control, margin });

// src/revamp/domain/mappers/layout/markdownLayoutToComponent.ts
var markdownLayoutToComponent = (uid, { align = "left", margin = "md", control, content }) => createMarkdownComponent({
  uid,
  align: mapLegacyAlign(align),
  control,
  content,
  margin
});

// src/revamp/domain/components/ModalComponent.ts
var createModalComponent = (modalProps) => __spreadProps(__spreadValues({
  type: "modal"
}, modalProps), {
  getChildren() {
    return this.content.components;
  },
  getLocalValue() {
    return getLocalValues(this.getChildren());
  },
  async getSubmittableValue() {
    return getSubmittableData(this.getChildren());
  },
  getSubmittableValueSync() {
    return getSubmittableDataSync(this.getChildren());
  },
  getSummary() {
    return summariseFromChildren(this.getChildren());
  },
  validate() {
    return validateComponents(this.getChildren());
  }
});

// src/revamp/domain/mappers/layout/modalLayoutToComponent.ts
var modalLayoutToComponent = (uid, { content, control, margin = "md", trigger }, mapperProps) => {
  const { components, title } = content;
  return createModalComponent({
    uid,
    content: {
      components: components.map(
        (component, index) => mapLayoutToComponent(`${uid}.modal-${index}`, component, mapperProps)
      ),
      title
    },
    control,
    margin,
    trigger
  });
};

// src/revamp/domain/components/ParagraphComponent.ts
var createParagraphComponent = (paragraphProps) => __spreadProps(__spreadValues({
  type: "paragraph"
}, paragraphProps), {
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getSummary: () => ({}),
  // Noop
  getLocalValue: () => null,
  validate: () => true
});

// src/revamp/domain/mappers/layout/paragraphLayoutToComponent.ts
var paragraphLayoutToComponent = (uid, { align = "left", control, margin = "md", text }) => createParagraphComponent({
  uid,
  text,
  control,
  align: mapLegacyAlign(align),
  margin
});

// src/revamp/domain/components/ReviewComponent.ts
var createReviewComponent = (reviewProps) => __spreadProps(__spreadValues({
  type: "review"
}, reviewProps), {
  getLocalValue: () => null,
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getSummary: () => ({}),
  // Noop
  validate: () => true
});

// src/revamp/domain/mappers/layout/reviewLayoutToComponent.ts
var reviewLayoutToComponent = (uid, { fields, title, callToAction, control, margin = "md", orientation, action }, { onBehavior, step }) => createReviewComponent({
  uid,
  callToAction: getReviewAction({ onBehavior, callToAction, action, stepActions: step.actions }),
  control: getOrientationControl({ control, orientation }),
  fields: fields.map((field) => {
    var _a;
    return __spreadProps(__spreadValues({}, field), { help: (_a = field.help) == null ? void 0 : _a.markdown });
  }),
  margin,
  title
});
var getReviewAction = ({
  onBehavior,
  callToAction,
  action,
  stepActions = []
}) => {
  if (callToAction) {
    return getDomainLayerCallToAction(callToAction, onBehavior, stepActions);
  }
  if (action == null ? void 0 : action.title) {
    return {
      title: action.title,
      onClick: () => {
        void onBehavior({ type: "action", action });
      }
    };
  }
  return void 0;
};
var getOrientationControl = ({
  control,
  orientation
}) => {
  if (control) {
    return control;
  }
  if (orientation) {
    return orientation;
  }
  return void 0;
};

// src/revamp/domain/components/searchComponent/SearchComponent.ts
var DEBOUNCE_TIME = 400;
var createSearchComponent = (searchProps, performSearch, onBehavior, updateComponent) => {
  const { uid, control, emptyMessage, margin, title } = searchProps;
  const update = getInputUpdateFunction(uid, updateComponent);
  let abortController = new AbortController();
  const search = (query, searchConfig) => {
    abortController.abort();
    abortController = new AbortController();
    const { signal } = abortController;
    performSearch({
      signal,
      query,
      config: searchConfig
    }).then((results) => {
      if (!signal.aborted) {
        update((draft) => {
          draft.results = results;
          draft.isLoading = false;
          draft.error = void 0;
        });
      }
    }).catch(() => {
      if (!signal.aborted) {
        update((draft) => {
          draft.error = "No response";
          draft.isLoading = false;
        });
      }
    });
  };
  const onSelect = ({ type, value }) => {
    if (type === "action") {
      void onBehavior({ type: "action", action: value });
    } else {
      update((draft) => {
        draft.query = value.query;
        draft.isLoading = true;
      });
      search(value.query, { method: value.method, param: value.param, url: value.url });
    }
  };
  const debouncedSearch = debounce(search, DEBOUNCE_TIME);
  const onChange = (query) => {
    update((draft) => {
      draft.query = query;
      draft.isLoading = true;
    });
    debouncedSearch(query.trim());
  };
  return {
    type: "search",
    uid,
    control,
    emptyMessage,
    margin,
    title,
    isLoading: false,
    query: "",
    results: [],
    getSubmittableValue: async () => null,
    getSubmittableValueSync: () => null,
    getLocalValue: () => null,
    getSummary: () => ({}),
    // Noop
    validate: () => true,
    onChange,
    onSelect
  };
};

// src/revamp/domain/features/search/getPerformSearchFunction.ts
var getPerformSearchFunction = (httpClient, defaultConfig) => {
  let latestSuccessfulRequestHash = hashRequest("", defaultConfig);
  let latestSuccessfulResults = [];
  return async ({ config = defaultConfig, query, signal }) => {
    const requestHash = hashRequest(query, config);
    if (requestHash !== latestSuccessfulRequestHash) {
      const { method, param, url } = config;
      const headers2 = { "Content-Type": "application/json" };
      const response = await (method === "GET" ? httpClient(addQueryParameter(url, param, query), {
        method,
        headers: headers2,
        signal
      }) : httpClient(url, {
        method,
        headers: headers2,
        signal,
        body: JSON.stringify({ [param]: query })
      }));
      const results = await parseResponse(response);
      latestSuccessfulRequestHash = requestHash;
      latestSuccessfulResults = results;
      return results;
    }
    return latestSuccessfulResults;
  };
};
var parseResponse = async (response) => {
  if (response.ok) {
    const body = await response.json().catch(() => null);
    if (isValidResponseBody(body)) {
      if (body.results.length === 0) {
        return [];
      }
      return body.results;
    }
  }
  throw Error("error response");
};
var addQueryParameter = (url, key, value) => {
  const [urlBase, urlQuery] = url.split("?");
  const urlQueryParams = new URLSearchParams(urlQuery);
  urlQueryParams.set(key, value);
  return `${urlBase}?${urlQueryParams.toString()}`;
};
var isValidResponseBody = (body) => isObject(body) && "results" in body && isArray(body.results) && body.results.every(
  (result) => isObject(result) && "title" in result && "type" in result && "value" in result
);
var hashRequest = (query, config) => JSON.stringify({ query, config });

// src/revamp/domain/mappers/layout/searchLayoutToComponent.ts
var searchLayoutToComponent = (uid, { control, emptyMessage = "", method, param, title, url, margin = "md" }, mapperProps) => {
  const { httpClient, onBehavior, updateComponent } = mapperProps;
  const search = getPerformSearchFunction(httpClient, { method, param, url });
  return createSearchComponent(
    {
      uid,
      control,
      emptyMessage,
      margin,
      title
    },
    search,
    onBehavior,
    updateComponent
  );
};

// src/revamp/domain/components/StatusListComponent.ts
var createStatusListComponent = (statusListProps) => __spreadProps(__spreadValues({
  type: "status-list"
}, statusListProps), {
  getLocalValue: () => null,
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getSummary: () => ({}),
  // Noop,
  validate: () => true
});

// src/revamp/domain/mappers/layout/statusListLayoutToComponent.ts
var statusListLayoutToComponent = (uid, { control, items, margin = "md", title }, { onBehavior, step }) => createStatusListComponent({
  uid,
  control,
  items: items.map((item) => {
    var _a;
    const callToAction = getDomainLayerCallToAction(
      item.callToAction,
      onBehavior,
      (_a = step.actions) != null ? _a : []
    );
    return __spreadProps(__spreadValues({}, item), { callToAction });
  }),
  margin,
  title
});

// src/revamp/domain/mappers/layout/deprecatedListLayoutToComponent.ts
var deprecatedListLayoutToComponent = (uid, { control, items, margin = "md", title }) => createStatusListComponent({
  uid,
  control,
  items: items.map(({ description, icon, status, title: itemTitle }) => ({
    description,
    icon: icon != null ? icon : { text: "" },
    title: itemTitle != null ? itemTitle : "",
    status: status ? mapLegacyStatus(status) : void 0
  })),
  margin,
  title
});
var mapLegacyStatus = (status) => {
  switch (status) {
    case "positive":
      return "done";
    case "warning":
      return "pending";
    case "neutral":
    default:
      return "not-done";
  }
};

// src/revamp/domain/components/ListComponent.ts
var createListComponent = (listProps) => __spreadProps(__spreadValues({
  type: "list"
}, listProps), {
  getLocalValue: () => null,
  getSubmittableValue: async () => null,
  getSubmittableValueSync: () => null,
  getSummary: () => ({}),
  // noop
  validate: () => true
});

// src/revamp/domain/mappers/layout/listLayoutToComponent.ts
var listLayoutToComponent = (uid, { callToAction, control, items, margin = "md", title }, mapperProps) => {
  var _a;
  const { step, onBehavior } = mapperProps;
  return createListComponent({
    uid,
    control,
    items: items.map((item) => __spreadProps(__spreadValues({}, item), {
      image: mapSpecImage(item.image)
    })),
    callToAction: getDomainLayerCallToAction(callToAction, onBehavior, (_a = step.actions) != null ? _a : []),
    margin,
    title
  });
};

// src/revamp/domain/mappers/mapLayoutToComponent.ts
var mapLayoutToComponent = (uid, layout, mapperProps) => {
  switch (layout.type) {
    case "alert":
      return alertLayoutToComponent(uid, layout, mapperProps);
    case "box":
      return boxLayoutToComponent(uid, layout, mapperProps);
    case "button":
      return buttonLayoutToComponent(uid, layout, mapperProps);
    case "columns":
      return columnsLayoutToComponent(uid, layout, mapperProps);
    case "decision":
      return decisionLayoutToComponent(uid, layout, mapperProps);
    case "divider":
      return dividerLayoutToComponent(uid, layout);
    case "form":
      return formLayoutToComponent(uid, layout, mapperProps);
    case "heading":
      return headingLayoutToComponent(uid, layout);
    case "image":
      return imageLayoutToComponent(uid, layout);
    case "info":
      return infoLayoutToComponent(uid, layout);
    case "instructions":
      return instructionsLayoutToComponent(uid, layout);
    case "list":
      if (layout.items.some((item) => item.status || item.description)) {
        return deprecatedListLayoutToComponent(uid, layout);
      }
      return listLayoutToComponent(uid, layout, mapperProps);
    case "loading-indicator":
      return loadingIndicatorLayoutToComponent(uid, layout);
    case "markdown":
      return markdownLayoutToComponent(uid, layout);
    case "modal":
      return modalLayoutToComponent(uid, layout, mapperProps);
    case "paragraph":
      return paragraphLayoutToComponent(uid, layout);
    case "review":
      return reviewLayoutToComponent(uid, layout, mapperProps);
    case "search":
      return searchLayoutToComponent(uid, layout, mapperProps);
    case "status-list":
      return statusListLayoutToComponent(uid, layout, mapperProps);
    default:
      throw new Error(`Invalid layout type in ${JSON.stringify(layout)}`);
  }
};

// src/revamp/domain/mappers/mapUnreferencedSchemas.ts
var mapUnreferencedSchemas = (mapperProps) => {
  const { step } = mapperProps;
  const { model } = step;
  return getUnreferencedSchemas(step).map((schema) => __spreadProps(__spreadValues({}, schema), { hidden: true })).map((schema, index) => {
    const uid = `unreferenced-schema-${index}`;
    return createFormComponent({
      uid,
      components: [
        mapSchemaToComponent(
          {
            uid: `${uid}.form`,
            schema,
            model: model != null ? model : null,
            localValue: null,
            required: false
          },
          mapperProps
        )
      ],
      control: void 0,
      margin: "xs"
    });
  });
};
var getUnreferencedSchemas = (step) => {
  const { schemas, layout } = step;
  const stringifiedLayout = JSON.stringify(layout);
  return schemas.filter(
    (schema) => !stringifiedLayout.includes(`"schemaId":"${schema.$id}"`) && !stringifiedLayout.includes(`"schema":{"$ref":"${schema.$id}"`)
  );
};

// src/revamp/domain/mappers/mapStepToComponent.ts
var mapStepToComponent = (_a) => {
  var _b = _a, {
    uid: rootUid,
    loadingState,
    displayStepTitle,
    trackEvent,
    onPoll,
    onBehavior
  } = _b, restProps = __objRest(_b, [
    "uid",
    "loadingState",
    "displayStepTitle",
    "trackEvent",
    "onPoll",
    "onBehavior"
  ]);
  var _a2, _b2;
  const { step, updateComponent } = restProps;
  const {
    id,
    control,
    description,
    errors,
    external,
    key,
    layout = [],
    navigation,
    polling,
    refreshAfter,
    title
  } = step;
  const backNavigation = (_a2 = navigation == null ? void 0 : navigation.back) != null ? _a2 : navigation == null ? void 0 : navigation.backButton;
  const back = backNavigation ? {
    title: backNavigation.title,
    onClick: () => {
      void onBehavior({
        type: "action",
        action: __spreadProps(__spreadValues({}, backNavigation.action), { skipValidation: true })
      });
    }
  } : void 0;
  const refreshUrl = (_b2 = step.refreshUrl) != null ? _b2 : step.refreshFormUrl;
  const stepId = id || key;
  if (stepId === void 0) {
    throw new Error("Step must have an id or a key");
  }
  const uid = `${rootUid}.${stepId != null ? stepId : "step"}`;
  const onRefresh = async (schemaId, url) => restProps.onRefresh(schemaId, url != null ? url : refreshUrl);
  const stepPolling = polling ? getStepPolling({ pollingConfig: polling, onBehavior, onPoll }) : void 0;
  const stepRefreshAfter = refreshAfter ? getStepRefreshAfter({ refreshAfter, onRefresh }) : void 0;
  const mapperProps = __spreadProps(__spreadValues({}, restProps), { trackEvent, onBehavior, onRefresh });
  const unreferencedSchemaFormComponents = mapUnreferencedSchemas(mapperProps);
  const layoutComponents = layout.map(
    (layoutComponent, index) => mapLayoutToComponent(`${uid}.layout-${index}`, layoutComponent, mapperProps)
  );
  const components = [...unreferencedSchemaFormComponents, ...layoutComponents];
  const stepComponent = createStepComponent({
    uid,
    back,
    components,
    control,
    description,
    error: errors == null ? void 0 : errors.error,
    external,
    loadingState,
    stepPolling,
    stepRefreshAfter,
    title: displayStepTitle ? title : void 0,
    step,
    updateComponent,
    trackEvent,
    onBehavior
  });
  return stepComponent;
};

// src/revamp/flow/getResponseType.ts
var responseTypes = ["step", "action", "exit"];
var getResponseType = async (response) => {
  assertResponseIsValid(response);
  const headerResponseType = getResponseTypeFromHeader(response);
  if (headerResponseType) {
    return headerResponseType;
  }
  const jsonBody = await parseResponseBodyAsJsonElement(response.clone());
  if (isObject(jsonBody) && jsonBody.action) {
    return "action";
  }
  return "step";
};
var getResponseTypeFromHeader = (response) => {
  var _a, _b;
  if ((_a = response.headers) == null ? void 0 : _a.has("X-Df-Response-Type")) {
    const type = response.headers.get("X-Df-Response-Type");
    assertDFResponseType(type);
    return type;
  }
  if ((_b = response.headers) == null ? void 0 : _b.has("X-Df-Exit")) {
    return "exit";
  }
  return void 0;
};
function assertDFResponseType(type) {
  if (!responseTypes.includes(type)) {
    throw new Error(
      "Unsupported X-Df-Response-Type. Allowed values are 'step', 'action', 'exit', 'error'."
    );
  }
}

// src/revamp/flow/executePoll.ts
var executePoll = async (props) => {
  const { errorBehavior, signal, url, httpClient, trackEvent } = props;
  try {
    const response = await httpClient(url != null ? url : "", {
      method: "GET",
      signal
    });
    if (!response.ok) {
      trackEvent("Polling Failed", { url, statusCode: response.status, variant: "revamp" });
      return { type: "behavior", behavior: errorBehavior };
    }
    const responseType = getResponseTypeFromHeader(response);
    const body = await parseResponseBodyAsJsonElement(response);
    try {
      switch (responseType) {
        case "step": {
          const etag = response.headers.get("etag") || null;
          assertStepResponseBody(body);
          return { type: "replace-step", step: body, etag };
        }
        case "exit": {
          return { type: "complete", result: body };
        }
        case "action": {
          assertActionResponseBody(body);
          return { type: "behavior", behavior: { type: "action", action: body.action } };
        }
        default: {
          if (isActionResponseBody(body)) {
            return { type: "behavior", behavior: { type: "action", action: body.action } };
          }
          return { type: "continue" };
        }
      }
    } catch (e) {
      return { type: "behavior", behavior: errorBehavior };
    }
  } catch (e) {
    return { type: "continue" };
  }
};

// src/revamp/flow/getErrorMessage.ts
var getErrorMessage = (error) => {
  return error instanceof Error ? error.message : typeof error === "string" ? error : `Unknown Error: type is ${typeof error}`;
};

// src/revamp/flow/executeRefresh.ts
var executeRefresh = async (props) => {
  const { abortSignal, url, model, schemaId, etag, httpClient, trackEvent, logEvent } = props;
  trackEvent("Refresh Triggered", { schema: schemaId });
  try {
    const response = await httpClient(url != null ? url : "", {
      method: "POST",
      body: JSON.stringify(model),
      headers: __spreadValues({
        "Content-Type": "application/json"
      }, etag ? { "If-None-Match": etag } : {}),
      signal: abortSignal
    });
    if (response.status === 304) {
      trackEvent("Refresh Succeeded", { schema: schemaId });
      return { type: "noop" };
    }
    if (!response.ok) {
      const responseBody = await parseResponseBodyAsJsonElement(response).catch(() => ({}));
      const body2 = isErrorResponseBody(responseBody) ? responseBody : {};
      trackEvent("Refresh Failed", __spreadProps(__spreadValues({}, body2.analytics), {
        schema: schemaId,
        statusCode: response.status
      }));
      logEvent("error", "Dynamic Flow - Refresh Failed", { schemaId, statusCode: response.status });
      return { type: "error", body: body2, statusCode: response.status };
    }
    const newEtag = response.headers.get("etag") || null;
    const body = await parseResponseBodyAsJsonElement(response);
    assertStepResponseBody(body);
    trackEvent("Refresh Succeeded", { schema: schemaId });
    return { type: "refresh-step", step: body, etag: newEtag };
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      trackEvent("Refresh Aborted", { schema: schemaId });
      return { type: "noop" };
    }
    trackEvent("Refresh Failed", { schema: schemaId });
    logEvent("error", "Dynamic Flow - Refresh Failed", {
      schemaId,
      errorMessage: getErrorMessage(error)
    });
    return { type: "error", body: {} };
  }
};

// src/revamp/flow/executeSubmission.ts
var executeSubmission = async (props) => {
  const { httpClient, trackEvent, logEvent } = props;
  const triggerAction = async (action, model, isInitial) => {
    const { exit, url, method = "POST", result = null, id: actionId } = action;
    const trackSubmissionEvent = !isInitial ? trackEvent : () => {
    };
    trackSubmissionEvent("Action Triggered", { actionId });
    if (exit && !url) {
      trackSubmissionEvent("Action Succeeded", { actionId });
      return { type: "complete", result };
    }
    const makeRequestBody = () => {
      var _a;
      if (method === "GET") {
        return void 0;
      }
      const payload = mergeModels(model, (_a = action.data) != null ? _a : null);
      return payload !== null ? JSON.stringify(payload) : null;
    };
    const response = await getSafeHttpClient(httpClient)(url != null ? url : "", {
      method,
      body: makeRequestBody(),
      headers: { "Content-Type": "application/json" }
    });
    if (!response) {
      const extra = { actionId, errorMessage: "Network Error" };
      trackEvent("Action Failed", extra);
      logEvent("error", "Dynamic Flow - Action Failed Unexpectedly", extra);
      return { type: "error", body: {} };
    }
    if (!response.ok) {
      return handleErrorResponse(response, actionId);
    }
    try {
      const responseType = await getResponseType(response);
      const body = await parseResponseBodyAsJsonElement(response);
      if (exit) {
        return { type: "complete", result: mergeModels(body, result) };
      }
      switch (responseType) {
        case "step": {
          const etag = response.headers.get("etag") || null;
          assertStepResponseBody(body);
          trackSubmissionEvent("Action Succeeded", { actionId });
          return { type: "replace-step", step: body, etag };
        }
        case "exit": {
          trackSubmissionEvent("Action Succeeded", { actionId });
          return { type: "complete", result: mergeModels(body, result) };
        }
        case "action": {
          assertActionResponseBody(body);
          trackSubmissionEvent("Action Succeeded", { actionId });
          return await triggerAction(body.action, null, false);
        }
        default: {
          throw new Error(`Unsupported response type: ${String(responseType)}`);
        }
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      trackSubmissionEvent("Action Failed", { actionId, errorMessage });
      logEvent("error", "Dynamic Flow - Action Failed Unexpectedly", { actionId, errorMessage });
      throw error;
    }
  };
  const handleErrorResponse = async (response, actionId) => {
    const body = await parseResponseBodyAsJsonElement(response);
    if (isErrorResponseBody(body)) {
      const refreshUrl = body.refreshUrl || body.refreshFormUrl;
      const { error, validation, analytics } = body;
      trackEvent("Action Failed", __spreadProps(__spreadValues({}, analytics), { actionId, statusCode: response.status }));
      const errors = { error, validation };
      return refreshUrl ? { type: "refresh", body: { refreshUrl, errors } } : { type: "error", body: { errors, analytics }, statusCode: response.status };
    }
    trackEvent("Action Failed", { actionId, statusCode: response.status });
    return { type: "error", body: {}, statusCode: response.status };
  };
  return triggerAction(props.action, props.model, props.isInitial);
};
var getSafeHttpClient = (httpClient) => async (input, init) => {
  try {
    return await httpClient(input, init);
  } catch (e) {
    return null;
  }
};

// src/revamp/renderers/getSchemaErrorMessageFunction.ts
import { formatDate } from "@transferwise/formatting";

// src/common/messages/validation.messages.ts
import { defineMessages as defineMessages2 } from "react-intl";
var validation_messages_default = defineMessages2({
  type: {
    id: "dynamicFlows.ControlFeedback.type",
    defaultMessage: "Incorrect type",
    description: ""
  },
  minimum: {
    id: "dynamicFlows.ControlFeedback.minimum",
    defaultMessage: `Please enter a number that's {minimum} or more.`,
    description: ""
  },
  maximum: {
    id: "dynamicFlows.ControlFeedback.maximum",
    defaultMessage: `Please enter a number that's {maximum} or less.`,
    description: ""
  },
  minLength: {
    id: "dynamicFlows.ControlFeedback.minLength",
    defaultMessage: "Please enter at least {minLength} characters.",
    description: ""
  },
  maxLength: {
    id: "dynamicFlows.ControlFeedback.maxLength",
    defaultMessage: "Please enter {maxLength} or fewer characters.",
    description: ""
  },
  minimumDate: {
    id: "dynamicFlows.ControlFeedback.minimumDate",
    defaultMessage: `Please enter a date that's on or after {minimum}.`,
    description: ""
  },
  maximumDate: {
    id: "dynamicFlows.ControlFeedback.maximumDate",
    defaultMessage: `Please enter a date that's on or before {maximum}.`,
    description: ""
  },
  pattern: {
    id: "dynamicFlows.ControlFeedback.pattern",
    defaultMessage: "Please enter this in the correct format.",
    description: ""
  },
  patternDate: {
    id: "dynamicFlows.ControlFeedback.patternDate",
    defaultMessage: "Please enter a date in the corrrect format.",
    description: ""
  },
  required: {
    id: "dynamicFlows.ControlFeedback.required",
    defaultMessage: "Please fill out this field.",
    description: ""
  }
});

// src/common/messages/validation.array.messages.ts
import { defineMessages as defineMessages3 } from "react-intl";
var validation_array_messages_default = defineMessages3({
  minItemsError: {
    id: "dynamicFlows.ArraySchema.minItemsError",
    defaultMessage: "Please add at least {minItems}.",
    description: "Customer inputs less than the expected number of values"
  },
  maxItemsError: {
    id: "dynamicFlows.ArraySchema.maxItemsError",
    defaultMessage: "Please add {maxItems} or fewer.",
    description: "Customer inputs more than the allowed number of values"
  }
});

// src/common/messages/file-upload.messages.ts
import { defineMessages as defineMessages4 } from "react-intl";
var file_upload_messages_default = defineMessages4({
  maxFileSizeError: {
    id: "dynamicFlows.FileUploadSchema.maxFileSizeError",
    defaultMessage: "Sorry, that file is too big. Please upload a smaller file.",
    description: "Customer has uploaded a file that's too big. To fix: upload a smaller file."
  },
  wrongFileTypeError: {
    id: "dynamicFlows.FileUploadSchema.wrongFileTypeError",
    defaultMessage: "Sorry, that file format is not supported. Please upload a different file.",
    description: "Customer has uploaded a file that is the wrong type. To fix: upload a file of the correct type."
  }
});

// src/common/messages/multi-file-upload.messages.ts
import { defineMessages as defineMessages5 } from "react-intl";
var multi_file_upload_messages_default = defineMessages5({
  minItemsError: {
    id: "dynamicFlows.MultipleFileUploadSchema.minItemsError",
    defaultMessage: "Please upload at least {minItems} file(s).",
    description: "Customer has uploaded not enough files. To fix: upload more files."
  },
  maxItemsError: {
    id: "dynamicFlows.MultipleFileUploadSchema.maxItemsError",
    defaultMessage: "Please upload {maxItems} or fewer files.",
    description: "Customer has uploaded too many files. To fix: upload fewer files."
  },
  maxFileSizeError: {
    id: "dynamicFlows.MultipleFileUploadSchema.maxFileSizeError",
    defaultMessage: "Sorry, that file is too big. Please upload a smaller file.",
    description: "Customer has uploaded a file that's too big. To fix: upload a smaller file."
  }
});

// src/revamp/renderers/getSchemaErrorMessageFunction.ts
function getSchemaErrorMessageFunction(formatMessage, locale) {
  return (validationMessages) => createErrorMessageFunctions(validationMessages != null ? validationMessages : {}, formatMessage, locale);
}
var createErrorMessageFunctions = (validationMessages, formatMessage, locale) => ({
  minimum(minimum) {
    var _a;
    return (_a = validationMessages.minimum) != null ? _a : formatMessage(validation_messages_default.minimum, {
      minimum
    });
  },
  maximum(maximum) {
    var _a;
    return (_a = validationMessages.maximum) != null ? _a : formatMessage(validation_messages_default.maximum, {
      maximum
    });
  },
  minimumDate(minimumDate) {
    var _a;
    return (_a = validationMessages.minimum) != null ? _a : formatMessage(validation_messages_default.minimumDate, {
      minimum: formatDate(new Date(minimumDate), locale, formatDateOptions)
    });
  },
  maximumDate(maximumDate) {
    var _a;
    return (_a = validationMessages.maximum) != null ? _a : formatMessage(validation_messages_default.maximumDate, {
      maximum: formatDate(new Date(maximumDate), locale, formatDateOptions)
    });
  },
  minLength(minLength) {
    var _a;
    return (_a = validationMessages.minLength) != null ? _a : formatMessage(validation_messages_default.minLength, {
      minLength
    });
  },
  maxLength(maxLength) {
    var _a;
    return (_a = validationMessages.maxLength) != null ? _a : formatMessage(validation_messages_default.maxLength, {
      maxLength
    });
  },
  minItems(minItems) {
    var _a;
    return (_a = validationMessages.minItems) != null ? _a : formatMessage(validation_array_messages_default.minItemsError, {
      minItems
    });
  },
  maxItems(maxItems) {
    var _a;
    return (_a = validationMessages.maxItems) != null ? _a : formatMessage(validation_array_messages_default.maxItemsError, {
      maxItems
    });
  },
  minFiles(minItems) {
    var _a;
    return (_a = validationMessages.minItems) != null ? _a : formatMessage(multi_file_upload_messages_default.minItemsError, {
      minItems
    });
  },
  maxFiles(maxItems) {
    var _a;
    return (_a = validationMessages.maxItems) != null ? _a : formatMessage(multi_file_upload_messages_default.maxItemsError, {
      maxItems
    });
  },
  maxSize() {
    var _a;
    return (_a = validationMessages.maxSize) != null ? _a : formatMessage(file_upload_messages_default.maxFileSizeError);
  },
  accepts() {
    var _a;
    return (_a = validationMessages.accepts) != null ? _a : formatMessage(file_upload_messages_default.wrongFileTypeError);
  },
  pattern() {
    var _a;
    return (_a = validationMessages.pattern) != null ? _a : formatMessage(validation_messages_default.pattern);
  },
  required() {
    var _a;
    return (_a = validationMessages.required) != null ? _a : formatMessage(validation_messages_default.required);
  },
  genericError() {
    return formatMessage(generic_error_messages_default.genericError);
  },
  genericErrorWithRetry() {
    return formatMessage(generic_error_messages_default.genericErrorRetryHint);
  }
});
var formatDateOptions = {
  timeZone: "UTC",
  dateStyle: "long"
};

// src/revamp/utils/findComponent.ts
var findComponent = (components, id, logEvent) => {
  const flattened = flattenComponents(components);
  const matching = flattened.filter((component) => component.uid === id);
  if (matching.length === 1) {
    return matching[0];
  }
  if (matching.length > 1) {
    throw new Error(`Multiple components with the same uid: ${id}`);
  }
  logEvent("error", "Failed to find domain layer component", {
    componentUid: id,
    componentsTree: flattened.map((component) => component.uid)
  });
  throw new Error(`Failed to find any components with uid: ${id}`);
};
var flattenComponents = (components) => components.reduce((acc, component) => {
  if (hasChildren(component)) {
    return [...acc, component, ...flattenComponents(component.getChildren())];
  }
  return [...acc, component];
}, []);

// src/revamp/utils/useStableCallback.tsx
import { useCallback, useLayoutEffect, useRef } from "react";
function useStableCallback(handler) {
  const ref = useRef(handler);
  useLayoutEffect(() => {
    ref.current = handler;
  });
  return useCallback((...args) => ref.current ? ref.current(...args) : null, []);
}

// src/revamp/useDynamicFlowCore.tsx
function useDynamicFlowCore(props) {
  const _a = props, { flowId, initialAction, initialStep, displayStepTitle = true } = _a, rest = __objRest(_a, ["flowId", "initialAction", "initialStep", "displayStepTitle"]);
  const httpClient = useStableCallback(rest.httpClient);
  const onCompletion = useStableCallback(rest.onCompletion);
  const onValueChange = useStableCallback(props.onValueChange);
  const onLink = useStableCallback(props.onLink);
  const onError = useStableCallback(rest.onError);
  const onEvent = useStableCallback(rest.onEvent);
  const onLog = useStableCallback(rest.onLog);
  const { formatMessage, locale } = useIntl2();
  const getErrorMessageFunctions = useMemo(
    () => getSchemaErrorMessageFunction(formatMessage, locale),
    [formatMessage, locale]
  );
  const rerender = useRerender();
  const rootComponentRef = useRef2(createRootDomainComponent());
  const updateComponent = useCallback2(
    (id, update) => {
      update(findComponent([rootComponentRef.current], id, logEvent));
      rerender();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const stepCount = useRef2(0);
  const stepRef = useRef2(initialStep != null ? initialStep : null);
  const etagRef = useRef2(null);
  const abortControllerRef = useRef2(new AbortController());
  const abortCurrentAndGetNewAbortSignal = () => {
    abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
    return abortControllerRef.current.signal;
  };
  useEffect(() => {
    trackCoreEvent("Initiated");
    if (!initialStep && initialAction) {
      void onAction(__spreadValues({ method: "GET" }, initialAction));
    }
    if (initialStep && !initialAction) {
      createStep(initialStep, null);
      trackCoreEvent("Step Shown", { isFirstStep: true });
    }
    return () => {
      rootComponentRef.current.stop();
    };
  }, []);
  const createStep = useCallback2((newStep, etag) => {
    if (rootComponentRef.current.hasStep()) {
      stepCount.current = (stepCount.current + 1) % 100;
    }
    initialiseWithStep(newStep, etag, null);
  }, []);
  const updateStep = useCallback2((newStep, etag) => {
    var _a2;
    initialiseWithStep(newStep, etag, (_a2 = rootComponentRef.current.getLocalValue()) != null ? _a2 : null);
  }, []);
  const initialiseWithStep = useCallback2(
    (newStep, etag, localValue) => {
      rootComponentRef.current.stop();
      stepRef.current = newStep;
      etagRef.current = etag;
      const validationResult = validateStep(newStep);
      if (!validationResult.valid) {
        logEvent("info", "The provided step does not conform to the specification.", {
          errors: validationResult.errors
        });
      }
      try {
        const newStepComponent = mapStepToComponent({
          uid: `${rootComponentRef.current.uid}:${stepCount.current}`,
          stepLocalValue: localValue,
          step: newStep,
          displayStepTitle,
          loadingState: "idle",
          updateComponent,
          getErrorMessageFunctions,
          trackEvent,
          logEvent,
          httpClient,
          onBehavior,
          onRefresh,
          onPoll,
          onValueChange
        });
        updateComponent(rootComponentRef.current.uid, (draft) => {
          draft.stepComponent = newStepComponent;
        });
      } catch (error) {
        closeWithError(error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const trackEvent = useCallback2(
    (eventName, properties) => {
      var _a2, _b, _c, _d, _e;
      const stepId = stepRef.current ? (_d = (_c = (_a2 = stepRef.current) == null ? void 0 : _a2.id) != null ? _c : (_b = stepRef.current) == null ? void 0 : _b.key) != null ? _d : "" : null;
      const analytics = (_e = stepRef.current) == null ? void 0 : _e.analytics;
      const metadata = __spreadValues(__spreadValues(__spreadValues(__spreadValues({
        flowId
      }, stepId !== null ? { stepId } : {}), stepRef.current ? { stepCount: stepCount.current } : {}), analytics), properties);
      try {
        onEvent == null ? void 0 : onEvent(`Dynamic Flow - ${eventName}`, __spreadValues({}, metadata));
      } catch (e) {
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const trackCoreEvent = trackEvent;
  const logEvent = useCallback2(
    (level, message, properties) => {
      var _a2, _b, _c, _d;
      const stepId = stepRef.current ? (_d = (_c = (_a2 = stepRef.current) == null ? void 0 : _a2.id) != null ? _c : (_b = stepRef.current) == null ? void 0 : _b.key) != null ? _d : "" : null;
      try {
        onLog == null ? void 0 : onLog(level, message, __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, properties), {
          flowId
        }), stepId !== null ? { stepId } : {}), stepRef.current ? { stepCount: stepCount.current } : {}));
      } catch (e) {
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const closeWithError = useCallback2(
    (error, analytics, statusCode) => {
      rootComponentRef.current.stop();
      trackCoreEvent("Failed", __spreadValues({}, analytics));
      logEvent("error", "Dynamic Flow failed", { errorMessage: getErrorMessage(error), analytics });
      onError(error, statusCode);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const onBehavior = useCallback2(async (behavior) => {
    switch (behavior.type) {
      case "action": {
        try {
          const { action } = behavior;
          await rootComponentRef.current.getSubmittableValue();
          const skipValidation2 = action.method === "GET" || Boolean(action.skipValidation);
          const canSubmit = skipValidation2 || rootComponentRef.current.validate();
          if (canSubmit) {
            void onAction(action);
          }
        } catch (e) {
          if (true) {
            console.log("\u274C:", "Failed to get submittable data");
          }
        }
        break;
      }
      case "link": {
        onLink(behavior.url);
        break;
      }
      // case 'modal':
      //   return undefined;
      // case 'dismiss':
      //   return undefined;
      case "none":
        break;
    }
  }, []);
  const onAction = useCallback2(async (action) => {
    var _a2;
    try {
      rootComponentRef.current.setLoadingState("submitting");
      const model = (_a2 = await rootComponentRef.current.getSubmittableValue()) != null ? _a2 : null;
      const command = await executeSubmission({
        action,
        model,
        isInitial: stepRef.current === null,
        httpClient,
        trackEvent: trackCoreEvent,
        logEvent
      });
      switch (command.type) {
        case "complete": {
          onCompletion(command.result);
          rootComponentRef.current.stop();
          trackCoreEvent("Succeeded");
          break;
        }
        case "replace-step": {
          const isFirstStep = stepRef.current === null;
          createStep(command.step, command.etag);
          trackCoreEvent("Step Shown", { isFirstStep });
          break;
        }
        case "error": {
          const genericErrorMessage = getErrorMessageFunctions().genericErrorWithRetry();
          const { errors = { error: genericErrorMessage } } = command.body;
          if (stepRef.current) {
            updateStep(
              __spreadProps(__spreadValues({}, stepRef.current), {
                // the existing step
                errors,
                // but with the new errors
                model,
                // and the model that was submitted
                polling: void 0,
                // and no polling, to avoid restarting it
                external: void 0
                // and no external, to avoid retriggering it
              }),
              etagRef.current
            );
          } else {
            closeWithError(
              new Error("Initial request failed", {
                cause: `method: ${action.method}, url: ${action.url}`
              }),
              {},
              command.statusCode
            );
          }
          break;
        }
        case "refresh": {
          const { refreshUrl, errors = {} } = command.body;
          void onRefresh(void 0, refreshUrl, errors);
          break;
        }
      }
    } catch (error) {
      closeWithError(error);
    }
  }, []);
  const onRefresh = useCallback2(
    async (schemaId, refreshUrl = "", errorsOverride) => {
      var _a2;
      try {
        rootComponentRef.current.setLoadingState("refreshing");
        const model = (_a2 = await rootComponentRef.current.getSubmittableValue()) != null ? _a2 : null;
        const command = await executeRefresh({
          abortSignal: abortCurrentAndGetNewAbortSignal(),
          url: refreshUrl,
          model,
          schemaId,
          etag: etagRef.current,
          httpClient,
          trackEvent: trackCoreEvent,
          logEvent
        });
        switch (command.type) {
          case "refresh-step":
            {
              const errors = errorsOverride != null ? errorsOverride : command.step.errors;
              updateStep(__spreadProps(__spreadValues({}, command.step), { errors }), command.etag);
            }
            break;
          case "error": {
            closeWithError(
              new Error("Failed to refresh"),
              command.body.analytics,
              command.statusCode
            );
            break;
          }
          case "noop":
            rootComponentRef.current.setLoadingState("idle");
            break;
        }
      } catch (error) {
        closeWithError(error, void 0);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const onPoll = useCallback2(
    async (url, errorBehavior, signal) => {
      const command = await executePoll({
        httpClient,
        url,
        errorBehavior,
        signal,
        trackEvent: trackCoreEvent
      });
      switch (command.type) {
        case "replace-step":
          createStep(command.step, command.etag);
          return true;
        case "behavior":
          void onBehavior(command.behavior);
          return true;
        case "complete":
          onCompletion(command.result);
          return true;
        case "continue":
          return false;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return { rootComponent: rootComponentRef.current };
}
var useRerender = () => {
  const [, setState] = useState({});
  return useCallback2(() => setState({}), []);
};

// src/revamp/DynamicFlowCore.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
function DynamicFlowCore(props) {
  var _a;
  const { rootComponent } = useDynamicFlowCore(props);
  const { renderers, httpClient, onEvent, onError, onLog } = props;
  const render = useMemo2(
    () => getRenderFunction([CoreRootRenderer, CoreContainerRenderer, ...renderers]),
    [renderers]
  );
  const tree = componentToRendererProps(rootComponent, {
    render,
    httpClient,
    trackEvent: (_a = rootComponent.getTrackEvent()) != null ? _a : () => {
    },
    stepLoadingState: rootComponent.getLoadingState()
  });
  return /* @__PURE__ */ jsx6(
    ErrorBoundary_default,
    {
      onError: (error) => {
        onEvent == null ? void 0 : onEvent("Dynamic Flow - Failed", { error });
        onError == null ? void 0 : onError(error);
        onLog == null ? void 0 : onLog("error", "Dynamic Flow - ErrorBoundary", { errorMessage: getErrorMessage(error) });
      },
      children: render(tree)
    }
  );
}

// src/revamp/DynamicFormCore.tsx
import { forwardRef, useImperativeHandle, useMemo as useMemo3 } from "react";

// src/revamp/utils/openLinkInNewTab.tsx
var openLinkInNewTab = (url) => {
  var _a;
  try {
    const w = (_a = window == null ? void 0 : window.open) == null ? void 0 : _a.call(window, url, "_blank");
    return Boolean(w);
  } catch (e) {
    return false;
  }
};

// src/revamp/DynamicFormCore.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var DynamicFormCore = forwardRef(function DynamicFormCore2(props, ref) {
  var _a;
  const {
    onCompletion = () => {
    },
    httpClient,
    onEvent,
    onError,
    onLink = openLinkInNewTab,
    renderers
  } = props;
  const { rootComponent } = useDynamicFlowCore(__spreadProps(__spreadValues({ onCompletion }, props), { onLink }));
  useImperativeHandle(
    ref,
    () => ({
      getValue: async () => {
        var _a2;
        return (_a2 = await rootComponent.getSubmittableValue()) != null ? _a2 : null;
      },
      validate: () => rootComponent.validate()
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const render = useMemo3(
    () => getRenderFunction([CoreRootRenderer, CoreContainerRenderer, ...renderers]),
    [renderers]
  );
  const tree = componentToRendererProps(rootComponent, {
    render,
    httpClient,
    trackEvent: (_a = rootComponent.getTrackEvent()) != null ? _a : () => {
    },
    stepLoadingState: rootComponent.getLoadingState()
  });
  return /* @__PURE__ */ jsx7(
    ErrorBoundary_default,
    {
      onError: (error) => {
        onEvent == null ? void 0 : onEvent("Dynamic Flow - Failed");
        onError(error);
      },
      children: render(tree)
    }
  );
});

// src/legacy/step/layoutStep/utils/layout-utils.ts
function convertStepToLayout(step, { displayStepTitle = true } = {}) {
  if (step.layout) {
    return addMissingTitleAndDescriptionToStep(step, displayStepTitle);
  }
  switch (step.type) {
    case "final":
      return convertFinalStepToDynamicLayout(step);
    case "decision":
      return convertDecisionStepToDynamicLayout(step);
    case "external":
      return convertExternalStepToDynamicLayout(step);
    default:
      return convertFormStepToDynamicLayout(step);
  }
}
function convertCommonComponents(step) {
  const layout = [];
  if (step.title) {
    layout.push(convertStepTitleToDynamicHeading(step.title));
  }
  if (step.image) {
    const image = convertStepImageToDynamicImage(step.image);
    layout.push(image);
  }
  if (step.description) {
    layout.push(convertStepDescriptionToDynamicParagraph(step.description));
  }
  return layout;
}
function convertExternalStepToDynamicLayout(step) {
  return [...convertCommonComponents(step), convertStepToExternalComponent(step)];
}
function convertStepToExternalComponent(step) {
  return {
    type: "external",
    requestUrl: step.requestUrl,
    polling: step.polling,
    responseHandlers: step.responseHandlers,
    retryTitle: step.retryTitle
  };
}
function convertFormStepToDynamicLayout(step) {
  const layout = convertCommonComponents(step);
  if (step.reviewFields) {
    layout.push(convertStepReviewToDynamicReview(step.reviewFields));
  }
  if (step.schemas) {
    layout.push(...getSchemaLayout(step));
  }
  if (step.actions) {
    const actions = step.actions.map(convertStepActionToDynamicAction);
    layout.push(dynamicBox(actions, "md"));
  }
  return layout;
}
function convertFinalStepToDynamicLayout(step) {
  const layout = [];
  if (step.details) {
    if (step.details.image) {
      const image = convertFinalStepImageToDynamicImage(step.details.image);
      layout.push(image);
    }
    if (step.details.title) {
      layout.push(convertStepTitleToDynamicHeading(step.details.title));
    }
    if (step.details.description) {
      layout.push(convertStepDescriptionToDynamicParagraph(step.details.description));
    }
  }
  if (step.actions) {
    const actions = step.actions.map(
      (action) => convertStepActionToDynamicAction(__spreadProps(__spreadValues({}, action), { type: action.type || "primary" }))
    );
    layout.push(dynamicBox(actions, "md"));
  }
  return layout;
}
function convertDecisionStepToDynamicLayout(step) {
  const layout = convertCommonComponents(step);
  if (step.options) {
    layout.push(convertStepDecisionToDynamicDecision(step.options));
  }
  return layout;
}
function dynamicBox(components, size) {
  return {
    type: "box",
    width: size || "md",
    components
  };
}
function convertStepTitleToDynamicHeading(title) {
  return {
    type: "heading",
    text: title,
    size: "lg",
    margin: "lg",
    align: "center"
  };
}
function convertStepDescriptionToDynamicParagraph(description) {
  return {
    type: "paragraph",
    text: description,
    align: "center"
  };
}
function convertStepSchemaToDynamicForm(schema) {
  return { type: "form", schema };
}
function convertStepDecisionToDynamicDecision(options) {
  return {
    type: "decision",
    options: options.map(convertStepDecisionOption)
  };
}
function convertStepDecisionOption(option) {
  return {
    title: option.title,
    description: option.description,
    action: {
      title: option.title,
      method: "GET",
      url: option.url,
      disabled: option.disabled
    }
  };
}
function convertStepImageToDynamicImage(image) {
  return {
    type: "image",
    url: image.url,
    text: image.text,
    margin: image.margin || "lg",
    size: image.size || "md"
  };
}
function convertFinalStepImageToDynamicImage(image) {
  return typeof image === "string" ? {
    type: "image",
    url: image,
    text: void 0,
    margin: "lg",
    size: "md"
  } : convertStepImageToDynamicImage(image);
}
function convertStepActionToDynamicAction(action) {
  const newAction = __spreadProps(__spreadValues({}, action), { title: action.title });
  return {
    type: "button",
    action: newAction
  };
}
function convertStepReviewToDynamicReview(reviewFields) {
  return {
    type: "review",
    title: reviewFields.title,
    fields: reviewFields.fields.map(convertReviewFieldToDefinition)
  };
}
function convertReviewFieldToDefinition(reviewField) {
  return {
    label: reviewField.title,
    value: reviewField.value
  };
}
function getSchemaLayout(step) {
  const layout = [];
  if (step.schemas && step.schemas[0]) {
    const schema = step.schemas[0];
    const dynamicForm = convertStepSchemaToDynamicForm(schema);
    if (isWideForm()) {
      layout.push(dynamicForm);
    } else {
      layout.push(dynamicBox([dynamicForm], "md"));
    }
  }
  return layout;
}
function isWideForm() {
  return false;
}
function addMissingTitleAndDescriptionToStep(step, displayStepTitle) {
  return [
    ...displayStepTitle && step.title ? [convertStepTitleToDynamicHeading(step.title)] : [],
    ...step.description ? [convertStepDescriptionToDynamicParagraph(step.description)] : [],
    ...step.layout || []
  ];
}

// src/legacy/step/layoutStep/utils/inline-reference-utils.ts
function inlineReferences({
  layout,
  schemas,
  actions,
  model
}) {
  if (!layout) {
    return [];
  }
  if (!schemas) {
    return layout;
  }
  return layout.map((component) => {
    if (component.type === "form") {
      return inlineFormSchema({ formComponent: component, schemas });
    }
    if (component.type === "decision") {
      return inlineDecisionActions({ decisionComponent: component, actions });
    }
    if (component.type === "button") {
      return inlineAction2({ actionComponent: component, actions });
    }
    if (component.type === "box") {
      return __spreadProps(__spreadValues({}, component), {
        components: inlineReferences({ layout: component.components, schemas, actions, model })
      });
    }
    if (component.type === "modal") {
      return __spreadProps(__spreadValues({}, component), {
        components: inlineReferences({
          layout: component.content.components,
          schemas,
          actions,
          model
        })
      });
    }
    if (component.type === "columns") {
      return __spreadProps(__spreadValues({}, component), {
        left: inlineReferences({ layout: component.left, schemas, actions, model }),
        right: inlineReferences({ layout: component.right, schemas, actions, model })
      });
    }
    return component;
  });
}
function inlineFormSchema({
  formComponent,
  schemas
}) {
  if (formComponent.schemaId) {
    return {
      type: "form",
      margin: formComponent.margin,
      schema: getSchemaById(schemas, formComponent.schemaId)
    };
  }
  if (formComponent.schema && isReference(formComponent.schema) && formComponent.schema.$ref) {
    return {
      type: "form",
      margin: formComponent.margin,
      schema: getSchemaById(schemas, formComponent.schema.$ref)
    };
  }
  if (formComponent.schema && !isReference(formComponent.schema)) {
    return __spreadValues({}, formComponent);
  }
  throw new Error('Invalid form layout component. Missing "schema" or "schemaId" properties.');
}
function inlineDecisionActions({
  decisionComponent,
  actions
}) {
  var _a;
  const newOptions = (_a = decisionComponent == null ? void 0 : decisionComponent.options) == null ? void 0 : _a.map(
    (option) => option.action && isReference(option.action) ? __spreadProps(__spreadValues({}, option), {
      action: getActionById(actions, option.action.$ref)
    }) : option
  );
  return __spreadProps(__spreadValues({}, decisionComponent), {
    options: newOptions
  });
}
function inlineAction2({
  actionComponent,
  actions
}) {
  var _a;
  if (actionComponent.action && isReference(actionComponent.action) && ((_a = actionComponent.action) == null ? void 0 : _a.$ref)) {
    const newAction = getActionById(actions, actionComponent.action.$ref);
    return convertStepActionToDynamicAction(newAction);
  }
  return actionComponent;
}
function getSchemaById(schemas, id) {
  const schema = schemas.find((schema2) => schema2.$id === id);
  if (!schema) {
    throw new Error(`Fatal Error. Schema not found. $id ${id}`);
  }
  return schema;
}
function getActionById(actions, id) {
  const action = actions.find((action2) => action2.$id === id);
  if (!action) {
    throw new Error(`Fatal Error. Action not found. $id ${id}`);
  }
  return action;
}
function isReference(block) {
  return Object.hasOwnProperty.call(block, "$ref");
}

// src/legacy/dynamicFlow/DynamicFlow.tsx
import { useCallback as useCallback11, useEffect as useEffect22, useMemo as useMemo21, useState as useState26 } from "react";
import { useIntl as useIntl23 } from "react-intl";

// src/legacy/common/contexts/dynamicFlowContexts/DynamicFlowContexts.tsx
import { createContext, useContext, useMemo as useMemo4 } from "react";

// src/legacy/common/contexts/dynamicFlowContexts/usePendingPromiseCounter.ts
import { useCallback as useCallback3, useState as useState2 } from "react";
function usePendingPromiseCounter() {
  const [count, setCount] = useState2(0);
  const addPendingPromise = useCallback3(
    (promise) => {
      setCount((c) => c + 1);
      promise.catch(noop2).finally(() => delayUntilNextCycle(() => setCount((c) => Math.max(0, c - 1))));
    },
    [setCount]
  );
  return { addPendingPromise, pendingPromises: count };
}
var delayUntilNextCycle = (fn) => setTimeout(() => fn(), 0);
var noop2 = () => {
};

// src/legacy/common/contexts/dynamicFlowContexts/DynamicFlowContexts.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var defaultContextValue = {
  loading: false,
  registerPersistAsyncPromise: (promise) => {
  }
};
var DFContext = createContext(defaultContextValue);
var DynamicFlowProvider = ({ loading, children }) => {
  const { pendingPromises, addPendingPromise } = usePendingPromiseCounter();
  const providerValue = useMemo4(() => {
    return {
      loading: loading || pendingPromises > 0,
      registerPersistAsyncPromise: addPendingPromise
    };
  }, [loading, pendingPromises, addPendingPromise]);
  return /* @__PURE__ */ jsx8(DFContext.Provider, { value: providerValue, children });
};
var useDynamicFlow = () => {
  const context = useContext(DFContext);
  return context || defaultContextValue;
};

// src/legacy/common/contexts/eventsContext/EventsContext.tsx
import { createContext as createContext2, useContext as useContext2, useMemo as useMemo5 } from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
var EventsContext = createContext2({
  triggerEvent: () => {
  }
});
function EventsContextProvider({ metadata, children, onEvent }) {
  const value = useMemo5(
    () => ({ triggerEvent: getEventDispatcher(onEvent, metadata) }),
    [onEvent, metadata]
  );
  return /* @__PURE__ */ jsx9(EventsContext.Provider, { value, children });
}
function useEventDispatcher() {
  const { triggerEvent } = useContext2(EventsContext);
  return triggerEvent;
}
var getEventDispatcher = (onEvent, metadata) => (eventName, properties = {}) => {
  try {
    onEvent(eventName, __spreadValues(__spreadValues({}, metadata), properties));
  } catch (e) {
  }
};

// src/legacy/common/contexts/logContext/LogContext.tsx
import { createContext as createContext3, useContext as useContext3, useMemo as useMemo6 } from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var getLogger = (level, onLog, flowId = "UNKNOWN-FLOW-ID", stepId = "UNKNOWN-FLOW-ID") => (title, description, extra) => {
  try {
    onLog(level, `Dynamic Flow ${level} - ${title} - ${description}`, __spreadValues({
      flowId,
      stepId
    }, extra));
  } catch (e) {
  }
};
var LogContext = createContext3(null);
function LogProvider({ flowId, stepId, children, onLog }) {
  const value = useMemo6(
    () => ({
      debug: getLogger("debug", onLog, flowId, stepId),
      info: getLogger("info", onLog, flowId, stepId),
      warning: getLogger("warning", onLog, flowId, stepId),
      error: getLogger("error", onLog, flowId, stepId),
      critical: getLogger("critical", onLog, flowId, stepId)
    }),
    [onLog, flowId, stepId]
  );
  return /* @__PURE__ */ jsx10(LogContext.Provider, { value, children });
}
var useLogger = () => {
  const logging = useContext3(LogContext);
  if (logging == null) {
    throw new Error(
      "Logging context not found. Did you forget to wrap your component in a <LogProvider />?"
    );
  }
  return logging;
};

// src/common/cameraCapture/utils/mobile-utils.ts
var isMobile = () => isMobileScreenSize() && (isTouchScreen() || isMobileUA());
var isMobileUA = (userAgent = window.navigator.userAgent) => (
  // eslint-disable-next-line regexp/no-unused-capturing-group
  /mobi|\b(iphone|android|blackberry|webos|windows phone)\b/i.test(userAgent)
);
var isMobileScreenSize = (width = window.screen.width, height = window.screen.height) => width < 768 || height < 768;
var isTouchScreen = (navigator2 = window.navigator, matchMedia = window.matchMedia) => {
  if ("maxTouchPoints" in navigator2) {
    return navigator2.maxTouchPoints > 0;
  }
  const mQ = matchMedia == null ? void 0 : matchMedia("(pointer:coarse)");
  if ((mQ == null ? void 0 : mQ.media) === "(pointer:coarse)") {
    return Boolean(mQ.matches);
  }
  return false;
};

// src/common/utils/debounce.ts
var debounce2 = (callback, waitMs) => {
  let timeoutId = null;
  let lastArgs = null;
  const clearTimer = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    lastArgs = null;
  };
  const debouncedFn = (...args) => {
    lastArgs = args;
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      callback(...lastArgs);
      timeoutId = null;
      lastArgs = null;
    }, waitMs);
  };
  debouncedFn.cancel = () => {
    if (timeoutId !== null) {
      clearTimer();
    }
  };
  debouncedFn.flush = () => {
    if (timeoutId !== null) {
      callback(...lastArgs);
      clearTimer();
    }
  };
  debouncedFn.isPending = () => timeoutId !== null;
  return debouncedFn;
};

// src/legacy/common/utils/api-utils.ts
function isStatus2xx(status) {
  return status >= 200 && status < 300;
}

// src/legacy/common/validators/types/type-validators.ts
var isString2 = (value) => typeof value === "string";
var isNumber2 = (value) => typeof value === "number" && !Number.isNaN(value);
var isInteger2 = (value) => {
  return isNumber2(value) && Math.floor(value) === value;
};
var isBoolean2 = (value) => typeof value === "boolean";
var isObject2 = (value) => !isNull2(value) && !isUndefined2(value) && (value == null ? void 0 : value.constructor) === Object;
var isArray2 = (value) => Array.isArray(value);
var isNull2 = (value) => value === null;
var isUndefined2 = (value) => typeof value === "undefined";

// src/legacy/common/validators/values/value-validators.ts
var isEmpty = (value) => isString2(value) && value.length === 0 || (isObject2(value) || isArray2(value)) && Object.keys(value).length === 0;

// src/legacy/common/validators/models/model-utils.ts
function cleanBasicModelWithOneOfSchema(model, schema) {
  return schema.oneOf.some(
    (nestedSchema) => getValidBasicModelOrNull(model, nestedSchema) === model
  ) ? model : null;
}
function cleanArrayModelWithOneOfSchema(model, schema) {
  var _a;
  const validModels = schema.oneOf.map((nestedSchema) => getValidArrayModelOrNull(model, nestedSchema)).filter((item) => item !== null);
  if (validModels.length === 0) {
    return null;
  }
  return (_a = validModels.find((model2) => model2.some((item) => item !== null))) != null ? _a : validModels[0];
}
function getValidArrayModelOrNull(model, schema) {
  if (!isArraySchema2(schema)) {
    return null;
  }
  if (!isListArraySchema(schema)) {
    return null;
  }
  return cleanModelWithArraySchema(model, schema);
}
function cleanModelWithStringSchema(model) {
  return isString2(model) && !isEmpty(model) ? model : null;
}
function cleanModelWithNumberSchema(model) {
  return isNumber2(model) ? model : null;
}
function cleanModelWithBooleanSchema(model) {
  return isBoolean2(model) ? model : null;
}
function cleanModelWithArraySchema(model, schema) {
  if (!isArray2(model)) {
    return null;
  }
  if (!isListArraySchema(schema)) {
    return null;
  }
  if (model.length > 0) {
    const expectedType = typeof model[0];
    if (!model.every((item) => typeof item === expectedType)) {
      return new Array(model.length).fill(null);
    }
  }
  return model.map((childModel) => getValidModelParts(childModel, schema.items));
}
function cleanObjectModelWithObjectSchema(model, schema) {
  return Object.keys(schema.properties).reduce((cleanedModel, property) => {
    if (model && !isUndefined2(model[property])) {
      const subModel = model[property];
      const subSchema = schema.properties[property];
      const newValue = getValidModelParts(subModel, subSchema);
      if (!isNull2(newValue)) {
        return __spreadProps(__spreadValues({}, cleanedModel), { [property]: newValue });
      }
    }
    return cleanedModel;
  }, {});
}
function cleanObjectModelWithAllOfSchema(model, schema) {
  return schema.allOf.reduce((cleanObjectModel, nestedSchema) => {
    const validSubsetOfModel = getValidObjectModelParts(model, nestedSchema);
    if (isObjectModel2(validSubsetOfModel)) {
      return __spreadValues(__spreadValues({}, cleanObjectModel), validSubsetOfModel);
    }
    return cleanObjectModel;
  }, {});
}
function cleanObjectModelWithOneOfSchema(model, schema) {
  return schema.oneOf.map((nestedSchema) => getValidObjectModelParts(model, nestedSchema)).reduce((combined, current) => {
    if (isNull2(combined)) {
      return current;
    }
    if (isObjectModel2(combined) && isObjectModel2(current)) {
      return deepMergeObject(combined, current);
    }
    if (isNull2(current)) {
      return combined;
    }
    return current;
  }, null);
}
function deepMergeObject(object1, object2) {
  return Object.keys(object2).reduce(
    (acc, property) => {
      const object1Property = object1[property];
      const object2Property = object2[property];
      if (isObjectModel2(object1Property) && isObjectModel2(object2Property)) {
        return __spreadProps(__spreadValues({}, acc), {
          [property]: deepMergeObject(object1Property, object2Property)
        });
      }
      return __spreadProps(__spreadValues({}, acc), {
        [property]: object2[property]
      });
    },
    __spreadValues({}, object1)
  );
}

// src/legacy/common/validators/models/model-validators.ts
var getValidModelParts = (model, schema) => {
  if (isObjectModel2(model)) {
    return getValidObjectModelParts(model, schema);
  }
  if (isArrayModel2(model)) {
    return getValidArrayModelParts(model, schema);
  }
  return getValidBasicModelOrNull(model, schema);
};
function getValidBasicModelOrNull(model, schema) {
  if (isNull2(model)) {
    return null;
  }
  if (schema.oneOf) {
    return cleanBasicModelWithOneOfSchema(model, schema);
  }
  if (!isUndefined2(schema.const) && model === schema.const) {
    return model;
  }
  if (schema.type) {
    switch (schema.type) {
      case "string":
        return cleanModelWithStringSchema(model);
      case "number":
      case "integer":
        return cleanModelWithNumberSchema(model);
      case "boolean":
        return cleanModelWithBooleanSchema(model);
      default:
        return null;
    }
  }
  return null;
}
function getValidObjectModelParts(model, schema) {
  if (isBasicSchema(schema) || isArraySchema2(schema) || isNull2(model)) {
    return null;
  }
  if (schema.allOf) {
    return cleanObjectModelWithAllOfSchema(model, schema);
  }
  if (schema.oneOf) {
    return cleanObjectModelWithOneOfSchema(model, schema);
  }
  if (!isUndefined2(schema.const) && isEqual(model, schema.const)) {
    return model;
  }
  return isObjectSchema2(schema) ? cleanObjectModelWithObjectSchema(model, schema) : null;
}
function getValidArrayModelParts(model, schema) {
  if (isOneOfSchema2(schema)) {
    return cleanArrayModelWithOneOfSchema(model, schema);
  }
  if (!isArraySchema2(schema)) {
    return null;
  }
  return cleanModelWithArraySchema(model, schema);
}

// src/legacy/common/validators/validationFailures/validation-failures.utils.ts
function isValidRequired(value, isRequired = false) {
  return !isRequired || !isUndefined2(value);
}
function isValidRequiredArray(value, isRequired = false) {
  return !isRequired || isArray2(value);
}
function isValidMinLength(value, minLength) {
  return !isNumber2(minLength) || isString2(value) && value.length >= minLength;
}
function isValidMaxLength(value, maxLength) {
  return !isNumber2(maxLength) || isString2(value) && value.length <= maxLength;
}
function isValidPattern(value, pattern) {
  if (pattern === void 0) {
    return true;
  }
  if (value === void 0 || value === null) {
    return false;
  }
  const regex = new RegExp(pattern);
  return Boolean(regex.test(value));
}
function isValidMaximum(value, maximum) {
  return !isNumber2(maximum) && !isString2(maximum) || (isNumber2(value) || isString2(value)) && value <= maximum;
}
function isValidMinimum(value, minimum) {
  return !isNumber2(minimum) && !isString2(minimum) || (isNumber2(value) || isString2(value)) && value >= minimum;
}
function isValidMinItems(value, minItems) {
  return !isNumber2(minItems) || isArray2(value) && value.length >= minItems;
}
function isValidMaxItems(value, maxItems) {
  return !isNumber2(maxItems) || isArray2(value) && value.length <= maxItems;
}

// src/legacy/common/validators/validationFailures/validation-failures.ts
function getValidationFailures(value, schema, isRequired) {
  if (schema.const) {
    return getConstValidationFailures(value, schema, isRequired);
  }
  if (isNull2(value)) {
    return isRequired ? ["required"] : [];
  }
  if (isStringSchema2(schema)) {
    return getStringValidationFailures(value, schema, isRequired);
  }
  switch (schema.type) {
    case "number":
      return getNumberValidationFailures(value, schema, isRequired);
    case "integer":
      return getIntegerValidationFailures(value, schema, isRequired);
    case "boolean":
      return getBooleanValidationFailures(value, schema, isRequired);
    case "array":
      return getArrayValidationFailures(value, schema, isRequired);
    case "object":
      return getObjectValidationFailures(value, schema);
    default:
      return [];
  }
}
function getStringValidationFailures(value, schema, isRequired) {
  if (!isString2(value) && !isNull2(value)) {
    return ["type"];
  }
  if (value === "" && isRequired) {
    return ["required"];
  }
  const failures = [];
  if (!isValidRequired(value, isRequired)) {
    failures.push("required");
  }
  if (!isValidMinLength(value, schema.minLength)) {
    failures.push("minLength");
  }
  if (!isValidMaxLength(value, schema.maxLength)) {
    failures.push("maxLength");
  }
  if (!isValidPattern(value, schema.pattern)) {
    failures.push("pattern");
  }
  if (!isValidMinimum(value, schema.minimum)) {
    failures.push("minimum");
  }
  if (!isValidMaximum(value, schema.maximum)) {
    failures.push("maximum");
  }
  return failures;
}
function getNumberValidationFailures(value, schema, isRequired) {
  if (!isNumber2(value) && !isNull2(value)) {
    return ["type"];
  }
  const failures = [];
  if (!isValidRequired(value, isRequired)) {
    failures.push("required");
  }
  if (!isValidMinimum(value, schema.minimum)) {
    failures.push("minimum");
  }
  if (!isValidMaximum(value, schema.maximum)) {
    failures.push("maximum");
  }
  return failures;
}
function getIntegerValidationFailures(value, schema, isRequired) {
  if (!isInteger2(value)) {
    return ["type"];
  }
  return getNumberValidationFailures(value, schema, isRequired);
}
function getBooleanValidationFailures(value, _schema, isRequired) {
  if (!isBoolean2(value) && !isNull2(value)) {
    return ["type"];
  }
  const failures = [];
  if (!isValidRequired(value, isRequired)) {
    failures.push("required");
  }
  return failures;
}
function getConstValidationFailures(value, schema, isRequired) {
  if (!isValidRequired(value, isRequired)) {
    return ["required"];
  }
  if (!isEqual(value, schema.const)) {
    return ["const"];
  }
  return [];
}
function getArrayValidationFailures(value, schema, isRequired) {
  if (!isArray2(value) && !isNull2(value)) {
    return ["type"];
  }
  if (!isValidRequiredArray(value, isRequired)) {
    return ["required"];
  }
  const failures = [];
  if (!isValidMinItems(value, schema.minItems)) {
    failures.push("minItems");
  }
  if (!isValidMaxItems(value, schema.maxItems)) {
    failures.push("maxItems");
  }
  return failures;
}
function getBlobValidationFailures(value, _schema) {
  if (isNull2(value)) {
    return ["type"];
  }
  return [];
}
function getObjectValidationFailures(value, schema) {
  if (!isObjectModel2(value)) {
    return ["type"];
  }
  if (!isArray2(schema.required)) {
    return [];
  }
  const allPresent = schema.required.map((property) => typeof value[property] !== "undefined").reduce((propertyInModel, validSoFar) => propertyInModel && validSoFar, true);
  return allPresent ? [] : ["required"];
}

// src/legacy/common/validators/schemas/schema-validators.ts
function isValidStringSchema(value, schema) {
  return !getStringValidationFailures(value, schema).length;
}
function isValidNumberSchema(value, schema) {
  return !getNumberValidationFailures(value, schema).length;
}
function isValidIntegerSchema(value, schema) {
  return !getIntegerValidationFailures(value, schema).length;
}
function isValidBooleanSchema(value, schema) {
  return !getBooleanValidationFailures(value, schema).length;
}
function isValidConstSchema(value, schema) {
  return !getConstValidationFailures(value, schema).length;
}
function isValidObjectSchema(value, schema) {
  if (!isObject2(value) || schema.type !== "object" || !isObject2(schema.properties)) {
    return false;
  }
  return Object.keys(schema.properties).map(
    (propertyName) => isObjectPropertyValid(
      value[propertyName],
      schema.properties[propertyName],
      schema.required && schema.required.includes(propertyName)
    )
  ).every((property) => property);
}
function isObjectPropertyValid(propertyValue, propertySchema, isRequired) {
  if (propertySchema.hidden) {
    return true;
  }
  if (typeof propertyValue === "undefined") {
    return !isRequired;
  }
  return isValidSchema(propertyValue, propertySchema);
}
function isValidArraySchema(value, schema) {
  if (schema.type !== "array" || !isObject2(schema.items)) {
    return false;
  }
  if (getArrayValidationFailures(value, schema).length > 0) {
    return false;
  }
  return Array.isArray(value) && isListArraySchema(schema) && // TupleArraySchema not yet supported
  value.map((item) => isValidSchema(item, schema.items)).every((valid) => valid);
}
function isValidOneOfSchema(value, schema) {
  if (!isArray2(schema.oneOf)) {
    return false;
  }
  return schema.oneOf.some((childSchema) => isValidSchema(value, childSchema));
}
function isValidAllOfSchema(value, schema) {
  if (!isArray2(schema.allOf)) {
    return false;
  }
  return schema.allOf.map((childSchema) => isValidSchema(value, childSchema)).every((valid) => valid);
}
function isValidBlobSchema(value, schema) {
  return !getBlobValidationFailures(value, schema).length;
}
function isValidSchema(value, schema) {
  if (schema.oneOf) {
    return isValidOneOfSchema(value, schema);
  }
  if (schema.allOf) {
    return isValidAllOfSchema(value, schema);
  }
  if (schema.const) {
    return isValidConstSchema(value, schema);
  }
  switch (schema.type) {
    case "string":
      return isValidStringSchema(value, schema);
    case "number":
      return isValidNumberSchema(value, schema);
    case "integer":
      return isValidIntegerSchema(value, schema);
    case "boolean":
      return isValidBooleanSchema(value, schema);
    case "array":
      return isValidArraySchema(value, schema);
    case "object":
      return isValidObjectSchema(value, schema);
    case "blob":
      return isValidBlobSchema(value, schema);
    default:
      return false;
  }
}

// src/legacy/common/utils/date-utils.ts
function formatDate2(date) {
  const d = new Date(date);
  const month = String(d.getMonth() + 1);
  const day = String(d.getDate());
  const year = d.getFullYear();
  const formattedMonth = month.length < 2 ? `0${month}` : month;
  const formattedDay = day.length < 2 ? `0${day}` : day;
  return [year, formattedMonth, formattedDay].join("-");
}
var dateStringToDate = (dateString) => {
  if (!dateString) {
    return null;
  }
  const [year, month, date] = dateString.split("-").map((number) => parseInt(number, 10));
  if (!isNumber2(year) || !isNumber2(month) || !isNumber2(date)) {
    return null;
  }
  return new Date(year, month - 1, date);
};
var dateToDateString = (date) => formatDate2(date);

// src/legacy/common/utils/file-utils.ts
function toKilobytes(sizeInBytes) {
  const ONE_KB_IN_BYTES = 1024;
  return Math.floor(sizeInBytes / ONE_KB_IN_BYTES);
}
var toBase642 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.addEventListener("load", () => resolve(reader.result));
  reader.addEventListener("error", (error) => reject(error));
});
function areFilesSame(newFiles, files) {
  const fileIdToExistingFileMap = files.reduce(
    (map, fileObject) => __spreadProps(__spreadValues({}, map), { [fileObject.id]: fileObject }),
    {}
  );
  for (const newFile of newFiles) {
    const existingFileObject = fileIdToExistingFileMap[newFile.id];
    const fileDoesNotExistAlready = !existingFileObject;
    if (fileDoesNotExistAlready) {
      return false;
    }
    if (existingFileObject.status !== newFile.status) {
      return false;
    }
  }
  return true;
}

// src/legacy/common/utils/id-utils.ts
var generateRandomId = (prefix = "") => {
  const prefixString = prefix ? `${prefix}-` : "";
  return `${prefixString}${Math.floor(1e8 * Math.random())}`;
};

// src/legacy/common/utils/is-equal.ts
var isEqual = (a, b) => {
  if (a === b) {
    return true;
  }
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((item, index) => isEqual(item, b[index]));
  }
  if (isNonNullObject(a) && isNonNullObject(b) && isObjectEquals(a, b)) {
    return true;
  }
  return false;
};
var isObjectEquals = (a, b) => {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  return keysA.length === keysB.length && keysA.every((key) => Object.hasOwnProperty.call(b, key) && isEqual(a[key], b[key]));
};
var isNonNullObject = (a) => typeof a === "object" && a !== null;

// src/legacy/common/utils/misc-utils.ts
var isBasicError = (error) => isString2(error) || isNull2(error);

// src/legacy/common/utils/model-utils.ts
var isObjectModel2 = (model) => typeof model === "object" && model !== null && model.constructor === Object;
var isNullableObjectModel = (model) => isNull2(model) || isObjectModel2(model);
var isNullableBasicModel = (model) => isBoolean2(model) || isNumber2(model) || isString2(model) || isNull2(model);
var isNullableStringModel = (model) => isString2(model) || isNull2(model);
var isArrayModel2 = (model) => {
  if (isArray2(model)) {
    if (model.length === 0) {
      return true;
    }
    return model.every(
      (item) => typeof item === "string" || typeof item === "number" || typeof item === "boolean" || typeof item === "object"
    );
  }
  return false;
};
var isNullableArrayModel = (model) => {
  if (isNull2(model)) {
    return true;
  }
  return isArrayModel2(model);
};

// src/legacy/common/utils/schema-utils.ts
function isConstSchema2(schema) {
  return !isUndefined2(schema == null ? void 0 : schema.const);
}
function isNoNConstSchema(schema) {
  return Boolean(schema) && !isConstSchema2(schema);
}
var isReadOnlySchema = (schema) => Boolean(schema.readOnly) && isBasicSchema(schema);
var isPromotedOneOfSchema = (schema) => Boolean(schema.oneOf) && Boolean(schema.promotion);
var basicTypes = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean"]);
function isBasicSchema(schema) {
  return basicTypes.has(schema.type || "") || "const" in schema && schema.const !== void 0 && !isObject2(schema.const);
}
function isObjectSchema2(schema) {
  return schema.type === "object";
}
function isOneOfObjectSchema(schema) {
  return isOneOfSchema2(schema) && schema.oneOf.every((subSchema) => subSchema.type === "object");
}
function isOneOfSchema2(schema) {
  return Boolean(schema.oneOf);
}
function isAllOfSchema2(schema) {
  return Boolean(schema.allOf);
}
function isBlobSchema2(schema) {
  return schema.type === "blob";
}
function isArraySchema2(schema) {
  return schema.type === "array";
}
function isListArraySchema(schema) {
  if (isArraySchema2(schema)) {
    const schemaItems = schema.items;
    return !Array.isArray(schemaItems);
  }
  return false;
}
function isStringSchema2(schema) {
  return schema.type === "string";
}
function isPersistAsyncSchema(schema) {
  return Boolean(schema.persistAsync);
}
function isPersistAsyncFileSchema(schema) {
  return isPersistAsyncSchema(schema) && (isBlobSchema2(schema.persistAsync.schema) || isBase64FileSchema(schema.persistAsync.schema));
}
var isValidationAsyncSchema = (schema) => isBasicSchema(schema) && Boolean(schema.validationAsync);
function isBase64FileSchema(schema) {
  return schema.type === "string" && schema.format === "base64url";
}
function isFileUploadSchema(schema) {
  return schema.type === "string" && schema.format === "base64url";
}
var isMultipleFileUploadSchema = (schema) => isListArraySchema(schema) && isPersistAsyncFileSchema(schema.items);
var isMultiSelectConstSchema = (schema) => {
  var _a;
  if (isListArraySchema(schema)) {
    const { items } = schema;
    if (isOneOfSchema2(items) && ((_a = items.oneOf) == null ? void 0 : _a.every(isConstSchema2))) {
      return true;
    }
  }
  return false;
};
var getSchemaType = (schema) => {
  if (isReadOnlySchema(schema)) {
    return "readOnly";
  }
  if (isPersistAsyncSchema(schema)) {
    return "persistAsync";
  }
  if (isValidationAsyncSchema(schema)) {
    return "validationAsync";
  }
  if (isObjectSchema2(schema)) {
    return "object";
  }
  if (isArraySchema2(schema)) {
    return "array";
  }
  if (isPromotedOneOfSchema(schema)) {
    return "promotedOneOf";
  }
  if (isOneOfSchema2(schema)) {
    return "oneOf";
  }
  if (isAllOfSchema2(schema)) {
    return "allOf";
  }
  if (isBasicSchema(schema)) {
    return "basic";
  }
  return null;
};

// src/legacy/common/utils/step-utils.ts
var isCameraStep = (step) => isFormStep(step) && hasSingleAction(step) && hasSingleFileUploadSchemaWithCameraOnly(step);
var isFormStep = (step) => !step.type || step.type === "form";
var hasSingleAction = (step) => {
  var _a;
  return ((_a = step == null ? void 0 : step.actions) == null ? void 0 : _a.length) === 1;
};
var hasSingleFileUploadSchemaWithCameraOnly = (step) => {
  if (!step.schemas) {
    return false;
  }
  const schemas = filterHiddenSchemas(step.schemas);
  if ((schemas == null ? void 0 : schemas.length) !== 1) {
    return false;
  }
  const firstSchema = schemas[0];
  if (!isObjectSchema2(firstSchema) || Object.values(firstSchema.properties).length !== 1) {
    return false;
  }
  const childSchema = Object.values(firstSchema.properties)[0];
  if (!isFileUploadSchema(childSchema)) {
    return false;
  }
  return childSchema.source === "camera";
};
var filterHiddenSchemas = (schemas) => schemas.filter((schema) => {
  if (isObjectSchema2(schema)) {
    return Object.values((schema == null ? void 0 : schema.properties) || {}).find((schema2) => (schema2 == null ? void 0 : schema2.hidden) !== true);
  }
  return (schema == null ? void 0 : schema.hidden) !== true;
});

// src/common/httpClientContext/HttpClientContext.tsx
import { createContext as createContext4, useContext as useContext4, useMemo as useMemo7 } from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var HttpClientContext = createContext4(void 0);
function HttpClientProvider({ httpClient, children }) {
  return /* @__PURE__ */ jsx11(HttpClientContext.Provider, { value: httpClient, children });
}
function HttpClientProviderFromBaseUrl({ baseUrl, children }) {
  const httpClient = useMemo7(() => makeHttpClient(baseUrl), [baseUrl]);
  return /* @__PURE__ */ jsx11(HttpClientContext.Provider, { value: httpClient, children });
}
var useHttpClient = () => {
  const contextFetch = useContext4(HttpClientContext);
  return contextFetch != null ? contextFetch : fetch;
};
var useHasHttpClientProvider = () => {
  const context = useContext4(HttpClientContext);
  return Boolean(context);
};

// src/legacy/common/hooks/useDebouncedFunction/useDebouncedFunction.tsx
import { useCallback as useCallback4 } from "react";
function useDebouncedFunction(callback, waitMs) {
  return useCallback4(debounce2(callback, waitMs), [callback, waitMs]);
}

// src/legacy/common/hooks/useExternal/useExternal.tsx
import { useEffect as useEffect3, useState as useState3 } from "react";
function useExternal(url) {
  const [externalWindow, setExternalWindow] = useState3(null);
  const [hasManuallyTriggered, setHasManuallyTriggered] = useState3(false);
  const dismissConfirmation = () => setHasManuallyTriggered(true);
  useEffect3(() => {
    if (url) {
      setHasManuallyTriggered(false);
      setExternalWindow(window.open(url, "_blank"));
    }
  }, [url]);
  const requiresManualTrigger = Boolean(url && !externalWindow && !hasManuallyTriggered);
  return { requiresManualTrigger, dismissConfirmation };
}

// src/legacy/common/hooks/useExternalStepPolling/useExternalStepPolling.tsx
import { useCallback as useCallback5, useMemo as useMemo8 } from "react";
function useExternalStepPolling(polling, onAction) {
  var _a, _b;
  const httpClient = useHttpClient();
  const asyncFn = useMemo8(() => {
    if (polling) {
      return () => httpClient(polling.url).then((response) => {
        if (response.ok) {
          try {
            return response.json();
          } catch (e) {
            throw new Error("failed");
          }
        } else {
          throw new Error("failed");
        }
      }).catch((error) => {
        throw new Error(error.message === "failed" ? "failed" : "network failed");
      });
    }
    return void 0;
  }, [polling, httpClient]);
  const onPollingResponse = useCallback5(
    (pollingResponse) => {
      const responseHandlers = (polling == null ? void 0 : polling.responseHandlers) || [];
      const responseHandler = responseHandlers.find(
        (handler) => handler.result === pollingResponse.result
      );
      if (responseHandler == null ? void 0 : responseHandler.action) {
        const { action } = responseHandler;
        if (action.exit) {
          const mergedResult = __spreadValues(__spreadValues({}, action.result || {}), pollingResponse.data || {});
          onAction(__spreadProps(__spreadValues({}, action), { result: mergedResult }));
        } else {
          const mergedData = __spreadValues(__spreadValues({}, action.data || {}), pollingResponse.data || {});
          onAction(__spreadProps(__spreadValues({}, action), { data: mergedData }));
        }
        return false;
      }
      return true;
    },
    [polling == null ? void 0 : polling.responseHandlers, onAction]
  );
  usePolling({
    asyncFn,
    delay: (_b = (_a = polling == null ? void 0 : polling.delay) != null ? _a : polling == null ? void 0 : polling.interval) != null ? _b : 0,
    maxAttempts: (polling == null ? void 0 : polling.maxAttempts) || 0,
    maxConsecutiveFails: (polling == null ? void 0 : polling.maxConsecutiveFails) || 0,
    onPollingResponse,
    onFailure: useCallback5(() => {
      if (polling) {
        onAction(polling.onError.action);
      }
    }, [onAction, polling])
  });
}

// src/legacy/common/hooks/usePersistAsync/usePersistAsync.ts
import { useState as useState20 } from "react";
import { useIntl as useIntl17 } from "react-intl";

// src/legacy/jsonSchemaForm/persistAsyncSchema/persistAsyncBasicSchema/PersistAsyncBasicSchema.tsx
import { useEffect as useEffect14, useState as useState19 } from "react";
import { useIntl as useIntl16 } from "react-intl";

// src/legacy/common/constants/DateMode.ts
var DateMode = {
  DAY_MONTH_YEAR: "day-month-year",
  MONTH_YEAR: "month-year"
};

// src/legacy/common/constants/FormControlType.ts
var FormControlType = {
  RADIO: "radio",
  CHECKBOX: "checkbox",
  SELECT: "select",
  EMAIL: "email",
  FILE: "file",
  DATE: "date",
  DATETIME: "date-time",
  DATELOOKUP: "date-lookup",
  TEL: "tel",
  // For string schemas with number format
  NUMERIC: "numeric",
  // For number schemas
  NUMBER: "number",
  HIDDEN: "hidden",
  PASSWORD: "password",
  TEXT: "text",
  TEXTAREA: "textarea",
  UPLOAD: "upload",
  TAB: "tab"
};

// src/legacy/common/constants/MonthFormat.ts
var MonthFormat = {
  SHORT: "short",
  LONG: "long"
};

// src/legacy/common/constants/Size.ts
var Size = {
  EXTRA_SMALL: "xs",
  SMALL: "sm",
  MEDIUM: "md",
  LARGE: "lg",
  EXTRA_LARGE: "xl"
};

// src/legacy/jsonSchemaForm/basicTypeSchema/BasicTypeSchema.tsx
import classNames10 from "classnames";
import { useEffect as useEffect13, useMemo as useMemo16, useState as useState18 } from "react";

// src/legacy/layout/alert/DynamicAlert.tsx
import { Alert as Alert2 } from "@transferwise/components";

// src/legacy/layout/utils/getNavigationOptionMedia.tsx
import { Avatar, AvatarType } from "@transferwise/components";

// src/legacy/layout/icon/FlagIcon.tsx
import { Flag } from "@wise/art";
import { jsx as jsx12 } from "react/jsx-runtime";
var isFlagIcon = (name) => name.startsWith("flag-");
function FlagIcon({ name }) {
  if (!isFlagIcon(name)) {
    return null;
  }
  const code = name.substring(5);
  return /* @__PURE__ */ jsx12(Flag, { intrinsicSize: 24, code });
}

// src/legacy/layout/icon/NamedIcon.tsx
import * as icons from "@transferwise/icons";
import { jsx as jsx13 } from "react/jsx-runtime";
var isNamedIcon = (name) => {
  const iconName = toCapitalisedCamelCase(name);
  return Object.keys(icons).includes(iconName);
};
function NamedIcon({ name }) {
  if (!isNamedIcon(name)) {
    return null;
  }
  const iconName = toCapitalisedCamelCase(name);
  const Icon = icons[iconName];
  return /* @__PURE__ */ jsx13(Icon, { size: 24 });
}
var toCapitalisedCamelCase = (value) => value.split("-").map(capitaliseFirstChar).join("");
var capitaliseFirstChar = (value) => `${value[0].toUpperCase()}${value.slice(1)}`;

// src/legacy/layout/icon/DynamicIcon.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
function DynamicIcon({ type }) {
  if (isFlagIcon(type)) {
    return /* @__PURE__ */ jsx14(FlagIcon, { name: type });
  }
  if (isNamedIcon(type)) {
    return /* @__PURE__ */ jsx14(NamedIcon, { name: type });
  }
  return null;
}
function isValidIconName(name) {
  return isNamedIcon(name) || isFlagIcon(name);
}
var DynamicIcon_default = DynamicIcon;

// src/legacy/layout/utils/getNavigationOptionMedia.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var getNavigationOptionMedia = ({ icon, image }) => {
  if (icon == null ? void 0 : icon.name) {
    return /* @__PURE__ */ jsx15(Avatar, { type: AvatarType.ICON, children: /* @__PURE__ */ jsx15(DynamicIcon_default, { type: icon.name }) });
  }
  if (icon == null ? void 0 : icon.text) {
    return /* @__PURE__ */ jsx15(Avatar, { type: AvatarType.INITIALS, children: icon.text });
  }
  if (image == null ? void 0 : image.url) {
    const { url, text } = image;
    return /* @__PURE__ */ jsx15("img", { src: url, alt: text });
  }
  return null;
};

// src/legacy/layout/utils/index.ts
var getMargin = (size) => {
  switch (size) {
    case "xs":
      return "m-b-0";
    case "sm":
      return "m-b-1";
    case "md":
      return "m-b-2";
    case "lg":
      return "m-b-3";
    case "xl":
      return "m-b-5";
    default:
      return "";
  }
};
var getTextAlignment = (align) => {
  switch (align) {
    case "right":
      return "text-xs-right";
    case "center":
      return "text-xs-center";
    case "left":
    default:
      return "";
  }
};
var getTextAlignmentAndMargin = (component) => `${getTextAlignment(component.align)} ${getMargin(component.margin)}`;

// src/legacy/layout/alert/DynamicAlert.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var DynamicAlert = ({ component: alert, onAction }) => {
  const { context, markdown, margin } = alert;
  return /* @__PURE__ */ jsx16(
    Alert2,
    {
      type: mapContextToAlertType(legacy_mapContext(context)),
      className: getMargin(margin),
      message: markdown,
      action: getAlertAction(alert, onAction)
    }
  );
};
var isAlertLayout = (layout) => {
  return Object.hasOwnProperty.call(layout, "type") && layout.type === "alert";
};
var getAlertAction = (component, onAction) => {
  if (!isAlertLayout(component) || !component.callToAction) {
    return void 0;
  }
  const { title, accessibilityDescription, behavior } = component.callToAction;
  if ("type" in behavior) {
    switch (behavior.type) {
      case "action": {
        const { action: action2 } = behavior;
        return {
          text: title,
          "aria-label": accessibilityDescription,
          onClick: onAction && action2 ? () => {
            onAction(action2);
          } : () => {
          }
        };
      }
      case "link": {
        return {
          text: title,
          "aria-label": accessibilityDescription,
          href: behavior.url,
          target: "_blank"
        };
      }
    }
  }
  const { action, link } = behavior;
  if (link) {
    return {
      text: title,
      "aria-label": accessibilityDescription,
      href: link.url,
      target: "_blank"
    };
  }
  if (action && onAction) {
    return {
      text: title,
      "aria-label": accessibilityDescription,
      onClick: () => {
        onAction(action);
      }
    };
  }
};
var legacy_mapContext = (context) => {
  switch (context) {
    case "success":
      return "positive";
    case "failure":
      return "negative";
    case "warning":
      return "warning";
    case "info":
    case "primary":
      return "neutral";
    default:
      return context;
  }
};
var mapContextToAlertType = (context) => {
  if (!context || !["neutral", "warning", "negative", "positive"].includes(context)) {
    return "neutral";
  }
  return context;
};
var DynamicAlert_default = DynamicAlert;

// src/legacy/layout/box/DynamicBox.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var DynamicBox = (props) => {
  const box = props.component;
  const margin = getMargin(box.margin || box.border ? "lg" : "xs");
  if (!box.width || box.width === "xl") {
    return /* @__PURE__ */ jsx17("div", { className: margin + getBorderClass(box.border), children: /* @__PURE__ */ jsx17(
      DynamicLayout_default,
      {
        components: box.components,
        model: props.model,
        submitted: props.submitted,
        errors: props.errors,
        onModelChange: props.onModelChange,
        onAction: props.onAction,
        onPersistAsync: props.onPersistAsync
      }
    ) });
  }
  return /* @__PURE__ */ jsx17("div", { className: "row", children: /* @__PURE__ */ jsx17("div", { className: margin + getBoxWidthClasses(box), children: /* @__PURE__ */ jsx17("div", { className: getBorderClass(box.border), children: /* @__PURE__ */ jsx17(
    DynamicLayout_default,
    {
      components: box.components,
      model: props.model,
      submitted: props.submitted,
      errors: props.errors,
      onModelChange: props.onModelChange,
      onAction: props.onAction,
      onPersistAsync: props.onPersistAsync
    }
  ) }) }) });
};
var getBorderClass = (border) => {
  return border ? " well p-b-0" : "";
};
var getBoxWidthClasses = (component) => {
  switch (component.width) {
    case "xs":
      return " col-md-4 col-md-offset-4";
    case "sm":
      return " col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4";
    case "md":
      return " col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3";
    case "lg":
      return " col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2";
    case "xl":
    default:
      return " col-xs-12";
  }
};
var DynamicBox_default = DynamicBox;

// src/legacy/layout/button/DynamicButton.tsx
import { Button } from "@transferwise/components";

// src/legacy/layout/button/utils.ts
var priorities = {
  primary: "primary",
  secondary: "secondary",
  link: "tertiary",
  positive: "primary",
  negative: "primary"
};
var getButtonPriority = (control, action) => {
  const actionType = action ? action.type : void 0;
  return control != null ? control : actionType ? priorities[actionType] : "secondary";
};
var contextToType = {
  positive: "positive",
  negative: "negative",
  neutral: "accent",
  warning: "accent"
};
var actionTypeToType = {
  primary: "accent",
  secondary: "accent",
  link: "accent",
  positive: "positive",
  negative: "negative"
};
var getButtonType = (context, action) => {
  if (context) {
    return contextToType[context];
  }
  const actionType = action ? action.type : void 0;
  return actionType ? actionTypeToType[actionType] : "accent";
};
var getButtonTypeFromContext = (context) => {
  return context ? contextToType[context] : "accent";
};
var getButtonSize = (size) => {
  switch (size) {
    case "xs":
    case "sm":
      return "sm";
    case "lg":
    case "xl":
      return "lg";
    case "md":
    default:
      return "md";
  }
};

// src/legacy/layout/button/DynamicButton.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
function DynamicButton(props) {
  return props.component.behavior ? /* @__PURE__ */ jsx18(DynamicButtonWithBehavior, __spreadValues({}, props)) : /* @__PURE__ */ jsx18(DynamicButtonWithoutBehavior, __spreadValues({}, props));
}
function DynamicButtonWithoutBehavior(props) {
  var _a, _b;
  const { component, onAction } = props;
  const componentAction = component.action;
  const type = getButtonType(component.context, componentAction);
  const priority = getButtonPriority(component.control, componentAction);
  const { loading } = useDynamicFlow();
  const className = getMargin(component.margin || "md");
  const disabled = loading || component.disabled || (componentAction == null ? void 0 : componentAction.disabled);
  const title = (_b = (_a = component.title) != null ? _a : componentAction == null ? void 0 : componentAction.title) != null ? _b : "";
  const onClick = () => {
    if (componentAction) {
      onAction(componentAction);
    }
  };
  return /* @__PURE__ */ jsx18(
    Button,
    {
      size: getButtonSize(component.size),
      type: priority === "tertiary" ? void 0 : type,
      priority,
      block: true,
      className,
      disabled,
      onClick,
      children: title
    }
  );
}
function DynamicButtonWithBehavior(props) {
  var _a, _b;
  const { component, onAction } = props;
  const type = getButtonTypeFromContext(component.context);
  const priority = (_a = component.control) != null ? _a : "secondary";
  const { loading } = useDynamicFlow();
  const className = getMargin(component.margin || "md");
  const disabled = loading || component.disabled;
  const title = (_b = component.title) != null ? _b : "";
  const onClick = () => {
    const { behavior } = component;
    if (!behavior) {
      return;
    }
    if ("type" in behavior) {
      switch (behavior.type) {
        case "action": {
          if (behavior.action) {
            onAction(behavior.action);
          }
          break;
        }
        case "link": {
          if (behavior.url) {
            window.open(behavior.url, "_blank");
          }
          break;
        }
      }
    } else {
      if (behavior == null ? void 0 : behavior.action) {
        onAction(behavior.action);
      }
      if (behavior == null ? void 0 : behavior.link) {
        window.open(behavior.link.url, "_blank");
      }
    }
  };
  return /* @__PURE__ */ jsx18(
    Button,
    {
      size: getButtonSize(component.size),
      type: priority === "tertiary" ? void 0 : type,
      priority,
      block: true,
      className,
      disabled,
      onClick,
      children: title
    }
  );
}
var DynamicButton_default = DynamicButton;

// src/legacy/layout/columns/DynamicColumns.tsx
import { jsx as jsx19, jsxs as jsxs2 } from "react/jsx-runtime";
var DynamicColumns = (props) => {
  const columns = props.component;
  const { leftWidth, rightWidth } = getWidth(columns.bias);
  return /* @__PURE__ */ jsxs2("div", { className: `${getMargin(columns.margin || "xs")} row`, children: [
    /* @__PURE__ */ jsx19("div", { className: `${leftWidth} m-b-0`, children: /* @__PURE__ */ jsx19(
      DynamicLayout_default,
      {
        components: columns.left,
        model: props.model,
        submitted: props.submitted,
        errors: props.errors,
        onModelChange: props.onModelChange,
        onAction: props.onAction,
        onPersistAsync: props.onPersistAsync
      }
    ) }),
    /* @__PURE__ */ jsx19("div", { className: `${rightWidth} m-b-0`, children: /* @__PURE__ */ jsx19(
      DynamicLayout_default,
      {
        components: columns.right,
        model: props.model,
        submitted: props.submitted,
        errors: props.errors,
        onModelChange: props.onModelChange,
        onAction: props.onAction,
        onPersistAsync: props.onPersistAsync
      }
    ) })
  ] });
};
var getWidth = (bias) => {
  if (bias === "left") {
    return {
      leftWidth: "col-md-8",
      rightWidth: "col-md-4"
    };
  }
  if (bias === "right") {
    return {
      leftWidth: "col-md-4",
      rightWidth: "col-md-8"
    };
  }
  return {
    leftWidth: "col-md-6",
    rightWidth: "col-md-6"
  };
};
var DynamicColumns_default = DynamicColumns;

// src/legacy/layout/decision/DynamicDecision.tsx
import { Header, NavigationOption, NavigationOptionsList } from "@transferwise/components";
import { jsx as jsx20, jsxs as jsxs3 } from "react/jsx-runtime";
function DynamicDecision({ component, onAction }) {
  const { loading } = useDynamicFlow();
  const { margin, options, title } = component;
  return /* @__PURE__ */ jsxs3("div", { className: getMargin(margin), children: [
    title && /* @__PURE__ */ jsx20(Header, { as: "h2", title }),
    /* @__PURE__ */ jsx20(NavigationOptionsList, { children: options.map((option) => /* @__PURE__ */ jsx20(
      NavigationOption,
      {
        title: option.title,
        content: option.description,
        disabled: loading || option.disabled,
        media: getNavigationOptionMedia(option),
        showMediaCircle: false,
        showMediaAtAllSizes: true,
        onClick: () => onAction(option.action)
      },
      JSON.stringify(option)
    )) })
  ] });
}
var DynamicDecision_default = DynamicDecision;

// src/legacy/layout/divider/DynamicDivider.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var DynamicDivider = ({ component }) => {
  const margin = getMargin(component.margin);
  const className = `m-t-0 ${margin}`;
  return /* @__PURE__ */ jsx21("hr", { className });
};
var DynamicDivider_default = DynamicDivider;

// src/legacy/layout/external/DynamicExternal.tsx
import { Button as Button2, Loader, Size as Size2 } from "@transferwise/components";
import { useCallback as useCallback6, useEffect as useEffect4, useMemo as useMemo9 } from "react";
import { useIntl as useIntl3 } from "react-intl";

// src/legacy/layout/external/DynamicExternal.messages.ts
import { defineMessages as defineMessages6 } from "react-intl";
var DynamicExternal_messages_default = defineMessages6({
  retryTitle: {
    id: "dynamicFlows.DynamicExternal.retryTitle",
    defaultMessage: "Reopen window",
    description: ""
  }
});

// src/legacy/layout/external/DynamicExternal.tsx
import { Fragment as Fragment4, jsx as jsx22, jsxs as jsxs4 } from "react/jsx-runtime";
var DynamicExternal = ({ component, onAction }) => {
  const { requestUrl, responseHandlers, polling, retryTitle } = component;
  const intl = useIntl3();
  const openExternalUrl = useCallback6(
    () => window.open(requestUrl, "df-external-window"),
    [requestUrl]
  );
  useEffect4(() => {
    openExternalUrl();
  }, [openExternalUrl]);
  const pollingConfiguration = useMemo9(() => {
    return polling && responseHandlers ? __spreadProps(__spreadValues({}, polling), {
      responseHandlers
    }) : void 0;
  }, [polling, responseHandlers]);
  useExternalStepPolling(pollingConfiguration, onAction);
  return /* @__PURE__ */ jsxs4(Fragment4, { children: [
    /* @__PURE__ */ jsx22(Loader, { size: Size2.LARGE, classNames: { "tw-loader": "tw-loader m-x-auto" } }),
    /* @__PURE__ */ jsx22("br", {}),
    /* @__PURE__ */ jsx22(Button2, { priority: "tertiary", block: true, onClick: openExternalUrl, children: retryTitle || intl.formatMessage(DynamicExternal_messages_default.retryTitle) })
  ] });
};
var DynamicExternal_default = DynamicExternal;

// src/legacy/jsonSchemaForm/genericSchema/GenericSchema.tsx
import { useEffect as useEffect11 } from "react";

// src/legacy/jsonSchemaForm/allOfSchema/AllOfSchema.tsx
import { Header as Header2 } from "@transferwise/components";
import classNames from "classnames";
import { useState as useState4 } from "react";
import { Fragment as Fragment5, jsx as jsx23, jsxs as jsxs5 } from "react/jsx-runtime";
var splitModel = (model, schemas) => schemas.map((schema) => getValidObjectModelParts(model, schema) || {});
var combineModels = (models) => models.reduce((current, combined) => __spreadValues(__spreadValues({}, combined), current), {});
var getSchemaColumnClasses = (width) => ({
  "col-xs-12": true,
  "col-sm-6": width === "md",
  "col-sm-4": width === "sm"
});
function AllOfSchema(props) {
  const { disabled = false, hideTitle = false } = props;
  const onChangeModelIndex = (index, onChangeProps) => {
    const modelSchema = props.schema.allOf[index];
    models[index] = getValidObjectModelParts(onChangeProps.model, modelSchema) || {};
    setModels(models);
    props.onChange(__spreadProps(__spreadValues({}, onChangeProps), { model: combineModels(models) }));
  };
  const [models, setModels] = useState4(splitModel(props.model, props.schema.allOf));
  return /* @__PURE__ */ jsxs5(Fragment5, { children: [
    props.schema.title && !hideTitle && /* @__PURE__ */ jsx23(Header2, { title: props.schema.title }),
    props.schema.description && /* @__PURE__ */ jsx23("p", { children: props.schema.description }),
    /* @__PURE__ */ jsx23("div", { className: "row", children: props.schema.allOf.map((schema, index) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ jsx23("div", { className: classNames(getSchemaColumnClasses(schema.width)), children: /* @__PURE__ */ jsx23(
        GenericSchema_default,
        {
          schema,
          model: models[index],
          errors: props.errors,
          submitted: props.submitted,
          disabled,
          onChange: (onChangeProps) => onChangeModelIndex(index, __spreadProps(__spreadValues({}, onChangeProps), {
            // We can safely assume that the model here is going to be of the same type as the model prop
            model: onChangeProps.model
          })),
          onPersistAsync: props.onPersistAsync
        }
      ) }, index)
    )) })
  ] });
}
var AllOfSchema_default = AllOfSchema;

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/multipleFileUploadSchema/MultipleFileUploadSchema.tsx
import {
  Status,
  UploadInput
} from "@transferwise/components";
import classNames2 from "classnames";
import { useMemo as useMemo10, useState as useState5 } from "react";

// src/legacy/jsonSchemaForm/controlFeedback/ControlFeedback.tsx
import { InlineAlert } from "@transferwise/components";
import { formatDate as formatDate3 } from "@transferwise/formatting";
import { useIntl as useIntl4 } from "react-intl";
import { jsx as jsx24, jsxs as jsxs6 } from "react/jsx-runtime";
function ControlFeedback(props) {
  const { errors = "", validations = [], validationMessages = {} } = props;
  const defaultValidationMessages = useDefaultValidationMessages(props.schema);
  const mergedValidationMessages = __spreadValues(__spreadValues(__spreadValues({}, defaultValidationMessages), validationMessages), props.schema.validationMessages);
  const isErrorVisible = (props.submitted || !props.changed) && Boolean(errors);
  const isValidationVisible = !isErrorVisible && (props.submitted || props.changed && props.blurred) && Boolean(validations == null ? void 0 : validations.length);
  const isDescriptionVisible = props.schema.type !== "boolean" && props.schema.description && !isErrorVisible && !isValidationVisible;
  const hasInfoMessage = Boolean(props.infoMessage);
  return /* @__PURE__ */ jsxs6("div", { id: props.id, children: [
    isErrorVisible ? /* @__PURE__ */ jsx24(InlineAlert, { type: "error", children: errors }) : null,
    isValidationVisible ? /* @__PURE__ */ jsx24(InlineAlert, { type: "error", children: validations.map((validation) => /* @__PURE__ */ jsx24("div", { children: mergedValidationMessages[validation] }, validation)) }) : null,
    (isDescriptionVisible || hasInfoMessage) && /* @__PURE__ */ jsxs6(InlineAlert, { type: "info", children: [
      isDescriptionVisible && /* @__PURE__ */ jsx24("div", { children: props.schema.description }),
      hasInfoMessage && /* @__PURE__ */ jsx24("div", { children: props.infoMessage })
    ] })
  ] });
}
function useDefaultValidationMessages(schema) {
  const { formatMessage, locale } = useIntl4();
  const formattedMessages = {
    type: formatMessage(validation_messages_default.type),
    minimum: formatMessage(validation_messages_default.minimum, {
      minimum: schema.minimum
    }),
    maximum: formatMessage(validation_messages_default.maximum, {
      maximum: schema.maximum
    }),
    minLength: formatMessage(validation_messages_default.minLength, {
      minLength: schema.minLength
    }),
    maxLength: formatMessage(validation_messages_default.maxLength, {
      maxLength: schema.maxLength
    }),
    minItems: formatMessage(validation_array_messages_default.minItemsError, {
      minItems: schema.minItems
    }),
    maxItems: formatMessage(validation_array_messages_default.maxItemsError, {
      maxItems: schema.maxItems
    }),
    pattern: formatMessage(validation_messages_default.pattern),
    required: formatMessage(validation_messages_default.required)
  };
  if (schema.format === "date") {
    const dateOverrides = {
      pattern: formatMessage(validation_messages_default.patternDate),
      minimum: schema.minimum ? formatMessage(validation_messages_default.minimumDate, {
        minimum: formatDate3(
          new Date(schema.minimum),
          locale,
          {
            timeZone: "UTC",
            dateStyle: "long"
          }
        )
      }) : void 0,
      maximum: schema.maximum ? formatMessage(validation_messages_default.maximumDate, {
        maximum: formatDate3(
          new Date(schema.maximum),
          locale,
          {
            timeZone: "UTC",
            dateStyle: "long"
          }
        )
      }) : void 0
    };
    return __spreadValues(__spreadValues({}, formattedMessages), dateOverrides);
  }
  return formattedMessages;
}
var ControlFeedback_default = ControlFeedback;

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/multipleFileUploadSchema/utils/upload-utils.ts
async function createPayload(userUploadedFile, isBlobSchema3) {
  if (isBlobSchema3) {
    return userUploadedFile;
  }
  if (userUploadedFile instanceof Blob) {
    return toBase642(userUploadedFile);
  }
  throw new Error(
    "Error creating payload for MultipleFileUploadSchema. Uploaded file is not an instance of Blob."
  );
}
function constructUploadResponse(response) {
  const id = response.data;
  return __spreadValues({ id }, response);
}
function constructUploadError(response) {
  const isError = response instanceof Error;
  const hasValidData = isObject2(response) && "data" in response;
  const isInvalidResponseData = !hasValidData && !isError;
  if (isInvalidResponseData) {
    return isString2(response) ? response : void 0;
  }
  if (isError) {
    const error = response;
    return { id: generateRandomId(), message: error.message };
  }
  return __spreadValues({
    message: isString2(response.message) ? response.message : ""
  }, response);
}

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/multipleFileUploadSchema/utils/useFormattedDefaultErrorMessages.tsx
import { useIntl as useIntl5 } from "react-intl";

// src/legacy/common/messages.ts
import { defineMessages as defineMessages7 } from "react-intl";
var messages_default = defineMessages7({
  required: {
    id: "dynamicFlows.DefaultErrorMessages.required",
    defaultMessage: "Please fill out this field.",
    description: "Customer has left the required field empty"
  }
});

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/multipleFileUploadSchema/utils/useFormattedDefaultErrorMessages.tsx
function useFormattedDefaultErrorMessages({
  maxItems,
  minItems
}) {
  const { formatMessage } = useIntl5();
  const { maxFileSizeError, maxItemsError, minItemsError } = multi_file_upload_messages_default;
  return {
    maxFileSizeErrorMessage: formatMessage(maxFileSizeError),
    maxItemsErrorMessage: formatMessage(maxItemsError, { maxItems }),
    minItemsErrorMessage: formatMessage(minItemsError, { minItems }),
    requiredMessage: formatMessage(messages_default.required)
  };
}

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/multipleFileUploadSchema/MultipleFileUploadSchema.tsx
import { jsx as jsx25, jsxs as jsxs7 } from "react/jsx-runtime";
function MultipleFileUploadSchema(props) {
  var _a, _b;
  const { onChange, errors = null, schema, required = false } = props;
  const onEvent = useEventDispatcher();
  const defaultErrorMessages = useFormattedDefaultErrorMessages(schema);
  const uid = useMemo10(() => schema.$id || generateRandomId(), [schema.$id]);
  const [inputChanged, setInputChanged] = useState5(false);
  const [files, setFiles] = useState5(() => convertFileIdsToComponentFileObjects(props.model || []));
  const performPersistAsync = usePersistAsync(schema.items.persistAsync);
  const fileSchemaDescriptor = schema.items.persistAsync.schema;
  const isBlob = isBlobSchema2(fileSchemaDescriptor);
  const uploadFile = async (userUploadedFile) => {
    setInputChanged(true);
    try {
      const payload = await createPayload(userUploadedFile, isBlob);
      onEvent("Dynamic Flow - PersistAsync", { status: "pending", schemaId: schema.$id });
      const response = await performPersistAsync(payload);
      onEvent("Dynamic Flow - PersistAsync", { status: "success", schemaId: schema.$id });
      return constructUploadResponse(response);
    } catch (error) {
      onEvent("Dynamic Flow - PersistAsync", { status: "failure", schemaId: schema.$id });
      return Promise.reject(constructUploadError(error));
    }
  };
  function onFilesChange(newFiles) {
    if (areFilesSame(newFiles, files)) {
      return;
    }
    setFiles(newFiles);
    const validFiles2 = getSuccessfullyProcessedFiles(newFiles);
    const data = validFiles2.map((file) => file.id);
    onChange({
      model: data,
      triggerSchema: schema,
      triggerModel: data
    });
  }
  const validFiles = getSuccessfullyProcessedFiles(files);
  const fileIds = validFiles.map((file) => file.id);
  const fileListValidationFailures = getArrayValidationFailures(fileIds, schema, required);
  const showError = Boolean(errors) || (inputChanged || props.submitted) && Boolean(fileListValidationFailures.length);
  const accepts = "accepts" in fileSchemaDescriptor && fileSchemaDescriptor.accepts;
  const maxSize = "maxSize" in fileSchemaDescriptor && fileSchemaDescriptor.maxSize;
  const uploadInputProps = __spreadProps(__spreadValues(__spreadValues({
    multiple: true,
    files,
    fileInputName: uid,
    id: uid
  }, accepts ? { fileTypes: accepts } : void 0), maxSize ? { sizeLimit: toKilobytes(maxSize) } : void 0), {
    sizeLimitErrorMessage: ((_a = fileSchemaDescriptor.validationMessages) == null ? void 0 : _a.maxSize) || defaultErrorMessages.maxFileSizeErrorMessage,
    maxFiles: props.schema.maxItems,
    maxFilesErrorMessage: ((_b = props.schema.validationMessages) == null ? void 0 : _b.maxItems) || defaultErrorMessages.maxItemsErrorMessage,
    uploadButtonTitle: fileSchemaDescriptor.title,
    description: fileSchemaDescriptor.description,
    disabled: props.disabled,
    onUploadFile: (formData) => uploadFile(formData.get(uid)),
    onFilesChange,
    onDeleteFile: () => Promise.resolve()
  });
  const feedbackId = `${uid}-feedback`;
  return /* @__PURE__ */ jsxs7("div", { className: classNames2("form-group", { "has-error": showError }), children: [
    /* @__PURE__ */ jsx25("label", { className: "d-block control-label", htmlFor: uid, children: props.schema.title }),
    /* @__PURE__ */ jsx25("div", { "aria-describedby": feedbackId, children: /* @__PURE__ */ jsx25(UploadInput, __spreadValues({}, uploadInputProps)) }),
    /* @__PURE__ */ jsx25(
      ControlFeedback_default,
      {
        id: feedbackId,
        changed: inputChanged,
        submitted: props.submitted,
        errors,
        schema: props.schema,
        validations: fileListValidationFailures,
        validationMessages: getValidationMessages(schema, Boolean(required), defaultErrorMessages),
        infoMessage: null,
        focused: false,
        blurred: true
      }
    )
  ] });
}
var MultipleFileUploadSchema_default = MultipleFileUploadSchema;
function getSuccessfullyProcessedFiles(allFiles) {
  return allFiles.filter((file) => !file.error && file.status === "succeeded");
}
function convertFileIdsToComponentFileObjects(fileIds) {
  return fileIds.map((id) => isValidId(id) ? { id, status: Status.SUCCEEDED } : null).filter((item) => item !== null);
}
function isValidId(id) {
  return isNumber2(id) || isString2(id);
}
function getValidationMessages(schema, required, defaultErrorMessages) {
  const { minItems, maxItems } = schema;
  return __spreadValues(__spreadValues(__spreadValues({}, required && { required: defaultErrorMessages.requiredMessage }), minItems && { minItems: defaultErrorMessages.minItemsErrorMessage }), maxItems && { maxItems: defaultErrorMessages.maxItemsErrorMessage });
}

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/multiSelectSchema/MultiSelectSchema.tsx
import { SelectInput, SelectInputOptionContent } from "@transferwise/components";
import classNames3 from "classnames";
import { useEffect as useEffect5, useMemo as useMemo11, useState as useState6 } from "react";
import { useIntl as useIntl6 } from "react-intl";

// src/legacy/jsonSchemaForm/schemaFormControl/utils/mapping-utils.tsx
import { Avatar as Avatar2, AvatarType as AvatarType2 } from "@transferwise/components";
import { Flag as Flag2 } from "@wise/art";
import { jsx as jsx26 } from "react/jsx-runtime";
var mapConstSchemaToOption = (schema, controlType) => {
  switch (controlType) {
    case "select":
      return mapConstSchemaToSelectOption(schema);
    case "radio":
    default:
      return mapConstSchemaToRadioOption(schema);
  }
};
var mapConstSchemaToRadioOption = (schema) => __spreadValues(__spreadValues(__spreadValues({
  // TODO: LOW avoid type assertion -- using || '' would fail some tests
  label: schema.title,
  value: schema.const
}, getRadioOptionDescription(schema.title, schema.description)), getAvatarPropertyForRadioOption(schema)), getDisabled(schema.disabled));
var mapConstSchemaToSelectOption = (schema) => __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
  // TODO: LOW avoid type assertion -- using || '' would fail some tests
  label: schema.title,
  value: schema.const
}, getOptionDescription(schema.title, schema.description)), getIconPropertyForSelectOption(schema.icon)), mapImage(schema.image)), getDisabled(schema.disabled)), mapKeywordsToSearchStrings(schema.keywords));
var mapKeywordsToSearchStrings = (searchStrings) => isArray2(searchStrings) ? { searchStrings } : {};
var mapImage = (image) => {
  if (image == null ? void 0 : image.url) {
    return {
      icon: /* @__PURE__ */ jsx26("div", { className: "media", children: /* @__PURE__ */ jsx26("div", { className: "np-option__no-media-circle", children: /* @__PURE__ */ jsx26("img", { src: image.url, alt: image.name || "" }) }) }),
      hideIconInTrigger: true
    };
  }
  return null;
};
var getIconPropertyForSelectOption = (icon) => {
  if ((icon == null ? void 0 : icon.name) && isFlagIcon(icon.name)) {
    return {
      icon: /* @__PURE__ */ jsx26(Flag2, { code: icon.name.substring(5), intrinsicSize: 24 })
    };
  }
  if ((icon == null ? void 0 : icon.name) && isValidIconName(icon.name)) {
    return {
      icon: /* @__PURE__ */ jsx26(DynamicIcon_default, { type: icon.name })
    };
  }
  if (icon == null ? void 0 : icon.text) {
    return {
      icon: /* @__PURE__ */ jsx26("span", { children: icon.text })
    };
  }
  return null;
};
var getAvatarPropertyForRadioOption = ({ image, icon }) => {
  if (image == null ? void 0 : image.url) {
    return {
      avatar: /* @__PURE__ */ jsx26(Avatar2, { type: AvatarType2.THUMBNAIL, children: /* @__PURE__ */ jsx26("img", { src: image.url, alt: "" }) })
    };
  }
  if ((icon == null ? void 0 : icon.name) && isValidIconName(icon.name)) {
    return {
      avatar: /* @__PURE__ */ jsx26(Avatar2, { type: AvatarType2.ICON, children: /* @__PURE__ */ jsx26(DynamicIcon_default, { type: icon.name }) })
    };
  }
  if (icon == null ? void 0 : icon.text) {
    return {
      avatar: /* @__PURE__ */ jsx26(Avatar2, { type: AvatarType2.INITIALS, children: icon.text })
    };
  }
  return null;
};
var mapSchemaToUploadOptions = ({ accepts }) => __spreadValues({}, isArray2(accepts) && { usAccept: accepts.join(",") });
var getOptionDescription = (title, description) => {
  if (title && description) {
    if ((title + description).length > 50) {
      return { secondary: description };
    }
    return { note: description };
  }
  return void 0;
};
var getRadioOptionDescription = (title, description) => {
  if (title && description) {
    return { note: description };
  }
  return void 0;
};
var getDisabled = (disabled) => {
  if (!isUndefined2(disabled) && !isNull2(disabled)) {
    return { disabled };
  }
  return void 0;
};

// src/common/messages/multi-select.messages.ts
import { defineMessages as defineMessages8 } from "react-intl";
var multi_select_messages_default = defineMessages8({
  summary: {
    id: "dynamicFlows.MultiSelect.summary",
    defaultMessage: "{first} and {count} more",
    description: "A summary of the multiple items selected. Showing the title of the first selected item, and the number of other items that have been selected."
  }
});

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/multiSelectSchema/MultiSelectSchema.tsx
import { jsx as jsx27, jsxs as jsxs8 } from "react/jsx-runtime";
function MultiSelectSchema({
  schema,
  model,
  submitted,
  required = false,
  errors,
  onChange
}) {
  const { formatMessage, locale } = useIntl6();
  const { disabled, items, validationMessages, placeholder } = schema;
  const options = items.oneOf.map((item) => mapConstSchemaToOption(item, "select"));
  const id = useMemo11(() => schema.$id || generateRandomId(), [schema.$id]);
  const [changed, setChanged] = useState6(false);
  const [selected, setSelected] = useState6(getInitialModelIndices2(model, options));
  useEffect5(
    () => {
      if (selected) {
        broadcastModelChange(selected);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const broadcastModelChange = (selected2) => {
    setSelected(selected2);
    const updatedModel = selected2.map((i) => options[i].value);
    setChanged(true);
    onChange({
      model: !required && updatedModel.length === 0 ? null : updatedModel,
      triggerSchema: schema.items,
      triggerModel: updatedModel
    });
  };
  const getFormattedMessage = () => {
    if (selected && selected.length > 0) {
      if (selected.length > 1) {
        return formatMessage(multi_select_messages_default.summary, {
          first: options[selected[0]].label,
          count: selected.length - 1
        });
      }
      return options[selected[0]].label;
    }
    return placeholder;
  };
  const validations = getValidationFailures(model, schema, required);
  const shouldShowInitialError = Boolean(errors) && !changed;
  const shouldShowValidationError = Boolean(validations.length) && submitted;
  const formGroupClasses = {
    "form-group": true,
    "has-error": shouldShowInitialError || shouldShowValidationError,
    "has-info": !!schema.description
  };
  return /* @__PURE__ */ jsxs8("div", { className: classNames3("d-flex flex-column", formGroupClasses), children: [
    schema.title ? /* @__PURE__ */ jsx27("label", { className: "control-label d-inline m-b-1", htmlFor: id, children: schema.title }) : void 0,
    /* @__PURE__ */ jsx27(
      SelectInput,
      {
        id,
        multiple: true,
        disabled,
        placeholder: placeholder ? String(placeholder) : void 0,
        items: options.map((value, index) => ({
          type: "option",
          value: index,
          disabled: value.disabled,
          filterMatchers: [
            value.label,
            value.value,
            ...value.note ? [value.note] : [],
            ...value.secondary ? [value.secondary] : [],
            ...value.searchStrings ? value.searchStrings : []
          ]
        })),
        filterable: options.length >= 8,
        value: selected != null ? selected : [],
        renderValue: (index, withinTrigger) => {
          const { icon, label, note, secondary } = options[index];
          if (withinTrigger) {
            return selected && index === selected[0] ? getFormattedMessage() : void 0;
          }
          return /* @__PURE__ */ jsx27(SelectInputOptionContent, { title: label, note: note != null ? note : secondary, icon });
        },
        onChange: broadcastModelChange
      }
    ),
    /* @__PURE__ */ jsx27(
      ControlFeedback_default,
      {
        id: `${id}-feedback`,
        changed,
        focused: !submitted,
        blurred: !submitted,
        errors: typeof errors === "string" ? errors : void 0,
        submitted,
        schema,
        validations: submitted ? validations : void 0,
        validationMessages,
        infoMessage: null
      }
    )
  ] });
}
var getInitialModelIndices2 = (model, options) => {
  if (model == null) {
    return null;
  }
  return model.map((m) => options.findIndex((o) => o.value === m)).filter((n) => n >= 0);
};

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/repeatableSchema/RepeatableSchema.tsx
import { Header as Header3, Modal, NavigationOption as NavigationOption3 } from "@transferwise/components";
import { Plus } from "@transferwise/icons";
import { useMemo as useMemo12, useState as useState8 } from "react";
import { useIntl as useIntl8 } from "react-intl";

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/repeatableSchema/ItemSummary.tsx
import { NavigationOption as NavigationOption2 } from "@transferwise/components";
import { jsx as jsx28 } from "react/jsx-runtime";
function ItemSummaryOption({ item, onClick }) {
  return /* @__PURE__ */ jsx28(
    NavigationOption2,
    {
      media: getNavigationOptionMedia(item),
      title: item.title,
      content: item.description,
      showMediaAtAllSizes: true,
      onClick
    }
  );
}

// src/common/messages/repeatable.messages.ts
import { defineMessages as defineMessages9 } from "react-intl";
var repeatable_messages_default = defineMessages9({
  addItemTitle: {
    id: "dynamicFlows.ArraySchema.addItemTitle",
    defaultMessage: "Add Item",
    description: "Label on the button used to open a form to add an item"
  },
  addItem: {
    id: "dynamicFlows.ArraySchema.addItem",
    defaultMessage: "Save",
    description: "Label on the add button used to submit a form that adds an item"
  },
  editItem: {
    id: "dynamicFlows.ArraySchema.editItem",
    defaultMessage: "Save",
    description: "Label on the edit button used to submit a form that edits an item"
  },
  removeItem: {
    id: "dynamicFlows.ArraySchema.removeItem",
    defaultMessage: "Remove",
    description: "Label on the remove button used to confirm deletion of an item"
  }
});

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/repeatableSchema/RepeatableSchemaStep.tsx
import { useState as useState7 } from "react";
import { useIntl as useIntl7 } from "react-intl";
import { jsx as jsx29 } from "react/jsx-runtime";
function RepeatableSchemaStep({
  type,
  schema,
  model,
  errors,
  submitted,
  onModelChange,
  onAction
}) {
  const { formatMessage } = useIntl7();
  const [filename, setFilename] = useState7(void 0);
  const step = {
    layout: [
      {
        type: "form",
        schema: schema.items
      },
      {
        type: "button",
        control: "primary",
        action: {
          url: type,
          title: formatMessage(type === "add" ? repeatable_messages_default.addItem : repeatable_messages_default.editItem)
        }
      },
      ...type === "edit" ? [
        {
          type: "button",
          context: "negative",
          action: {
            url: "remove",
            title: formatMessage(repeatable_messages_default.removeItem)
          }
        }
      ] : []
    ],
    title: "",
    actions: [],
    schemas: []
  };
  const onChange = (props) => {
    const _a = props, { metadata, model: model2 } = _a, modelChangeProps = __objRest(_a, ["metadata", "model"]);
    if (schema.items.format === "base64url" && typeof model2 === "string" && typeof (metadata == null ? void 0 : metadata.filename) === "string") {
      setFilename(metadata.filename);
    }
    onModelChange(__spreadProps(__spreadValues({}, modelChangeProps), { model: model2 }));
  };
  return /* @__PURE__ */ jsx29(
    DynamicFlowStep,
    {
      step,
      model,
      stepLayoutOptions: { displayStepTitle: false },
      submitted,
      formErrors: errors,
      globalError: null,
      onAction: (action) => {
        onAction(action.url, filename);
        setFilename(void 0);
      },
      onModelChange: onChange
    }
  );
}
var RepeatableSchemaStep_default = RepeatableSchemaStep;

// src/legacy/jsonSchemaForm/oneOfSchema/utils.ts
var getActiveSchemaIndex = (schema, model) => {
  const indexFromModel = getValidIndexFromValue(schema, model);
  if (indexFromModel >= 0) {
    return indexFromModel;
  }
  if (schema.oneOf.length === 1 && isNoNConstSchema(schema.oneOf[0])) {
    return 0;
  }
  if (isConstSchema2(schema.oneOf[0])) {
    const indexFromDefault = getValidIndexFromValue(schema, schema.default);
    if (indexFromDefault >= 0) {
      return indexFromDefault;
    }
  }
  if (isOneOfObjectSchema(schema) && isObjectModel2(model) && Object.keys(model).length >= 1) {
    return getBestMatchingSchemaIndexForValue(schema, model);
  }
  if (isOneOfObjectSchema(schema) && !isUndefined2(schema.default) && isObjectModel2(schema.default) && Object.keys(schema.default).length >= 1) {
    return getBestMatchingSchemaIndexForValue(schema, schema.default);
  }
  return null;
};
var getValidIndexFromValue = (schema, value) => {
  const predicate = (childSchema) => !isUndefined2(value) && isValidSchema(value, childSchema);
  if (schema.oneOf.filter(predicate).length === 1) {
    return schema.oneOf.findIndex(predicate);
  }
  return -1;
};
function getBestMatchingSchemaIndexForValue(schema, value) {
  if (value === null || value === void 0) {
    return null;
  }
  const schemaPoints = schema.oneOf.map(
    (childSchema) => getSchemaProperties(childSchema).reduce((total, [key, propertySchema]) => {
      if (isConstSchema2(propertySchema) && propertySchema.const === value[key]) {
        return total + 2;
      }
      if (isNoNConstSchema(propertySchema) && typeof value[key] !== "undefined") {
        return total + 1;
      }
      return total;
    }, 0)
  );
  if (schemaPoints.every((p) => p === schemaPoints[0])) {
    return null;
  }
  return schemaPoints.indexOf(Math.max(...schemaPoints));
}
function getSchemaProperties(childSchema) {
  return childSchema.properties !== null && typeof childSchema.properties === "object" ? Object.entries(childSchema.properties) : [];
}

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/repeatableSchema/utils/summary-utils.ts
var getItemSummaryFromSchema = (schema, model, defaults = {}, summaryTextOverride) => {
  const { defaultTitle = "", defaultDescription = "", defaultIcon, defaultImage } = defaults;
  const title = getSummaryPropFromSchema({
    schema,
    model,
    providesProp: "providesTitle",
    getValueFromSchema: (schema2, model2) => summaryTextOverride != null ? summaryTextOverride : getStringValueFromSchema(schema2, model2)
  });
  const description = getSummaryPropFromSchema({
    schema,
    model,
    providesProp: "providesDescription",
    getValueFromSchema: (schema2, model2) => summaryTextOverride != null ? summaryTextOverride : getStringValueFromSchema(schema2, model2)
  });
  const icon = getSummaryPropFromSchema({
    schema,
    model,
    providesProp: "providesIcon",
    getValueFromSchema: (schema2) => {
      var _a;
      return (_a = schema2.icon) != null ? _a : null;
    }
  });
  const image = getSummaryPropFromSchema({
    schema,
    model,
    providesProp: "providesImage",
    getValueFromSchema: (schema2) => {
      var _a;
      return (_a = schema2.image) != null ? _a : null;
    }
  });
  return {
    value: model,
    title: title || defaultTitle,
    description: description || defaultDescription,
    icon: icon || defaultIcon,
    image: image || defaultImage
  };
};
var getSummaryPropFromSchema = (props) => {
  const { schema, model, providesProp, getValueFromSchema } = props;
  const type = getSchemaType(schema);
  if (schemaSummaryProvides(schema.summary, providesProp)) {
    return getValueFromSchema(schema, model);
  }
  switch (type) {
    case "object": {
      return getObjectValueFromSchema(props);
    }
    case "oneOf": {
      return getOneOfValueFromSchema(props);
    }
    case "allOf": {
      return getAllOfValueFromSchema(props);
    }
    default:
      return null;
  }
};
var getObjectValueFromSchema = (props) => {
  const { schema, model } = props;
  const objectSchema = schema;
  for (const propertyKey in objectSchema.properties) {
    const propertySchema = objectSchema.properties[propertyKey];
    const propertyModel = isObjectModel2(model) && propertyKey in model ? model[propertyKey] : null;
    const result = getSummaryPropFromSchema(__spreadProps(__spreadValues({}, props), {
      schema: propertySchema,
      model: propertyModel
    }));
    if (result) {
      return result;
    }
  }
  return null;
};
var getOneOfValueFromSchema = (props) => {
  const { schema, model } = props;
  if (isOneOfObjectSchema(schema)) {
    if (!isObjectModel2(model)) {
      return null;
    }
    const activeSchemaIndex2 = getBestMatchingSchemaIndexForValue(schema, model);
    if (activeSchemaIndex2 === null || activeSchemaIndex2 < 0) {
      return null;
    }
    const activeSchema = schema.oneOf[activeSchemaIndex2];
    return getSummaryPropFromSchema(__spreadProps(__spreadValues({}, props), {
      schema: activeSchema
    }));
  }
  const oneOfSchema = schema;
  const activeSchemaIndex = getActiveSchemaIndex(oneOfSchema, model);
  if (activeSchemaIndex === null || activeSchemaIndex < 0) {
    return null;
  }
  return getSummaryPropFromSchema(__spreadProps(__spreadValues({}, props), {
    schema: oneOfSchema.oneOf[activeSchemaIndex]
  }));
};
var getAllOfValueFromSchema = (props) => {
  const { schema } = props;
  const allOfSchema = schema;
  for (const childSchema of allOfSchema.allOf) {
    const result = getSummaryPropFromSchema(__spreadProps(__spreadValues({}, props), {
      schema: childSchema
    }));
    if (result) {
      return result;
    }
  }
  return null;
};
var getStringValueFromSchema = (schema, model) => {
  if (isConstSchema2(schema)) {
    if (schema.title) {
      return schema.title;
    }
    if (isString2(schema.const)) {
      return schema.const;
    }
    return null;
  }
  return isNullableStringModel(model) ? model : null;
};
var schemaSummaryProvides = (summary, providesProp) => (
  // eslint-disable-next-line prefer-object-has-own, no-implicit-coercion
  !!summary && Object.hasOwnProperty.call(summary, providesProp) && Boolean(summary[providesProp])
);

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/repeatableSchema/RepeatableSchema.tsx
import classNames4 from "classnames";
import { jsx as jsx30, jsxs as jsxs9 } from "react/jsx-runtime";
function RepeatableSchema({
  schema,
  model,
  errors,
  submitted,
  required = false,
  onChange
}) {
  var _a;
  const [openModalType, setOpenModalType] = useState8(null);
  const [changed, setChanged] = useState8(false);
  const [itemSummaries, setItemSummaries] = useState8(() => {
    if (isObject2(model) && !isArray2(model)) {
      throw new Error(
        "RepeatableSchema does not support object models. Ensure your array schema is wrapped inside an object schema."
      );
    }
    return model ? model.map((item) => getItemSummaryFromSchema(schema.items, item, schema == null ? void 0 : schema.summary)) : null;
  });
  const [editableItem, setEditableItem] = useState8({ item: null, model: null });
  const id = useMemo12(() => schema.$id || generateRandomId(), [schema.$id]);
  const broadcastModelChange = (updatedItems) => {
    const updatedModel = updatedItems ? updatedItems.map(({ value }) => value) : null;
    onChange({
      model: updatedModel,
      triggerSchema: schema.items,
      triggerModel: updatedModel
    });
  };
  const onAddItem = () => {
    setOpenModalType("add");
  };
  const onEditItem = (item) => {
    setEditableItem({ item, model: item.value });
    setOpenModalType("edit");
  };
  const onSaveItem = (action, summaryTextOverride) => {
    var _a2;
    setChanged(true);
    const updatedItem = action === "remove" ? null : getItemSummaryFromSchema(
      schema.items,
      editableItem.model,
      schema.summary,
      summaryTextOverride
    );
    if (action !== "remove" && !isValidSchema((_a2 = updatedItem == null ? void 0 : updatedItem.value) != null ? _a2 : null, schema.items)) {
      return;
    }
    const updatedItemSummaries = getUpdatedItemSummaries(action, {
      originalItem: editableItem.item,
      updatedItem,
      itemSummaries
    });
    setItemSummaries(updatedItemSummaries);
    broadcastModelChange(updatedItemSummaries);
    setEditableItem({ item: null, model: null });
    setOpenModalType(null);
  };
  const onCancelEdit = () => {
    setEditableItem({ item: null, model: null });
    setOpenModalType(null);
  };
  const { formatMessage } = useIntl8();
  const validations = getValidationFailures(model, schema, required);
  const base64ValidationMessages = useFormattedDefaultErrorMessages({
    minItems: schema.minItems,
    maxItems: schema.maxItems
  });
  const validationMessages = schema.items.type === "string" && schema.items.format === "base64url" ? {
    minItems: base64ValidationMessages.minItemsErrorMessage,
    maxItems: base64ValidationMessages.maxItemsErrorMessage,
    required: base64ValidationMessages.requiredMessage
  } : void 0;
  const formGroupClasses = {
    "has-error": (_a = errors && !isEmpty(errors)) != null ? _a : submitted && validations.length
  };
  return /* @__PURE__ */ jsxs9("div", { id, className: classNames4(formGroupClasses), children: [
    schema.title && /* @__PURE__ */ jsx30(Header3, { title: schema.title }),
    itemSummaries == null ? void 0 : itemSummaries.map((itemSummary) => /* @__PURE__ */ jsx30(
      ItemSummaryOption,
      {
        item: itemSummary,
        onClick: () => onEditItem(itemSummary)
      },
      JSON.stringify(itemSummary)
    )),
    /* @__PURE__ */ jsx30(
      NavigationOption3,
      {
        media: /* @__PURE__ */ jsx30(Plus, {}),
        title: schema.addItemTitle || formatMessage(repeatable_messages_default.addItemTitle),
        showMediaAtAllSizes: true,
        onClick: onAddItem
      }
    ),
    /* @__PURE__ */ jsx30(
      Modal,
      {
        open: openModalType !== null,
        title: (openModalType === "add" ? schema.addItemTitle : schema.editItemTitle) || formatMessage(repeatable_messages_default.addItemTitle),
        body: /* @__PURE__ */ jsx30(
          RepeatableSchemaStep_default,
          {
            type: openModalType != null ? openModalType : "add",
            schema,
            model: editableItem.model,
            errors,
            submitted,
            onAction: onSaveItem,
            onModelChange: ({ model: model2 }) => setEditableItem(__spreadProps(__spreadValues({}, editableItem), { model: model2 }))
          }
        ),
        onClose: onCancelEdit
      }
    ),
    /* @__PURE__ */ jsx30(
      ControlFeedback_default,
      {
        id: `${id}-feedback`,
        changed,
        focused: false,
        blurred: false,
        errors: typeof errors === "string" ? errors : void 0,
        submitted,
        schema,
        validations,
        validationMessages,
        infoMessage: null
      }
    )
  ] });
}
var getUpdatedItemSummaries = (action, {
  originalItem,
  updatedItem,
  itemSummaries
}) => {
  if (action === "remove") {
    return (itemSummaries || []).filter((itemSummary) => itemSummary !== originalItem);
  }
  if (!updatedItem) {
    return itemSummaries;
  }
  switch (action) {
    case "add":
      return [...itemSummaries || [], updatedItem];
    case "edit":
      return (itemSummaries || []).map(
        (itemSummary) => itemSummary === originalItem ? updatedItem : itemSummary
      );
    default:
      return null;
  }
};
var RepeatableSchema_default = RepeatableSchema;

// src/legacy/jsonSchemaForm/arrayTypeSchema/arrayListSchema/ArrayListSchema.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
function ArrayListSchema(props) {
  const { errors = null, schema } = props;
  if (isMultipleFileUploadSchema(schema)) {
    return /* @__PURE__ */ jsx31(MultipleFileUploadSchema_default, __spreadProps(__spreadValues({}, props), { errors, schema }));
  }
  if (isMultiSelectConstSchema(schema)) {
    return /* @__PURE__ */ jsx31(MultiSelectSchema, __spreadProps(__spreadValues({}, props), { errors, schema }));
  }
  if (isListArraySchema(schema)) {
    return /* @__PURE__ */ jsx31(RepeatableSchema_default, __spreadProps(__spreadValues({}, props), { errors, schema }));
  }
  throw new Error("Invalid array list schema");
}
var ArrayListSchema_default = ArrayListSchema;

// src/legacy/jsonSchemaForm/arrayTypeSchema/ArraySchema.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var ArraySchema = (props) => {
  const { schema } = props;
  if (isListArraySchema(schema)) {
    return /* @__PURE__ */ jsx32(ArrayListSchema_default, __spreadValues({}, props));
  }
  throw new Error("Not implemented");
};
var ArraySchema_default = ArraySchema;

// src/legacy/jsonSchemaForm/objectSchema/ObjectSchema.tsx
import { Header as Header4 } from "@transferwise/components";
import classNames5 from "classnames";
import { useState as useState9, useEffect as useEffect6 } from "react";
import { Fragment as Fragment6, jsx as jsx33, jsxs as jsxs10 } from "react/jsx-runtime";
var getSchemaColumnClasses2 = (width) => ({
  "col-xs-12": true,
  "col-sm-6": width === "md",
  "col-sm-4": width === "sm"
});
function ObjectSchema(props) {
  const { disabled = false, hideTitle = false } = props;
  const [model, setModel] = useState9(() => __spreadValues({}, getValidObjectModelParts(props.model, props.schema)));
  const onChangeProperty = (propertyName, onChangeProps) => {
    if (onChangeProps.model !== null) {
      model[propertyName] = onChangeProps.model;
    } else {
      delete model[propertyName];
    }
    setModel(model);
    props.onChange(__spreadProps(__spreadValues({}, onChangeProps), { model }));
  };
  const isRequired = (propertyName) => props.schema.required && props.schema.required.includes(propertyName);
  useEffect6(() => {
    const newModel = getValidObjectModelParts(model, props.schema) || {};
    setModel(newModel);
    if (!isEqual(newModel, model)) {
      props.onChange({
        model: newModel,
        triggerSchema: props.schema,
        triggerModel: newModel
      });
    }
  }, [props.schema]);
  const allorderedPropertiesSet = /* @__PURE__ */ new Set([
    ...props.schema.displayOrder || [],
    ...Object.keys(props.schema.properties)
  ]);
  const isPropertyDefined = (propertyName) => typeof props.schema.properties[propertyName] !== "undefined";
  const orderedPropertyNames = Array.from(allorderedPropertiesSet).filter(isPropertyDefined);
  const propsErrors = props.errors;
  return /* @__PURE__ */ jsxs10(Fragment6, { children: [
    props.schema.alert && /* @__PURE__ */ jsx33(DynamicAlert_default, { component: props.schema.alert }),
    /* @__PURE__ */ jsxs10("fieldset", { children: [
      props.schema.title && !hideTitle && /* @__PURE__ */ jsx33(Header4, { title: props.schema.title, as: "legend" }),
      props.schema.description && !hideTitle && /* @__PURE__ */ jsxs10("p", { children: [
        " ",
        props.schema.description,
        " "
      ] }),
      /* @__PURE__ */ jsx33("div", { className: "row", children: orderedPropertyNames.map((propertyName) => /* @__PURE__ */ jsx33(
        "div",
        {
          className: classNames5(
            getSchemaColumnClasses2(props.schema.properties[propertyName].width)
          ),
          children: /* @__PURE__ */ jsx33(
            GenericSchema_default,
            {
              schema: props.schema.properties[propertyName],
              model: props.model && props.model[propertyName],
              errors: propsErrors == null ? void 0 : propsErrors[propertyName],
              submitted: props.submitted,
              required: isRequired(propertyName),
              disabled,
              onChange: (onChangeProps) => onChangeProperty(propertyName, onChangeProps),
              onPersistAsync: props.onPersistAsync
            }
          )
        },
        propertyName
      )) })
    ] })
  ] });
}
var ObjectSchema_default = ObjectSchema;

// src/legacy/jsonSchemaForm/oneOfSchema/OneOfSchema.tsx
import { Header as Header5 } from "@transferwise/components";
import classNames6 from "classnames";
import { useEffect as useEffect8, useMemo as useMemo13, useState as useState10 } from "react";

// src/legacy/jsonSchemaForm/help/Help.tsx
import { Markdown, Info } from "@transferwise/components";
import { useIntl as useIntl9 } from "react-intl";

// src/common/messages/help.messages.ts
import { defineMessages as defineMessages10 } from "react-intl";
var help_messages_default = defineMessages10({
  helpAria: {
    id: "dynamicFlows.Help.ariaLabel",
    defaultMessage: "Click here for more info.",
    description: "Aria label for help."
  }
});

// src/legacy/jsonSchemaForm/help/Help.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
function Help(props) {
  const intl = useIntl9();
  return /* @__PURE__ */ jsx34(
    Info,
    {
      className: "m-l-1",
      content: /* @__PURE__ */ jsx34(Markdown, { config: { link: { target: "_blank" } }, children: props.help.markdown }),
      presentation: "POPOVER",
      size: "sm",
      "aria-label": intl.formatMessage(help_messages_default.helpAria)
    }
  );
}
var Help_default = Help;

// src/legacy/jsonSchemaForm/schemaFormControl/SchemaFormControl.tsx
import { useEffect as useEffect7 } from "react";
import { useIntl as useIntl10 } from "react-intl";

// src/legacy/formControl/FormControl.tsx
import {
  Checkbox,
  DateInput,
  DateLookup,
  InputWithDisplayFormat,
  PhoneNumberInput,
  RadioGroup,
  SelectInput as SelectInput2,
  SelectInputOptionContent as SelectInputOptionContent2,
  Tabs,
  TextareaWithDisplayFormat,
  Upload
} from "@transferwise/components";
import { PureComponent } from "react";

// src/legacy/formControl/utils/value-utils.ts
var getSafeStringValue = (value, options = {}) => {
  const { coerceValue = false } = options;
  if (isNull2(value)) {
    return void 0;
  }
  if (isObject2(value)) {
    logInvalidTypeFallbackWarning({ received: "object", expected: "string" });
    return void 0;
  }
  if (!isString2(value)) {
    if (coerceValue) {
      logInvalidTypeCoercedWarning({ received: typeof value, expected: "string" });
      return String(value);
    }
    logInvalidTypeFallbackWarning({ received: typeof value, expected: "string" });
    return void 0;
  }
  return value;
};
var getSafeStringOrNumberValue = (value, options = {}) => {
  const { coerceValue = false } = options;
  if (isNull2(value)) {
    return void 0;
  }
  if (isNumber2(value)) {
    return value;
  }
  const logProps = { received: typeof value, expected: "string or number" };
  if (isObject2(value)) {
    logInvalidTypeFallbackWarning(logProps);
    return void 0;
  }
  if (!isString2(value)) {
    if (coerceValue) {
      logInvalidTypeCoercedWarning(logProps);
      return String(value);
    }
    logInvalidTypeFallbackWarning(logProps);
    return void 0;
  }
  return value;
};
var getSafeBooleanValue = (value, options = {}) => {
  const { coerceValue = false } = options;
  if (isNull2(value)) {
    return false;
  }
  if (!isBoolean2(value)) {
    if (coerceValue) {
      logInvalidTypeCoercedWarning({ received: typeof value, expected: "boolean" });
      return Boolean(value);
    }
    logInvalidTypeFallbackWarning({ received: typeof value, expected: "boolean" });
    return void 0;
  }
  return value;
};
var getSafeDateOrStringValue = (value) => {
  if (isNull2(value)) {
    return void 0;
  }
  if (!(value instanceof Date) && !isString2(value)) {
    logInvalidTypeFallbackWarning({ received: typeof value, expected: "string or Date" });
    return void 0;
  }
  return value;
};
var getSafeDateStringValue = (value) => {
  if (isNull2(value)) {
    return null;
  }
  if (!isString2(value)) {
    logInvalidTypeFallbackWarning({
      received: typeof value,
      expected: "string",
      fallback: "null"
    });
    return null;
  }
  const date = dateStringToDate(value);
  if (date === null) {
    console.warn("Incorrectly formatted date string. Falling back to null.");
  }
  return date;
};
var logInvalidTypeCoercedWarning = ({
  received,
  expected
}) => {
  console.warn(
    `Value with type ${received} passed to control that only accepts type ${expected}. Type will be coerced, but this behaviour will change in the future, so please fix your code.`
  );
};
var logInvalidTypeFallbackWarning = ({
  received,
  expected,
  fallback = "undefined"
}) => {
  console.warn(
    `Value with type ${received} passed to control that only accepts type ${expected}. Falling back to ${fallback}`
  );
};

// src/legacy/formControl/utils/getAutocompleteString.ts
var getAutocompleteString2 = (hints, { prefix = "", suffix = "" } = {}) => {
  const autoCompleteString = hints.map((hint) => {
    const builtHint = `${prefix}${hint}${suffix}`;
    return isAutocompleteToken(builtHint) ? autocompleteTokenMap2[builtHint] : void 0;
  }).filter((str) => str).join(" ");
  return autoCompleteString || "off";
};
var isAutocompleteToken = (str) => Object.keys(autocompleteTokenMap2).some((hint) => hint === str);
var autocompleteTokenMap2 = {
  on: "on",
  name: "name",
  "name-prefix": "honorific-prefix",
  "given-name": "given-name",
  "additional-name": "additional-name",
  "family-name": "family-name",
  "name-suffix": "honorific-suffix",
  nickname: "nickname",
  email: "email",
  // Web doesn't have a specific mapping for new username, but this is semantically close enough
  "new-username": "username",
  username: "username",
  "new-password": "new-password",
  password: "current-password",
  "one-time-code": "one-time-code",
  "job-title": "organization-title",
  "organization-name": "organization",
  "full-street-address": "street-address",
  "street-address-line-1": "address-line1",
  "street-address-line-2": "address-line2",
  "street-address-line-3": "address-line3",
  "address-level-1": "address-level1",
  "address-level-2": "address-level2",
  "address-level-3": "address-level3",
  "address-level-4": "address-level4",
  "country-code": "country",
  "country-name": "country-name",
  "postal-code": "postal-code",
  "credit-card-name": "cc-name",
  "credit-card-given-name": "cc-given-name",
  "credit-card-middle-name": "cc-additional-name",
  "credit-card-family-name": "cc-family-name",
  "credit-card-number": "cc-number",
  "credit-card-expiration": "cc-exp",
  "credit-card-expiration-month": "cc-exp-month",
  "credit-card-expiration-year": "cc-exp-year",
  "credit-card-security-code": "cc-csc",
  "credit-card-type": "cc-type",
  "transaction-currency": "transaction-currency",
  "transaction-amount": "transaction-amount",
  language: "language",
  birthdate: "bday",
  "birthdate-day": "bday-day",
  "birthdate-month": "bday-month",
  "birthdate-year": "bday-year",
  gender: "sex",
  "phone-number": "tel",
  "phone-country-code": "tel-country-code",
  "phone-national": "tel-national",
  "phone-area-code": "tel-area-code",
  "phone-local": "tel-local",
  "phone-local-prefix": "tel-local-prefix",
  "phone-local-suffix": "tel-local-suffix",
  "phone-extension": "tel-extension",
  url: "url",
  photo: "photo",
  impp: "impp",
  shipping: "shipping",
  billing: "billing",
  home: "home",
  work: "work",
  mobile: "mobile",
  fax: "fax",
  pager: "pager"
};

// src/legacy/formControl/FormControl.tsx
import { Fragment as Fragment7, jsx as jsx35 } from "react/jsx-runtime";
var _FormControl = class _FormControl extends PureComponent {
  constructor(props) {
    super(props);
    this.getAutocompleteValue = ({ prefix = "", suffix = "" } = {}) => {
      const { autoComplete, autocompleteHint } = this.props;
      if (isArray2(autocompleteHint)) {
        return getAutocompleteString2(autocompleteHint, { prefix, suffix });
      }
      return autoComplete ? "on" : "off";
    };
    this.handleOnChange = (value, metadata) => {
      this.props.onChange(value, void 0, metadata);
    };
    this.handleInputOnChange = (event) => {
      this.props.onChange(event.target.value);
    };
    this.handleOnFocus = () => {
      var _a, _b;
      (_b = (_a = this.props).onFocus) == null ? void 0 : _b.call(_a);
    };
    this.handleOnBlur = () => {
      var _a, _b;
      (_b = (_a = this.props).onBlur) == null ? void 0 : _b.call(_a);
    };
    this.getSelectedOption = (options) => {
      if (this.state.selectedOption !== null && typeof this.state.selectedOption !== "undefined") {
        return options.find((option) => {
          var _a;
          return ((_a = this.state.selectedOption) == null ? void 0 : _a.value) === option.value;
        });
      }
      if (this.props.value !== null && typeof this.props.value !== "undefined") {
        return options.find((option) => this.props.value === option.value);
      }
      return void 0;
    };
    this.mapOption = (option) => __spreadProps(__spreadValues({}, option), {
      value: isNumber2(option.value) || isString2(option.value) ? option.value : void 0,
      secondary: option.note,
      disabled: option.disabled || this.props.disabled,
      readOnly: this.props.readOnly
    });
    this.state = {
      selectedOption: props.selectedOption,
      touched: false,
      prevValue: props.value
    };
  }
  static getDerivedStateFromProps(nextProps, previousState) {
    if (previousState.prevValue !== nextProps.value) {
      return { prevValue: nextProps.value, value: nextProps.value };
    }
    return null;
  }
  render() {
    var _a;
    const {
      name,
      placeholder,
      step,
      countryCode,
      type,
      options,
      disabled,
      readOnly,
      required,
      minLength,
      maxLength,
      min,
      max,
      searchPlaceholder,
      onSearchChange,
      size,
      uploadProps,
      label,
      description,
      monthFormat,
      // FIXME pass id to all components that accept it
      id,
      invalid,
      minDate,
      maxDate,
      value,
      mode,
      describedBy,
      labelledBy
    } = this.props;
    switch (type) {
      case FormControlType.RADIO:
        return /* @__PURE__ */ jsx35(
          RadioGroup,
          {
            radios: options.map(this.mapOption),
            name,
            selectedValue: getSafeStringOrNumberValue(value, { coerceValue: true }),
            UNSAFE_inputAttributes: {
              id,
              "aria-invalid": invalid,
              "aria-labelledby": labelledBy,
              "aria-describedby": describedBy
            },
            onChange: this.handleOnChange
          }
        );
      case FormControlType.CHECKBOX:
        return /* @__PURE__ */ jsx35(
          Checkbox,
          {
            checked: getSafeBooleanValue(value, { coerceValue: true }),
            disabled,
            label,
            secondary: description,
            required,
            readOnly,
            onChange: this.handleOnChange,
            onBlur: this.handleOnBlur,
            onFocus: this.handleOnFocus
          }
        );
      case FormControlType.SELECT: {
        const search = options.length >= 8;
        const items = options;
        const selected = this.getSelectedOption(options);
        return /* @__PURE__ */ jsx35("div", { className: "d-flex flex-column", children: /* @__PURE__ */ jsx35(
          SelectInput2,
          {
            id,
            UNSAFE_triggerButtonProps: {
              id,
              "aria-invalid": invalid,
              "aria-labelledby": labelledBy,
              "aria-describedby": describedBy
            },
            items: items.map((value2) => ({
              type: "option",
              value: value2,
              disabled: value2.disabled
            })),
            value: selected != null ? selected : null,
            renderValue: ({ hideIconInTrigger, icon, label: label2, note, secondary }, withinTrigger) => /* @__PURE__ */ jsx35(
              SelectInputOptionContent2,
              {
                title: label2,
                note: withinTrigger ? note != null ? note : secondary : note,
                description: withinTrigger ? void 0 : secondary,
                icon: withinTrigger && hideIconInTrigger ? void 0 : icon
              }
            ),
            filterable: search,
            disabled,
            placeholder,
            filterPlaceholder: searchPlaceholder,
            onChange: (option) => {
              var _a2;
              this.setState({ selectedOption: option });
              this.props.onChange((_a2 = option == null ? void 0 : option.value) != null ? _a2 : null);
            },
            onFilterChange: search && onSearchChange ? ({ query }) => {
              onSearchChange(query);
            } : void 0,
            onClear: required ? void 0 : () => {
              this.setState({ selectedOption: null });
              this.props.onChange(null);
            }
          }
        ) });
      }
      case FormControlType.TAB:
        return /* @__PURE__ */ jsx35(
          Tabs,
          {
            selected: ((_a = this.getSelectedOption(options)) == null ? void 0 : _a.value) || 0,
            tabs: options.map((option) => ({
              title: option.label,
              content: /* @__PURE__ */ jsx35(Fragment7, {}),
              disabled: option.disabled || false
            })),
            name: id,
            onTabSelect: (index) => {
              const hasSelectedOption = !!this.state.selectedOption;
              this.setState({
                selectedOption: options.find((option) => option.value === index)
              });
              this.props.onChange(index, hasSelectedOption ? "user" : "init");
            }
          }
        );
      case FormControlType.NUMERIC:
      case FormControlType.NUMBER: {
        return /* @__PURE__ */ jsx35(
          "input",
          {
            autoComplete: this.getAutocompleteValue(),
            className: "form-control",
            disabled,
            id,
            max,
            min,
            placeholder,
            readOnly,
            required,
            step,
            type: "number",
            value: getSafeStringOrNumberValue(value, { coerceValue: true }),
            "aria-describedby": describedBy,
            onBlur: this.handleOnBlur,
            onChange: (event) => {
              if (type === FormControlType.NUMERIC) {
                this.props.onChange(event.target.value);
              } else {
                this.props.onChange(parseFloat(event.target.value));
              }
            },
            onFocus: this.handleOnFocus,
            onWheel: (event) => {
              if (event.target instanceof HTMLElement) {
                event.target.blur();
              }
            }
          }
        );
      }
      case FormControlType.HIDDEN:
        return /* @__PURE__ */ jsx35(
          "input",
          {
            type: "hidden",
            name,
            value: getSafeStringValue(value, { coerceValue: true }),
            id
          }
        );
      case FormControlType.PASSWORD:
        return /* @__PURE__ */ jsx35(
          "input",
          {
            autoComplete: this.getAutocompleteValue(),
            className: "form-control",
            disabled,
            id,
            placeholder,
            readOnly,
            required,
            type: "password",
            value: getSafeStringValue(value, { coerceValue: true }),
            "aria-describedby": describedBy,
            onBlur: this.handleOnBlur,
            onChange: this.handleInputOnChange,
            onFocus: this.handleOnFocus
          }
        );
      case FormControlType.DATE:
      case FormControlType.DATETIME:
        return /* @__PURE__ */ jsx35(
          DateInput,
          {
            "aria-labelledby": labelledBy,
            dayAutoComplete: this.getAutocompleteValue({ suffix: "-day" }),
            yearAutoComplete: this.getAutocompleteValue({ suffix: "-year" }),
            disabled,
            size,
            value: getSafeDateOrStringValue(value),
            mode,
            monthFormat,
            onBlur: this.handleOnBlur,
            onChange: this.handleOnChange,
            onFocus: this.handleOnFocus
          }
        );
      case FormControlType.DATELOOKUP: {
        return /* @__PURE__ */ jsx35(
          DateLookup,
          {
            value: getSafeDateStringValue(value),
            min: minDate,
            max: maxDate,
            placeholder,
            monthFormat,
            disabled,
            onChange: (date) => {
              this.handleOnChange(date !== null ? dateToDateString(date) : null);
            },
            onBlur: this.handleOnBlur,
            onFocus: this.handleOnFocus
          }
        );
      }
      case FormControlType.TEL:
        return /* @__PURE__ */ jsx35(
          PhoneNumberInput,
          {
            disabled,
            countryCode,
            placeholder,
            required,
            searchPlaceholder,
            size,
            initialValue: getSafeStringValue(value),
            onBlur: this.handleOnBlur,
            onChange: (value2) => this.handleOnChange(value2),
            onFocus: this.handleOnFocus
          }
        );
      case FormControlType.TEXTAREA: {
        const textareaProps = {
          className: "form-control tw-form-control",
          id,
          name,
          placeholder,
          value: getSafeStringValue(value, { coerceValue: true }),
          readOnly,
          required,
          minLength,
          maxLength,
          onFocus: this.handleOnFocus,
          onBlur: this.handleOnBlur,
          disabled,
          autoComplete: this.getAutocompleteValue()
        };
        if (this.props.displayPattern) {
          return /* @__PURE__ */ jsx35(
            TextareaWithDisplayFormat,
            __spreadProps(__spreadValues({
              displayPattern: this.props.displayPattern
            }, textareaProps), {
              onChange: this.handleOnChange
            })
          );
        }
        return /* @__PURE__ */ jsx35(
          "textarea",
          __spreadProps(__spreadValues({}, textareaProps), {
            "aria-describedby": describedBy,
            onChange: this.handleInputOnChange
          })
        );
      }
      case FormControlType.FILE:
      case FormControlType.UPLOAD: {
        return /* @__PURE__ */ jsx35(
          Upload,
          __spreadProps(__spreadValues({}, uploadProps), {
            usAccept: uploadProps.usAccept || "*",
            usDisabled: uploadProps.usDisabled || disabled,
            onSuccess: (base64url, filename) => {
              this.handleOnChange(base64url, { filename });
            },
            onFailure: () => {
              this.handleOnChange(null);
            },
            onCancel: () => {
              this.handleOnChange(null);
            }
          })
        );
      }
      case FormControlType.TEXT:
      case FormControlType.EMAIL:
      default: {
        const inputProps = {
          type: type === FormControlType.EMAIL ? "email" : "text",
          className: "form-control",
          id,
          name,
          placeholder,
          value: getSafeStringValue(value, { coerceValue: true }),
          readOnly,
          required,
          minLength,
          maxLength,
          onFocus: this.handleOnFocus,
          onBlur: this.handleOnBlur,
          disabled,
          autoComplete: this.getAutocompleteValue()
        };
        if (this.props.displayPattern) {
          return /* @__PURE__ */ jsx35(
            InputWithDisplayFormat,
            __spreadProps(__spreadValues({
              displayPattern: this.props.displayPattern
            }, inputProps), {
              onChange: this.handleOnChange
            })
          );
        }
        return /* @__PURE__ */ jsx35(
          "input",
          __spreadProps(__spreadValues({}, inputProps), {
            "aria-describedby": describedBy,
            onChange: this.handleInputOnChange
          })
        );
      }
    }
  }
};
_FormControl.Type = FormControlType;
_FormControl.Size = Size;
_FormControl.MonthFormat = MonthFormat;
_FormControl.DateMode = DateMode;
_FormControl.defaultProps = {
  autoComplete: true,
  countryCode: null,
  disabled: false,
  displayPattern: null,
  id: null,
  invalid: false,
  label: "",
  max: null,
  maxDate: null,
  maxLength: null,
  min: null,
  minDate: null,
  minLength: null,
  mode: _FormControl.DateMode.DAY_MONTH_YEAR,
  monthFormat: _FormControl.MonthFormat.LONG,
  onBlur: null,
  onFocus: null,
  onSearchChange: null,
  options: [],
  placeholder: null,
  readOnly: false,
  required: false,
  searchPlaceholder: null,
  searchValue: "",
  selectedOption: null,
  size: _FormControl.Size.MEDIUM,
  step: 1,
  type: _FormControl.Type.TEXT,
  uploadProps: {},
  value: null
};
var FormControl = _FormControl;

// src/legacy/jsonSchemaForm/schemaFormControl/SchemaFormControl.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var isNativeInput = (propsSchemaType) => propsSchemaType === "string" || propsSchemaType === "number";
var getControlType = (schema) => {
  if (isOneOfSchema2(schema)) {
    if (schema.control === FormControlType.TAB && schema.oneOf.length > 3) {
      return FormControlType.SELECT;
    }
    if (schema.control == null || !Object.values(FormControlType).includes(schema.control)) {
      return FormControlType.SELECT;
    }
    return schema.control;
  }
  if (isStringSchema2(schema)) {
    return getStringSchemaControlType(schema);
  }
  if ("control" in schema && schema.control) {
    return schema.control;
  }
  if (schema.type === "boolean") {
    return "checkbox";
  }
  if (schema.type === "integer") {
    return "number";
  }
  return schema.type;
};
var getStringSchemaControlType = ({
  format,
  control,
  displayFormat
}) => {
  if (displayFormat) {
    return "text";
  }
  if (control) {
    return stringControlToFormControlType[control] || control;
  }
  if (format) {
    return stringFormatToFormControlType[format] || "text";
  }
  return "text";
};
var stringControlToFormControlType = {
  "date-lookup": "date-lookup",
  password: "password",
  textarea: "textarea",
  email: "email",
  numeric: "numeric",
  "phone-number": "tel"
};
var stringFormatToFormControlType = {
  date: "date",
  // Legacy formats
  email: "email",
  base64url: "file",
  password: "password",
  "phone-number": "tel"
};
var getOptions = (schema, controlType) => {
  if (schema.oneOf) {
    return schema.oneOf.map((childSchema) => mapConstSchemaToOption(childSchema, controlType));
  }
  return null;
};
function SchemaFormControl(props) {
  const {
    id,
    schema,
    value = null,
    disabled = false,
    invalid,
    required,
    onChange,
    onFocus,
    onBlur,
    onSearchChange,
    describedBy,
    labelledBy
  } = props;
  const log = useLogger();
  const intl = useIntl10();
  const getSanitisedValue = (value2) => isNativeInput(schema.type) && (isNull2(value2) || isUndefined2(value2)) ? "" : value2;
  const onModelChange = (value2, type, metadata) => {
    onChange(getValidBasicModelOrNull(value2, schema), type, metadata);
  };
  const controlType = getControlType(schema);
  useEffect7(() => {
    warnIfInvalidSchema(schema, log, controlType);
  }, [JSON.stringify(schema), log, controlType]);
  const options = schema.values || getOptions(schema, controlType);
  const events = {
    onFocus,
    onBlur,
    onSearchChange,
    onChange: onModelChange
  };
  const safeValue = getSanitisedValue(value);
  const controlProps = {
    id,
    name: id,
    label: schema.title,
    description: schema.description,
    invalid,
    options: options || [],
    placeholder: schema.placeholder,
    autoComplete: !schema.help,
    autocompleteHint: schema.autocompleteHint,
    disabled: disabled || schema.disabled,
    displayPattern: schema.displayFormat,
    // TODO: LOW avoid type assertion below
    uploadProps: __spreadValues({
      intl
    }, mapSchemaToUploadOptions(schema)),
    describedBy,
    labelledBy,
    required
  };
  return /* @__PURE__ */ jsx36("div", { "aria-describedby": describedBy, children: /* @__PURE__ */ jsx36(FormControl, __spreadValues(__spreadValues({ type: controlType, value: safeValue }, events), controlProps)) });
}
var warnIfInvalidSchema = (schema, log, controlType) => {
  if (isOneOfSchema2(schema) && schema.oneOf.length === 2 && !schema.control) {
    log.warning(
      "Deprecation warning",
      'A oneOf schema with 2 options and no control type currently renders as a "radio" but will be changed to render as a "select". Please specify control radio to retain the existing behaviour.'
    );
  }
  if (controlType === "file") {
    log.warning(
      "Deprecation warning",
      "Please use a persist-async blob schema instead of string with base64url for file uploads. The base64url does not perform well on low end devices. Support for this schema will be removed in a later release."
    );
  }
  if (schema.values) {
    log.warning("Deprecated schema", "Schema.values is a legacy approach. Please use oneOf.");
  }
};
var SchemaFormControl_default = SchemaFormControl;

// src/legacy/jsonSchemaForm/oneOfSchema/OneOfSchema.tsx
import { Fragment as Fragment8, jsx as jsx37, jsxs as jsxs11 } from "react/jsx-runtime";
function OneOfSchema(props) {
  const onEvent = useEventDispatcher();
  const [changed, setChanged] = useState10(false);
  const [focused, setFocused] = useState10(false);
  const [blurred, setBlurred] = useState10(false);
  const { disabled = false, required = false } = props;
  const id = useMemo13(() => props.schema.$id || generateRandomId(), [props.schema.$id]);
  const [schemaIndex, setSchemaIndex] = useState10(
    getActiveSchemaIndex(props.schema, props.model)
  );
  const [models, setModels] = useState10(getModelPartsForSchemas(props.model, props.schema.oneOf));
  const debouncedTrackEvent = useDebouncedFunction(onEvent, 200);
  const onSearchChange = (searchValue) => {
    debouncedTrackEvent("Dynamic Flow - OneOf Searched", {
      oneOfId: props.schema.analyticsId,
      searchValueLength: searchValue.length
    });
  };
  useEffect8(() => {
    const modelIndex = getValidIndexFromValue(props.schema, props.model);
    const defaultIndex = getValidIndexFromValue(props.schema, props.schema.default);
    if (modelIndex === -1 && defaultIndex >= 0) {
      onChooseNewSchema(defaultIndex, "init");
    }
  }, [props.schema]);
  if (!isArray2(props.schema.oneOf)) {
    console.error("Incorrect format", props.schema);
    return null;
  }
  const onChildModelChange = (index, onChangeParameters) => {
    setModels([...models.slice(0, index), onChangeParameters.model, ...models.slice(index + 1)]);
    setChanged(true);
    props.onChange(onChangeParameters);
  };
  const onFocus = () => {
    setFocused(true);
  };
  const onBlur = () => {
    setFocused(false);
    setBlurred(true);
  };
  const onChooseNewSchema = (index, type, metadata) => {
    setSchemaIndex(index);
    const newSchema = props.schema.oneOf[index];
    if (isConstSchema2(newSchema)) {
      const model = newSchema.const;
      props.onChange({
        model,
        triggerSchema: props.schema,
        triggerModel: model,
        type,
        metadata
      });
    } else {
      props.onChange({
        model: models[index],
        triggerSchema: newSchema,
        triggerModel: models[index],
        type,
        metadata
      });
    }
    if (type !== "init" && props.schema.analyticsId) {
      onEvent("Dynamic Flow - OneOf Selected", {
        oneOfId: props.schema.analyticsId,
        schemaId: newSchema == null ? void 0 : newSchema.analyticsId
      });
    }
  };
  const schemaForSelect = mapSchemasForSelect(props.schema);
  const validations = getValidations(props, schemaIndex);
  const formGroupClasses = {
    "form-group": true,
    "has-error": !changed && props.errors && !isEmpty(props.errors) || (props.submitted || changed && blurred) && validations.length
  };
  const isHidden = props.schema.hidden;
  const feedbackId = `${id}-feedback`;
  const labelId = `${id}-label`;
  return !isHidden ? /* @__PURE__ */ jsxs11(Fragment8, { children: [
    (props.schema.oneOf.length > 1 || isConstSchema2(props.schema.oneOf[0])) && /* @__PURE__ */ jsxs11(Fragment8, { children: [
      props.schema.alert && /* @__PURE__ */ jsx37(DynamicAlert_default, { component: props.schema.alert }),
      /* @__PURE__ */ jsxs11("div", { className: classNames6(formGroupClasses), children: [
        getTitleAndHelp(props.schema, id, labelId),
        /* @__PURE__ */ jsx37(
          SchemaFormControl_default,
          {
            id,
            schema: schemaForSelect,
            value: schemaIndex,
            disabled,
            invalid: !isEmpty(props.errors) || validations.length > 0,
            describedBy: feedbackId,
            labelledBy: labelId,
            required,
            onChange: onChooseNewSchema,
            onFocus,
            onBlur,
            onSearchChange
          }
        ),
        /* @__PURE__ */ jsx37(
          ControlFeedback_default,
          {
            id: feedbackId,
            changed,
            focused,
            blurred,
            submitted: props.submitted,
            errors: errorsToString(props.errors),
            schema: props.schema,
            validations,
            infoMessage: null
          }
        )
      ] })
    ] }),
    isNoNConstSchema(props.schema.oneOf[schemaIndex]) && /* @__PURE__ */ jsx37(
      GenericSchema_default,
      {
        schema: props.schema.oneOf[schemaIndex],
        model: models[schemaIndex],
        errors: props.errors,
        submitted: props.submitted,
        hideTitle: true,
        disabled,
        onChange: (parameters) => onChildModelChange(schemaIndex, parameters),
        onPersistAsync: props.onPersistAsync
      }
    )
  ] }) : null;
}
function getTitleAndHelp(schema, forId, labelId) {
  var _a;
  const helpElement = schema.help ? /* @__PURE__ */ jsx37(Help_default, { help: schema.help }) : null;
  const titleElement = isConstSchema2(schema.oneOf[0]) ? /* @__PURE__ */ jsx37("div", { className: "m-b-1", children: /* @__PURE__ */ jsxs11("label", { className: "control-label d-inline", id: labelId, htmlFor: forId, children: [
    schema.title,
    " ",
    helpElement
  ] }) }) : /* @__PURE__ */ jsx37(Fragment8, { children: helpElement ? /* @__PURE__ */ jsxs11("h4", { className: "m-b-2", children: [
    schema.title,
    " ",
    helpElement
  ] }) : /* @__PURE__ */ jsx37(Header5, { title: (_a = schema.title) != null ? _a : "" }) });
  return schema.title ? titleElement : helpElement;
}
function getValidations(props, schemaIndex) {
  const { schema, required = false } = props;
  const selectedSchema = schema.oneOf[schemaIndex != null ? schemaIndex : -1];
  if (isConstSchema2(selectedSchema)) {
    return getValidationFailures(selectedSchema.const, schema, Boolean(required));
  }
  if (schemaIndex === null || schemaIndex < 0) {
    return getValidationFailures(null, schema, Boolean(required));
  }
  return [];
}
function errorsToString(errors) {
  if (typeof errors === "string") {
    return errors;
  }
  return null;
}
function getModelPartsForSchemas(model, schemas) {
  return schemas.map((schema) => getValidModelParts(model, schema));
}
function mapSchemasForSelect(schema) {
  return __spreadProps(__spreadValues({}, schema), { oneOf: schema.oneOf.map(mapOneOfToConst) });
}
function mapOneOfToConst(schema, index) {
  const { title, description, disabled = false, icon, image, keywords } = schema;
  return { title, description, disabled, icon, image, const: index, keywords };
}
var OneOfSchema_default = OneOfSchema;

// src/legacy/jsonSchemaForm/persistAsyncSchema/persistAsyncBlobSchema/PersistAsyncBlobSchema.tsx
import classNames7 from "classnames";
import { useEffect as useEffect9, useState as useState11 } from "react";
import { useIntl as useIntl11 } from "react-intl";

// src/legacy/jsonSchemaForm/persistAsyncSchema/persistAsyncBlobSchema/UploadInputAdapter.tsx
import { Status as Status2, UploadInput as UploadInput2 } from "@transferwise/components";
import { useMemo as useMemo14 } from "react";
import { jsx as jsx38 } from "react/jsx-runtime";
function UploadInputAdapter(props) {
  const {
    id,
    httpClient = fetch,
    httpOptions,
    fileId,
    idProperty,
    usAccept,
    maxSize,
    usPlaceholder,
    onSuccess,
    onFailure,
    onCancel
  } = props;
  const onEvent = useEventDispatcher();
  const files = useMemo14(() => fileId ? [{ id: fileId, status: Status2.SUCCEEDED }] : [], [fileId]);
  const uploadFile = (formData) => {
    onEvent("Dynamic Flow - PersistAsync", { status: "pending", schemaId: id });
    return httpClient(String(httpOptions.url), {
      method: httpOptions.method || "POST",
      body: formData
    }).then((response) => {
      var _a;
      if (response.ok) {
        const file = formData.get((_a = httpOptions.fileInputName) != null ? _a : "file");
        onSuccess == null ? void 0 : onSuccess(response.clone(), file ? file.name : "");
        return response.json().then((responseBody) => ({
          id: responseBody[idProperty]
        }));
      }
      onFailure == null ? void 0 : onFailure({ response });
      return Promise.reject();
    });
  };
  return /* @__PURE__ */ jsx38(
    UploadInput2,
    {
      id,
      fileInputName: httpOptions.fileInputName,
      files,
      uploadButtonTitle: props.usLabel,
      sizeLimit: maxSize ? toKilobytes(maxSize) : void 0,
      fileTypes: usAccept,
      description: usPlaceholder,
      onUploadFile: uploadFile,
      onDeleteFile: (_id) => {
        onCancel == null ? void 0 : onCancel();
        return Promise.resolve();
      }
    }
  );
}

// src/legacy/jsonSchemaForm/persistAsyncSchema/persistAsyncBlobSchema/PersistAsyncBlobSchema.tsx
import { jsx as jsx39, jsxs as jsxs12 } from "react/jsx-runtime";
function PersistAsyncBlobSchema(props) {
  const { model, schema, submitted, required = false, errors, onChange } = props;
  const [persistAsyncValidationMessages, setPersistAsyncValidationMessages] = useState11({});
  const [persistAsyncValidations, setPersistAsyncValidations] = useState11(null);
  const [validations, setValidations] = useState11([]);
  const [changed, setChanged] = useState11(false);
  const intl = useIntl11();
  const httpClient = useHttpClient();
  const onEvent = useEventDispatcher();
  useEffect9(() => {
    if (submitted) {
      setValidations(getValidationFailures(model, schema, Boolean(required)));
    } else {
      setValidations([]);
    }
  }, [model, schema, submitted, required]);
  const onSuccess = async (httpResponse, _fileName) => {
    const jsonResponse = await getResponseJsonObject(httpResponse);
    const id2 = getIdFromResponse(schema.persistAsync.idProperty, jsonResponse);
    onChange({ model: id2, triggerSchema: schema, triggerModel: id2 });
    setChanged(true);
    onEvent("Dynamic Flow - PersistAsync", { status: "success", schemaId: schema.$id });
  };
  const onFailure = async (error) => {
    const errorResponse = error;
    if (errorResponse.response) {
      const jsonResponse = await getResponseJsonObject(errorResponse.response);
      setPersistAsyncValidationMessages(jsonResponse.validation || {});
      setPersistAsyncValidations([schema.persistAsync.param]);
    }
    onChange({ model: null, triggerSchema: schema, triggerModel: null });
    setChanged(true);
    onEvent("Dynamic Flow - PersistAsync", { status: "failure", schemaId: schema.$id });
  };
  const onCancel = () => {
    setPersistAsyncValidations(null);
    onChange({ model: null, triggerSchema: schema, triggerModel: null });
    setChanged(true);
  };
  const { url, method } = schema.persistAsync;
  const combinedValidations = persistAsyncValidations || validations;
  const formGroupClasses = {
    "form-group": true,
    "has-error": (submitted || changed) && Boolean(combinedValidations.length)
  };
  const id = schema.$id || schema.persistAsync.schema.$id || schema.persistAsync.idProperty;
  const feedbackId = `${id}-feedback`;
  return /* @__PURE__ */ jsxs12("div", { className: classNames7(formGroupClasses), children: [
    /* @__PURE__ */ jsx39("div", { "aria-describedby": feedbackId, children: /* @__PURE__ */ jsx39(
      UploadInputAdapter,
      __spreadValues({
        id,
        intl,
        fileId: model,
        idProperty: schema.persistAsync.idProperty,
        animationDelay: 0,
        maxSize: schema.persistAsync.schema.maxSize,
        usLabel: schema.title || schema.persistAsync.schema.title,
        usPlaceholder: schema.description || schema.persistAsync.schema.description,
        httpOptions: { url, method, fileInputName: schema.persistAsync.param },
        httpClient,
        onSuccess,
        onFailure,
        onCancel
      }, mapSchemaToUploadOptions(schema.persistAsync.schema))
    ) }),
    /* @__PURE__ */ jsx39(
      ControlFeedback_default,
      {
        id: feedbackId,
        blurred: true,
        focused: false,
        changed,
        submitted,
        errors,
        schema,
        validations: combinedValidations,
        validationMessages: __spreadValues({
          required: "Value is required..."
        }, persistAsyncValidationMessages),
        infoMessage: null
      }
    )
  ] });
}
var getResponseJsonObject = async (response) => {
  const json = await response.json().catch(() => ({}));
  return isObject2(json) ? json : {};
};
var PersistAsyncBlobSchema_default = PersistAsyncBlobSchema;

// src/legacy/jsonSchemaForm/persistAsyncSchema/PersistAsyncSchema.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
function PersistAsyncSchema(props) {
  const { schema } = props;
  const persistAsyncSchemaType = schema.persistAsync.schema.type;
  if (persistAsyncSchemaType === "blob") {
    return /* @__PURE__ */ jsx40(
      PersistAsyncBlobSchema_default,
      __spreadValues({}, props)
    );
  }
  return /* @__PURE__ */ jsx40(PersistAsyncBasicSchema_default, __spreadValues({}, props));
}
var PersistAsyncSchema_default = PersistAsyncSchema;

// src/legacy/jsonSchemaForm/promotedOneOfSchema/PromotedOneOfSchema.tsx
import { useState as useState12 } from "react";

// src/legacy/jsonSchemaForm/promotedOneOfSchema/promoted-one-of-utils.ts
var getSelectionFromModel = (schema, model) => {
  const index = getBestMatchingSchemaIndexForValue(schema, model);
  if (index !== null) {
    return schema.oneOf[index].promoted ? "promoted" : "other";
  }
  return null;
};

// src/legacy/jsonSchemaForm/promotedOneOfSchema/promotedOneOfControl/PromotedOneOfCheckboxControl.tsx
import { Checkbox as Checkbox2 } from "@transferwise/components";
import { jsx as jsx41 } from "react/jsx-runtime";
var PromotedOneOfCheckboxControl = (props) => {
  const { id, selection, setSelection } = props;
  const { promoted, other, checkedMeans } = props.promotion;
  const title = checkedMeans === "other" ? other.title : (promoted == null ? void 0 : promoted.title) || props.promotedOneOf.title;
  const selectionWhenChecked = checkedMeans === "other" ? "other" : "promoted";
  const selectionWhenUnchecked = checkedMeans === "other" ? "promoted" : "other";
  const checked = selection === selectionWhenChecked;
  const toggleSelection = () => {
    setSelection(checked ? selectionWhenUnchecked : selectionWhenChecked);
  };
  return /* @__PURE__ */ jsx41("div", { className: "form-group", children: /* @__PURE__ */ jsx41(Checkbox2, { id, label: title, checked, onChange: toggleSelection }) });
};
var PromotedOneOfCheckboxControl_default = PromotedOneOfCheckboxControl;

// src/legacy/jsonSchemaForm/promotedOneOfSchema/promotedOneOfControl/PromotedOneOfRadioControl.tsx
import { RadioGroup as RadioGroup2 } from "@transferwise/components";
import { jsx as jsx42, jsxs as jsxs13 } from "react/jsx-runtime";
function PromotedOneOfRadioControl(props) {
  var _a, _b;
  const { id, selection, setSelection, promotion, promotedOneOf, title } = props;
  const radios = [
    __spreadValues({
      value: "promoted",
      // TODO: LOW avoid type assertion below: the expression may be nullish, but "label" cannot be
      label: ((_a = promotion.promoted) == null ? void 0 : _a.title) || promotedOneOf.title,
      secondary: ((_b = promotion.promoted) == null ? void 0 : _b.description) || promotedOneOf.description
    }, getAvatarPropertyForRadioOption(promotedOneOf)),
    __spreadValues({
      value: "other",
      label: promotion.other.title,
      secondary: promotion.other.description
    }, getAvatarPropertyForRadioOption(promotion.other))
  ];
  return /* @__PURE__ */ jsxs13("div", { className: "form-group", children: [
    title && /* @__PURE__ */ jsx42("label", { className: "control-label", htmlFor: id, children: title }),
    /* @__PURE__ */ jsx42(
      RadioGroup2,
      {
        name: "promoted-selection",
        selectedValue: selection,
        radios,
        id,
        onChange: setSelection
      }
    )
  ] });
}
PromotedOneOfRadioControl.defaultProps = {
  title: void 0
};
var PromotedOneOfRadioControl_default = PromotedOneOfRadioControl;

// src/legacy/jsonSchemaForm/promotedOneOfSchema/promotedOneOfControl/PromotedOneOfControl.tsx
import { Fragment as Fragment9, jsx as jsx43 } from "react/jsx-runtime";
function PromotedOneOfControl(props) {
  const controlType = props.promotion.control || "radio";
  switch (controlType) {
    case "radio":
      return /* @__PURE__ */ jsx43(PromotedOneOfRadioControl_default, __spreadValues({}, props));
    case "checkbox":
      return /* @__PURE__ */ jsx43(PromotedOneOfCheckboxControl_default, __spreadValues({}, props));
    default:
      return /* @__PURE__ */ jsx43(Fragment9, {});
  }
}
PromotedOneOfControl.defaultProps = {
  id: generateRandomId(),
  title: void 0
};
var PromotedOneOfControl_default = PromotedOneOfControl;

// src/legacy/jsonSchemaForm/promotedOneOfSchema/PromotedOneOfSchema.tsx
import { Fragment as Fragment10, jsx as jsx44, jsxs as jsxs14 } from "react/jsx-runtime";
var isPromoted = (schema) => schema.promoted === true;
var PromotedOneOfSchema = (props) => {
  var _a;
  const [selection, setSelection] = useState12(
    getSelectionFromModel(props.schema, props.model) || ((_a = props.schema.promotion) == null ? void 0 : _a.default) || "promoted"
  );
  const promotedAlert = props.schema.alert;
  const promotedOneOf = props.schema.oneOf.find(isPromoted);
  const promotedObjectSchema = getPromotedObjectSchema(promotedOneOf);
  const otherOneOf = getOtherOneOf(props.schema);
  return /* @__PURE__ */ jsxs14(Fragment10, { children: [
    promotedAlert && /* @__PURE__ */ jsx44(DynamicAlert_default, { component: promotedAlert }),
    /* @__PURE__ */ jsx44(
      PromotedOneOfControl_default,
      {
        id: props.schema.$id,
        title: props.schema.title,
        promotedOneOf,
        promotion: props.schema.promotion,
        selection,
        setSelection
      }
    ),
    selection === "promoted" && /* @__PURE__ */ jsx44(ObjectSchema_default, __spreadProps(__spreadValues({}, props), { schema: promotedObjectSchema })),
    selection === "other" && /* @__PURE__ */ jsx44(GenericSchema_default, __spreadProps(__spreadValues({}, props), { schema: otherOneOf }))
  ] });
};
function getPromotedObjectSchema(promotedSchema) {
  return __spreadProps(__spreadValues({}, promotedSchema), {
    // We don't need to show these since they are already displayed in the radio option
    title: void 0,
    description: void 0
  });
}
function getOtherOneOf(schema) {
  var _a, _b, _c;
  const other = ((_a = schema.promotion) == null ? void 0 : _a.displayTwice) ? [...schema.oneOf] : schema.oneOf.filter((one) => !isPromoted(one));
  const title = (_c = (_b = schema.promotion) == null ? void 0 : _b.other.heading) == null ? void 0 : _c.text;
  if (other.length === 1) {
    return __spreadProps(__spreadValues({}, other[0]), { title });
  }
  if (other.length > 1) {
    return {
      title,
      oneOf: other,
      // TODO: LOW avoid type assertion -- the spec does not recognise a `control` property in ObjectSchema
      control: schema.control
    };
  }
  return null;
}
var PromotedOneOfSchema_default = PromotedOneOfSchema;

// src/legacy/jsonSchemaForm/readOnlySchema/ReadOnlySchema.tsx
import { DefinitionList, Layout } from "@transferwise/components";
import { useIntl as useIntl12 } from "react-intl";

// src/legacy/jsonSchemaForm/readOnlySchema/ReadOnlySchema.messages.ts
import { defineMessages as defineMessages11 } from "react-intl";
var ReadOnlySchema_messages_default = defineMessages11({
  yes: {
    id: "dynamicFlows.ReadOnlySchema.yes",
    defaultMessage: "Yes",
    description: "Yes, used for boolean schemas with a value of true."
  },
  no: {
    id: "dynamicFlows.ReadOnlySchema.no",
    defaultMessage: "No",
    description: "No: used for boolean schemas with a value of false."
  }
});

// src/legacy/jsonSchemaForm/readOnlySchema/ReadOnlySchema.tsx
import { Fragment as Fragment11, jsx as jsx45, jsxs as jsxs15 } from "react/jsx-runtime";
function ReadOnlySchema({ schema, model }) {
  const { title = "" } = schema;
  const { formatMessage } = useIntl12();
  const value = getValueForSchema({ schema, model, formatMessage });
  return /* @__PURE__ */ jsx45(DefinitionList, { layout: Layout.VERTICAL_ONE_COLUMN, definitions: [{ title, value, key: "" }] });
}
var ReadOnlySchema_default = ReadOnlySchema;
function getValueForSchema({
  schema,
  model,
  formatMessage
}) {
  if (isBasicSchema(schema)) {
    if (isOneOfSchema2(schema)) {
      return getValueFromOneOfSchema(schema, model);
    } else {
      if (schema.type === "boolean" && isBoolean2(model)) {
        return model ? formatMessage(ReadOnlySchema_messages_default.yes) : formatMessage(ReadOnlySchema_messages_default.no);
      } else {
        return model && model.toString() || "";
      }
    }
  }
  return "";
}
function getValueFromOneOfSchema(schema, model) {
  const option = getSelectedOneOf(schema, model);
  return option ? getValueFromOption(option) : model;
}
function getSelectedOneOf(schema, model) {
  return schema.oneOf.find(
    (childSchema) => "const" in childSchema ? model === childSchema.const : false
  );
}
function getValueFromOption(option) {
  const text = option.title && option.description ? `${option.title} - ${option.description}` : option.title || "";
  const icon = getAvatarPropertyForRadioOption({ icon: option.icon });
  return (icon == null ? void 0 : icon.avatar) ? /* @__PURE__ */ jsxs15(Fragment11, { children: [
    icon.avatar,
    " ",
    text
  ] }) : text;
}

// src/legacy/jsonSchemaForm/validationAsyncSchema/ValidationAsyncSchema.tsx
import { useEffect as useEffect10, useRef as useRef3, useState as useState13 } from "react";
import { jsx as jsx46 } from "react/jsx-runtime";
function ValidationAsyncSchema(props) {
  const { schema, model, required = false, submitted, errors, onChange } = props;
  const [validationAsyncModel, setValidationAsyncModel] = useState13(model);
  const previousRequestedModelReference = useRef3(null);
  const [validationAsyncSuccessMessage, setValidationAsyncSuccessMessage] = useState13(
    null
  );
  const [validationAsyncErrors, setValidationAsyncErrors] = useState13(null);
  const [fieldSubmitted, setFieldSubmitted] = useState13(false);
  const [abortController, setAbortController] = useState13(null);
  const httpClient = useHttpClient();
  const onEvent = useEventDispatcher();
  const log = useLogger();
  useEffect10(() => {
    if (!schema.validationAsync.method) {
      log.warning(
        "Invalid schema or model",
        'ValidationAsyncSchema without a "method" property would have defaulted to "GET" in previous versions. Now defaults to "POST".',
        {}
      );
    }
  }, [log, schema.validationAsync.method]);
  const getValidationAsyncResponse = async (currentValidationAsyncModel, validationAsyncSpec) => {
    const signal = abortCurrentRequestAndGetNewAbortSignal();
    const requestBody = { [validationAsyncSpec.param]: currentValidationAsyncModel };
    previousRequestedModelReference.current = currentValidationAsyncModel;
    setFieldSubmitted(true);
    onEvent("Dynamic Flow - ValidationAsync", { status: "pending" });
    const response = await httpClient(validationAsyncSpec.url, {
      method: validationAsyncSpec.method || "POST",
      headers: { "Content-Type": "application/json" },
      body: validationAsyncSpec.method === "GET" ? void 0 : JSON.stringify(requestBody),
      signal
    });
    try {
      const jsonResponse = await response.json();
      if (!isObject2(jsonResponse)) {
        throw new Error("Response body is not an object");
      }
      onEvent("Dynamic Flow - ValidationAsync", { status: "success" });
      if (response.status === 200) {
        setValidationAsyncSuccessMessage(
          isString2(jsonResponse.message) ? jsonResponse.message : null
        );
      } else if (response.status === 422) {
        setValidationAsyncErrors(isString2(jsonResponse.message) ? jsonResponse.message : null);
      }
    } catch (e) {
      onEvent("Dynamic Flow - ValidationAsync", { status: "failure" });
    }
  };
  const abortCurrentRequestAndGetNewAbortSignal = () => {
    if (abortController) {
      abortController.abort();
    }
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    return newAbortController.signal;
  };
  const onBlur = () => {
    if (!isNull2(validationAsyncModel) && !isEqual(validationAsyncModel, previousRequestedModelReference.current) && isValidSchema(validationAsyncModel, schema)) {
      void getValidationAsyncResponse(validationAsyncModel, schema.validationAsync);
    }
  };
  const onValidationAsyncChange = (parameters) => {
    onChange(__spreadProps(__spreadValues({}, parameters), {
      triggerSchema: schema,
      triggerModel: parameters.model
    }));
    setValidationAsyncErrors(null);
    setValidationAsyncSuccessMessage(null);
    setValidationAsyncModel(parameters.model);
  };
  const basicTypeSchemaProps = {
    submitted: submitted || fieldSubmitted,
    model: validationAsyncModel,
    errors: validationAsyncErrors || errors,
    infoMessage: validationAsyncSuccessMessage,
    onChange: onValidationAsyncChange,
    onBlur,
    required,
    schema
  };
  return /* @__PURE__ */ jsx46(BasicTypeSchema_default, __spreadValues({}, basicTypeSchemaProps));
}
var ValidationAsyncSchema_default = ValidationAsyncSchema;

// src/legacy/jsonSchemaForm/genericSchema/GenericSchema.tsx
import { Fragment as Fragment12, jsx as jsx47 } from "react/jsx-runtime";
import { createElement } from "react";
function GenericSchemaForm(props) {
  const { schema, model = null, errors = null, hideTitle = false, disabled = false } = props;
  const schemaProps = __spreadProps(__spreadValues({}, props), { model, errors, hideTitle, disabled });
  const type = getSchemaType(schema);
  const log = useLogger();
  useEffect11(() => {
    if (!isValidGenericSchema(schema, model, errors)) {
      log.error(
        "Invalid schema or model",
        `Schema of type ${type || "undefined"} requested, but schema did not pass validation.`
      );
    }
  }, [JSON.stringify(schema), JSON.stringify(model), JSON.stringify(errors), type, log]);
  switch (type) {
    case "readOnly":
      return /* @__PURE__ */ jsx47(ReadOnlySchema_default, __spreadValues({}, schemaProps));
    case "persistAsync":
      return /* @__PURE__ */ jsx47(PersistAsyncSchema_default, __spreadValues({}, schemaProps));
    case "validationAsync":
      return /* @__PURE__ */ jsx47(ValidationAsyncSchema_default, __spreadValues({}, schemaProps));
    case "basic": {
      const basicTypeProps = __spreadValues({
        infoMessage: null
      }, schemaProps);
      return /* @__PURE__ */ jsx47(BasicTypeSchema_default, __spreadValues({}, basicTypeProps));
    }
    case "object":
      return /* @__PURE__ */ createElement(ObjectSchema_default, __spreadProps(__spreadValues({}, schemaProps), { key: JSON.stringify(schema) }));
    case "array":
      return /* @__PURE__ */ jsx47(ArraySchema_default, __spreadValues({}, schemaProps));
    case "promotedOneOf":
      return /* @__PURE__ */ jsx47(PromotedOneOfSchema_default, __spreadValues({}, schemaProps));
    case "oneOf":
      return /* @__PURE__ */ jsx47(OneOfSchema_default, __spreadValues({}, schemaProps));
    case "allOf":
      return /* @__PURE__ */ jsx47(AllOfSchema_default, __spreadValues({}, schemaProps));
  }
  return /* @__PURE__ */ jsx47(Fragment12, {});
}
var GenericSchema_default = GenericSchemaForm;
var isValidGenericSchema = (schema, model, errors) => {
  const type = getSchemaType(schema);
  switch (type) {
    case "persistAsync":
      return isPersistAsyncSchema(schema) && isNullableStringModel(model) && isBasicError(errors);
    case "validationAsync":
      return isValidationAsyncSchema(schema) && isNullableBasicModel(model) && isBasicError(errors);
    case "basic":
      return isBasicSchema(schema) && isNullableBasicModel(model) && isBasicError(errors);
    case "object":
      return isObjectSchema2(schema) && isNullableObjectModel(model);
    case "array":
      return isArraySchema2(schema) && isNullableArrayModel(model) && isBasicError(errors);
    case "promotedOneOf":
      return isOneOfObjectSchema(schema) && isNullableObjectModel(model);
    case "oneOf":
      return isOneOfSchema2(schema);
    case "allOf":
      return isAllOfSchema2(schema) && isObjectModel2(model);
  }
  return false;
};

// src/legacy/layout/form/DynamicForm.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
function DynamicForm({
  component,
  model = null,
  errors = null,
  submitted,
  onModelChange,
  onPersistAsync
}) {
  const formSchema = component.schema;
  return /* @__PURE__ */ jsx48("div", { className: getMargin(component.margin || "md"), children: /* @__PURE__ */ jsx48(
    GenericSchema_default,
    {
      schema: formSchema,
      model,
      errors,
      submitted,
      onChange: (parameters) => {
        onModelChange(__spreadValues({ formSchema }, parameters));
      },
      onPersistAsync
    }
  ) });
}
var DynamicForm_default = DynamicForm;

// src/legacy/layout/heading/DynamicHeading.tsx
import { Display } from "@transferwise/components";
import classNames8 from "classnames";
import { jsx as jsx49 } from "react/jsx-runtime";
var DynamicHeading = (props) => {
  const { text, size = "md", align = "left", margin = "md", control } = props.component;
  const classes = classNames8(getTextAlignmentAndMargin({ align, margin }));
  return control === "display" ? /* @__PURE__ */ jsx49(DisplayHeading, { size, text, classes }) : /* @__PURE__ */ jsx49(StandardHeading, { size, text, classes });
};
var StandardHeading = ({ size, text, classes }) => {
  switch (size) {
    case "xs":
      return /* @__PURE__ */ jsx49("h5", { className: classes, children: text });
    case "sm":
      return /* @__PURE__ */ jsx49("h4", { className: classes, children: text });
    case "lg":
      return /* @__PURE__ */ jsx49("h2", { className: classes, children: text });
    case "xl":
      return /* @__PURE__ */ jsx49("h1", { className: classes, children: text });
    case "md":
    default:
      return /* @__PURE__ */ jsx49("h3", { className: classes, children: text });
  }
};
var DisplayHeading = ({ size, text, classes }) => {
  switch (size) {
    case "xs":
    case "sm":
      return /* @__PURE__ */ jsx49(Display, { type: "display-small", className: classes, children: text });
    case "xl":
    case "lg":
      return /* @__PURE__ */ jsx49(Display, { type: "display-large", className: classes, children: text });
    case "md":
    default:
      return /* @__PURE__ */ jsx49(Display, { type: "display-medium", className: classes, children: text });
  }
};
var DynamicHeading_default = DynamicHeading;

// src/legacy/layout/markdown/DynamicMarkdown.tsx
import { Markdown as Markdown2 } from "@transferwise/components";
import { jsx as jsx50 } from "react/jsx-runtime";
var DynamicMarkdown = ({ component }) => {
  const { content, align, margin } = component;
  return /* @__PURE__ */ jsx50("div", { className: getTextAlignmentAndMargin({ align, margin }), children: /* @__PURE__ */ jsx50(Markdown2, { config: { link: { target: "_blank" } }, children: content }) });
};
var DynamicInfo = ({ component }) => {
  return /* @__PURE__ */ jsx50("div", { className: getTextAlignmentAndMargin(component), children: /* @__PURE__ */ jsx50(Markdown2, { config: { link: { target: "_blank" } }, children: component.markdown }) });
};

// src/legacy/layout/image/DynamicImage.tsx
import { Image } from "@transferwise/components";
import { useEffect as useEffect12, useState as useState14 } from "react";
import { jsx as jsx51 } from "react/jsx-runtime";
function DynamicImage({ component: image }) {
  var _a, _b, _c;
  const { content, url, size, text, margin, accessibilityDescription } = image;
  const httpClient = useHttpClient();
  const [imageSource, setImageSource] = useState14("");
  useEffect12(() => {
    if (content) {
      const { uri, url: contentUrl } = content;
      if (uri && !uri.startsWith("urn:")) {
        void getImageSource(httpClient, uri).then(setImageSource);
        return;
      }
      if (contentUrl) {
        void getImageSource(httpClient, contentUrl).then(setImageSource);
        return;
      }
    }
    if (url) {
      void getImageSource(httpClient, url).then(setImageSource);
    }
  }, [content, url, httpClient]);
  const imageProps = {
    alt: (_c = (_b = (_a = content == null ? void 0 : content.accessibilityDescription) != null ? _a : accessibilityDescription) != null ? _b : text) != null ? _c : "",
    src: imageSource,
    stretch: true,
    shrink: true
  };
  if (!imageSource) {
    return null;
  }
  return /* @__PURE__ */ jsx51("div", { className: `df-legacy-image ${size || "md"}`, children: /* @__PURE__ */ jsx51(Image, __spreadValues({ className: `img-responsive ${getMargin(margin || "md")}` }, imageProps)) });
}
var readImageBlobAsDataURL = (imageBlob) => (
  // we can safely assume the type of reader.result is string
  // because we're calling reader.readAsDataURL
  // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/result
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("loadend", () => resolve(reader.result));
    reader.addEventListener("error", (error) => reject(error));
    reader.readAsDataURL(imageBlob);
  })
);
var getImageSource = async (httpClient, imageUrl) => {
  var _a;
  try {
    if (isRelativePath(imageUrl) || (imageUrl == null ? void 0 : imageUrl.startsWith(`${(_a = window == null ? void 0 : window.location) == null ? void 0 : _a.origin}/`))) {
      return httpClient(imageUrl, {
        method: "GET",
        headers: { "Content-Type": "image/image" },
        credentials: "same-origin"
      }).then((response) => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error("Image fetching failed");
      }).then(readImageBlobAsDataURL).catch(() => imageUrl);
    }
    return imageUrl;
  } catch (e) {
    return imageUrl;
  }
};
var DynamicImage_default = DynamicImage;

// src/legacy/layout/instructions/DynamicInstructions.tsx
import { Header as Header6, InstructionsList } from "@transferwise/components";
import { jsx as jsx52, jsxs as jsxs16 } from "react/jsx-runtime";
var doContext = ["positive", "neutral"];
var dontContext = ["warning", "negative"];
var DynamicInstructions = ({ component }) => {
  const { items } = component;
  const dos = items.filter((item) => doContext.includes(item.context)).map(({ text }) => text);
  const donts = items.filter((item) => dontContext.includes(item.context)).map(({ text }) => text);
  return /* @__PURE__ */ jsxs16("div", { className: getMargin(component.margin || "md"), children: [
    component.title ? /* @__PURE__ */ jsx52(Header6, { title: component.title }) : null,
    /* @__PURE__ */ jsx52(InstructionsList, { dos, donts })
  ] });
};
var DynamicInstructions_default = DynamicInstructions;

// src/legacy/layout/DynamicLayout.tsx
import { Fragment as Fragment13, jsx as jsx53 } from "react/jsx-runtime";
var getKey = (component) => JSON.stringify(component);
function DynamicLayout(props) {
  const { components, model, submitted, errors, onModelChange, onAction, onPersistAsync, baseUrl } = props;
  const renderComponent = (component) => {
    switch (component.type) {
      case "heading":
        return /* @__PURE__ */ jsx53(DynamicHeading_default, { component }, getKey(component));
      case "paragraph":
        return /* @__PURE__ */ jsx53(DynamicParagraph_default, { component }, getKey(component));
      case "image":
        return /* @__PURE__ */ jsx53(DynamicImage_default, { component }, getKey(component));
      case "alert":
        return /* @__PURE__ */ jsx53(DynamicAlert_default, { component, onAction }, getKey(component));
      case "review":
        return /* @__PURE__ */ jsx53(DynamicReview_default, { component, onAction }, getKey(component));
      case "divider":
        return /* @__PURE__ */ jsx53(DynamicDivider_default, { component }, getKey(component));
      case "info":
        return /* @__PURE__ */ jsx53(DynamicInfo, { component }, getKey(component));
      case "instructions":
        return /* @__PURE__ */ jsx53(DynamicInstructions_default, { component }, getKey(component));
      case "markdown":
        return /* @__PURE__ */ jsx53(DynamicMarkdown, { component }, getKey(component));
      case "columns":
        return /* @__PURE__ */ jsx53(
          DynamicColumns_default,
          {
            component,
            model,
            submitted,
            errors,
            onModelChange,
            onAction,
            onPersistAsync
          },
          getKey(component)
        );
      case "form":
        return /* @__PURE__ */ jsx53(
          DynamicForm_default,
          {
            component,
            model,
            submitted,
            errors,
            onModelChange,
            onPersistAsync
          },
          getKey(__spreadProps(__spreadValues({}, component), { errors: errors != null ? errors : null }))
        );
      case "button":
        return /* @__PURE__ */ jsx53(DynamicButton_default, { component, onAction }, getKey(component));
      case "box":
        return /* @__PURE__ */ jsx53(
          DynamicBox_default,
          {
            component,
            model,
            submitted,
            errors,
            onModelChange,
            onAction,
            onPersistAsync
          },
          getKey(component)
        );
      case "decision":
        return /* @__PURE__ */ jsx53(DynamicDecision_default, { component, onAction }, getKey(component));
      case "external":
        return /* @__PURE__ */ jsx53(DynamicExternal_default, { component, onAction }, getKey(component));
      case "list":
      case "status-list":
        return /* @__PURE__ */ jsx53(DynamicStatusList_default, { component, onAction }, getKey(component));
      case "loading-indicator":
        return /* @__PURE__ */ jsx53(DynamicLoadingIndicator_default, { component }, getKey(component));
      case "search":
        return /* @__PURE__ */ jsx53(DynamicSearch_default, { component, onAction }, getKey(component));
      case "modal":
        return /* @__PURE__ */ jsx53(
          DynamicModal_default,
          {
            component,
            model,
            submitted,
            errors,
            onModelChange,
            onAction,
            onPersistAsync
          },
          getKey(component)
        );
      default:
        return /* @__PURE__ */ jsx53("div", {}, getKey(component));
    }
  };
  if (useHasHttpClientProvider() || baseUrl == null) {
    return /* @__PURE__ */ jsx53(Fragment13, { children: components.map(renderComponent) });
  }
  return /* @__PURE__ */ jsx53(HttpClientProviderFromBaseUrl, { baseUrl, children: components.map(renderComponent) });
}
var DynamicLayout_default = DynamicLayout;

// src/legacy/layout/list/DynamicStatusList.tsx
import { Header as Header7, Summary } from "@transferwise/components";
import { jsx as jsx54, jsxs as jsxs17 } from "react/jsx-runtime";
var DynamicStatusList = ({ component, onAction }) => {
  return /* @__PURE__ */ jsxs17("div", { className: getMargin(component.margin || "md"), children: [
    component.title ? /* @__PURE__ */ jsx54(Header7, { title: component.title, className: "m-b-2" }) : null,
    component.items.map((item) => mapListItemToSummary(item, onAction))
  ] });
};
var mapListItemToSummary = (props, onAction) => {
  const { title, description, icon, status } = props;
  const summaryProps = __spreadValues(__spreadValues({
    title,
    description,
    action: "callToAction" in props ? callToActionToSummaryAction(props == null ? void 0 : props.callToAction, onAction) : void 0
  }, (icon == null ? void 0 : icon.name) ? { icon: /* @__PURE__ */ jsx54(DynamicIcon_default, { type: icon.name }) } : {}), status ? { status: statusMap[status] } : {});
  return /* @__PURE__ */ jsx54(Summary, __spreadValues({}, summaryProps), `${title}/${description || ""}`);
};
var callToActionToSummaryAction = (callToAction, onAction) => {
  if (!callToAction) {
    return void 0;
  }
  const { accessibilityDescription, behavior, title } = callToAction;
  if ("type" in behavior) {
    switch (behavior.type) {
      case "action": {
        const { action } = behavior;
        return {
          text: title,
          "aria-label": accessibilityDescription,
          onClick: () => {
            onAction(action);
          }
        };
      }
      case "link": {
        return {
          text: title,
          "aria-label": accessibilityDescription,
          href: behavior.url,
          target: "_blank"
        };
      }
    }
  }
  if (behavior.link) {
    const { link } = behavior;
    return {
      text: title,
      "aria-label": accessibilityDescription,
      href: link.url,
      target: "_blank"
    };
  }
  if (behavior.action) {
    const { action } = behavior;
    return {
      text: title,
      "aria-label": accessibilityDescription,
      onClick: () => {
        onAction(action);
      }
    };
  }
  return {
    text: "title",
    "aria-label": accessibilityDescription,
    onClick: () => {
    }
  };
};
var statusListMap = {
  done: "done",
  pending: "pending",
  "not-done": "notDone"
};
var legacyStatusMap = {
  positive: "done",
  warning: "pending",
  neutral: "notDone"
};
var statusMap = __spreadValues(__spreadValues({}, statusListMap), legacyStatusMap);
var DynamicStatusList_default = DynamicStatusList;

// src/legacy/layout/loadingIndicator/DynamicLoadingIndicator.tsx
import { Loader as Loader2 } from "@transferwise/components";
import { jsx as jsx55 } from "react/jsx-runtime";
var DynamicLoadingIndicator = ({ component }) => {
  const { margin = "md", size = "md" } = component;
  return /* @__PURE__ */ jsx55(
    Loader2,
    {
      size,
      classNames: {
        "tw-loader": `tw-loader m-x-auto ${getMargin(margin)}`
      },
      "data-testid": "loading-indicator"
    }
  );
};
var DynamicLoadingIndicator_default = DynamicLoadingIndicator;

// src/legacy/layout/paragraph/DynamicParagraph.tsx
import { Button as Button3 } from "@transferwise/components";
import { useIntl as useIntl13 } from "react-intl";

// src/common/messages/paragraph.messages.ts
import { defineMessages as defineMessages12 } from "react-intl";
var paragraph_messages_default = defineMessages12({
  copy: {
    id: "dynamicFlows.DynamicParagraph.copy",
    defaultMessage: "Copy",
    description: "Copy to clipboard button label."
  },
  copied: {
    id: "dynamicFlows.DynamicParagraph.copied",
    defaultMessage: "Copied to clipboard",
    description: "Appears in a snackbar when the copy operation succeeds."
  }
});

// src/legacy/layout/paragraph/useSnackBarIfAvailable.ts
import { SnackbarContext } from "@transferwise/components";
import { useContext as useContext5 } from "react";
function useSnackBarIfAvailable() {
  const context = useContext5(SnackbarContext);
  return context ? context.createSnackbar : noop3;
}
function noop3() {
}

// src/legacy/layout/paragraph/DynamicParagraph.tsx
import { jsx as jsx56, jsxs as jsxs18 } from "react/jsx-runtime";
function DynamicParagraph({ component }) {
  return component.control === "copyable" ? /* @__PURE__ */ jsx56(CopyableDynamicParagraph, { component }) : /* @__PURE__ */ jsx56(BasicDynamicParagraph, { component });
}
function BasicDynamicParagraph({ component }) {
  return /* @__PURE__ */ jsx56("p", { className: `np-text-body-large ${getTextAlignmentAndMargin(component)}`, children: component.text });
}
function CopyableDynamicParagraph({ component }) {
  const { formatMessage } = useIntl13();
  const createSnackbar = useSnackBarIfAvailable();
  const { text } = component;
  const copy = () => {
    var _a;
    (_a = navigator.clipboard) == null ? void 0 : _a.writeText(text).then(() => createSnackbar({ text: formatMessage(paragraph_messages_default.copied) })).catch(noop4);
  };
  const classNames11 = `${getTextAlignmentAndMargin({
    align: component.align,
    margin: "sm"
  })} form-control`;
  return /* @__PURE__ */ jsxs18("div", { className: getTextAlignmentAndMargin(component), children: [
    /* @__PURE__ */ jsx56(
      "input",
      {
        type: "text",
        className: classNames11,
        value: text,
        readOnly: true,
        style: { textOverflow: "ellipsis" }
      }
    ),
    /* @__PURE__ */ jsx56(Button3, { block: true, onClick: copy, children: formatMessage(paragraph_messages_default.copy) })
  ] });
}
function noop4() {
}
var DynamicParagraph_default = DynamicParagraph;

// src/legacy/layout/review/DynamicReview.tsx
import { DefinitionList as DefinitionList2, Header as Header8 } from "@transferwise/components";
import { Fragment as Fragment14, jsx as jsx57, jsxs as jsxs19 } from "react/jsx-runtime";
var getDefinitions = (orientation, review) => review.fields.map(({ label, value, help }, index) => ({
  key: String(index),
  title: label,
  value: getFieldValue(value, help, orientation)
}));
var getFieldValue = (value, help, orientation) => {
  if (help) {
    return orientation === "HORIZONTAL_RIGHT_ALIGNED" ? /* @__PURE__ */ jsxs19(Fragment14, { children: [
      /* @__PURE__ */ jsx57(Help_default, { help }),
      " ",
      value
    ] }) : /* @__PURE__ */ jsxs19(Fragment14, { children: [
      value,
      " ",
      /* @__PURE__ */ jsx57(Help_default, { help })
    ] });
  }
  return value;
};
var getDefinitionListLayout = (review) => {
  const orientation = review.control || review.orientation;
  switch (orientation) {
    case "horizontal":
    case "horizontal-end-aligned":
      return "HORIZONTAL_RIGHT_ALIGNED";
    case "horizontal-start-aligned":
      return "HORIZONTAL_LEFT_ALIGNED";
    case "vertical-two-column":
      return "VERTICAL_TWO_COLUMN";
    case "vertical":
    case "vertical-one-column":
    default:
      return "VERTICAL_ONE_COLUMN";
  }
};
function DynamicReview({ component: review, onAction }) {
  var _a, _b;
  const margin = getMargin(review.margin || "xs");
  const getReviewAction2 = (callToAction2) => {
    const { title, action, behavior } = callToAction2;
    if (behavior) {
      if ("type" in behavior) {
        switch (behavior.type) {
          case "action": {
            const { action: behaviorAction2 } = behavior;
            return {
              text: title != null ? title : "",
              onClick: behaviorAction2 ? getOnClick(behaviorAction2) : void 0
            };
          }
          case "link": {
            return {
              text: title != null ? title : "",
              href: behavior.url
            };
          }
        }
      }
      const { action: behaviorAction, link } = behavior;
      if (behaviorAction) {
        return {
          text: title != null ? title : "",
          onClick: behaviorAction ? getOnClick(behaviorAction) : void 0
        };
      }
      if (link) {
        return {
          text: title != null ? title : "",
          href: link == null ? void 0 : link.url
        };
      }
    }
    return {
      text: title != null ? title : "",
      onClick: action ? getOnClick(action) : void 0
    };
  };
  const getOnClick = (action) => {
    return (event) => {
      event.preventDefault();
      if (action) {
        onAction(action);
      }
    };
  };
  const orientation = getDefinitionListLayout(review);
  const callToAction = review.callToAction ? getReviewAction2(review.callToAction) : null;
  const legacyCallToAction = !callToAction && review.action ? { text: (_a = review.action.title) != null ? _a : "", onClick: getOnClick(review.action) } : null;
  return /* @__PURE__ */ jsxs19("div", { className: margin, children: [
    review.title && /* @__PURE__ */ jsx57(Header8, { title: review.title, action: (_b = callToAction != null ? callToAction : legacyCallToAction) != null ? _b : void 0 }),
    /* @__PURE__ */ jsx57("div", { className: margin, children: /* @__PURE__ */ jsx57(DefinitionList2, { layout: orientation, definitions: getDefinitions(orientation, review) }) })
  ] });
}
var DynamicReview_default = DynamicReview;

// src/legacy/layout/search/DynamicSearch.tsx
import { useMemo as useMemo15, useState as useState16 } from "react";
import { Search } from "@transferwise/icons";

// src/legacy/layout/search/SearchInput.tsx
import { Input } from "@transferwise/components";
import { jsx as jsx58, jsxs as jsxs20 } from "react/jsx-runtime";
var SearchInput = ({ title, value, onFocus, onChange }) => {
  return /* @__PURE__ */ jsxs20("label", { className: "control-label d-inline", children: [
    title,
    /* @__PURE__ */ jsx58(
      Input,
      {
        type: "text",
        value,
        className: "m-t-1",
        onFocus,
        onChange: (event) => onChange(event.currentTarget.value)
      }
    )
  ] });
};

// src/legacy/layout/search/SearchResults.tsx
import { NavigationOption as NavigationOption4, NavigationOptionsList as NavigationOptionsList2 } from "@transferwise/components";
import { useIntl as useIntl14 } from "react-intl";
import { jsx as jsx59, jsxs as jsxs21 } from "react/jsx-runtime";
function SearchResults({ results, emptyMessage, onSelect }) {
  if (results.length === 0) {
    return /* @__PURE__ */ jsx59("p", { className: "m-t-2", children: emptyMessage });
  }
  return /* @__PURE__ */ jsx59(NavigationOptionsList2, { children: results.map((result) => /* @__PURE__ */ jsx59(
    NavigationOption4,
    {
      title: result.title,
      content: result.description,
      media: getNavigationOptionMedia(result),
      showMediaCircle: false,
      showMediaAtAllSizes: true,
      onClick: () => onSelect(result)
    },
    JSON.stringify(result)
  )) });
}
function ErrorResult({ onRetrySearch }) {
  const intl = useIntl14();
  return /* @__PURE__ */ jsxs21("p", { className: "m-t-2", children: [
    intl.formatMessage(generic_error_messages_default.genericError),
    "\xA0",
    /* @__PURE__ */ jsx59(
      "a",
      {
        href: "/",
        onClick: (e) => {
          e.preventDefault();
          onRetrySearch();
        },
        children: intl.formatMessage(generic_error_messages_default.retry)
      }
    )
  ] });
}

// src/legacy/layout/search/useSearch.tsx
import { useCallback as useCallback7, useRef as useRef4, useState as useState15 } from "react";
var headers = { "Content-Type": "application/json" };
var useSearch = (defaultSearchConfig) => {
  const [state, setState] = useState15({
    status: "idle"
  });
  const abortControllerRef = useRef4(null);
  const httpClient = useHttpClient();
  const search = useCallback7(
    async (query, { url, method, param } = defaultSearchConfig) => {
      var _a;
      (_a = abortControllerRef.current) == null ? void 0 : _a.abort();
      if (!query) {
        setState({ status: "idle" });
        return;
      }
      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;
      setState({ status: "loading" });
      try {
        const request = method === "GET" ? httpClient(addQueryParameter2(url, param, query), {
          method,
          signal,
          headers
        }) : httpClient(url, {
          method,
          signal,
          headers,
          body: JSON.stringify({ [param]: query })
        });
        const response = await request;
        void handleResponse(response, query);
      } catch (error) {
        handleError(error, query);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [httpClient, JSON.stringify(defaultSearchConfig)]
  );
  const handleResponse = async (response, query) => {
    if (response.ok) {
      const body = await response.json().catch(() => null);
      if (isValidResponseBody2(body)) {
        setState({ status: "success", results: body.results });
        return;
      }
    }
    setState({ status: "error" });
  };
  const handleError = (error, query) => {
    if (!isAbortError(error)) {
      setState({ status: "error" });
    }
  };
  const results = state.status === "success" ? state.results : [];
  return { status: state.status, results, search };
};
var isValidResponseBody2 = (body) => isObject2(body) && "results" in body && isArray2(body.results) && body.results.every(
  (result) => isObject2(result) && "title" in result && "type" in result && "value" in result
);
var isAbortError = (error) => error instanceof DOMException && error.name === "AbortError";
var addQueryParameter2 = (url, key, value) => {
  const [urlBase, urlQuery] = url.split("?");
  const urlQueryParams = new URLSearchParams(urlQuery);
  urlQueryParams.set(key, value);
  return `${urlBase}?${urlQueryParams.toString()}`;
};

// src/legacy/layout/search/DynamicSearch.tsx
import { Markdown as Markdown3, Typeahead } from "@transferwise/components";
import classNames9 from "classnames";
import { useIntl as useIntl15 } from "react-intl";

// src/common/messages/search.messages.ts
import { defineMessages as defineMessages13 } from "react-intl";
var search_messages_default = defineMessages13({
  loading: {
    id: "dynamicFlows.SearchLayout.loading",
    defaultMessage: "Loading...",
    description: "A message shown to the user while their search is being processed, before results appear."
  }
});

// src/legacy/layout/search/DynamicSearch.tsx
import { jsx as jsx60, jsxs as jsxs22 } from "react/jsx-runtime";
var DEBOUNCE_TIME2 = 400;
function DynamicSearch({ component, onAction }) {
  const [query, setQuery] = useState16("");
  const intl = useIntl15();
  const { control, title, margin, url, method, param, emptyMessage } = component;
  const { status, results, search } = useSearch({ url, method, param });
  const onEvent = useEventDispatcher();
  const debouncedSearch = useMemo15(() => debounce2(search, DEBOUNCE_TIME2), [search]);
  const onSearchStart = () => {
    onEvent("Dynamic Flow - Search Started", {});
  };
  const onChange = (value) => {
    setQuery(value);
    debouncedSearch(value.trim());
  };
  const onResultSelected = ({ type, value }) => {
    if (type === "action") {
      setQuery("");
      onEvent("Dynamic Flow - Search Result Selected", {
        type: "action",
        actionId: value.id || value.$id
      });
      onAction(value);
    }
    if (type === "search") {
      setQuery(value.query);
      const { url: url2, method: method2, param: param2, query: query2 } = value;
      onEvent("Dynamic Flow - Search Result Selected", { type: "search" });
      void search(query2.trim(), { url: url2, method: method2, param: param2 });
    }
  };
  const onRetrySearch = () => {
    setQuery(query);
    void search(query);
  };
  const loadingMessage = intl.formatMessage(search_messages_default.loading);
  if (control === "inline") {
    return /* @__PURE__ */ jsx60("div", { className: classNames9(getMargin(margin != null ? margin : "md"), "df-search-typeahead"), children: /* @__PURE__ */ jsxs22("label", { className: "control-label d-inline", children: [
      title,
      /* @__PURE__ */ jsx60("div", { className: "m-t-1", children: /* @__PURE__ */ jsx60(
        Typeahead,
        {
          id: "typeahead-input-id",
          intl,
          name: "typeahead-input-name",
          size: "md",
          maxHeight: 100,
          footer: /* @__PURE__ */ jsx60(
            TypeaheadFooter,
            {
              state: status,
              results,
              emptyMessage,
              loadingMessage,
              onRetrySearch
            }
          ),
          multiple: false,
          clearable: false,
          addon: /* @__PURE__ */ jsx60(Search, { size: 24 }),
          options: results.map(mapResultToTypeaheadOption),
          onChange: (values) => {
            if (values.length > 0) {
              const [updatedValue] = values;
              if (updatedValue.value) {
                onResultSelected(updatedValue.value);
              }
            }
          },
          onInputChange: onChange
        }
      ) })
    ] }) });
  }
  return /* @__PURE__ */ jsxs22("div", { className: getMargin(margin != null ? margin : "md"), children: [
    /* @__PURE__ */ jsx60(SearchInput, { title, value: query, onChange, onFocus: onSearchStart }),
    status === "loading" && /* @__PURE__ */ jsx60(DynamicLoadingIndicator_default, { component: { type: "loading-indicator", size: "sm" } }),
    status === "error" && /* @__PURE__ */ jsx60(ErrorResult, { onRetrySearch }),
    status === "success" && /* @__PURE__ */ jsx60(SearchResults, { results, emptyMessage, onSelect: onResultSelected })
  ] });
}
function mapResultToTypeaheadOption(result) {
  return {
    label: result.title,
    secondary: result.description,
    value: result,
    clearQueryOnSelect: result.type === "action",
    keepFocusOnSelect: result.type === "search"
  };
}
function TypeaheadFooter({
  emptyMessage,
  loadingMessage,
  results,
  state,
  onRetrySearch
}) {
  if (state === "success" && results.length === 0) {
    return /* @__PURE__ */ jsx60(Markdown3, { className: "m-t-2 m-x-2", config: { link: { target: "_blank" } }, children: emptyMessage });
  }
  if (state === "error" && results.length === 0) {
    return /* @__PURE__ */ jsx60("div", { className: "m-t-2 m-x-2", children: /* @__PURE__ */ jsx60(ErrorResult, { onRetrySearch }) });
  }
  if (state === "loading" || results.length === 0) {
    return /* @__PURE__ */ jsx60("p", { className: "m-t-2 m-x-2", children: loadingMessage });
  }
  return null;
}
var DynamicSearch_default = DynamicSearch;

// src/legacy/layout/modal/DynamicModal.tsx
import { Button as Button4, Modal as Modal2 } from "@transferwise/components";
import { useState as useState17 } from "react";
import { jsx as jsx61, jsxs as jsxs23 } from "react/jsx-runtime";
function DynamicModal(props) {
  const [visible, isVisible] = useState17(false);
  const { component, onAction } = props;
  const { margin = "md" } = component;
  return /* @__PURE__ */ jsxs23("div", { className: getTextAlignmentAndMargin({ margin }), children: [
    /* @__PURE__ */ jsx61(Button4, { priority: "tertiary", block: true, onClick: () => isVisible(true), children: component.trigger.title }),
    /* @__PURE__ */ jsx61(
      Modal2,
      {
        scroll: "content",
        open: visible,
        size: "lg",
        title: component.content.title,
        body: /* @__PURE__ */ jsx61(
          DynamicLayout_default,
          __spreadProps(__spreadValues({}, props), {
            components: component.content.components,
            onAction: (action) => {
              isVisible(false);
              onAction(action);
            }
          })
        ),
        onClose: () => isVisible(false)
      }
    )
  ] });
}
var DynamicModal_default = DynamicModal;

// src/legacy/jsonSchemaForm/basicTypeSchema/BasicTypeSchema.tsx
import { Fragment as Fragment15, jsx as jsx62, jsxs as jsxs24 } from "react/jsx-runtime";
var isNullish2 = (value) => isNull2(value) || isUndefined2(value);
var getDefaultValue = (schema) => {
  return schema.type === "boolean" && isNullish2(schema.default) ? false : schema.default;
};
var BasicTypeSchema = (props) => {
  var _a, _b, _c;
  const { disabled = false, required = false } = props;
  const onChange = (newModel, _type, metadata) => {
    setChanged(true);
    setModelAndBroadcast(sanitiseModel(newModel), "user", metadata);
  };
  const getValidationKeys = (newModel) => getValidationFailures(newModel, props.schema, required);
  const setModelAndBroadcast = (newModel, type, metadata) => {
    setModel(newModel);
    const validationKeys = getValidationKeys(newModel);
    setValidations(validationKeys);
    const broadcastModel = newModel;
    setLastModel(broadcastModel);
    if (broadcastModel !== lastModel) {
      props.onChange({
        model: broadcastModel,
        triggerSchema: props.schema,
        triggerModel: broadcastModel,
        lastTriggerModel: lastModel,
        type,
        metadata
      });
    }
  };
  const sanitiseModel = (newModel) => getValidBasicModelOrNull(newModel, props.schema);
  const onFocus = () => setFocused(true);
  const onBlur = () => {
    setFocused(false);
    setBlurred(true);
    if (props.onBlur) {
      props.onBlur();
    }
  };
  const [model, setModel] = useState18((_a = props.model) != null ? _a : null);
  const [lastModel, setLastModel] = useState18((_b = props.model) != null ? _b : null);
  const [changed, setChanged] = useState18(false);
  const [focused, setFocused] = useState18(false);
  const [blurred, setBlurred] = useState18(false);
  const [validations, setValidations] = useState18([]);
  const id = useMemo16(() => props.schema.$id || generateRandomId(), [props.schema.$id]);
  const onSchemaChange = () => {
    const defaultValue = getDefaultValue(props.schema);
    if (isNullish2(model) && !isNullish2(defaultValue)) {
      setModelAndBroadcast(defaultValue, "init");
    }
    if (props.schema.const) {
      setModelAndBroadcast(props.schema.const, "init");
    }
  };
  const refreshValidations = () => {
    setValidations(getValidationKeys(model));
  };
  const isConst = props.schema.const;
  const isHidden = props.schema.hidden || isConst;
  useEffect13(refreshValidations, [props.model, props.submitted]);
  useEffect13(onSchemaChange, [props.schema]);
  useEffect13(() => {
    var _a2;
    const newModel = (_a2 = props.model) != null ? _a2 : null;
    if (newModel !== model) {
      setModel(newModel);
    }
  }, [props.model]);
  const formGroupClasses = {
    "form-group": true,
    "has-error": (props.submitted || !changed) && !!props.errors || (props.submitted || changed && blurred) && !!validations.length,
    "has-info": !!props.schema.description || !!props.infoMessage
  };
  const showLabel = props.schema.format !== "file" && props.schema.type !== "boolean";
  const schemaHelp = props.schema.help;
  const feedbackId = `${id}-feedback`;
  const labelId = `${id}-label`;
  return !isHidden ? /* @__PURE__ */ jsxs24(Fragment15, { children: [
    props.schema.alert && /* @__PURE__ */ jsx62(DynamicAlert_default, { component: props.schema.alert }),
    /* @__PURE__ */ jsxs24("div", { className: classNames10(formGroupClasses), children: [
      showLabel && /* @__PURE__ */ jsxs24("div", { className: "d-inline-block m-b-1", children: [
        /* @__PURE__ */ jsx62("label", { className: "control-label d-inline", htmlFor: id, id: labelId, children: props.schema.title }),
        !!schemaHelp && /* @__PURE__ */ jsx62(Help_default, { help: schemaHelp })
      ] }),
      !showLabel && !!schemaHelp && /* @__PURE__ */ jsx62(Help_default, { help: schemaHelp }),
      /* @__PURE__ */ jsx62(
        SchemaFormControl_default,
        {
          id,
          schema: props.schema,
          value: model,
          disabled: !!disabled,
          onChange,
          onFocus,
          onBlur,
          describedBy: feedbackId,
          labelledBy: labelId
        }
      ),
      /* @__PURE__ */ jsx62(
        ControlFeedback_default,
        {
          id: feedbackId,
          changed,
          focused,
          blurred,
          submitted: props.submitted,
          errors: (_c = props.errors) != null ? _c : null,
          schema: props.schema,
          validations,
          infoMessage: props.infoMessage
        }
      )
    ] })
  ] }) : null;
};
var BasicTypeSchema_default = BasicTypeSchema;

// src/legacy/jsonSchemaForm/persistAsyncSchema/persistAsyncBasicSchema/PersistAsyncBasicSchema.tsx
import { jsx as jsx63 } from "react/jsx-runtime";
var getIdFromResponse = (idProperty, response) => response[idProperty];
var getErrorFromResponse = (errorProperty, response) => {
  var _a;
  return (_a = response.validation) == null ? void 0 : _a[errorProperty];
};
var controlTypesWithPersistOnChange = /* @__PURE__ */ new Set([
  FormControlType.RADIO,
  FormControlType.SELECT,
  FormControlType.DATELOOKUP,
  FormControlType.FILE,
  FormControlType.UPLOAD
]);
function PersistAsyncBasicSchema(props) {
  const { schema, required = false, submitted, errors, onChange, onPersistAsync } = props;
  const intl = useIntl16();
  const httpClient = useHttpClient();
  const onEvent = useEventDispatcher();
  const [persistAsyncModel, setPersistAsyncModel] = useState19(null);
  const previousPersistAsyncModel = usePrevious(persistAsyncModel);
  const [persistAsyncError, setPersistAsyncError] = useState19(null);
  const [fieldSubmitted, setFieldSubmitted] = useState19(false);
  const [abortController, setAbortController] = useState19(null);
  useEffect14(() => {
    if (controlTypesWithPersistOnChange.has(
      // TODO: LOW avoid type assertion below -- control type may be nullish. consider ?? ''
      getControlType(schema.persistAsync.schema)
    )) {
      persistAsyncIfValid();
    }
  }, [persistAsyncModel]);
  const setGenericPersistAsyncError = () => setPersistAsyncError(intl.formatMessage(generic_error_messages_default.genericErrorRetryHint));
  const getPersistAsyncResponse = async (currentPersistAsyncModel, persistAsyncSpec) => {
    const signal = abortCurrentRequestAndGetNewAbortSignal();
    const requestBody = { [persistAsyncSpec.param]: currentPersistAsyncModel };
    setFieldSubmitted(true);
    try {
      onEvent("Dynamic Flow - PersistAsync", { status: "pending", schemaId: schema.$id });
      const persistAsyncFetch = httpClient(persistAsyncSpec.url, {
        method: persistAsyncSpec.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
        signal
      });
      onPersistAsync(persistAsyncFetch);
      const response = await persistAsyncFetch;
      const responseBody = await response.json();
      if (!isObject2(responseBody)) {
        throw new Error("Response is not an object");
      }
      const { idProperty, param } = schema.persistAsync;
      if (isStatus2xx(response.status)) {
        const id = getIdFromResponse(idProperty, responseBody);
        onChange({ model: id, triggerSchema: schema, triggerModel: id });
      } else if (!response.ok) {
        const { validation } = responseBody;
        const error = isObject2(validation) && (validation == null ? void 0 : validation[param]) || null;
        setPersistAsyncError(error);
        onChange({ model: null, triggerSchema: schema, triggerModel: null });
      } else {
        setGenericPersistAsyncError();
      }
      onEvent("Dynamic Flow - PersistAsync", { status: "success", schemaId: schema.$id });
    } catch (e) {
      onEvent("Dynamic Flow - PersistAsync", { status: "failure", schemaId: schema.$id });
      setGenericPersistAsyncError();
    }
  };
  const abortCurrentRequestAndGetNewAbortSignal = () => {
    if (abortController) {
      abortController.abort();
    }
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    return newAbortController.signal;
  };
  const persistAsyncIfValid = () => {
    if (!isNull2(persistAsyncModel) && !isEqual(persistAsyncModel, previousPersistAsyncModel)) {
      void getPersistAsyncResponse(persistAsyncModel, schema.persistAsync);
    }
  };
  const onBlur = () => {
    persistAsyncIfValid();
  };
  const persistAsyncOnChange = ({ model: newPersistAsyncModel }) => {
    setPersistAsyncError(null);
    if (isValidSchema(newPersistAsyncModel, schema.persistAsync.schema)) {
      setPersistAsyncModel(newPersistAsyncModel);
    }
  };
  return /* @__PURE__ */ jsx63(
    BasicTypeSchema_default,
    {
      required,
      submitted: submitted || fieldSubmitted,
      schema: schema.persistAsync.schema,
      errors: persistAsyncError || errors,
      model: null,
      infoMessage: null,
      onChange: persistAsyncOnChange,
      onBlur
    }
  );
}
var PersistAsyncBasicSchema_default = PersistAsyncBasicSchema;

// src/legacy/common/hooks/usePersistAsync/usePersistAsync.ts
var usePersistAsync = (persistAsync) => {
  const [abortController, setAbortController] = useState20(null);
  const httpClient = useHttpClient();
  const intl = useIntl17();
  const { schema } = persistAsync;
  async function handlePersistAsync(model) {
    const isInvalidSchema = model instanceof Blob ? !isBlobSchema2(schema) : !isValidSchema(model, schema);
    if (isNull2(model) || isInvalidSchema) {
      handleError();
    }
    return await performPersistAsync(model);
  }
  const abortCurrentRequestAndGetNewAbortSignal = () => {
    if (abortController) {
      abortController.abort();
    }
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    return newAbortController.signal;
  };
  function constructFetchInit(model) {
    const isBlob = isBlobSchema2(schema);
    const signal = abortCurrentRequestAndGetNewAbortSignal();
    const requestKey = persistAsync.param;
    const requestBody = isBlob ? wrapInFormData2(requestKey, model) : JSON.stringify({ [requestKey]: model });
    return {
      method: persistAsync.method,
      headers: __spreadValues({}, !isBlob && { "Content-Type": "application/json" }),
      body: requestBody,
      signal
    };
  }
  async function performPersistAsync(payload) {
    try {
      const response = await httpClient(persistAsync.url, constructFetchInit(payload));
      if (!response.ok) {
        return handleHTTPError(response);
      }
      const jsonResponse = await response.json();
      if (isObject2(jsonResponse)) {
        const id = jsonResponse[persistAsync.idProperty];
        if (isString2(id) || isNumber2(id)) {
          return { data: id };
        }
      }
      return handleError();
    } catch (error) {
      return handleError(error);
    }
  }
  async function handleHTTPError(response) {
    const jsonResponse = await response.json();
    if (isObject2(jsonResponse)) {
      const error = getErrorFromResponse(persistAsync.param, jsonResponse);
      if (isString2(error)) {
        throw new Error(error);
      }
    }
    throw new Error(intl.formatMessage(generic_error_messages_default.genericErrorRetryHint));
  }
  const handleError = (error) => {
    const message = hasStringMessage(error) ? error.message : intl.formatMessage(generic_error_messages_default.genericErrorRetryHint);
    throw new Error(message);
  };
  return handlePersistAsync;
};
function wrapInFormData2(key, value) {
  const formData = new FormData();
  if (value !== null) {
    formData.append(key, value);
  }
  return formData;
}
function hasStringMessage(value) {
  return isObject2(value) && "message" in value && typeof value.message === "string";
}

// src/legacy/common/hooks/usePolling/usePolling.tsx
import { useEffect as useEffect15, useMemo as useMemo17, useRef as useRef5 } from "react";
function usePolling({
  asyncFn,
  delay,
  maxAttempts,
  maxConsecutiveFails,
  onPollingResponse,
  onFailure
}) {
  const onPollingResponseReference = useRef5(onPollingResponse);
  const onFailureReference = useRef5(onFailure);
  const poll = useMemo17(
    () => createPollingClosure(
      asyncFn,
      maxAttempts,
      maxConsecutiveFails,
      (pollingResponse) => onPollingResponseReference.current(pollingResponse),
      () => onFailureReference.current()
    ),
    [asyncFn, maxAttempts, maxConsecutiveFails]
  );
  useEffect15(() => {
    if (delay > 0) {
      poll();
      const intervalReference = setInterval(() => {
        poll();
      }, delay);
      return () => clearInterval(intervalReference);
    }
  }, [poll, delay]);
  useEffect15(() => {
    onPollingResponseReference.current = onPollingResponse;
    onFailureReference.current = onFailure;
  }, [onPollingResponse, onFailure]);
}
function createPollingClosure(asyncFn, maxAttempts, maxConsecutiveFails, onPollingResponse, onFailure) {
  let isPolling = true;
  let consecutiveFailures = 0;
  let attemptCount = 0;
  return asyncFn ? () => {
    if (isPolling) {
      attemptCount++;
      asyncFn().then((pollingResponse) => {
        consecutiveFailures = 0;
        isPolling = onPollingResponse(pollingResponse);
      }).catch((error) => {
        if (error.message !== "network failed") {
          consecutiveFailures += 1;
        }
      }).finally(() => {
        if (consecutiveFailures >= maxConsecutiveFails || attemptCount >= maxAttempts) {
          onFailure();
          isPolling = false;
        }
      });
    }
  } : () => {
  };
}

// src/legacy/common/hooks/usePrevious/usePrevious.js
import { useEffect as useEffect16, useRef as useRef6 } from "react";
var usePrevious = (value) => {
  const reference = useRef6();
  useEffect16(() => {
    reference.current = value;
  }, [value]);
  return reference.current;
};

// src/legacy/common/hooks/useStepPolling/useStepPolling.tsx
import { useCallback as useCallback8, useMemo as useMemo18 } from "react";
function useStepPolling(polling, onAction) {
  var _a, _b;
  const httpClient = useHttpClient();
  const onEvent = useEventDispatcher();
  const asyncFn = useMemo18(() => {
    if (polling) {
      return () => httpClient(polling.url).then((response) => {
        if (response.ok) {
          return response.json().then((pollingResponse) => pollingResponse).catch(() => null);
        }
        onEvent("Dynamic Flow - Polling Failed", {
          url: polling.url,
          statusCode: response.status,
          variant: "legacy"
        });
        throw new Error("failed");
      }).catch((error) => {
        throw new Error(error.message === "failed" ? "failed" : "network failed");
      });
    }
    return void 0;
  }, [polling, httpClient]);
  const onPollingResponse = useCallback8(
    (pollingResponse) => {
      if (pollingResponse == null ? void 0 : pollingResponse.action) {
        onAction(pollingResponse.action);
        return false;
      }
      return true;
    },
    [onAction]
  );
  usePolling({
    asyncFn,
    delay: 1e3 * ((_b = (_a = polling == null ? void 0 : polling.delay) != null ? _a : polling == null ? void 0 : polling.interval) != null ? _b : 0),
    maxAttempts: (polling == null ? void 0 : polling.maxAttempts) || 0,
    maxConsecutiveFails: 1,
    onPollingResponse,
    onFailure: useCallback8(() => {
      if (polling) {
        onAction(polling.onError.action);
      }
    }, [onAction, polling])
  });
}

// src/legacy/step/layoutStep/LayoutStep.tsx
import { jsx as jsx64 } from "react/jsx-runtime";
var getComponents = (step, options) => {
  var _a;
  if (isEmpty(step)) {
    return [];
  }
  const layout = convertStepToLayout(step, options);
  return inlineReferences({
    layout,
    schemas: step.schemas || [],
    actions: step.actions || [],
    model: (_a = step.model) != null ? _a : null
  });
};
var LayoutStep = (props) => {
  const { stepSpecification, stepLayoutOptions, submitted, model, formErrors, onModelChange } = props;
  const components = getComponents(stepSpecification, stepLayoutOptions);
  const { loading, registerPersistAsyncPromise } = useDynamicFlow();
  const onEvent = useEventDispatcher();
  const onAction = !loading ? props.onAction : () => {
    onEvent("Dynamic Flow - onAction supressed", { reason: "LayoutStep - loading state" });
  };
  useStepPolling(stepSpecification.polling, onAction);
  return /* @__PURE__ */ jsx64(
    DynamicLayout_default,
    {
      components,
      submitted,
      model,
      errors: formErrors,
      onAction,
      onModelChange,
      onPersistAsync: registerPersistAsyncPromise
    }
  );
};
var LayoutStep_default = LayoutStep;

// src/legacy/step/cameraStep/CameraStep.tsx
import { useEffect as useEffect21, useState as useState23 } from "react";

// src/common/cameraCapture/CameraCapture.tsx
import { useCallback as useCallback10, useEffect as useEffect20, useMemo as useMemo19, useRef as useRef8, useState as useState22 } from "react";
import { useIntl as useIntl20 } from "react-intl";
import Webcam from "react-webcam";

// src/common/cameraCapture/CameraCapture.messages.ts
import { defineMessages as defineMessages14 } from "react-intl";
var CameraCapture_messages_default = defineMessages14({
  reviewSubmit: {
    id: "dynamicFlows.CameraCapture.reviewSubmit",
    defaultMessage: "Yes, submit",
    description: "Accept and submit the image taken with the camera"
  },
  reviewRetry: {
    id: "dynamicFlows.CameraCapture.reviewRetry",
    defaultMessage: "No, try again",
    description: "Image taken with camera is not good, don't submit, and retake the image"
  },
  reviewInstructions: {
    id: "dynamicFlows.CameraCapture.reviewInstructions",
    defaultMessage: "Is your picture clear, readable and complete?",
    description: "After taking an image with the camera, prompt user to review the image"
  },
  cameraNotSupportedTitle: {
    id: "dynamicFlows.CameraCapture.CameraNotSupported.title",
    defaultMessage: "Camera not supported",
    description: "Title of standalone page prompting that camera is not available on users browser"
  },
  cameraNotSupportedParagraph: {
    id: "dynamicFlows.CameraCapture.CameraNotSupported.paragraph",
    defaultMessage: "The browser you're using doesn't have support for a camera. Try a different browser, device, or download our mobile app.",
    description: "Further text of standalone page prompting that camera is not available on user's browser"
  },
  noCameraAccessTitle: {
    id: "dynamicFlows.CameraCapture.NoCameraAccess.title",
    defaultMessage: "We can't access your camera",
    description: "Title of standalone page prompting missing camera permissions"
  },
  noCameraAccessParagraph: {
    id: "dynamicFlows.CameraCapture.NoCameraAccess.paragraph",
    defaultMessage: "Enable camera access in your browser's settings to get going again.",
    description: "Further text of standalone page prompting missing camera permissions"
  },
  noCameraAccessAction: {
    id: "dynamicFlows.CameraCapture.NoCameraAccess.action",
    defaultMessage: "Enable camera access",
    description: "Action to ask for camera permissions again"
  },
  cameraConnectionIssueTitle: {
    id: "dynamicFlows.CameraCapture.CameraConnectionIssue.title",
    defaultMessage: "We can't access your camera",
    description: "Title of standalone page prompting that there was an issue connecting to a camera"
  },
  cameraConnectionIssueParagraph: {
    id: "dynamicFlows.CameraCapture.CameraConnectionIssue.paragraph",
    defaultMessage: "Please check if it is connected and try again.",
    description: "Further text of standalone page prompting that there was an issue connecting to a camera"
  },
  cameraConnectionIssueAction: {
    id: "dynamicFlows.CameraCapture.CameraConnectionIssue.action",
    defaultMessage: "Try again",
    description: "Action to try using camera again"
  }
});

// src/common/cameraCapture/components/bottomBar/BottomBar.tsx
import { Button as Button5, ControlType, Priority, Size as Size3 } from "@transferwise/components";
import { useIntl as useIntl18 } from "react-intl";
import { jsx as jsx65, jsxs as jsxs25 } from "react/jsx-runtime";
var CaptureBottomBar = ({ onCapture }) => /* @__PURE__ */ jsx65("div", { className: "bottom-bar", children: /* @__PURE__ */ jsx65(CaptureButton, { onClick: onCapture }) });
var ReviewBottomBar = ({
  onSubmit,
  onRetry
}) => {
  const intl = useIntl18();
  return /* @__PURE__ */ jsx65("div", { className: "bottom-bar p-x-2", children: /* @__PURE__ */ jsx65("div", { className: "row", children: /* @__PURE__ */ jsxs25("div", { className: "col-xs-12 col-md-6 col-md-offset-3", children: [
    /* @__PURE__ */ jsx65(
      Button5,
      {
        className: "m-b-1",
        block: true,
        size: Size3.MEDIUM,
        type: ControlType.ACCENT,
        onClick: onSubmit,
        children: intl.formatMessage(CameraCapture_messages_default.reviewSubmit)
      }
    ),
    /* @__PURE__ */ jsx65(
      Button5,
      {
        className: "m-b-2",
        block: true,
        size: Size3.MEDIUM,
        type: ControlType.ACCENT,
        priority: Priority.SECONDARY,
        onClick: onRetry,
        children: intl.formatMessage(CameraCapture_messages_default.reviewRetry)
      }
    )
  ] }) }) });
};
var CaptureButton = ({ onClick }) => /* @__PURE__ */ jsx65(
  "button",
  {
    type: "button",
    className: "camera-capture-btn m-b-2",
    "data-testid": "camera-capture-button",
    onClick,
    children: /* @__PURE__ */ jsx65("span", { className: "camera-capture-btn-inner" })
  }
);

// src/common/cameraCapture/components/orientationLockOverlay/OrientationLockOverlay.tsx
import { useIntl as useIntl19 } from "react-intl";

// src/common/cameraCapture/components/orientationLockOverlay/OrientationLockOverlay.messages.ts
import { defineMessages as defineMessages15 } from "react-intl";
var OrientationLockOverlay_messages_default = defineMessages15({
  text: {
    id: "dynamicFlows.CameraCapture.rotatePhone.text",
    defaultMessage: "Rotate your phone to portrait view to take a photo",
    description: "Prompt the user to rotate their phone from landscape to portrait mode when attempting to take a photo"
  }
});

// src/common/cameraCapture/components/orientationLockOverlay/OrientationLockOverlay.tsx
import { jsx as jsx66, jsxs as jsxs26 } from "react/jsx-runtime";
function OrientationLockOverlay() {
  const intl = useIntl19();
  return /* @__PURE__ */ jsxs26("div", { className: "orientation-lock-overlay", children: [
    /* @__PURE__ */ jsx66(
      "img",
      {
        className: "m-b-3",
        src: "https://wise.com/public-resources/assets/camera-guidelines/icon-rotate-phone.svg",
        width: "96",
        height: "96",
        alt: ""
      }
    ),
    /* @__PURE__ */ jsx66("p", { className: "text-center m-b-0", children: intl.formatMessage(OrientationLockOverlay_messages_default.text) })
  ] });
}
var OrientationLockOverlay_default = OrientationLockOverlay;

// src/common/cameraCapture/hooks/useFullScreenOrientationLock.ts
import { useCallback as useCallback9, useEffect as useEffect17 } from "react";
import screenfull from "screenfull";

// src/common/cameraCapture/utils/index.ts
var isSelfieCamera = (stream) => {
  var _a;
  const { facingMode } = ((_a = getVideoTrack(stream)) == null ? void 0 : _a.getSettings()) || {};
  return facingMode === "user" || facingMode === void 0;
};
var isMainBackCamera = (deviceInfo) => !!((deviceInfo == null ? void 0 : deviceInfo.label) || "").match(/camera2? 0/g);
var generateCanvasFromVideo = async (video) => {
  const canvas = document.createElement("canvas");
  if (video) {
    canvas.setAttribute("height", `${video.videoHeight}`);
    canvas.setAttribute("width", `${video.videoWidth}`);
    const context = canvas == null ? void 0 : canvas.getContext("2d");
    if (context) {
      await new Promise((resolve) => {
        setTimeout(resolve, 100);
      });
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
    }
  }
  return canvas;
};
var getAvailableVideoDevices = async () => {
  var _a, _b;
  return (await ((_b = (_a = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a.enumerateDevices) == null ? void 0 : _b.call(_a)) || []).filter(
    (deviceInfo) => deviceInfo.kind === "videoinput"
  );
};
var getAvailableVideoDeviceLabels = async () => {
  var _a, _b;
  return (await ((_b = (_a = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a.enumerateDevices) == null ? void 0 : _b.call(_a)) || []).filter((deviceInfo) => deviceInfo.kind === "videoinput").map((deviceInfo) => deviceInfo.label);
};
var getActiveVideoDeviceLabel = async (videoStream) => {
  var _a, _b, _c;
  const capabilities = getVideoCapabilities(videoStream);
  return (_c = (await ((_b = (_a = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a.enumerateDevices) == null ? void 0 : _b.call(_a)) || []).filter((deviceInfo) => deviceInfo.kind === "videoinput").find((deviceInfo) => deviceInfo.deviceId === (capabilities == null ? void 0 : capabilities.deviceId))) == null ? void 0 : _c.label;
};
var getVideoTrack = (videoStream) => {
  var _a;
  return (((_a = videoStream == null ? void 0 : videoStream.getVideoTracks) == null ? void 0 : _a.call(videoStream)) || [])[0];
};
var getVideoCapabilities = (videoStream) => {
  var _a, _b;
  return (_b = (_a = getVideoTrack(videoStream)) == null ? void 0 : _a.getCapabilities) == null ? void 0 : _b.call(_a);
};

// src/common/cameraCapture/tracking/index.ts
var trackCameraError = (message, onEvent, error) => onEvent == null ? void 0 : onEvent(message, { Error: getSerializedError(error) });
var getSerializedError = (error) => error instanceof DOMException ? JSON.stringify({
  name: error == null ? void 0 : error.name,
  message: error == null ? void 0 : error.message
}) : error;
var trackCameraFeedStarted = async (onEvent, props, stream) => onEvent == null ? void 0 : onEvent("Dynamic Flow - Camera Feed Started", await getCameraStartedProperties(props, stream));
var getCameraStartedProperties = async (props, videoStream) => {
  var _a;
  const videoTrack = getVideoTrack(videoStream);
  const capabilities = getVideoCapabilities(videoStream);
  const settings = (_a = videoTrack == null ? void 0 : videoTrack.getSettings) == null ? void 0 : _a.call(videoTrack);
  return __spreadProps(__spreadValues({}, videoTrack && {
    "Available Video Devices (by label)": await getAvailableVideoDeviceLabels(),
    "Active Video Device (by label)": await getActiveVideoDeviceLabel(videoStream),
    "Camera Capabilities": capabilities,
    "Camera Settings": settings
  }), {
    "Camera Direction (Asked)": props == null ? void 0 : props.direction
  });
};
var trackCameraOrientationLandscape = (onEvent) => {
  void (onEvent == null ? void 0 : onEvent("Dynamic Flow - Camera Orientation Lock Overlay Shown", {}));
};
var trackCameraOrientationLocked = (onEvent) => {
  void (onEvent == null ? void 0 : onEvent("Dynamic Flow - Camera Orientation Locked", {}));
};

// src/common/cameraCapture/hooks/useFullScreenOrientationLock.ts
var useFullScreenOrientationLock = (shouldLockOrientation, onEvent) => {
  const lockOrientation = useCallback9(() => {
    if (window.screen.orientation && "lock" in window.screen.orientation && typeof window.screen.orientation.lock === "function") {
      const lockPromise = window.screen.orientation.lock("portrait");
      if (lockPromise instanceof Promise) {
        lockPromise.then(() => trackCameraOrientationLocked(onEvent)).catch(noop5);
      }
    }
  }, [onEvent]);
  const unlockOrientation = useCallback9(() => {
    var _a, _b, _c;
    return (_c = (_b = (_a = window == null ? void 0 : window.screen) == null ? void 0 : _a.orientation) == null ? void 0 : _b.unlock) == null ? void 0 : _c.call(_b);
  }, []);
  const enterFullScreen = useCallback9(() => {
    setTimeout(() => {
      if (shouldLockOrientation && !screenfull.isFullscreen && screenfull.isEnabled) {
        screenfull.request(document.documentElement, { navigationUI: "show" }).then(() => {
          lockOrientation();
        }).catch(noop5);
      }
    }, 100);
  }, [shouldLockOrientation, lockOrientation]);
  const exitFullScreen = useCallback9(() => {
    if (screenfull.isFullscreen) {
      screenfull.exit().catch(noop5);
    }
    unlockOrientation();
  }, [unlockOrientation]);
  const handleOrientationChange = useCallback9(
    (event) => {
      var _a, _b;
      if ((_a = event == null ? void 0 : event.target) == null ? void 0 : _a.type.includes("landscape")) {
        if ((_b = window.screen) == null ? void 0 : _b.orientation) {
          trackCameraOrientationLandscape(onEvent);
        }
      }
    },
    [onEvent]
  );
  useEffect17(() => {
    var _a, _b;
    if (shouldLockOrientation) {
      (_b = (_a = window.screen) == null ? void 0 : _a.orientation) == null ? void 0 : _b.addEventListener(
        "change",
        (event) => handleOrientationChange(event)
      );
    }
    return () => {
      var _a2, _b2;
      (_b2 = (_a2 = window.screen) == null ? void 0 : _a2.orientation) == null ? void 0 : _b2.removeEventListener("change", handleOrientationChange);
      exitFullScreen();
    };
  }, [exitFullScreen, handleOrientationChange, shouldLockOrientation]);
  return {
    enterFullScreen,
    exitFullScreen
  };
};
var noop5 = () => {
};

// src/common/cameraCapture/hooks/useVideoConstraints.ts
import { useEffect as useEffect18, useState as useState21 } from "react";
var useVideoConstraints = (direction) => {
  const [videoConstraints, setVideoConstraints] = useState21();
  useEffect18(() => {
    void getVideoConstraints(direction).then(setVideoConstraints);
  }, [direction]);
  return { videoConstraints };
};
var getVideoConstraints = async (dir) => {
  const defaultVideoConstraints = {
    facingMode: dir === "front" ? "user" : "environment",
    height: { min: 480, max: 1080, ideal: 720 },
    width: { min: 640, max: 1920, ideal: 1280 },
    frameRate: 30,
    aspectRatio: 16 / 9
  };
  if (dir === "back") {
    const mainCamera = (await getAvailableVideoDevices()).find(isMainBackCamera);
    if (mainCamera == null ? void 0 : mainCamera.deviceId) {
      return __spreadProps(__spreadValues({}, defaultVideoConstraints), {
        deviceId: { exact: mainCamera.deviceId }
      });
    }
  }
  return defaultVideoConstraints;
};

// src/common/cameraCapture/overlay/Overlay.tsx
import { useEffect as useEffect19, useRef as useRef7 } from "react";
import { Fragment as Fragment16, jsx as jsx67, jsxs as jsxs27 } from "react/jsx-runtime";
var captureButtonHeight = 92;
var reviewButtonsHeight = 120;
var imageHeight = 40;
var titleHeight = 32;
var instructionsHeight = 48;
var reviewInstructionsHeight = 40;
var overlayMaxWidth = 800;
function Overlay({ overlay, outline, imageUrl, title, instructions, reviewInstructions }) {
  const svgReference = useRef7(null);
  useEffect19(() => {
    const listener = debounce2(() => {
      var _a;
      if ((_a = svgReference.current) == null ? void 0 : _a.innerHTML) {
        const reference = svgReference.current;
        reference.innerHTML = String(reference.innerHTML);
      }
    }, 100);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  });
  let helperBoxHeight = (imageUrl ? imageHeight : 0) + (title ? titleHeight : 0) + (instructions ? instructionsHeight : 0);
  let helperBox = /* @__PURE__ */ jsxs27(Fragment16, { children: [
    imageUrl && /* @__PURE__ */ jsx67("img", { className: "camera-capture-img", src: imageUrl, alt: "" }),
    title && /* @__PURE__ */ jsx67("h4", { className: "camera-capture-title", children: title }),
    instructions && /* @__PURE__ */ jsx67("small", { className: "camera-capture-instructions", children: instructions })
  ] });
  const frameBottomMargin = captureButtonHeight + helperBoxHeight;
  if (reviewInstructions) {
    helperBoxHeight = frameBottomMargin - reviewButtonsHeight;
    helperBox = /* @__PURE__ */ jsx67("small", { className: "camera-capture-instructions", children: reviewInstructions });
    const frameWithReviewInstructionsMinBottomMargin = reviewButtonsHeight + reviewInstructionsHeight;
    if (frameBottomMargin < frameWithReviewInstructionsMinBottomMargin) {
      helperBox = /* @__PURE__ */ jsx67(Fragment16, {});
    }
  }
  const framePosition = {
    x: "50%",
    y: "5%",
    width: `min(90%, ${overlayMaxWidth}px)`,
    height: `calc(90% - ${frameBottomMargin}px)`,
    style: { transform: `translateX(max(-45%, -${overlayMaxWidth / 2}px))` }
  };
  const helperBoxPosition = {
    style: {
      left: "5%",
      top: `calc(100% - ${frameBottomMargin}px - 5%)`,
      height: `calc(${helperBoxHeight}px + 5%)`,
      width: "90%"
    }
  };
  return /* @__PURE__ */ jsxs27("svg", { ref: svgReference, xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx67("defs", { children: /* @__PURE__ */ jsxs27("mask", { id: "mask", children: [
      /* @__PURE__ */ jsx67("rect", { width: "100%", height: "100%", fill: "#fff" }),
      /* @__PURE__ */ jsx67("image", __spreadValues({ href: overlay }, framePosition))
    ] }) }),
    overlay && /* @__PURE__ */ jsx67("rect", { width: "100%", height: "100%", mask: "url(#mask)", fillOpacity: "0.72" }),
    outline && /* @__PURE__ */ jsx67("image", __spreadValues({ href: outline }, framePosition)),
    /* @__PURE__ */ jsx67("foreignObject", { width: "100%", height: "100%", children: /* @__PURE__ */ jsx67("div", __spreadProps(__spreadValues({ className: "camera-capture-text-and-image-container" }, helperBoxPosition), { children: helperBox })) })
  ] });
}
var Overlay_default = Overlay;

// src/common/cameraCapture/screens/cameraErrorScreen/CameraErrorScreen.tsx
import { Button as Button6 } from "@transferwise/components";
import { jsx as jsx68, jsxs as jsxs28 } from "react/jsx-runtime";
function CameraErrorScreen({ title, description, actionButton, onAction }) {
  return /* @__PURE__ */ jsx68("div", { className: "container p-t-5", children: /* @__PURE__ */ jsx68("div", { className: "row", children: /* @__PURE__ */ jsxs28("div", { className: "col-md-6 col-md-offset-3", children: [
    /* @__PURE__ */ jsx68("h2", { className: "text-xs-center m-b-3", children: title }),
    /* @__PURE__ */ jsx68("p", { className: "text-xs-center m-b-5", children: description }),
    onAction && actionButton && /* @__PURE__ */ jsx68(Button6, { block: true, onClick: onAction, children: actionButton })
  ] }) }) });
}
var CameraErrorScreen_default = CameraErrorScreen;

// src/common/cameraCapture/CameraCapture.tsx
import { jsx as jsx69, jsxs as jsxs29 } from "react/jsx-runtime";
function CameraCapture({
  direction = "back",
  overlay = "",
  outline = "",
  imageUrl = "",
  title = "",
  instructions = "",
  showReview = false,
  onCapture,
  onEvent
}) {
  const [mode, setMode] = useState22("CAPTURE" /* CAPTURE */);
  const [cameraError, setCameraError] = useState22();
  const [isVideoMirrored, setIsVideoMirrored] = useState22(false);
  const [ready, setReady] = useState22(false);
  const [reviewImage, setReviewImage] = useState22();
  const webcamReference = useRef8(null);
  const { videoConstraints } = useVideoConstraints(direction);
  const shouldLockOrientation = useMemo19(
    () => !!(isMobile() && mode === "CAPTURE" /* CAPTURE */),
    [mode]
  );
  const { enterFullScreen, exitFullScreen } = useFullScreenOrientationLock(
    shouldLockOrientation,
    onEvent
  );
  const intl = useIntl20();
  const handleCapture = useCallback10(async () => {
    var _a, _b, _c, _d, _e, _f;
    if (((_a = webcamReference == null ? void 0 : webcamReference.current) == null ? void 0 : _a.video) && ((_c = (_b = webcamReference == null ? void 0 : webcamReference.current) == null ? void 0 : _b.video) == null ? void 0 : _c.readyState) >= 3) {
      (_e = (_d = webcamReference == null ? void 0 : webcamReference.current) == null ? void 0 : _d.video) == null ? void 0 : _e.pause();
      const canvas = await generateCanvasFromVideo((_f = webcamReference == null ? void 0 : webcamReference.current) == null ? void 0 : _f.video);
      canvas == null ? void 0 : canvas.toBlob(
        (blob) => {
          if (blob) {
            if (showReview) {
              const source = window.URL.createObjectURL(blob);
              setReviewImage({ source, blob });
              setMode("REVIEW" /* REVIEW */);
            } else {
              onCapture(blob);
            }
          }
        },
        "image/jpeg",
        0.92
      );
    }
  }, [webcamReference, showReview, setReviewImage, setMode, onCapture, isVideoMirrored]);
  const handleUserMediaError = useCallback10(
    (error) => {
      setMode("ERROR" /* ERROR */);
      if (error instanceof DOMException) {
        switch (error == null ? void 0 : error.name) {
          case "NotAllowedError":
            setCameraError({
              title: intl.formatMessage(CameraCapture_messages_default.noCameraAccessTitle),
              description: intl.formatMessage(CameraCapture_messages_default.noCameraAccessParagraph),
              actionButton: intl.formatMessage(CameraCapture_messages_default.noCameraAccessAction),
              onAction: handleRetryCameraAccess
            });
            trackCameraError("Dynamic Flow - Camera Permission Denied", onEvent, error);
            return;
          case "NotFoundError":
          case "OverconstrainedError":
          case "AbortError":
          case "NotReadableError":
            setCameraError({
              title: intl.formatMessage(CameraCapture_messages_default.cameraConnectionIssueTitle),
              description: intl.formatMessage(CameraCapture_messages_default.cameraConnectionIssueParagraph),
              actionButton: intl.formatMessage(CameraCapture_messages_default.cameraConnectionIssueAction),
              onAction: handleRetryCameraAccess
            });
            trackCameraError("Dynamic Flow - Camera Not Accessible", onEvent, error);
            return;
        }
      }
      setCameraError({
        title: intl.formatMessage(CameraCapture_messages_default.cameraNotSupportedTitle),
        description: intl.formatMessage(CameraCapture_messages_default.cameraNotSupportedParagraph)
      });
      trackCameraError("Dynamic Flow - Camera Not Supported", onEvent, error);
    },
    [intl, onEvent]
  );
  const handleUserMedia = useCallback10(
    (stream) => {
      enterFullScreen();
      setReady(true);
      setIsVideoMirrored(isSelfieCamera(stream));
      void trackCameraFeedStarted(onEvent, { direction }, stream);
    },
    [setIsVideoMirrored, onEvent, direction, enterFullScreen]
  );
  const handleReviewSubmit = () => {
    onCapture((reviewImage == null ? void 0 : reviewImage.blob) || null);
  };
  const handleReviewRetry = () => {
    setMode("CAPTURE" /* CAPTURE */);
    setReviewImage(void 0);
  };
  const handleRetryCameraAccess = () => setMode("CAPTURE" /* CAPTURE */);
  useEffect20(() => {
    if (mode !== "CAPTURE" /* CAPTURE */) {
      exitFullScreen();
    }
  }, [mode, exitFullScreen]);
  const captureScreen = /* @__PURE__ */ jsxs29("div", { className: "camera-capture", children: [
    videoConstraints && /* @__PURE__ */ jsx69(
      Webcam,
      {
        ref: webcamReference,
        audio: false,
        videoConstraints,
        mirrored: isVideoMirrored,
        onUserMediaError: handleUserMediaError,
        onUserMedia: handleUserMedia
      }
    ),
    /* @__PURE__ */ jsx69(
      Overlay_default,
      {
        overlay,
        outline,
        imageUrl,
        title,
        instructions
      }
    ),
    shouldLockOrientation && /* @__PURE__ */ jsx69(OrientationLockOverlay_default, {}),
    ready && /* @__PURE__ */ jsx69(
      CaptureBottomBar,
      {
        onCapture: () => {
          void handleCapture();
        }
      }
    )
  ] });
  const reviewScreen = /* @__PURE__ */ jsxs29("div", { className: "camera-capture", children: [
    /* @__PURE__ */ jsx69("img", { className: "review-image", src: reviewImage == null ? void 0 : reviewImage.source, alt: "" }),
    /* @__PURE__ */ jsx69(
      Overlay_default,
      {
        overlay,
        imageUrl,
        title,
        instructions,
        reviewInstructions: intl.formatMessage(CameraCapture_messages_default.reviewInstructions)
      }
    ),
    /* @__PURE__ */ jsx69(ReviewBottomBar, { onSubmit: handleReviewSubmit, onRetry: handleReviewRetry })
  ] });
  return /* @__PURE__ */ jsxs29("section", { children: [
    mode === "CAPTURE" /* CAPTURE */ && captureScreen,
    mode === "REVIEW" /* REVIEW */ && reviewScreen,
    mode === "ERROR" /* ERROR */ && cameraError && /* @__PURE__ */ jsx69(CameraErrorScreen_default, __spreadValues({}, cameraError))
  ] });
}
var CameraCapture_default = CameraCapture;

// src/legacy/step/cameraStep/CameraStep.tsx
import { jsx as jsx70 } from "react/jsx-runtime";
function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}
function CameraStep(props) {
  const { step, model, onModelChange, onAction } = props;
  const onEvent = useEventDispatcher();
  const objectSchema = getObjectSchema(step);
  const cameraSchema = getCameraSchema(step);
  const action = getFirstAction(step);
  const { title, image, cameraConfig } = cameraSchema;
  const { assets, direction, instructions } = cameraConfig || {};
  const { overlay, outline } = assets || {};
  const { url: imageUrl } = image || {};
  const [captureClicked, setCaptureClicked] = useState23(false);
  useEffect21(() => {
    if (captureClicked) {
      onAction(action);
    }
  }, [model]);
  const handleCapture = async (blob) => {
    const { $id } = cameraSchema;
    if (blob) {
      const newValue = await blobToBase64(blob);
      const newModel = { [$id || ""]: newValue };
      setCaptureClicked(true);
      onModelChange({
        model: newModel,
        formSchema: objectSchema,
        triggerModel: newValue,
        triggerSchema: cameraSchema
      });
    }
  };
  return /* @__PURE__ */ jsx70(
    CameraCapture_default,
    {
      overlay,
      outline,
      title,
      imageUrl,
      instructions,
      direction,
      onEvent,
      onCapture: (blob) => {
        void handleCapture(blob);
      }
    }
  );
}
var CameraStep_default = CameraStep;
function getObjectSchema(step) {
  const nonHiddenSchemas = filterHiddenSchemas(step.schemas || []);
  const objectSchema = nonHiddenSchemas[0];
  if (!objectSchema || !isObjectSchema2(objectSchema)) {
    throw new Error(
      "The first schema in a camera step is expected to be of type object and have at least one property with a schema..."
    );
  }
  return objectSchema;
}
function getCameraSchema(step) {
  const objectSchema = getObjectSchema(step);
  const firstProperty = Object.values(objectSchema.properties)[0];
  if (!firstProperty) {
    throw new Error(
      "The first schema in a camera step is expected to be of type object and have at least one property with a schema..."
    );
  }
  return firstProperty;
}
function getFirstAction(step) {
  var _a, _b;
  if (!step.schemas || ((_a = filterHiddenSchemas(step.schemas)) == null ? void 0 : _a.length) !== 1) {
    throw new Error("camera step expects 1 non-hidden object schema");
  }
  if (((_b = step == null ? void 0 : step.actions) == null ? void 0 : _b.length) !== 1) {
    throw new Error("camera step expects 1 action");
  }
  return step.actions[0];
}

// src/legacy/step/externalConfirmationStep/ExternalConfirmationStep.tsx
import { useIntl as useIntl21 } from "react-intl";

// src/common/messages/external-confirmation.messages.ts
import { defineMessages as defineMessages16 } from "react-intl";
var external_confirmation_messages_default = defineMessages16({
  title: {
    id: "dynamicFlows.ExternalConfirmation.title",
    defaultMessage: "Please confirm",
    description: "Heading for the confirmation screen."
  },
  description: {
    id: "dynamicFlows.ExternalConfirmation.description",
    defaultMessage: "Please confirm you want to open **{origin}** in a new browser tab.",
    description: "Description for the confirmation screen."
  },
  open: {
    id: "dynamicFlows.ExternalConfirmation.open",
    defaultMessage: "Open in new tab",
    description: "Button text confirming opening a new browser tab."
  },
  cancel: {
    id: "dynamicFlows.ExternalConfirmation.cancel",
    defaultMessage: "Cancel",
    description: "Button text rejecting opening a new browser tab."
  }
});

// src/legacy/step/externalConfirmationStep/ExternalConfirmationStep.tsx
import { jsx as jsx71 } from "react/jsx-runtime";
var noop6 = () => {
};
function ExternalConfirmationStep({ url, onClose }) {
  const { formatMessage } = useIntl21();
  return /* @__PURE__ */ jsx71(
    DynamicLayout_default,
    {
      components: [
        {
          type: "box",
          width: "lg",
          components: [
            {
              type: "heading",
              text: formatMessage(external_confirmation_messages_default.title),
              size: "lg",
              align: "center",
              margin: "xl"
            },
            {
              type: "info",
              markdown: formatMessage(external_confirmation_messages_default.description, { origin: getOrigin(url) }),
              align: "center",
              margin: "xl"
            },
            {
              type: "box",
              width: "md",
              components: [
                {
                  type: "button",
                  action: { title: formatMessage(external_confirmation_messages_default.open), type: "primary", url, exit: true }
                },
                {
                  type: "button",
                  action: {
                    title: formatMessage(external_confirmation_messages_default.cancel),
                    type: "link",
                    url: "",
                    exit: true
                  }
                }
              ]
            }
          ]
        }
      ],
      submitted: false,
      onAction: (action) => {
        if (action.url) {
          window.open(action.url, "_blank");
        }
        onClose();
      },
      onModelChange: noop6,
      onPersistAsync: noop6
    }
  );
}
var ExternalConfirmationStep_default = ExternalConfirmationStep;
function getOrigin(url) {
  try {
    return new URL(url).origin;
  } catch (e) {
    return url;
  }
}

// src/legacy/dynamicFlow/BackButton.tsx
import { Avatar as Avatar3 } from "@transferwise/components";
import { ArrowLeft } from "@transferwise/icons";
import { jsx as jsx72, jsxs as jsxs30 } from "react/jsx-runtime";
function BackButton({ title, action, onAction }) {
  return /* @__PURE__ */ jsx72("div", { className: "m-b-2", children: /* @__PURE__ */ jsxs30(
    "a",
    {
      href: "/",
      className: "df-back-btn",
      "aria-label": title,
      onClick: (event) => {
        event.preventDefault();
        onAction(__spreadProps(__spreadValues({}, action), { skipValidation: true }));
      },
      children: [
        /* @__PURE__ */ jsx72("span", { className: "sr-only", children: title }),
        /* @__PURE__ */ jsx72(Avatar3, { type: "icon", children: /* @__PURE__ */ jsx72(ArrowLeft, { size: "24" }) })
      ]
    }
  ) });
}
var BackButton_default = BackButton;

// src/legacy/dynamicFlow/DynamicFlowStep.tsx
import { Fragment as Fragment17, jsx as jsx73, jsxs as jsxs31 } from "react/jsx-runtime";
function DynamicFlowStep(props) {
  var _a, _b, _c;
  const { step, globalError, onAction } = props;
  const externalUrl = (_a = step == null ? void 0 : step.external) == null ? void 0 : _a.url;
  const backButton = ((_b = step == null ? void 0 : step.navigation) == null ? void 0 : _b.back) || ((_c = step == null ? void 0 : step.navigation) == null ? void 0 : _c.backButton);
  const { requiresManualTrigger, dismissConfirmation } = useExternal(externalUrl);
  if (step === void 0) {
    if (globalError) {
      return /* @__PURE__ */ jsx73(DynamicAlert_default, { component: { context: "negative", markdown: globalError, margin: "lg" } });
    }
    return null;
  }
  if (externalUrl && requiresManualTrigger) {
    return /* @__PURE__ */ jsx73(ExternalConfirmationStep_default, { url: externalUrl, onClose: dismissConfirmation });
  }
  if (isCameraStep(step)) {
    return /* @__PURE__ */ jsx73(CameraStep_default, __spreadProps(__spreadValues({}, props), { step }));
  }
  return /* @__PURE__ */ jsxs31(Fragment17, { children: [
    backButton && /* @__PURE__ */ jsx73(BackButton_default, __spreadProps(__spreadValues({}, backButton), { onAction })),
    globalError ? /* @__PURE__ */ jsx73(DynamicAlert_default, { component: { context: "negative", markdown: globalError, margin: "lg" } }) : null,
    /* @__PURE__ */ jsx73(LayoutStep_default, __spreadProps(__spreadValues({}, props), { stepSpecification: step }))
  ] });
}

// src/legacy/dynamicFlow/utils/useDebouncedRefresh/useDebouncedRefresh.ts
import { useRef as useRef9 } from "react";
var DEBOUNCE_DELAY = 1e3;
function useDebouncedRefresh(fetchRefresh) {
  const map = useRef9(/* @__PURE__ */ new Map());
  const retrieveOrCreate = (key) => {
    if (map.current.has(key)) {
      return map.current.get(key);
    }
    const debouncedFetchRefresh = debounce2(
      (url, data, etag) => fetchRefresh(url, data, etag),
      DEBOUNCE_DELAY
    );
    map.current.set(key, debouncedFetchRefresh);
    return debouncedFetchRefresh;
  };
  const debouncedRefresh = (url, data, etag, schema) => {
    const debouncedFetchRefresh = retrieveOrCreate(url);
    debouncedFetchRefresh(url, data, etag);
    if (!schema || !shouldDebounceSchema(schema)) {
      debouncedFetchRefresh.flush();
    }
  };
  const cancelPendingRefreshes = () => {
    map.current.forEach((debouncedFetchRefresh) => {
      debouncedFetchRefresh.cancel();
    });
  };
  const isDebouncing = Array.from(map.current.values()).some(
    (debouncedFunction) => debouncedFunction.isPending()
  );
  return { debouncedRefresh, isDebouncing, cancelPendingRefreshes };
}
var shouldDebounceSchema = (schema) => getSchemaType(schema) === "basic" && schema.type !== "boolean" && schema.format !== "base64url";

// src/legacy/dynamicFlow/utils/useDynamicFlowState.ts
import { useMemo as useMemo20, useState as useState24 } from "react";
var useDynamicFlowState = (initialStep) => {
  var _a, _b;
  const [formErrors, setFormErrors] = useState24((_a = initialStep == null ? void 0 : initialStep.errors) == null ? void 0 : _a.validation);
  const [globalError, setGlobalError] = useState24((_b = initialStep == null ? void 0 : initialStep.errors) == null ? void 0 : _b.error);
  const [stepAndModels, setStepAndModels] = useState24({
    step: initialStep || void 0,
    models: (initialStep == null ? void 0 : initialStep.model) ? buildInitialModels(initialStep.model, getAllSchemas(initialStep)) : {},
    etag: void 0
  });
  const { step, models, etag } = stepAndModels;
  const setStepAndEtag = (step2, etag2) => {
    var _a2, _b2, _c, _d;
    setStepAndModels({
      step: step2,
      models: step2.model ? buildInitialModels(step2.model, getAllSchemas(step2)) : {},
      etag: etag2
    });
    setFormErrors((_b2 = (_a2 = step2 == null ? void 0 : step2.errors) == null ? void 0 : _a2.validation) != null ? _b2 : null);
    setGlobalError((_d = (_c = step2 == null ? void 0 : step2.errors) == null ? void 0 : _c.error) != null ? _d : null);
  };
  const setSchemaModel = (schemaId, objectModel, onModelsUpdated) => {
    setStepAndModels((previous) => {
      const updatedModels = __spreadProps(__spreadValues({}, previous.models), {
        [schemaId]: objectModel
      });
      const updatedState = {
        step: previous.step,
        models: updatedModels,
        etag: previous.etag
      };
      onModelsUpdated(updatedModels);
      return updatedState;
    });
  };
  const modelIsValid = useMemo20(
    () => areModelsValid(models, getAllValidatableSchemas(step)),
    [models, step]
  );
  return {
    formErrors,
    globalError,
    step,
    models,
    etag,
    modelIsValid,
    setFormErrors,
    setGlobalError,
    setStepAndEtag,
    setSchemaModel
  };
};
var buildInitialModels = (model, schemas = []) => schemas.reduce((acc, schema) => {
  if (!schema.$id) {
    console.warn("Schema without $id property found.");
  }
  return __spreadProps(__spreadValues({}, acc), {
    [schema.$id || ""]: getValidObjectModelParts(model, schema) || {}
  });
}, {});
var getAllSchemas = (step) => [
  ...getAllSchemasInLayout((step == null ? void 0 : step.layout) || []),
  ...(step == null ? void 0 : step.schemas) || []
];
var getAllSchemasInLayout = (components) => components.flatMap((component) => {
  switch (component.type) {
    case "columns":
      return [...getAllSchemasInLayout([...component.left, ...component.right])];
    case "box":
      return getAllSchemasInLayout(component.components);
    case "form":
      return isInlineSchema(component.schema) ? [component.schema] : [];
    default:
      return [];
  }
});
var getAllValidatableSchemas = (step) => [
  ...getAllReferencedSchemaIds((step == null ? void 0 : step.layout) || []).map((id) => ((step == null ? void 0 : step.schemas) || []).find((schema) => schema.$id === id)).filter(Boolean),
  ...getAllSchemasInLayout((step == null ? void 0 : step.layout) || [])
];
var getAllReferencedSchemaIds = (components) => components.flatMap((component) => {
  switch (component.type) {
    case "columns":
      return [...getAllReferencedSchemaIds([...component.left, ...component.right])];
    case "box":
      return getAllReferencedSchemaIds(component.components);
    case "form":
      return [getSchemaReference(component)];
    default:
      return [];
  }
}).filter(Boolean);
var areModelsValid = (formModels, schemas = []) => !(schemas == null ? void 0 : schemas.some((schema) => {
  if (!schema.$id) {
    console.warn("Schema without $id property found.");
  }
  return !isValidSchema(formModels[schema.$id || ""] || {}, schema);
}));
var getSchemaReference = (component) => {
  if (component.schema && !isInlineSchema(component.schema)) {
    return component.schema.$ref;
  }
  return component.schemaId;
};
var isInlineSchema = (schema) => schema !== void 0 && typeof schema === "object" && !Object.hasOwnProperty.call(schema, "$ref");

// src/legacy/dynamicFlow/utils/useLoader.tsx
import { Loader as Loader3, Size as Size4 } from "@transferwise/components";
import { useState as useState25 } from "react";
import { jsx as jsx74 } from "react/jsx-runtime";
function useLoader(loaderConfig, initialState) {
  const config = __spreadValues({
    size: Size4.EXTRA_LARGE,
    initial: true,
    submission: false
  }, loaderConfig);
  const [loadingState, setLoadingState] = useState25(initialState);
  const shouldDisplayLoader = config.initial && loadingState === "initial" || config.submission && loadingState === "submission";
  const loader = shouldDisplayLoader ? /* @__PURE__ */ jsx74(
    Loader3,
    {
      size: config.size,
      classNames: { "tw-loader": "tw-loader m-x-auto" },
      "data-testid": "loader"
    }
  ) : null;
  return { isLoading: loadingState !== "idle", setLoadingState, loader };
}

// src/legacy/dynamicFlow/utils/responseParsers/response-parsers.ts
var parseFetchResponseByResponseType = async (response, type) => {
  switch (type) {
    case "step":
      return parseStepResponse(response);
    case "exit":
      return parseExitResponse(response);
    case "action":
      return parseActionResponse(response);
    default:
      throw new Error(
        "Unsupported X-Df-Response-Type. Allowed values are 'step', 'action', 'exit'."
      );
  }
};
var parseStepResponse = async (response) => {
  const jsonBody = await parseResponseJson(response);
  if (!isObject2(jsonBody)) {
    throw new Error("Incorrect response body in response. Expected an object.");
  }
  const etag = response.headers.get("etag") || void 0;
  return { type: "step", step: jsonBody, etag };
};
var parseActionResponse = async (response) => {
  const jsonBody = await parseResponseJson(response);
  if (!isObject2(jsonBody)) {
    throw new Error("Incorrect response body in response. Expected an object.");
  }
  if (!isObject2(jsonBody.action)) {
    throw new Error(
      "Incorrect response body in action response. Expected an object satisfying the type { action: Action }."
    );
  }
  const action = jsonBody.action;
  if (action.exit === true && isObject2(action.result)) {
    return { type: "exit", result: action.result };
  }
  return { type: "action", action: jsonBody.action };
};
var parseExitResponse = async (response) => ({ type: "exit", result: await getJsonObjectOrNull(response) });
var parseFetchResponse = async (response) => {
  var _a, _b;
  assertResponseIsValid2(response);
  if ((_a = response.headers) == null ? void 0 : _a.has("X-Df-Response-Type")) {
    const type = response.headers.get("X-Df-Response-Type");
    return parseFetchResponseByResponseType(response, type);
  }
  if ((_b = response.headers) == null ? void 0 : _b.has("X-Df-Exit")) {
    return parseExitResponse(response);
  }
  const jsonBody = await parseResponseJson(response.clone());
  if (isObject2(jsonBody) && jsonBody.action) {
    return parseActionResponse(response);
  }
  return parseStepResponse(response);
};
var parseErrorResponse = async (response) => {
  assertResponseIsValid2(response);
  const jsonBody = await parseResponseJson(response);
  if (!isObject2(jsonBody)) {
    throw new Error("Incorrect response body in error response. Expected an object.");
  }
  if (!jsonBody.refreshFormUrl && !jsonBody.refreshUrl && !jsonBody.validation && !jsonBody.error) {
    throw jsonBody;
  }
  return jsonBody;
};
var getJsonObjectOrNull = async (response) => {
  assertResponseIsValid2(response);
  const result = await parseResponseJson(response);
  return isObject2(result) ? result : null;
};
var parseResponseJson = async (response) => {
  try {
    return await response.json();
  } catch (e) {
    return null;
  }
};
var assertResponseIsValid2 = (response) => {
  if (!isResponse2(response)) {
    throw new Error("Incorrect type of response from fetch. Expected object of type Response.");
  }
  if (response.bodyUsed) {
    throw new Error(
      "The body of the provided Response object has already been used. Every request must respond with a new Response object."
    );
  }
};
var isResponse2 = (response) => typeof response === "object" && response !== null && "clone" in response && "bodyUsed" in response;

// src/legacy/dynamicFlow/utils/useErrorResponse.tsx
import { useIntl as useIntl22 } from "react-intl";
var useErrorResponse = () => {
  const { formatMessage } = useIntl22();
  return async (response, fetchType, isInitialRequest) => {
    try {
      const errorResponse = await parseErrorResponse(response);
      return errorResponse;
    } catch (error) {
      if (fetchType === "submission" && !isInitialRequest) {
        return { error: formatMessage(generic_error_messages_default.genericErrorRetryHint) };
      }
      throw error;
    }
  };
};

// src/legacy/dynamicFlow/DynamicFlow.tsx
import { jsx as jsx75 } from "react/jsx-runtime";
var noop7 = () => {
};
var DynamicFlowComponent = ({
  flowId,
  httpClient,
  initialAction,
  initialStep,
  loaderConfig,
  displayStepTitle = true,
  onCompletion,
  onError,
  onEvent = noop7,
  onLog = noop7
}) => {
  const {
    formErrors,
    globalError,
    step,
    models,
    etag,
    modelIsValid,
    setFormErrors,
    setGlobalError,
    setStepAndEtag,
    setSchemaModel
  } = useDynamicFlowState(initialStep);
  const [submitted, setSubmitted] = useState26(false);
  const { locale } = useIntl23();
  const { isLoading, loader, setLoadingState } = useLoader(
    loaderConfig,
    initialStep ? "idle" : "initial"
  );
  const logCritical = getLogger("critical", onLog, flowId, (step == null ? void 0 : step.id) || (step == null ? void 0 : step.key));
  const logWarning = getLogger("warning", onLog, flowId, (step == null ? void 0 : step.id) || (step == null ? void 0 : step.key));
  const warnIfNoStepLayout = (step2) => {
    if (step2 && !step2.layout) {
      logWarning(
        "Deprecation warning",
        "Support for steps with no layout is being dropped. Please add a layout array to your step.",
        {
          stepId: step2.id || step2.key
        }
      );
    }
  };
  const analyticsMetadata = useMemo21(
    () => {
      var _a;
      return __spreadValues({ flowId, stepId: (step == null ? void 0 : step.id) || (step == null ? void 0 : step.key) }, (_a = step == null ? void 0 : step.analytics) != null ? _a : {});
    },
    [flowId, step]
  );
  const dispatchEvent = useMemo21(
    () => getEventDispatcher(onEvent, analyticsMetadata),
    [onEvent, analyticsMetadata]
  );
  const dfHttpClient = useCallback11(
    ({
      action,
      data,
      etag: etag2
    }) => {
      const { url, method = "POST" } = action;
      return httpClient(url != null ? url : "", {
        method,
        credentials: "include",
        headers: __spreadValues({
          "Content-Type": "application/json",
          "accept-language": locale
        }, etag2 ? { "If-None-Match": etag2 } : {}),
        body: method === "GET" ? void 0 : JSON.stringify(data)
      });
    },
    [httpClient, locale]
  );
  const performAction = async (action, data = {}) => {
    cancelPendingRefreshes();
    setLoadingState(!step ? "initial" : "submission");
    dispatchEvent("Dynamic Flow - Step Submitted", { actionId: action.id || action.$id });
    try {
      const response = await dfHttpClient({ action, data });
      if (action.exit && response.ok) {
        await handleExitResponse(response, action.result);
        return;
      }
      await handleResponse(response, "submission", action.result);
    } catch (error) {
      completeWithError(
        error,
        action.exit ? "Error fetching exit result" : "Error fetching next step"
      );
    }
  };
  const performRefresh = async (url, data, etag2) => {
    cancelPendingRefreshes();
    setLoadingState("refresh");
    dispatchEvent("Dynamic Flow - Step Refreshed", { status: "pending" });
    try {
      const response = await dfHttpClient({ action: { url, method: "POST" }, data, etag: etag2 });
      await handleResponse(response, "refresh");
    } catch (error) {
      completeWithError(error, "Error fetching refresh step");
    }
  };
  const handleExitResponse = async (response, actionResult) => {
    const exitResult = await getJsonObjectOrNull(response);
    dispatchEventAndComplete(__spreadValues(__spreadValues({}, exitResult), actionResult));
  };
  const { debouncedRefresh, isDebouncing, cancelPendingRefreshes } = useDebouncedRefresh(performRefresh);
  const dispatchEventAndComplete = useCallback11(
    (result) => {
      dispatchEvent("Dynamic Flow - Flow Finished", { result: "success" });
      onCompletion(result);
    },
    [onCompletion, dispatchEvent]
  );
  useEffect22(() => {
    dispatchEvent("Dynamic Flow - Flow Started", {});
  }, []);
  useEffect22(() => {
    if (!initialStep) {
      const action = __spreadValues({
        id: "#initial-step-request",
        method: "GET"
      }, initialAction);
      void performAction(action, action.data);
    }
    if (initialStep) {
      warnIfNoStepLayout(initialStep);
    }
  }, [httpClient, JSON.stringify(initialStep), JSON.stringify(initialAction)]);
  const getErrorResponse = useErrorResponse();
  const handleResponse = async (response, fetchType, actionResult) => {
    try {
      if (response.status === 304) {
        setLoadingState("idle");
        return;
      }
      if (!response.ok) {
        const isInitialRequest = step === void 0;
        const errorResponse = await getErrorResponse(response, fetchType, isInitialRequest);
        void updateAfterError(errorResponse);
        return;
      }
      const result = await parseFetchResponse(response);
      if (result.type === "action") {
        void performAction(result.action, result.action.data);
      } else if (result.type === "exit") {
        dispatchEventAndComplete(
          isObject2(actionResult) ? __spreadValues(__spreadValues({}, result.result), actionResult) : result.result
        );
      } else {
        updateStep(result.step, result.etag, fetchType);
      }
    } catch (error) {
      completeWithError(error, "Error parsing fetch response", fetchType, response.status);
    }
  };
  const updateStep = (newStep, etag2, fetchType) => {
    warnIfNoStepLayout(newStep);
    setStepAndEtag(newStep, etag2);
    setLoadingState("idle");
    if (fetchType === "submission") {
      setSubmitted(false);
      dispatchEvent("Dynamic Flow - Step Started", __spreadValues({
        stepId: newStep.id || newStep.key
      }, newStep == null ? void 0 : newStep.analytics));
    } else {
      dispatchEvent("Dynamic Flow - Step Refreshed", { status: "success" });
    }
  };
  const updateAfterError = async (errorBody) => {
    const refreshUrl = errorBody.refreshUrl || errorBody.refreshFormUrl;
    if (refreshUrl) {
      await performRefresh(refreshUrl, combineModels2(models), etag);
    }
    if (errorBody.validation) {
      setFormErrors(errorBody.validation);
    }
    if (errorBody.error) {
      setGlobalError(errorBody.error);
    }
    setLoadingState("idle");
  };
  const completeWithError = (error, message, fetchType, statusCode) => {
    logCritical("Error fetching", message);
    if (fetchType === "refresh") {
      dispatchEvent("Dynamic Flow - Step Refreshed", { status: "failure" });
    }
    dispatchEvent("Dynamic Flow - Flow Finished", { status: "failure" });
    onError(error, statusCode);
    setLoadingState("idle");
  };
  const onModelChange = (onModelChangeProps) => {
    const { model, formSchema } = onModelChangeProps;
    const { $id = "" } = formSchema;
    setGlobalError(null);
    if (!isObjectModel2(model)) {
      logCritical(
        "Invalid model on change",
        "onModelChange was called but the model argument is not an object"
      );
    }
    const objectModel = model;
    setSchemaModel($id, objectModel, (updatedModels) => {
      refreshOnChangeIfNeeded(onModelChangeProps, updatedModels);
    });
  };
  const refreshOnChangeIfNeeded = (props, updatedModels) => {
    const { triggerSchema } = props;
    if (shouldTriggerRefresh(props)) {
      const triggerSchemaRefreshUrl = triggerSchema.refreshUrl || triggerSchema.refreshFormUrl;
      const stepRefreshUrl = (step == null ? void 0 : step.refreshUrl) || (step == null ? void 0 : step.refreshFormUrl);
      const refreshUrl = triggerSchemaRefreshUrl || stepRefreshUrl;
      if (refreshUrl) {
        debouncedRefresh(refreshUrl, combineModels2(updatedModels), etag, triggerSchema);
      }
    }
  };
  const onAction = async (action) => {
    if (isLoading || isDebouncing || action.disabled) {
      return;
    }
    if (action.exit && !action.url) {
      dispatchEventAndComplete(action.result);
      return;
    }
    const { data, method, skipValidation: skipValidation2 } = action;
    const submissionData = __spreadValues(__spreadValues({}, combineModels2(models)), data);
    if (isSubmissionMethod(method)) {
      setFormErrors(null);
      if (!skipValidation2) {
        setSubmitted(true);
      }
      if (modelIsValid || skipValidation2) {
        await performAction(action, submissionData);
      }
    } else {
      await performAction(action);
    }
  };
  return /* @__PURE__ */ jsx75(LogProvider, { flowId, stepId: (step == null ? void 0 : step.id) || (step == null ? void 0 : step.key), onLog, children: /* @__PURE__ */ jsx75(EventsContextProvider, { metadata: analyticsMetadata, onEvent, children: /* @__PURE__ */ jsx75(DynamicFlowProvider, { loading: isLoading || isDebouncing, children: /* @__PURE__ */ jsx75(HttpClientProvider, { httpClient, children: loader !== null ? loader : /* @__PURE__ */ jsx75("div", { id: (step == null ? void 0 : step.id) || (step == null ? void 0 : step.key), className: "dynamic-flow-legacy", children: /* @__PURE__ */ jsx75(
    DynamicFlowStep,
    {
      step,
      model: combineModels2(models),
      submitted,
      globalError,
      formErrors,
      stepLayoutOptions: { displayStepTitle },
      onAction: (action) => {
        void onAction(action);
      },
      onModelChange
    }
  ) }) }) }) }) });
};
function DynamicFlow(props) {
  return /* @__PURE__ */ jsx75(ErrorBoundary_default, { onError: props.onError, children: /* @__PURE__ */ jsx75(DynamicFlowComponent, __spreadValues({}, props)) });
}
var DynamicFlow_default = DynamicFlow;
var combineModels2 = (formModels) => Object.values(formModels).reduce((previous, model) => __spreadValues(__spreadValues({}, previous), model), {});
var isSubmissionMethod = (method = "POST") => {
  const submissionMethods = ["POST", "PUT", "PATCH"];
  return submissionMethods.includes(method.toUpperCase());
};
var shouldTriggerRefresh = (props) => {
  const { type, triggerSchema, triggerModel, lastTriggerModel = null } = props;
  const isValid = () => isValidSchema(triggerModel, triggerSchema);
  const wasValid = () => isValidSchema(lastTriggerModel, triggerSchema);
  const hasRefreshOnChange = (triggerSchema == null ? void 0 : triggerSchema.refreshStepOnChange) || (triggerSchema == null ? void 0 : triggerSchema.refreshFormOnChange);
  return type !== "init" && hasRefreshOnChange && (isValid() || wasValid());
};

// src/legacy/jsonSchemaForm/JsonSchemaForm.tsx
import { jsx as jsx76 } from "react/jsx-runtime";
function JsonSchemaForm(props) {
  const schemaProps = __spreadValues({
    model: null,
    errors: null
  }, props);
  const { baseUrl = "", onEvent = noop8, onLog = noop8 } = props;
  return /* @__PURE__ */ jsx76(LogProvider, { flowId: "JsonSchemaForm", stepId: "JsonSchemaForm", onLog, children: /* @__PURE__ */ jsx76(
    EventsContextProvider,
    {
      metadata: { flowId: "JsonSchemaForm", stepId: "JsonSchemaForm" },
      onEvent,
      children: /* @__PURE__ */ jsx76(HttpClientProviderFromBaseUrl, { baseUrl, children: /* @__PURE__ */ jsx76(GenericSchema_default, __spreadValues({}, schemaProps)) })
    }
  ) });
}
var JsonSchemaForm_default = JsonSchemaForm;
var noop8 = () => {
};
export {
  DynamicFlow_default as DynamicFlow,
  DynamicFlowCore as DynamicFlowCoreRevamp,
  DynamicFormCore,
  JsonSchemaForm_default as JsonSchemaForm,
  DynamicLayout_default as Layout,
  convertStepToLayout,
  findRendererPropsByType,
  inlineReferences,
  isValidSchema,
  makeHttpClient,
  i18n_default as translations
};
